'use strict';

function _AsyncGenerator(e) {
  var r, t;
  function resume(r, t) {
    try {
      var n = e[r](t),
        o = n.value,
        u = o instanceof _OverloadYield;
      Promise.resolve(u ? o.v : o).then(function (t) {
        if (u) {
          var i = "return" === r ? "return" : "next";
          if (!o.k || t.done) return resume(i, t);
          t = e[i](t).value;
        }
        settle(n.done ? "return" : "normal", t);
      }, function (e) {
        resume("throw", e);
      });
    } catch (e) {
      settle("throw", e);
    }
  }
  function settle(e, n) {
    switch (e) {
      case "return":
        r.resolve({
          value: n,
          done: !0
        });
        break;
      case "throw":
        r.reject(n);
        break;
      default:
        r.resolve({
          value: n,
          done: !1
        });
    }
    (r = r.next) ? resume(r.key, r.arg) : t = null;
  }
  this._invoke = function (e, n) {
    return new Promise(function (o, u) {
      var i = {
        key: e,
        arg: n,
        resolve: o,
        reject: u,
        next: null
      };
      t ? t = t.next = i : (r = t = i, resume(e, n));
    });
  }, "function" != typeof e.return && (this.return = void 0);
}
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () {
  return this;
}, _AsyncGenerator.prototype.next = function (e) {
  return this._invoke("next", e);
}, _AsyncGenerator.prototype.throw = function (e) {
  return this._invoke("throw", e);
}, _AsyncGenerator.prototype.return = function (e) {
  return this._invoke("return", e);
};
function _OverloadYield(t, e) {
  this.v = t, this.k = e;
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _asyncIterator(r) {
  var n,
    t,
    o,
    e = 2;
  for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) {
    if (t && null != (n = r[t])) return n.call(r);
    if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
    t = "@@asyncIterator", o = "@@iterator";
  }
  throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(r) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var n = r.done;
    return Promise.resolve(r.value).then(function (r) {
      return {
        value: r,
        done: n
      };
    });
  }
  return AsyncFromSyncIterator = function (r) {
    this.s = r, this.n = r.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function () {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    return: function (r) {
      var n = this.s.return;
      return void 0 === n ? Promise.resolve({
        value: r,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
    },
    throw: function (r) {
      var n = this.s.return;
      return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(r);
}
function _awaitAsyncGenerator(e) {
  return new _OverloadYield(e, 0);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classPrivateFieldGet2(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldSet2(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _classPrivateGetter(s, r, a) {
  return a(_assertClassBrand(s, r));
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _wrapAsyncGenerator(fn) {
  return function () {
    return new _AsyncGenerator(fn.apply(this, arguments));
  };
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike  ) {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}

/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

/******/
var __webpack_modules__ = {
  /***/9306: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isCallable = __webpack_require__(4901);
    var tryToString = __webpack_require__(6823);
    var $TypeError = TypeError;

    // `Assert: IsCallable(argument) is true`
    module.exports = function (argument) {
      if (isCallable(argument)) return argument;
      throw new $TypeError(tryToString(argument) + ' is not a function');
    };

    /***/
  }),
  /***/7080: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var has = __webpack_require__(4402).has;

    // Perform ? RequireInternalSlot(M, [[SetData]])
    module.exports = function (it) {
      has(it);
      return it;
    };

    /***/
  }),
  /***/679: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isPrototypeOf = __webpack_require__(1625);
    var $TypeError = TypeError;
    module.exports = function (it, Prototype) {
      if (isPrototypeOf(Prototype, it)) return it;
      throw new $TypeError('Incorrect invocation');
    };

    /***/
  }),
  /***/8551: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isObject = __webpack_require__(34);
    var $String = String;
    var $TypeError = TypeError;

    // `Assert: Type(argument) is Object`
    module.exports = function (argument) {
      if (isObject(argument)) return argument;
      throw new $TypeError($String(argument) + ' is not an object');
    };

    /***/
  }),
  /***/9617: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var toIndexedObject = __webpack_require__(5397);
    var toAbsoluteIndex = __webpack_require__(5610);
    var lengthOfArrayLike = __webpack_require__(6198);

    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod = function createMethod(IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare -- NaN check
          if (value !== value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
      };
    };
    module.exports = {
      // `Array.prototype.includes` method
      // https://tc39.es/ecma262/#sec-array.prototype.includes
      includes: createMethod(true),
      // `Array.prototype.indexOf` method
      // https://tc39.es/ecma262/#sec-array.prototype.indexof
      indexOf: createMethod(false)
    };

    /***/
  }),
  /***/4527: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var isArray = __webpack_require__(4376);
    var $TypeError = TypeError;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // Safari < 13 does not throw an error in this case
    var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
      // makes no sense without proper strict mode support
      if (this !== undefined) return true;
      try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
          writable: false
        }).length = 1;
      } catch (error) {
        return error instanceof TypeError;
      }
    }();
    module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
      if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
        throw new $TypeError('Cannot set read only .length');
      }
      return O.length = length;
    } : function (O, length) {
      return O.length = length;
    };

    /***/
  }),
  /***/6319: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var anObject = __webpack_require__(8551);
    var iteratorClose = __webpack_require__(9539);

    // call something on iterator step with safe closing on error
    module.exports = function (iterator, fn, value, ENTRIES) {
      try {
        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
      } catch (error) {
        iteratorClose(iterator, 'throw', error);
      }
    };

    /***/
  }),
  /***/4576: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var toString = uncurryThis({}.toString);
    var stringSlice = uncurryThis(''.slice);
    module.exports = function (it) {
      return stringSlice(toString(it), 8, -1);
    };

    /***/
  }),
  /***/6955: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var TO_STRING_TAG_SUPPORT = __webpack_require__(2140);
    var isCallable = __webpack_require__(4901);
    var classofRaw = __webpack_require__(4576);
    var wellKnownSymbol = __webpack_require__(8227);
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var $Object = Object;

    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function () {
      return arguments;
    }()) === 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (error) {/* empty */}
    };

    // getting tag from ES6+ `Object.prototype.toString`
    module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
      var O, tag, result;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
      // builtinTag case
      : CORRECT_ARGUMENTS ? classofRaw(O)
      // ES3 arguments fallback
      : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
    };

    /***/
  }),
  /***/7740: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var hasOwn = __webpack_require__(9297);
    var ownKeys = __webpack_require__(5031);
    var getOwnPropertyDescriptorModule = __webpack_require__(7347);
    var definePropertyModule = __webpack_require__(4913);
    module.exports = function (target, source, exceptions) {
      var keys = ownKeys(source);
      var defineProperty = definePropertyModule.f;
      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
          defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      }
    };

    /***/
  }),
  /***/2211: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var fails = __webpack_require__(9039);
    module.exports = !fails(function () {
      function F() {/* empty */}
      F.prototype.constructor = null;
      // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
      return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    /***/
  }),
  /***/2529: ( /***/function _(module) {
    // `CreateIterResultObject` abstract operation
    // https://tc39.es/ecma262/#sec-createiterresultobject
    module.exports = function (value, done) {
      return {
        value: value,
        done: done
      };
    };

    /***/
  }),
  /***/6699: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var definePropertyModule = __webpack_require__(4913);
    var createPropertyDescriptor = __webpack_require__(6980);
    module.exports = DESCRIPTORS ? function (object, key, value) {
      return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    /***/
  }),
  /***/6980: ( /***/function _(module) {
    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    /***/
  }),
  /***/4659: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var definePropertyModule = __webpack_require__(4913);
    var createPropertyDescriptor = __webpack_require__(6980);
    module.exports = function (object, key, value) {
      if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
    };

    /***/
  }),
  /***/2106: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var makeBuiltIn = __webpack_require__(283);
    var defineProperty = __webpack_require__(4913);
    module.exports = function (target, name, descriptor) {
      if (descriptor.get) makeBuiltIn(descriptor.get, name, {
        getter: true
      });
      if (descriptor.set) makeBuiltIn(descriptor.set, name, {
        setter: true
      });
      return defineProperty.f(target, name, descriptor);
    };

    /***/
  }),
  /***/6840: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isCallable = __webpack_require__(4901);
    var definePropertyModule = __webpack_require__(4913);
    var makeBuiltIn = __webpack_require__(283);
    var defineGlobalProperty = __webpack_require__(9433);
    module.exports = function (O, key, value, options) {
      if (!options) options = {};
      var simple = options.enumerable;
      var name = options.name !== undefined ? options.name : key;
      if (isCallable(value)) makeBuiltIn(value, name, options);
      if (options.global) {
        if (simple) O[key] = value;else defineGlobalProperty(key, value);
      } else {
        try {
          if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
        } catch (error) {/* empty */}
        if (simple) O[key] = value;else definePropertyModule.f(O, key, {
          value: value,
          enumerable: false,
          configurable: !options.nonConfigurable,
          writable: !options.nonWritable
        });
      }
      return O;
    };

    /***/
  }),
  /***/6279: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var defineBuiltIn = __webpack_require__(6840);
    module.exports = function (target, src, options) {
      for (var key in src) defineBuiltIn(target, key, src[key], options);
      return target;
    };

    /***/
  }),
  /***/9433: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);

    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty = Object.defineProperty;
    module.exports = function (key, value) {
      try {
        defineProperty(global, key, {
          value: value,
          configurable: true,
          writable: true
        });
      } catch (error) {
        global[key] = value;
      }
      return value;
    };

    /***/
  }),
  /***/3724: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var fails = __webpack_require__(9039);

    // Detect IE8's incomplete defineProperty implementation
    module.exports = !fails(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1] !== 7;
    });

    /***/
  }),
  /***/4055: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var isObject = __webpack_require__(34);
    var document = global.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS = isObject(document) && isObject(document.createElement);
    module.exports = function (it) {
      return EXISTS ? document.createElement(it) : {};
    };

    /***/
  }),
  /***/6837: ( /***/function _(module) {
    var $TypeError = TypeError;
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

    module.exports = function (it) {
      if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
      return it;
    };

    /***/
  }),
  /***/9392: ( /***/function _(module) {
    module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

    /***/
  }),
  /***/7388: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var userAgent = __webpack_require__(9392);
    var process = global.process;
    var Deno = global.Deno;
    var versions = process && process.versions || Deno && Deno.version;
    var v8 = versions && versions.v8;
    var match, version;
    if (v8) {
      match = v8.split('.');
      // in old Chrome, versions of V8 isn't V8 = Chrome / 10
      // but their correct versions are not interesting for us
      version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    }

    // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
    // so check `userAgent` even if `.v8` exists, but 0
    if (!version && userAgent) {
      match = userAgent.match(/Edge\/(\d+)/);
      if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
      }
    }
    module.exports = version;

    /***/
  }),
  /***/8727: ( /***/function _(module) {
    // IE8- don't enum bug keys
    module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

    /***/
  }),
  /***/6518: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var getOwnPropertyDescriptor = __webpack_require__(7347).f;
    var createNonEnumerableProperty = __webpack_require__(6699);
    var defineBuiltIn = __webpack_require__(6840);
    var defineGlobalProperty = __webpack_require__(9433);
    var copyConstructorProperties = __webpack_require__(7740);
    var isForced = __webpack_require__(2796);

    /*
      options.target         - name of the target object
      options.global         - target is the global object
      options.stat           - export as static methods of target
      options.proto          - export as prototype methods of target
      options.real           - real prototype method for the `pure` version
      options.forced         - export even if the native feature is available
      options.bind           - bind methods to the target, required for the `pure` version
      options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
      options.unsafe         - use the simple assignment of property instead of delete + defineProperty
      options.sham           - add a flag to not completely full polyfills
      options.enumerable     - export as enumerable property
      options.dontCallGetSet - prevent calling a getter on target
      options.name           - the .name of the function if it does not match the key
    */
    module.exports = function (options, source) {
      var TARGET = options.target;
      var GLOBAL = options.global;
      var STATIC = options.stat;
      var FORCED, target, key, targetProperty, sourceProperty, descriptor;
      if (GLOBAL) {
        target = global;
      } else if (STATIC) {
        target = global[TARGET] || defineGlobalProperty(TARGET, {});
      } else {
        target = global[TARGET] && global[TARGET].prototype;
      }
      if (target) for (key in source) {
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
          descriptor = getOwnPropertyDescriptor(target, key);
          targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
          if (_typeof(sourceProperty) == _typeof(targetProperty)) continue;
          copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) {
          createNonEnumerableProperty(sourceProperty, 'sham', true);
        }
        defineBuiltIn(target, key, sourceProperty, options);
      }
    };

    /***/
  }),
  /***/9039: ( /***/function _(module) {
    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (error) {
        return true;
      }
    };

    /***/
  }),
  /***/6080: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(7476);
    var aCallable = __webpack_require__(9306);
    var NATIVE_BIND = __webpack_require__(616);
    var bind = uncurryThis(uncurryThis.bind);

    // optional / simple context binding
    module.exports = function (fn, that) {
      aCallable(fn);
      return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function /* ...args */
      () {
        return fn.apply(that, arguments);
      };
    };

    /***/
  }),
  /***/616: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var fails = __webpack_require__(9039);
    module.exports = !fails(function () {
      // eslint-disable-next-line es/no-function-prototype-bind -- safe
      var test = function () {/* empty */}.bind();
      // eslint-disable-next-line no-prototype-builtins -- safe
      return typeof test != 'function' || test.hasOwnProperty('prototype');
    });

    /***/
  }),
  /***/9565: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var NATIVE_BIND = __webpack_require__(616);
    var call = Function.prototype.call;
    module.exports = NATIVE_BIND ? call.bind(call) : function () {
      return call.apply(call, arguments);
    };

    /***/
  }),
  /***/350: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var hasOwn = __webpack_require__(9297);
    var FunctionPrototype = Function.prototype;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
    var EXISTS = hasOwn(FunctionPrototype, 'name');
    // additional protection from minified / mangled / dropped function names
    var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
    var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
    module.exports = {
      EXISTS: EXISTS,
      PROPER: PROPER,
      CONFIGURABLE: CONFIGURABLE
    };

    /***/
  }),
  /***/6706: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var aCallable = __webpack_require__(9306);
    module.exports = function (object, key, method) {
      try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
      } catch (error) {/* empty */}
    };

    /***/
  }),
  /***/7476: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var classofRaw = __webpack_require__(4576);
    var uncurryThis = __webpack_require__(9504);
    module.exports = function (fn) {
      // Nashorn bug:
      //   https://github.com/zloirock/core-js/issues/1128
      //   https://github.com/zloirock/core-js/issues/1130
      if (classofRaw(fn) === 'Function') return uncurryThis(fn);
    };

    /***/
  }),
  /***/9504: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var NATIVE_BIND = __webpack_require__(616);
    var FunctionPrototype = Function.prototype;
    var call = FunctionPrototype.call;
    var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
    module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
      return function () {
        return call.apply(fn, arguments);
      };
    };

    /***/
  }),
  /***/7751: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var isCallable = __webpack_require__(4901);
    var aFunction = function aFunction(argument) {
      return isCallable(argument) ? argument : undefined;
    };
    module.exports = function (namespace, method) {
      return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
    };

    /***/
  }),
  /***/1767: ( /***/function _(module) {
    // `GetIteratorDirect(obj)` abstract operation
    // https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
    module.exports = function (obj) {
      return {
        iterator: obj,
        next: obj.next,
        done: false
      };
    };

    /***/
  }),
  /***/851: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var classof = __webpack_require__(6955);
    var getMethod = __webpack_require__(5966);
    var isNullOrUndefined = __webpack_require__(4117);
    var Iterators = __webpack_require__(6269);
    var wellKnownSymbol = __webpack_require__(8227);
    var ITERATOR = wellKnownSymbol('iterator');
    module.exports = function (it) {
      if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
    };

    /***/
  }),
  /***/81: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var tryToString = __webpack_require__(6823);
    var getIteratorMethod = __webpack_require__(851);
    var $TypeError = TypeError;
    module.exports = function (argument, usingIterator) {
      var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
      if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
      throw new $TypeError(tryToString(argument) + ' is not iterable');
    };

    /***/
  }),
  /***/5966: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aCallable = __webpack_require__(9306);
    var isNullOrUndefined = __webpack_require__(4117);

    // `GetMethod` abstract operation
    // https://tc39.es/ecma262/#sec-getmethod
    module.exports = function (V, P) {
      var func = V[P];
      return isNullOrUndefined(func) ? undefined : aCallable(func);
    };

    /***/
  }),
  /***/3789: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var call = __webpack_require__(9565);
    var toIntegerOrInfinity = __webpack_require__(1291);
    var getIteratorDirect = __webpack_require__(1767);
    var INVALID_SIZE = 'Invalid size';
    var $RangeError = RangeError;
    var $TypeError = TypeError;
    var max = Math.max;
    var SetRecord = function SetRecord(set, intSize) {
      this.set = set;
      this.size = max(intSize, 0);
      this.has = aCallable(set.has);
      this.keys = aCallable(set.keys);
    };
    SetRecord.prototype = {
      getIterator: function getIterator() {
        return getIteratorDirect(anObject(call(this.keys, this.set)));
      },
      includes: function includes(it) {
        return call(this.has, this.set, it);
      }
    };

    // `GetSetRecord` abstract operation
    // https://tc39.es/proposal-set-methods/#sec-getsetrecord
    module.exports = function (obj) {
      anObject(obj);
      var numSize = +obj.size;
      // NOTE: If size is undefined, then numSize will be NaN
      // eslint-disable-next-line no-self-compare -- NaN check
      if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
      var intSize = toIntegerOrInfinity(numSize);
      if (intSize < 0) throw new $RangeError(INVALID_SIZE);
      return new SetRecord(obj, intSize);
    };

    /***/
  }),
  /***/4475: ( /***/function _(module) {
    var check = function check(it) {
      return it && it.Math === Math && it;
    };

    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    module.exports =
    // eslint-disable-next-line es/no-global-this -- safe
    check((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) == 'object' && globalThis) || check((typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window) ||
    // eslint-disable-next-line no-restricted-globals -- safe
    check((typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self) || check((typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global) || check(_typeof(this) == 'object' && this) ||
    // eslint-disable-next-line no-new-func -- fallback
    function () {
      return this;
    }() || Function('return this')();

    /***/
  }),
  /***/9297: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var toObject = __webpack_require__(8981);
    var hasOwnProperty = uncurryThis({}.hasOwnProperty);

    // `HasOwnProperty` abstract operation
    // https://tc39.es/ecma262/#sec-hasownproperty
    // eslint-disable-next-line es/no-object-hasown -- safe
    module.exports = Object.hasOwn || function hasOwn(it, key) {
      return hasOwnProperty(toObject(it), key);
    };

    /***/
  }),
  /***/421: ( /***/function _(module) {
    module.exports = {};

    /***/
  }),
  /***/397: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var getBuiltIn = __webpack_require__(7751);
    module.exports = getBuiltIn('document', 'documentElement');

    /***/
  }),
  /***/5917: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var fails = __webpack_require__(9039);
    var createElement = __webpack_require__(4055);

    // Thanks to IE8 for its funny defineProperty
    module.exports = !DESCRIPTORS && !fails(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(createElement('div'), 'a', {
        get: function get() {
          return 7;
        }
      }).a !== 7;
    });

    /***/
  }),
  /***/7055: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var fails = __webpack_require__(9039);
    var classof = __webpack_require__(4576);
    var $Object = Object;
    var split = uncurryThis(''.split);

    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    module.exports = fails(function () {
      // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
      // eslint-disable-next-line no-prototype-builtins -- safe
      return !$Object('z').propertyIsEnumerable(0);
    }) ? function (it) {
      return classof(it) === 'String' ? split(it, '') : $Object(it);
    } : $Object;

    /***/
  }),
  /***/3706: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var isCallable = __webpack_require__(4901);
    var store = __webpack_require__(7629);
    var functionToString = uncurryThis(Function.toString);

    // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
    if (!isCallable(store.inspectSource)) {
      store.inspectSource = function (it) {
        return functionToString(it);
      };
    }
    module.exports = store.inspectSource;

    /***/
  }),
  /***/1181: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var NATIVE_WEAK_MAP = __webpack_require__(8622);
    var global = __webpack_require__(4475);
    var isObject = __webpack_require__(34);
    var createNonEnumerableProperty = __webpack_require__(6699);
    var hasOwn = __webpack_require__(9297);
    var shared = __webpack_require__(7629);
    var sharedKey = __webpack_require__(6119);
    var hiddenKeys = __webpack_require__(421);
    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var TypeError = global.TypeError;
    var WeakMap = global.WeakMap;
    var set, get, has;
    var enforce = function enforce(it) {
      return has(it) ? get(it) : set(it, {});
    };
    var getterFor = function getterFor(TYPE) {
      return function (it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) {
          throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
        }
        return state;
      };
    };
    if (NATIVE_WEAK_MAP || shared.state) {
      var store = shared.state || (shared.state = new WeakMap());
      /* eslint-disable no-self-assign -- prototype methods protection */
      store.get = store.get;
      store.has = store.has;
      store.set = store.set;
      /* eslint-enable no-self-assign -- prototype methods protection */
      set = function set(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
      };
      get = function get(it) {
        return store.get(it) || {};
      };
      has = function has(it) {
        return store.has(it);
      };
    } else {
      var STATE = sharedKey('state');
      hiddenKeys[STATE] = true;
      set = function set(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
      };
      get = function get(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
      };
      has = function has(it) {
        return hasOwn(it, STATE);
      };
    }
    module.exports = {
      set: set,
      get: get,
      has: has,
      enforce: enforce,
      getterFor: getterFor
    };

    /***/
  }),
  /***/4209: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var wellKnownSymbol = __webpack_require__(8227);
    var Iterators = __webpack_require__(6269);
    var ITERATOR = wellKnownSymbol('iterator');
    var ArrayPrototype = Array.prototype;

    // check on default Array iterator
    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
    };

    /***/
  }),
  /***/4376: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var classof = __webpack_require__(4576);

    // `IsArray` abstract operation
    // https://tc39.es/ecma262/#sec-isarray
    // eslint-disable-next-line es/no-array-isarray -- safe
    module.exports = Array.isArray || function isArray(argument) {
      return classof(argument) === 'Array';
    };

    /***/
  }),
  /***/4901: ( /***/function _(module) {
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
    var documentAll = (typeof document === "undefined" ? "undefined" : _typeof(document)) == 'object' && document.all;

    // `IsCallable` abstract operation
    // https://tc39.es/ecma262/#sec-iscallable
    // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
    module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
      return typeof argument == 'function' || argument === documentAll;
    } : function (argument) {
      return typeof argument == 'function';
    };

    /***/
  }),
  /***/2796: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var fails = __webpack_require__(9039);
    var isCallable = __webpack_require__(4901);
    var replacement = /#|\.prototype\./;
    var isForced = function isForced(feature, detection) {
      var value = data[normalize(feature)];
      return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
    };
    var normalize = isForced.normalize = function (string) {
      return String(string).replace(replacement, '.').toLowerCase();
    };
    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';
    module.exports = isForced;

    /***/
  }),
  /***/4117: ( /***/function _(module) {
    // we can't use just `it == null` since of `document.all` special case
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
    module.exports = function (it) {
      return it === null || it === undefined;
    };

    /***/
  }),
  /***/34: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isCallable = __webpack_require__(4901);
    module.exports = function (it) {
      return _typeof(it) == 'object' ? it !== null : isCallable(it);
    };

    /***/
  }),
  /***/6395: ( /***/function _(module) {
    module.exports = false;

    /***/
  }),
  /***/757: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var getBuiltIn = __webpack_require__(7751);
    var isCallable = __webpack_require__(4901);
    var isPrototypeOf = __webpack_require__(1625);
    var USE_SYMBOL_AS_UID = __webpack_require__(7040);
    var $Object = Object;
    module.exports = USE_SYMBOL_AS_UID ? function (it) {
      return _typeof(it) == 'symbol';
    } : function (it) {
      var $Symbol = getBuiltIn('Symbol');
      return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
    };

    /***/
  }),
  /***/507: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
      var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
      var next = record.next;
      var step, result;
      while (!(step = call(next, iterator)).done) {
        result = fn(step.value);
        if (result !== undefined) return result;
      }
    };

    /***/
  }),
  /***/2652: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var bind = __webpack_require__(6080);
    var call = __webpack_require__(9565);
    var anObject = __webpack_require__(8551);
    var tryToString = __webpack_require__(6823);
    var isArrayIteratorMethod = __webpack_require__(4209);
    var lengthOfArrayLike = __webpack_require__(6198);
    var isPrototypeOf = __webpack_require__(1625);
    var getIterator = __webpack_require__(81);
    var getIteratorMethod = __webpack_require__(851);
    var iteratorClose = __webpack_require__(9539);
    var $TypeError = TypeError;
    var Result = function Result(stopped, result) {
      this.stopped = stopped;
      this.result = result;
    };
    var ResultPrototype = Result.prototype;
    module.exports = function (iterable, unboundFunction, options) {
      var that = options && options.that;
      var AS_ENTRIES = !!(options && options.AS_ENTRIES);
      var IS_RECORD = !!(options && options.IS_RECORD);
      var IS_ITERATOR = !!(options && options.IS_ITERATOR);
      var INTERRUPTED = !!(options && options.INTERRUPTED);
      var fn = bind(unboundFunction, that);
      var iterator, iterFn, index, length, result, next, step;
      var stop = function stop(condition) {
        if (iterator) iteratorClose(iterator, 'normal', condition);
        return new Result(true, condition);
      };
      var callFn = function callFn(value) {
        if (AS_ENTRIES) {
          anObject(value);
          return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
      };
      if (IS_RECORD) {
        iterator = iterable.iterator;
      } else if (IS_ITERATOR) {
        iterator = iterable;
      } else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
          for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
            result = callFn(iterable[index]);
            if (result && isPrototypeOf(ResultPrototype, result)) return result;
          }
          return new Result(false);
        }
        iterator = getIterator(iterable, iterFn);
      }
      next = IS_RECORD ? iterable.next : iterator.next;
      while (!(step = call(next, iterator)).done) {
        try {
          result = callFn(step.value);
        } catch (error) {
          iteratorClose(iterator, 'throw', error);
        }
        if (_typeof(result) == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
      }
      return new Result(false);
    };

    /***/
  }),
  /***/9539: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var anObject = __webpack_require__(8551);
    var getMethod = __webpack_require__(5966);
    module.exports = function (iterator, kind, value) {
      var innerResult, innerError;
      anObject(iterator);
      try {
        innerResult = getMethod(iterator, 'return');
        if (!innerResult) {
          if (kind === 'throw') throw value;
          return value;
        }
        innerResult = call(innerResult, iterator);
      } catch (error) {
        innerError = true;
        innerResult = error;
      }
      if (kind === 'throw') throw value;
      if (innerError) throw innerResult;
      anObject(innerResult);
      return value;
    };

    /***/
  }),
  /***/9462: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var create = __webpack_require__(2360);
    var createNonEnumerableProperty = __webpack_require__(6699);
    var defineBuiltIns = __webpack_require__(6279);
    var wellKnownSymbol = __webpack_require__(8227);
    var InternalStateModule = __webpack_require__(1181);
    var getMethod = __webpack_require__(5966);
    var IteratorPrototype = __webpack_require__(7657).IteratorPrototype;
    var createIterResultObject = __webpack_require__(2529);
    var iteratorClose = __webpack_require__(9539);
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var ITERATOR_HELPER = 'IteratorHelper';
    var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
    var setInternalState = InternalStateModule.set;
    var createIteratorProxyPrototype = function createIteratorProxyPrototype(IS_ITERATOR) {
      var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
      return defineBuiltIns(create(IteratorPrototype), {
        next: function next() {
          var state = getInternalState(this);
          // for simplification:
          //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
          //   for `%IteratorHelperPrototype%.next` - just a value
          if (IS_ITERATOR) return state.nextHandler();
          try {
            var result = state.done ? undefined : state.nextHandler();
            return createIterResultObject(result, state.done);
          } catch (error) {
            state.done = true;
            throw error;
          }
        },
        'return': function _return() {
          var state = getInternalState(this);
          var iterator = state.iterator;
          state.done = true;
          if (IS_ITERATOR) {
            var returnMethod = getMethod(iterator, 'return');
            return returnMethod ? call(returnMethod, iterator) : createIterResultObject(undefined, true);
          }
          if (state.inner) try {
            iteratorClose(state.inner.iterator, 'normal');
          } catch (error) {
            return iteratorClose(iterator, 'throw', error);
          }
          iteratorClose(iterator, 'normal');
          return createIterResultObject(undefined, true);
        }
      });
    };
    var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
    var IteratorHelperPrototype = createIteratorProxyPrototype(false);
    createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
    module.exports = function (nextHandler, IS_ITERATOR) {
      var IteratorProxy = function Iterator(record, state) {
        if (state) {
          state.iterator = record.iterator;
          state.next = record.next;
        } else state = record;
        state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
        state.nextHandler = nextHandler;
        state.counter = 0;
        state.done = false;
        setInternalState(this, state);
      };
      IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
      return IteratorProxy;
    };

    /***/
  }),
  /***/713: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var getIteratorDirect = __webpack_require__(1767);
    var createIteratorProxy = __webpack_require__(9462);
    var callWithSafeIterationClosing = __webpack_require__(6319);
    var IteratorProxy = createIteratorProxy(function () {
      var iterator = this.iterator;
      var result = anObject(call(this.next, iterator));
      var done = this.done = !!result.done;
      if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
    });

    // `Iterator.prototype.map` method
    // https://github.com/tc39/proposal-iterator-helpers
    module.exports = function map(mapper) {
      anObject(this);
      aCallable(mapper);
      return new IteratorProxy(getIteratorDirect(this), {
        mapper: mapper
      });
    };

    /***/
  }),
  /***/7657: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var fails = __webpack_require__(9039);
    var isCallable = __webpack_require__(4901);
    var isObject = __webpack_require__(34);
    var create = __webpack_require__(2360);
    var getPrototypeOf = __webpack_require__(2787);
    var defineBuiltIn = __webpack_require__(6840);
    var wellKnownSymbol = __webpack_require__(8227);
    var IS_PURE = __webpack_require__(6395);
    var ITERATOR = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS = false;

    // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

    /* eslint-disable es/no-array-prototype-keys -- safe */
    if ([].keys) {
      arrayIterator = [].keys();
      // Safari 8 has buggy iterators w/o `next`
      if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
      }
    }
    var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
      var test = {};
      // FF44- legacy iterators case
      return IteratorPrototype[ITERATOR].call(test) !== test;
    });
    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

    // `%IteratorPrototype%[@@iterator]()` method
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
    if (!isCallable(IteratorPrototype[ITERATOR])) {
      defineBuiltIn(IteratorPrototype, ITERATOR, function () {
        return this;
      });
    }
    module.exports = {
      IteratorPrototype: IteratorPrototype,
      BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
    };

    /***/
  }),
  /***/6269: ( /***/function _(module) {
    module.exports = {};

    /***/
  }),
  /***/6198: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var toLength = __webpack_require__(8014);

    // `LengthOfArrayLike` abstract operation
    // https://tc39.es/ecma262/#sec-lengthofarraylike
    module.exports = function (obj) {
      return toLength(obj.length);
    };

    /***/
  }),
  /***/283: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var fails = __webpack_require__(9039);
    var isCallable = __webpack_require__(4901);
    var hasOwn = __webpack_require__(9297);
    var DESCRIPTORS = __webpack_require__(3724);
    var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(350).CONFIGURABLE;
    var inspectSource = __webpack_require__(3706);
    var InternalStateModule = __webpack_require__(1181);
    var enforceInternalState = InternalStateModule.enforce;
    var getInternalState = InternalStateModule.get;
    var $String = String;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty = Object.defineProperty;
    var stringSlice = uncurryThis(''.slice);
    var replace = uncurryThis(''.replace);
    var join = uncurryThis([].join);
    var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
      return defineProperty(function () {/* empty */}, 'length', {
        value: 8
      }).length !== 8;
    });
    var TEMPLATE = String(String).split('String');
    var makeBuiltIn = module.exports = function (value, name, options) {
      if (stringSlice($String(name), 0, 7) === 'Symbol(') {
        name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
      }
      if (options && options.getter) name = 'get ' + name;
      if (options && options.setter) name = 'set ' + name;
      if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS) defineProperty(value, 'name', {
          value: name,
          configurable: true
        });else value.name = name;
      }
      if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
        defineProperty(value, 'length', {
          value: options.arity
        });
      }
      try {
        if (options && hasOwn(options, 'constructor') && options.constructor) {
          if (DESCRIPTORS) defineProperty(value, 'prototype', {
            writable: false
          });
          // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
        } else if (value.prototype) value.prototype = undefined;
      } catch (error) {/* empty */}
      var state = enforceInternalState(value);
      if (!hasOwn(state, 'source')) {
        state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
      }
      return value;
    };

    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    // eslint-disable-next-line no-extend-native -- required
    Function.prototype.toString = makeBuiltIn(function toString() {
      return isCallable(this) && getInternalState(this).source || inspectSource(this);
    }, 'toString');

    /***/
  }),
  /***/741: ( /***/function _(module) {
    var ceil = Math.ceil;
    var floor = Math.floor;

    // `Math.trunc` method
    // https://tc39.es/ecma262/#sec-math.trunc
    // eslint-disable-next-line es/no-math-trunc -- safe
    module.exports = Math.trunc || function trunc(x) {
      var n = +x;
      return (n > 0 ? floor : ceil)(n);
    };

    /***/
  }),
  /***/6043: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aCallable = __webpack_require__(9306);
    var $TypeError = TypeError;
    var PromiseCapability = function PromiseCapability(C) {
      var resolve, reject;
      this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aCallable(resolve);
      this.reject = aCallable(reject);
    };

    // `NewPromiseCapability` abstract operation
    // https://tc39.es/ecma262/#sec-newpromisecapability
    module.exports.f = function (C) {
      return new PromiseCapability(C);
    };

    /***/
  }),
  /***/2360: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    /* global ActiveXObject -- old IE, WSH */
    var anObject = __webpack_require__(8551);
    var definePropertiesModule = __webpack_require__(6801);
    var enumBugKeys = __webpack_require__(8727);
    var hiddenKeys = __webpack_require__(421);
    var html = __webpack_require__(397);
    var documentCreateElement = __webpack_require__(4055);
    var sharedKey = __webpack_require__(6119);
    var GT = '>';
    var LT = '<';
    var PROTOTYPE = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');
    var EmptyConstructor = function EmptyConstructor() {/* empty */};
    var scriptTag = function scriptTag(content) {
      return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };

    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
      activeXDocument.write(scriptTag(''));
      activeXDocument.close();
      var temp = activeXDocument.parentWindow.Object;
      activeXDocument = null; // avoid memory leak
      return temp;
    };

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = documentCreateElement('iframe');
      var JS = 'java' + SCRIPT + ':';
      var iframeDocument;
      iframe.style.display = 'none';
      html.appendChild(iframe);
      // https://github.com/zloirock/core-js/issues/475
      iframe.src = String(JS);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(scriptTag('document.F=Object'));
      iframeDocument.close();
      return iframeDocument.F;
    };

    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var _NullProtoObject = function NullProtoObject() {
      try {
        activeXDocument = new ActiveXObject('htmlfile');
      } catch (error) {/* ignore */}
      _NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
      var length = enumBugKeys.length;
      while (length--) delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
      return _NullProtoObject();
    };
    hiddenKeys[IE_PROTO] = true;

    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    // eslint-disable-next-line es/no-object-create -- safe
    module.exports = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = _NullProtoObject();
      return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
    };

    /***/
  }),
  /***/6801: ( /***/function _(__unused_webpack_module, exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
    var definePropertyModule = __webpack_require__(4913);
    var anObject = __webpack_require__(8551);
    var toIndexedObject = __webpack_require__(5397);
    var objectKeys = __webpack_require__(1072);

    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var props = toIndexedObject(Properties);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
      return O;
    };

    /***/
  }),
  /***/4913: ( /***/function _(__unused_webpack_module, exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var IE8_DOM_DEFINE = __webpack_require__(5917);
    var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
    var anObject = __webpack_require__(8551);
    var toPropertyKey = __webpack_require__(6969);
    var $TypeError = TypeError;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var $defineProperty = Object.defineProperty;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = 'enumerable';
    var CONFIGURABLE = 'configurable';
    var WRITABLE = 'writable';

    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPropertyKey(P);
      anObject(Attributes);
      if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
          O[P] = Attributes.value;
          Attributes = {
            configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
            enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
            writable: false
          };
        }
      }
      return $defineProperty(O, P, Attributes);
    } : $defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPropertyKey(P);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
      } catch (error) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    /***/
  }),
  /***/7347: ( /***/function _(__unused_webpack_module, exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var call = __webpack_require__(9565);
    var propertyIsEnumerableModule = __webpack_require__(8773);
    var createPropertyDescriptor = __webpack_require__(6980);
    var toIndexedObject = __webpack_require__(5397);
    var toPropertyKey = __webpack_require__(6969);
    var hasOwn = __webpack_require__(9297);
    var IE8_DOM_DEFINE = __webpack_require__(5917);

    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject(O);
      P = toPropertyKey(P);
      if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
      } catch (error) {/* empty */}
      if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
    };

    /***/
  }),
  /***/8480: ( /***/function _(__unused_webpack_module, exports, __webpack_require__) {
    var internalObjectKeys = __webpack_require__(1828);
    var enumBugKeys = __webpack_require__(8727);
    var hiddenKeys = enumBugKeys.concat('length', 'prototype');

    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe
    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return internalObjectKeys(O, hiddenKeys);
    };

    /***/
  }),
  /***/3717: ( /***/function _(__unused_webpack_module, exports) {
    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    exports.f = Object.getOwnPropertySymbols;

    /***/
  }),
  /***/2787: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var hasOwn = __webpack_require__(9297);
    var isCallable = __webpack_require__(4901);
    var toObject = __webpack_require__(8981);
    var sharedKey = __webpack_require__(6119);
    var CORRECT_PROTOTYPE_GETTER = __webpack_require__(2211);
    var IE_PROTO = sharedKey('IE_PROTO');
    var $Object = Object;
    var ObjectPrototype = $Object.prototype;

    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    // eslint-disable-next-line es/no-object-getprototypeof -- safe
    module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
      var object = toObject(O);
      if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
      var constructor = object.constructor;
      if (isCallable(constructor) && object instanceof constructor) {
        return constructor.prototype;
      }
      return object instanceof $Object ? ObjectPrototype : null;
    };

    /***/
  }),
  /***/1625: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    module.exports = uncurryThis({}.isPrototypeOf);

    /***/
  }),
  /***/1828: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var hasOwn = __webpack_require__(9297);
    var toIndexedObject = __webpack_require__(5397);
    var indexOf = __webpack_require__(9617).indexOf;
    var hiddenKeys = __webpack_require__(421);
    var push = uncurryThis([].push);
    module.exports = function (object, names) {
      var O = toIndexedObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
      // Don't enum bug & hidden keys
      while (names.length > i) if (hasOwn(O, key = names[i++])) {
        ~indexOf(result, key) || push(result, key);
      }
      return result;
    };

    /***/
  }),
  /***/1072: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var internalObjectKeys = __webpack_require__(1828);
    var enumBugKeys = __webpack_require__(8727);

    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe
    module.exports = Object.keys || function keys(O) {
      return internalObjectKeys(O, enumBugKeys);
    };

    /***/
  }),
  /***/8773: ( /***/function _(__unused_webpack_module, exports) {
    var $propertyIsEnumerable = {}.propertyIsEnumerable;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
      1: 2
    }, 1);

    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
    exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor(this, V);
      return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;

    /***/
  }),
  /***/4270: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var isCallable = __webpack_require__(4901);
    var isObject = __webpack_require__(34);
    var $TypeError = TypeError;

    // `OrdinaryToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-ordinarytoprimitive
    module.exports = function (input, pref) {
      var fn, val;
      if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
      if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
      if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
      throw new $TypeError("Can't convert object to primitive value");
    };

    /***/
  }),
  /***/5031: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var getBuiltIn = __webpack_require__(7751);
    var uncurryThis = __webpack_require__(9504);
    var getOwnPropertyNamesModule = __webpack_require__(8480);
    var getOwnPropertySymbolsModule = __webpack_require__(3717);
    var anObject = __webpack_require__(8551);
    var concat = uncurryThis([].concat);

    // all object keys, includes non-enumerable and symbols
    module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
      var keys = getOwnPropertyNamesModule.f(anObject(it));
      var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
      return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
    };

    /***/
  }),
  /***/8235: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var hasOwn = __webpack_require__(9297);
    var $SyntaxError = SyntaxError;
    var $parseInt = parseInt;
    var fromCharCode = String.fromCharCode;
    var at = uncurryThis(''.charAt);
    var slice = uncurryThis(''.slice);
    var exec = uncurryThis(/./.exec);
    var codePoints = {
      '\\"': '"',
      '\\\\': '\\',
      '\\/': '/',
      '\\b': '\b',
      '\\f': '\f',
      '\\n': '\n',
      '\\r': '\r',
      '\\t': '\t'
    };
    var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
    // eslint-disable-next-line regexp/no-control-character -- safe
    var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
    module.exports = function (source, i) {
      var unterminated = true;
      var value = '';
      while (i < source.length) {
        var chr = at(source, i);
        if (chr === '\\') {
          var twoChars = slice(source, i, i + 2);
          if (hasOwn(codePoints, twoChars)) {
            value += codePoints[twoChars];
            i += 2;
          } else if (twoChars === "\\u") {
            i += 2;
            var fourHexDigits = slice(source, i, i + 4);
            if (!exec(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
            value += fromCharCode($parseInt(fourHexDigits, 16));
            i += 4;
          } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
        } else if (chr === '"') {
          unterminated = false;
          i++;
          break;
        } else {
          if (exec(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
          value += chr;
          i++;
        }
      }
      if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
      return {
        value: value,
        end: i
      };
    };

    /***/
  }),
  /***/7750: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var isNullOrUndefined = __webpack_require__(4117);
    var $TypeError = TypeError;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    module.exports = function (it) {
      if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
      return it;
    };

    /***/
  }),
  /***/9286: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var SetHelpers = __webpack_require__(4402);
    var iterate = __webpack_require__(8469);
    var Set = SetHelpers.Set;
    var add = SetHelpers.add;
    module.exports = function (set) {
      var result = new Set();
      iterate(set, function (it) {
        add(result, it);
      });
      return result;
    };

    /***/
  }),
  /***/3440: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var SetHelpers = __webpack_require__(4402);
    var clone = __webpack_require__(9286);
    var size = __webpack_require__(5170);
    var getSetRecord = __webpack_require__(3789);
    var iterateSet = __webpack_require__(8469);
    var iterateSimple = __webpack_require__(507);
    var has = SetHelpers.has;
    var remove = SetHelpers.remove;

    // `Set.prototype.difference` method
    // https://github.com/tc39/proposal-set-methods
    module.exports = function difference(other) {
      var O = aSet(this);
      var otherRec = getSetRecord(other);
      var result = clone(O);
      if (size(O) <= otherRec.size) iterateSet(O, function (e) {
        if (otherRec.includes(e)) remove(result, e);
      });else iterateSimple(otherRec.getIterator(), function (e) {
        if (has(O, e)) remove(result, e);
      });
      return result;
    };

    /***/
  }),
  /***/4402: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);

    // eslint-disable-next-line es/no-set -- safe
    var SetPrototype = Set.prototype;
    module.exports = {
      // eslint-disable-next-line es/no-set -- safe
      Set: Set,
      add: uncurryThis(SetPrototype.add),
      has: uncurryThis(SetPrototype.has),
      remove: uncurryThis(SetPrototype['delete']),
      proto: SetPrototype
    };

    /***/
  }),
  /***/8750: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var SetHelpers = __webpack_require__(4402);
    var size = __webpack_require__(5170);
    var getSetRecord = __webpack_require__(3789);
    var iterateSet = __webpack_require__(8469);
    var iterateSimple = __webpack_require__(507);
    var Set = SetHelpers.Set;
    var add = SetHelpers.add;
    var has = SetHelpers.has;

    // `Set.prototype.intersection` method
    // https://github.com/tc39/proposal-set-methods
    module.exports = function intersection(other) {
      var O = aSet(this);
      var otherRec = getSetRecord(other);
      var result = new Set();
      if (size(O) > otherRec.size) {
        iterateSimple(otherRec.getIterator(), function (e) {
          if (has(O, e)) add(result, e);
        });
      } else {
        iterateSet(O, function (e) {
          if (otherRec.includes(e)) add(result, e);
        });
      }
      return result;
    };

    /***/
  }),
  /***/4449: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var has = __webpack_require__(4402).has;
    var size = __webpack_require__(5170);
    var getSetRecord = __webpack_require__(3789);
    var iterateSet = __webpack_require__(8469);
    var iterateSimple = __webpack_require__(507);
    var iteratorClose = __webpack_require__(9539);

    // `Set.prototype.isDisjointFrom` method
    // https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
    module.exports = function isDisjointFrom(other) {
      var O = aSet(this);
      var otherRec = getSetRecord(other);
      if (size(O) <= otherRec.size) return iterateSet(O, function (e) {
        if (otherRec.includes(e)) return false;
      }, true) !== false;
      var iterator = otherRec.getIterator();
      return iterateSimple(iterator, function (e) {
        if (has(O, e)) return iteratorClose(iterator, 'normal', false);
      }) !== false;
    };

    /***/
  }),
  /***/3838: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var size = __webpack_require__(5170);
    var iterate = __webpack_require__(8469);
    var getSetRecord = __webpack_require__(3789);

    // `Set.prototype.isSubsetOf` method
    // https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
    module.exports = function isSubsetOf(other) {
      var O = aSet(this);
      var otherRec = getSetRecord(other);
      if (size(O) > otherRec.size) return false;
      return iterate(O, function (e) {
        if (!otherRec.includes(e)) return false;
      }, true) !== false;
    };

    /***/
  }),
  /***/8527: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var has = __webpack_require__(4402).has;
    var size = __webpack_require__(5170);
    var getSetRecord = __webpack_require__(3789);
    var iterateSimple = __webpack_require__(507);
    var iteratorClose = __webpack_require__(9539);

    // `Set.prototype.isSupersetOf` method
    // https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
    module.exports = function isSupersetOf(other) {
      var O = aSet(this);
      var otherRec = getSetRecord(other);
      if (size(O) < otherRec.size) return false;
      var iterator = otherRec.getIterator();
      return iterateSimple(iterator, function (e) {
        if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
      }) !== false;
    };

    /***/
  }),
  /***/8469: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var iterateSimple = __webpack_require__(507);
    var SetHelpers = __webpack_require__(4402);
    var Set = SetHelpers.Set;
    var SetPrototype = SetHelpers.proto;
    var forEach = uncurryThis(SetPrototype.forEach);
    var keys = uncurryThis(SetPrototype.keys);
    var next = keys(new Set()).next;
    module.exports = function (set, fn, interruptible) {
      return interruptible ? iterateSimple({
        iterator: keys(set),
        next: next
      }, fn) : forEach(set, fn);
    };

    /***/
  }),
  /***/4916: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var getBuiltIn = __webpack_require__(7751);
    var createSetLike = function createSetLike(size) {
      return {
        size: size,
        has: function has() {
          return false;
        },
        keys: function keys() {
          return {
            next: function next() {
              return {
                done: true
              };
            }
          };
        }
      };
    };
    module.exports = function (name) {
      var Set = getBuiltIn('Set');
      try {
        new Set()[name](createSetLike(0));
        try {
          // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
          // https://github.com/tc39/proposal-set-methods/pull/88
          new Set()[name](createSetLike(-1));
          return false;
        } catch (error2) {
          return true;
        }
      } catch (error) {
        return false;
      }
    };

    /***/
  }),
  /***/5170: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThisAccessor = __webpack_require__(6706);
    var SetHelpers = __webpack_require__(4402);
    module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
      return set.size;
    };

    /***/
  }),
  /***/3650: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var SetHelpers = __webpack_require__(4402);
    var clone = __webpack_require__(9286);
    var getSetRecord = __webpack_require__(3789);
    var iterateSimple = __webpack_require__(507);
    var add = SetHelpers.add;
    var has = SetHelpers.has;
    var remove = SetHelpers.remove;

    // `Set.prototype.symmetricDifference` method
    // https://github.com/tc39/proposal-set-methods
    module.exports = function symmetricDifference(other) {
      var O = aSet(this);
      var keysIter = getSetRecord(other).getIterator();
      var result = clone(O);
      iterateSimple(keysIter, function (e) {
        if (has(O, e)) remove(result, e);else add(result, e);
      });
      return result;
    };

    /***/
  }),
  /***/4204: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var aSet = __webpack_require__(7080);
    var add = __webpack_require__(4402).add;
    var clone = __webpack_require__(9286);
    var getSetRecord = __webpack_require__(3789);
    var iterateSimple = __webpack_require__(507);

    // `Set.prototype.union` method
    // https://github.com/tc39/proposal-set-methods
    module.exports = function union(other) {
      var O = aSet(this);
      var keysIter = getSetRecord(other).getIterator();
      var result = clone(O);
      iterateSimple(keysIter, function (it) {
        add(result, it);
      });
      return result;
    };

    /***/
  }),
  /***/6119: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var shared = __webpack_require__(5745);
    var uid = __webpack_require__(3392);
    var keys = shared('keys');
    module.exports = function (key) {
      return keys[key] || (keys[key] = uid(key));
    };

    /***/
  }),
  /***/7629: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var IS_PURE = __webpack_require__(6395);
    var globalThis = __webpack_require__(4475);
    var defineGlobalProperty = __webpack_require__(9433);
    var SHARED = '__core-js_shared__';
    var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
    (store.versions || (store.versions = [])).push({
      version: '3.37.1',
      mode: IS_PURE ? 'pure' : 'global',
      copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
      license: 'https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE',
      source: 'https://github.com/zloirock/core-js'
    });

    /***/
  }),
  /***/5745: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var store = __webpack_require__(7629);
    module.exports = function (key, value) {
      return store[key] || (store[key] = value || {});
    };

    /***/
  }),
  /***/4495: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    /* eslint-disable es/no-symbol -- required for testing */
    var V8_VERSION = __webpack_require__(7388);
    var fails = __webpack_require__(9039);
    var global = __webpack_require__(4475);
    var $String = global.String;

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
    module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
      var symbol = Symbol('symbol detection');
      // Chrome 38 Symbol has incorrect toString conversion
      // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
      // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
      // of course, fail.
      return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
      // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
      !Symbol.sham && V8_VERSION && V8_VERSION < 41;
    });

    /***/
  }),
  /***/5610: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var toIntegerOrInfinity = __webpack_require__(1291);
    var max = Math.max;
    var min = Math.min;

    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    module.exports = function (index, length) {
      var integer = toIntegerOrInfinity(index);
      return integer < 0 ? max(integer + length, 0) : min(integer, length);
    };

    /***/
  }),
  /***/5397: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject = __webpack_require__(7055);
    var requireObjectCoercible = __webpack_require__(7750);
    module.exports = function (it) {
      return IndexedObject(requireObjectCoercible(it));
    };

    /***/
  }),
  /***/1291: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var trunc = __webpack_require__(741);

    // `ToIntegerOrInfinity` abstract operation
    // https://tc39.es/ecma262/#sec-tointegerorinfinity
    module.exports = function (argument) {
      var number = +argument;
      // eslint-disable-next-line no-self-compare -- NaN check
      return number !== number || number === 0 ? 0 : trunc(number);
    };

    /***/
  }),
  /***/8014: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var toIntegerOrInfinity = __webpack_require__(1291);
    var min = Math.min;

    // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength
    module.exports = function (argument) {
      var len = toIntegerOrInfinity(argument);
      return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    /***/
  }),
  /***/8981: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var requireObjectCoercible = __webpack_require__(7750);
    var $Object = Object;

    // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject
    module.exports = function (argument) {
      return $Object(requireObjectCoercible(argument));
    };

    /***/
  }),
  /***/2777: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var call = __webpack_require__(9565);
    var isObject = __webpack_require__(34);
    var isSymbol = __webpack_require__(757);
    var getMethod = __webpack_require__(5966);
    var ordinaryToPrimitive = __webpack_require__(4270);
    var wellKnownSymbol = __webpack_require__(8227);
    var $TypeError = TypeError;
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

    // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive
    module.exports = function (input, pref) {
      if (!isObject(input) || isSymbol(input)) return input;
      var exoticToPrim = getMethod(input, TO_PRIMITIVE);
      var result;
      if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
      }
      if (pref === undefined) pref = 'number';
      return ordinaryToPrimitive(input, pref);
    };

    /***/
  }),
  /***/6969: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var toPrimitive = __webpack_require__(2777);
    var isSymbol = __webpack_require__(757);

    // `ToPropertyKey` abstract operation
    // https://tc39.es/ecma262/#sec-topropertykey
    module.exports = function (argument) {
      var key = toPrimitive(argument, 'string');
      return isSymbol(key) ? key : key + '';
    };

    /***/
  }),
  /***/2140: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var wellKnownSymbol = __webpack_require__(8227);
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var test = {};
    test[TO_STRING_TAG] = 'z';
    module.exports = String(test) === '[object z]';

    /***/
  }),
  /***/655: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var classof = __webpack_require__(6955);
    var $String = String;
    module.exports = function (argument) {
      if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
      return $String(argument);
    };

    /***/
  }),
  /***/6823: ( /***/function _(module) {
    var $String = String;
    module.exports = function (argument) {
      try {
        return $String(argument);
      } catch (error) {
        return 'Object';
      }
    };

    /***/
  }),
  /***/3392: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var uncurryThis = __webpack_require__(9504);
    var id = 0;
    var postfix = Math.random();
    var toString = uncurryThis(1.0.toString);
    module.exports = function (key) {
      return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
    };

    /***/
  }),
  /***/7040: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    /* eslint-disable es/no-symbol -- required for testing */
    var NATIVE_SYMBOL = __webpack_require__(4495);
    module.exports = NATIVE_SYMBOL && !Symbol.sham && _typeof(Symbol.iterator) == 'symbol';

    /***/
  }),
  /***/8686: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var fails = __webpack_require__(9039);

    // V8 ~ Chrome 36-
    // https://bugs.chromium.org/p/v8/issues/detail?id=3334
    module.exports = DESCRIPTORS && fails(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(function () {/* empty */}, 'prototype', {
        value: 42,
        writable: false
      }).prototype !== 42;
    });

    /***/
  }),
  /***/2812: ( /***/function _(module) {
    var $TypeError = TypeError;
    module.exports = function (passed, required) {
      if (passed < required) throw new $TypeError('Not enough arguments');
      return passed;
    };

    /***/
  }),
  /***/8622: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var isCallable = __webpack_require__(4901);
    var WeakMap = global.WeakMap;
    module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

    /***/
  }),
  /***/8227: ( /***/function _(module, __unused_webpack_exports, __webpack_require__) {
    var global = __webpack_require__(4475);
    var shared = __webpack_require__(5745);
    var hasOwn = __webpack_require__(9297);
    var uid = __webpack_require__(3392);
    var NATIVE_SYMBOL = __webpack_require__(4495);
    var USE_SYMBOL_AS_UID = __webpack_require__(7040);
    var _Symbol = global.Symbol;
    var WellKnownSymbolsStore = shared('wks');
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? _Symbol['for'] || _Symbol : _Symbol && _Symbol.withoutSetter || uid;
    module.exports = function (name) {
      if (!hasOwn(WellKnownSymbolsStore, name)) {
        WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(_Symbol, name) ? _Symbol[name] : createWellKnownSymbol('Symbol.' + name);
      }
      return WellKnownSymbolsStore[name];
    };

    /***/
  }),
  /***/4114: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var toObject = __webpack_require__(8981);
    var lengthOfArrayLike = __webpack_require__(6198);
    var setArrayLength = __webpack_require__(4527);
    var doesNotExceedSafeInteger = __webpack_require__(6837);
    var fails = __webpack_require__(9039);
    var INCORRECT_TO_LENGTH = fails(function () {
      return [].push.call({
        length: 0x100000000
      }, 1) !== 4294967297;
    });

    // V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
    // https://bugs.chromium.org/p/v8/issues/detail?id=12681
    var properErrorOnNonWritableLength = function properErrorOnNonWritableLength() {
      try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
          writable: false
        }).push();
      } catch (error) {
        return error instanceof TypeError;
      }
    };
    var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

    // `Array.prototype.push` method
    // https://tc39.es/ecma262/#sec-array.prototype.push
    $({
      target: 'Array',
      proto: true,
      arity: 1,
      forced: FORCED
    }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      push: function push(item) {
        var O = toObject(this);
        var len = lengthOfArrayLike(O);
        var argCount = arguments.length;
        doesNotExceedSafeInteger(len + argCount);
        for (var i = 0; i < argCount; i++) {
          O[len] = arguments[i];
          len++;
        }
        setArrayLength(O, len);
        return len;
      }
    });

    /***/
  }),
  /***/4628: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var newPromiseCapabilityModule = __webpack_require__(6043);

    // `Promise.withResolvers` method
    // https://github.com/tc39/proposal-promise-with-resolvers
    $({
      target: 'Promise',
      stat: true
    }, {
      withResolvers: function withResolvers() {
        var promiseCapability = newPromiseCapabilityModule.f(this);
        return {
          promise: promiseCapability.promise,
          resolve: promiseCapability.resolve,
          reject: promiseCapability.reject
        };
      }
    });

    /***/
  }),
  /***/7642: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var difference = __webpack_require__(3440);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.difference` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('difference')
    }, {
      difference: difference
    });

    /***/
  }),
  /***/8004: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var fails = __webpack_require__(9039);
    var intersection = __webpack_require__(8750);
    var setMethodAcceptSetLike = __webpack_require__(4916);
    var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
      // eslint-disable-next-line es/no-array-from, es/no-set -- testing
      return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
    });

    // `Set.prototype.intersection` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: INCORRECT
    }, {
      intersection: intersection
    });

    /***/
  }),
  /***/3853: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var isDisjointFrom = __webpack_require__(4449);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.isDisjointFrom` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('isDisjointFrom')
    }, {
      isDisjointFrom: isDisjointFrom
    });

    /***/
  }),
  /***/5876: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var isSubsetOf = __webpack_require__(3838);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.isSubsetOf` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('isSubsetOf')
    }, {
      isSubsetOf: isSubsetOf
    });

    /***/
  }),
  /***/2475: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var isSupersetOf = __webpack_require__(8527);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.isSupersetOf` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('isSupersetOf')
    }, {
      isSupersetOf: isSupersetOf
    });

    /***/
  }),
  /***/5024: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var symmetricDifference = __webpack_require__(3650);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.symmetricDifference` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('symmetricDifference')
    }, {
      symmetricDifference: symmetricDifference
    });

    /***/
  }),
  /***/1698: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var union = __webpack_require__(4204);
    var setMethodAcceptSetLike = __webpack_require__(4916);

    // `Set.prototype.union` method
    // https://github.com/tc39/proposal-set-methods
    $({
      target: 'Set',
      proto: true,
      real: true,
      forced: !setMethodAcceptSetLike('union')
    }, {
      union: union
    });

    /***/
  }),
  /***/8992: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var global = __webpack_require__(4475);
    var anInstance = __webpack_require__(679);
    var anObject = __webpack_require__(8551);
    var isCallable = __webpack_require__(4901);
    var getPrototypeOf = __webpack_require__(2787);
    var defineBuiltInAccessor = __webpack_require__(2106);
    var createProperty = __webpack_require__(4659);
    var fails = __webpack_require__(9039);
    var hasOwn = __webpack_require__(9297);
    var wellKnownSymbol = __webpack_require__(8227);
    var IteratorPrototype = __webpack_require__(7657).IteratorPrototype;
    var DESCRIPTORS = __webpack_require__(3724);
    var IS_PURE = __webpack_require__(6395);
    var CONSTRUCTOR = 'constructor';
    var ITERATOR = 'Iterator';
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var $TypeError = TypeError;
    var NativeIterator = global[ITERATOR];

    // FF56- have non-standard global helper `Iterator`
    var FORCED = IS_PURE || !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype
    // FF44- non-standard `Iterator` passes previous tests
    || !fails(function () {
      NativeIterator({});
    });
    var IteratorConstructor = function Iterator() {
      anInstance(this, IteratorPrototype);
      if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError('Abstract class Iterator not directly constructable');
    };
    var defineIteratorPrototypeAccessor = function defineIteratorPrototypeAccessor(key, value) {
      if (DESCRIPTORS) {
        defineBuiltInAccessor(IteratorPrototype, key, {
          configurable: true,
          get: function get() {
            return value;
          },
          set: function set(replacement) {
            anObject(this);
            if (this === IteratorPrototype) throw new $TypeError("You can't redefine this property");
            if (hasOwn(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
          }
        });
      } else IteratorPrototype[key] = value;
    };
    if (!hasOwn(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);
    if (FORCED || !hasOwn(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) {
      defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
    }
    IteratorConstructor.prototype = IteratorPrototype;

    // `Iterator` constructor
    // https://github.com/tc39/proposal-iterator-helpers
    $({
      global: true,
      constructor: true,
      forced: FORCED
    }, {
      Iterator: IteratorConstructor
    });

    /***/
  }),
  /***/3215: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var iterate = __webpack_require__(2652);
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var getIteratorDirect = __webpack_require__(1767);

    // `Iterator.prototype.every` method
    // https://github.com/tc39/proposal-iterator-helpers
    $({
      target: 'Iterator',
      proto: true,
      real: true
    }, {
      every: function every(predicate) {
        anObject(this);
        aCallable(predicate);
        var record = getIteratorDirect(this);
        var counter = 0;
        return !iterate(record, function (value, stop) {
          if (!predicate(value, counter++)) return stop();
        }, {
          IS_RECORD: true,
          INTERRUPTED: true
        }).stopped;
      }
    });

    /***/
  }),
  /***/4520: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var call = __webpack_require__(9565);
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var getIteratorDirect = __webpack_require__(1767);
    var createIteratorProxy = __webpack_require__(9462);
    var callWithSafeIterationClosing = __webpack_require__(6319);
    var IS_PURE = __webpack_require__(6395);
    var IteratorProxy = createIteratorProxy(function () {
      var iterator = this.iterator;
      var predicate = this.predicate;
      var next = this.next;
      var result, done, value;
      while (true) {
        result = anObject(call(next, iterator));
        done = this.done = !!result.done;
        if (done) return;
        value = result.value;
        if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
      }
    });

    // `Iterator.prototype.filter` method
    // https://github.com/tc39/proposal-iterator-helpers
    $({
      target: 'Iterator',
      proto: true,
      real: true,
      forced: IS_PURE
    }, {
      filter: function filter(predicate) {
        anObject(this);
        aCallable(predicate);
        return new IteratorProxy(getIteratorDirect(this), {
          predicate: predicate
        });
      }
    });

    /***/
  }),
  /***/3949: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var iterate = __webpack_require__(2652);
    var aCallable = __webpack_require__(9306);
    var anObject = __webpack_require__(8551);
    var getIteratorDirect = __webpack_require__(1767);

    // `Iterator.prototype.forEach` method
    // https://github.com/tc39/proposal-iterator-helpers
    $({
      target: 'Iterator',
      proto: true,
      real: true
    }, {
      forEach: function forEach(fn) {
        anObject(this);
        aCallable(fn);
        var record = getIteratorDirect(this);
        var counter = 0;
        iterate(record, function (value) {
          fn(value, counter++);
        }, {
          IS_RECORD: true
        });
      }
    });

    /***/
  }),
  /***/1454: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var map = __webpack_require__(713);
    var IS_PURE = __webpack_require__(6395);

    // `Iterator.prototype.map` method
    // https://github.com/tc39/proposal-iterator-helpers
    $({
      target: 'Iterator',
      proto: true,
      real: true,
      forced: IS_PURE
    }, {
      map: map
    });

    /***/
  }),
  /***/8335: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var $ = __webpack_require__(6518);
    var DESCRIPTORS = __webpack_require__(3724);
    var global = __webpack_require__(4475);
    var getBuiltIn = __webpack_require__(7751);
    var uncurryThis = __webpack_require__(9504);
    var call = __webpack_require__(9565);
    var isCallable = __webpack_require__(4901);
    var isObject = __webpack_require__(34);
    var isArray = __webpack_require__(4376);
    var hasOwn = __webpack_require__(9297);
    var toString = __webpack_require__(655);
    var lengthOfArrayLike = __webpack_require__(6198);
    var createProperty = __webpack_require__(4659);
    var fails = __webpack_require__(9039);
    var parseJSONString = __webpack_require__(8235);
    var NATIVE_SYMBOL = __webpack_require__(4495);
    var JSON = global.JSON;
    var Number = global.Number;
    var SyntaxError = global.SyntaxError;
    var nativeParse = JSON && JSON.parse;
    var enumerableOwnProperties = getBuiltIn('Object', 'keys');
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var at = uncurryThis(''.charAt);
    var slice = uncurryThis(''.slice);
    var exec = uncurryThis(/./.exec);
    var push = uncurryThis([].push);
    var IS_DIGIT = /^\d$/;
    var IS_NON_ZERO_DIGIT = /^[1-9]$/;
    var IS_NUMBER_START = /^(?:-|\d)$/;
    var IS_WHITESPACE = /^[\t\n\r ]$/;
    var PRIMITIVE = 0;
    var OBJECT = 1;
    var $parse = function $parse(source, reviver) {
      source = toString(source);
      var context = new Context(source, 0);
      var root = context.parse();
      var value = root.value;
      var endIndex = context.skip(IS_WHITESPACE, root.end);
      if (endIndex < source.length) {
        throw new SyntaxError('Unexpected extra character: "' + at(source, endIndex) + '" after the parsed data at: ' + endIndex);
      }
      return isCallable(reviver) ? internalize({
        '': value
      }, '', reviver, root) : value;
    };
    var internalize = function internalize(holder, name, reviver, node) {
      var val = holder[name];
      var unmodified = node && val === node.value;
      var context = unmodified && typeof node.source == 'string' ? {
        source: node.source
      } : {};
      var elementRecordsLen, keys, len, i, P;
      if (isObject(val)) {
        var nodeIsArray = isArray(val);
        var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
        if (nodeIsArray) {
          elementRecordsLen = nodes.length;
          len = lengthOfArrayLike(val);
          for (i = 0; i < len; i++) {
            internalizeProperty(val, i, internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
          }
        } else {
          keys = enumerableOwnProperties(val);
          len = lengthOfArrayLike(keys);
          for (i = 0; i < len; i++) {
            P = keys[i];
            internalizeProperty(val, P, internalize(val, P, reviver, hasOwn(nodes, P) ? nodes[P] : undefined));
          }
        }
      }
      return call(reviver, holder, name, val, context);
    };
    var internalizeProperty = function internalizeProperty(object, key, value) {
      if (DESCRIPTORS) {
        var descriptor = getOwnPropertyDescriptor(object, key);
        if (descriptor && !descriptor.configurable) return;
      }
      if (value === undefined) delete object[key];else createProperty(object, key, value);
    };
    var Node = function Node(value, end, source, nodes) {
      this.value = value;
      this.end = end;
      this.source = source;
      this.nodes = nodes;
    };
    var Context = function Context(source, index) {
      this.source = source;
      this.index = index;
    };

    // https://www.json.org/json-en.html
    Context.prototype = {
      fork: function fork(nextIndex) {
        return new Context(this.source, nextIndex);
      },
      parse: function parse() {
        var source = this.source;
        var i = this.skip(IS_WHITESPACE, this.index);
        var fork = this.fork(i);
        var chr = at(source, i);
        if (exec(IS_NUMBER_START, chr)) return fork.number();
        switch (chr) {
          case '{':
            return fork.object();
          case '[':
            return fork.array();
          case '"':
            return fork.string();
          case 't':
            return fork.keyword(true);
          case 'f':
            return fork.keyword(false);
          case 'n':
            return fork.keyword(null);
        }
        throw new SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
      },
      node: function node(type, value, start, end, nodes) {
        return new Node(value, end, type ? null : slice(this.source, start, end), nodes);
      },
      object: function object() {
        var source = this.source;
        var i = this.index + 1;
        var expectKeypair = false;
        var object = {};
        var nodes = {};
        while (i < source.length) {
          i = this.until(['"', '}'], i);
          if (at(source, i) === '}' && !expectKeypair) {
            i++;
            break;
          }
          // Parsing the key
          var result = this.fork(i).string();
          var key = result.value;
          i = result.end;
          i = this.until([':'], i) + 1;
          // Parsing value
          i = this.skip(IS_WHITESPACE, i);
          result = this.fork(i).parse();
          createProperty(nodes, key, result);
          createProperty(object, key, result.value);
          i = this.until([',', '}'], result.end);
          var chr = at(source, i);
          if (chr === ',') {
            expectKeypair = true;
            i++;
          } else if (chr === '}') {
            i++;
            break;
          }
        }
        return this.node(OBJECT, object, this.index, i, nodes);
      },
      array: function array() {
        var source = this.source;
        var i = this.index + 1;
        var expectElement = false;
        var array = [];
        var nodes = [];
        while (i < source.length) {
          i = this.skip(IS_WHITESPACE, i);
          if (at(source, i) === ']' && !expectElement) {
            i++;
            break;
          }
          var result = this.fork(i).parse();
          push(nodes, result);
          push(array, result.value);
          i = this.until([',', ']'], result.end);
          if (at(source, i) === ',') {
            expectElement = true;
            i++;
          } else if (at(source, i) === ']') {
            i++;
            break;
          }
        }
        return this.node(OBJECT, array, this.index, i, nodes);
      },
      string: function string() {
        var index = this.index;
        var parsed = parseJSONString(this.source, this.index + 1);
        return this.node(PRIMITIVE, parsed.value, index, parsed.end);
      },
      number: function number() {
        var source = this.source;
        var startIndex = this.index;
        var i = startIndex;
        if (at(source, i) === '-') i++;
        if (at(source, i) === '0') i++;else if (exec(IS_NON_ZERO_DIGIT, at(source, i))) i = this.skip(IS_DIGIT, ++i);else throw new SyntaxError('Failed to parse number at: ' + i);
        if (at(source, i) === '.') i = this.skip(IS_DIGIT, ++i);
        if (at(source, i) === 'e' || at(source, i) === 'E') {
          i++;
          if (at(source, i) === '+' || at(source, i) === '-') i++;
          var exponentStartIndex = i;
          i = this.skip(IS_DIGIT, i);
          if (exponentStartIndex === i) throw new SyntaxError("Failed to parse number's exponent value at: " + i);
        }
        return this.node(PRIMITIVE, Number(slice(source, startIndex, i)), startIndex, i);
      },
      keyword: function keyword(value) {
        var keyword = '' + value;
        var index = this.index;
        var endIndex = index + keyword.length;
        if (slice(this.source, index, endIndex) !== keyword) throw new SyntaxError('Failed to parse value at: ' + index);
        return this.node(PRIMITIVE, value, index, endIndex);
      },
      skip: function skip(regex, i) {
        var source = this.source;
        for (; i < source.length; i++) if (!exec(regex, at(source, i))) break;
        return i;
      },
      until: function until(array, i) {
        i = this.skip(IS_WHITESPACE, i);
        var chr = at(this.source, i);
        for (var j = 0; j < array.length; j++) if (array[j] === chr) return i;
        throw new SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
      }
    };
    var NO_SOURCE_SUPPORT = fails(function () {
      var unsafeInt = '9007199254740993';
      var source;
      nativeParse(unsafeInt, function (key, value, context) {
        source = context.source;
      });
      return source !== unsafeInt;
    });
    var PROPER_BASE_PARSE = NATIVE_SYMBOL && !fails(function () {
      // Safari 9 bug
      return 1 / nativeParse('-0 \t') !== -Infinity;
    });

    // `JSON.parse` method
    // https://tc39.es/ecma262/#sec-json.parse
    // https://github.com/tc39/proposal-json-parse-with-source
    $({
      target: 'JSON',
      stat: true,
      forced: NO_SOURCE_SUPPORT
    }, {
      parse: function parse(text, reviver) {
        return PROPER_BASE_PARSE && !isCallable(reviver) ? nativeParse(text) : $parse(text, reviver);
      }
    });

    /***/
  }),
  /***/3375: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(7642);

    /***/
  }),
  /***/9225: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(8004);

    /***/
  }),
  /***/3972: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(3853);

    /***/
  }),
  /***/9209: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(5876);

    /***/
  }),
  /***/5714: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(2475);

    /***/
  }),
  /***/7561: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(5024);

    /***/
  }),
  /***/6197: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    // TODO: Remove from `core-js@4`
    __webpack_require__(1698);

    /***/
  }),
  /***/4603: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var defineBuiltIn = __webpack_require__(6840);
    var uncurryThis = __webpack_require__(9504);
    var toString = __webpack_require__(655);
    var validateArgumentsLength = __webpack_require__(2812);
    var $URLSearchParams = URLSearchParams;
    var URLSearchParamsPrototype = $URLSearchParams.prototype;
    var append = uncurryThis(URLSearchParamsPrototype.append);
    var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
    var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
    var push = uncurryThis([].push);
    var params = new $URLSearchParams('a=1&a=2&b=3');
    params['delete']('a', 1);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params['delete']('b', undefined);
    if (params + '' !== 'a=2') {
      defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
        var length = arguments.length;
        var $value = length < 2 ? undefined : arguments[1];
        if (length && $value === undefined) return $delete(this, name);
        var entries = [];
        forEach(this, function (v, k) {
          // also validates `this`
          push(entries, {
            key: k,
            value: v
          });
        });
        validateArgumentsLength(length, 1);
        var key = toString(name);
        var value = toString($value);
        var index = 0;
        var dindex = 0;
        var found = false;
        var entriesLength = entries.length;
        var entry;
        while (index < entriesLength) {
          entry = entries[index++];
          if (found || entry.key === key) {
            found = true;
            $delete(this, entry.key);
          } else dindex++;
        }
        while (dindex < entriesLength) {
          entry = entries[dindex++];
          if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
        }
      }, {
        enumerable: true,
        unsafe: true
      });
    }

    /***/
  }),
  /***/7566: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var defineBuiltIn = __webpack_require__(6840);
    var uncurryThis = __webpack_require__(9504);
    var toString = __webpack_require__(655);
    var validateArgumentsLength = __webpack_require__(2812);
    var $URLSearchParams = URLSearchParams;
    var URLSearchParamsPrototype = $URLSearchParams.prototype;
    var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
    var $has = uncurryThis(URLSearchParamsPrototype.has);
    var params = new $URLSearchParams('a=1');

    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    if (params.has('a', 2) || !params.has('a', undefined)) {
      defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
        var length = arguments.length;
        var $value = length < 2 ? undefined : arguments[1];
        if (length && $value === undefined) return $has(this, name);
        var values = getAll(this, name); // also validates `this`
        validateArgumentsLength(length, 1);
        var value = toString($value);
        var index = 0;
        while (index < values.length) {
          if (values[index++] === value) return true;
        }
        return false;
      }, {
        enumerable: true,
        unsafe: true
      });
    }

    /***/
  }),
  /***/8721: ( /***/function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
    var DESCRIPTORS = __webpack_require__(3724);
    var uncurryThis = __webpack_require__(9504);
    var defineBuiltInAccessor = __webpack_require__(2106);
    var URLSearchParamsPrototype = URLSearchParams.prototype;
    var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

    // `URLSearchParams.prototype.size` getter
    // https://github.com/whatwg/url/pull/734
    if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
      defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
        get: function size() {
          var count = 0;
          forEach(this, function () {
            count++;
          });
          return count;
        },
        configurable: true,
        enumerable: true
      });
    }

    /***/
  })

  /******/
};
/************************************************************************/
/******/ // The module cache
/******/
var __webpack_module_cache__ = {};
/******/
/******/ // The require function
/******/
function __webpack_require__(moduleId) {
  /******/ // Check if module is in cache
  /******/var cachedModule = __webpack_module_cache__[moduleId];
  /******/
  if (cachedModule !== undefined) {
    /******/return cachedModule.exports;
    /******/
  }
  /******/ // Create a new module (and put it into the cache)
  /******/
  var module = __webpack_module_cache__[moduleId] = {
    /******/ // no module.id needed
    /******/ // no module.loaded needed
    /******/exports: {}
    /******/
  };
  /******/
  /******/ // Execute the module function
  /******/
  __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
  /******/
  /******/ // Return the exports of the module
  /******/
  return module.exports;
  /******/
}
/******/
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/
(function () {
  /******/ // define getter functions for harmony exports
  /******/__webpack_require__.d = function (exports, definition) {
    /******/for (var key in definition) {
      /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
        /******/Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
        /******/
      }
      /******/
    }
    /******/
  };
  /******/
})();
/******/
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/
(function () {
  /******/__webpack_require__.o = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
  /******/
})();
/******/
/************************************************************************/
var __webpack_exports__ = globalThis.pdfjsViewer = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(function (_genericl10n_GenericL10n, _TextLayerBuilder2) {
  // EXPORTS
  __webpack_require__.d(__webpack_exports__, {
    AnnotationLayerBuilder: function AnnotationLayerBuilder() {
      return /* reexport */_AnnotationLayerBuilder;
    },
    DownloadManager: function DownloadManager() {
      return /* reexport */_DownloadManager;
    },
    EventBus: function EventBus() {
      return /* reexport */_EventBus;
    },
    FindState: function FindState() {
      return /* reexport */_FindState;
    },
    GenericL10n: function GenericL10n() {
      return /* reexport */genericl10n_GenericL10n;
    },
    LinkTarget: function LinkTarget() {
      return /* reexport */_LinkTarget;
    },
    PDFFindController: function PDFFindController() {
      return /* reexport */_PDFFindController;
    },
    PDFHistory: function PDFHistory() {
      return /* reexport */_PDFHistory;
    },
    PDFLinkService: function PDFLinkService() {
      return /* reexport */_PDFLinkService;
    },
    PDFPageView: function PDFPageView() {
      return /* reexport */_PDFPageView;
    },
    PDFScriptingManager: function PDFScriptingManager() {
      return /* reexport */PDFScriptingManagerComponents;
    },
    PDFSinglePageViewer: function PDFSinglePageViewer() {
      return /* reexport */_PDFSinglePageViewer;
    },
    PDFViewer: function PDFViewer() {
      return /* reexport */_PDFViewer;
    },
    ProgressBar: function ProgressBar() {
      return /* reexport */_ProgressBar;
    },
    RenderingStates: function RenderingStates() {
      return /* reexport */_RenderingStates;
    },
    ScrollMode: function ScrollMode() {
      return /* reexport */_ScrollMode;
    },
    SimpleLinkService: function SimpleLinkService() {
      return /* reexport */_SimpleLinkService;
    },
    SpreadMode: function SpreadMode() {
      return /* reexport */_SpreadMode;
    },
    StructTreeLayerBuilder: function StructTreeLayerBuilder() {
      return /* reexport */_StructTreeLayerBuilder;
    },
    TextLayerBuilder: function TextLayerBuilder() {
      return /* reexport */_TextLayerBuilder;
    },
    XfaLayerBuilder: function XfaLayerBuilder() {
      return /* reexport */_XfaLayerBuilder;
    },
    parseQueryString: function parseQueryString() {
      return /* reexport */_parseQueryString;
    }
  });

  // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
  __webpack_require__(4114);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.with-resolvers.js
  __webpack_require__(4628);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
  __webpack_require__(8992);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
  __webpack_require__(4520);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.map.js
  __webpack_require__(1454);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.difference.v2.js
  __webpack_require__(3375);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.intersection.v2.js
  __webpack_require__(9225);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
  __webpack_require__(3972);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
  __webpack_require__(9209);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
  __webpack_require__(5714);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
  __webpack_require__(7561);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.union.v2.js
  __webpack_require__(6197);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.delete.js
  __webpack_require__(4603);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.has.js
  __webpack_require__(7566);
  // EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.size.js
  __webpack_require__(8721);

  var DEFAULT_SCALE_VALUE = "auto";
  var DEFAULT_SCALE = 1.0;
  var DEFAULT_SCALE_DELTA = 1.1;
  var MIN_SCALE = 0.1;
  var MAX_SCALE = 10.0;
  var UNKNOWN_SCALE = 0;
  var MAX_AUTO_SCALE = 1.25;
  var SCROLLBAR_PADDING = 40;
  var VERTICAL_PADDING = 5;
  var _RenderingStates = {
    INITIAL: 0,
    RUNNING: 1,
    PAUSED: 2,
    FINISHED: 3
  };
  var PresentationModeState = {
    UNKNOWN: 0,
    NORMAL: 1,
    CHANGING: 2,
    FULLSCREEN: 3
  };
  var TextLayerMode = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_PERMISSIONS: 2
  };
  var _ScrollMode = {
    UNKNOWN: -1,
    VERTICAL: 0,
    HORIZONTAL: 1,
    WRAPPED: 2,
    PAGE: 3
  };
  var _SpreadMode = {
    UNKNOWN: -1,
    NONE: 0,
    ODD: 1,
    EVEN: 2
  };
  var OutputScale = /*#__PURE__*/function () {
    function OutputScale() {
      _classCallCheck(this, OutputScale);
      var pixelRatio = window.devicePixelRatio || 1;
      this.sx = pixelRatio;
      this.sy = pixelRatio;
    }
    return _createClass(OutputScale, [{
      key: "scaled",
      get: function get() {
        return this.sx !== 1 || this.sy !== 1;
      }
    }]);
  }();
  function scrollIntoView(element, spot) {
    var scrollMatches = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var parent = element.offsetParent;
    if (!parent) {
      console.error("offsetParent is not set -- cannot scroll");
      return;
    }
    var offsetY = element.offsetTop + element.clientTop;
    var offsetX = element.offsetLeft + element.clientLeft;
    while (parent.clientHeight === parent.scrollHeight && parent.clientWidth === parent.scrollWidth || scrollMatches && (parent.classList.contains("markedContent") || getComputedStyle(parent).overflow === "hidden")) {
      offsetY += parent.offsetTop;
      offsetX += parent.offsetLeft;
      parent = parent.offsetParent;
      if (!parent) {
        return;
      }
    }
    if (spot) {
      if (spot.top !== undefined) {
        offsetY += spot.top;
      }
      if (spot.left !== undefined) {
        offsetX += spot.left;
        parent.scrollLeft = offsetX;
      }
    }
    parent.scrollTop = offsetY;
  }
  function watchScroll(viewAreaElement, callback) {
    var debounceScroll = function debounceScroll(evt) {
      if (rAF) {
        return;
      }
      rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
        rAF = null;
        var currentX = viewAreaElement.scrollLeft;
        var lastX = state.lastX;
        if (currentX !== lastX) {
          state.right = currentX > lastX;
        }
        state.lastX = currentX;
        var currentY = viewAreaElement.scrollTop;
        var lastY = state.lastY;
        if (currentY !== lastY) {
          state.down = currentY > lastY;
        }
        state.lastY = currentY;
        callback(state);
      });
    };
    var state = {
      right: true,
      down: true,
      lastX: viewAreaElement.scrollLeft,
      lastY: viewAreaElement.scrollTop,
      _eventHandler: debounceScroll
    };
    var rAF = null;
    viewAreaElement.addEventListener("scroll", debounceScroll, true);
    return state;
  }
  function _parseQueryString(query) {
    var params = new Map();
    var _iterator2 = _createForOfIteratorHelper(new URLSearchParams(query)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          key = _step2$value[0],
          value = _step2$value[1];
        params.set(key.toLowerCase(), value);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return params;
  }
  var InvisibleCharsRegExp = /[\x00-\x1F]/g;
  function removeNullCharacters(str) {
    var replaceInvisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!InvisibleCharsRegExp.test(str)) {
      return str;
    }
    if (replaceInvisible) {
      return str.replaceAll(InvisibleCharsRegExp, function (m) {
        return m === "\x00" ? "" : " ";
      });
    }
    return str.replaceAll("\x00", "");
  }
  function binarySearchFirstItem(items, condition) {
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var minIndex = start;
    var maxIndex = items.length - 1;
    if (maxIndex < 0 || !condition(items[maxIndex])) {
      return items.length;
    }
    if (condition(items[minIndex])) {
      return minIndex;
    }
    while (minIndex < maxIndex) {
      var currentIndex = minIndex + maxIndex >> 1;
      var currentItem = items[currentIndex];
      if (condition(currentItem)) {
        maxIndex = currentIndex;
      } else {
        minIndex = currentIndex + 1;
      }
    }
    return minIndex;
  }
  function approximateFraction(x) {
    if (Math.floor(x) === x) {
      return [x, 1];
    }
    var xinv = 1 / x;
    var limit = 8;
    if (xinv > limit) {
      return [1, limit];
    } else if (Math.floor(xinv) === xinv) {
      return [1, xinv];
    }
    var x_ = x > 1 ? xinv : x;
    var a = 0,
      b = 1,
      c = 1,
      d = 1;
    while (true) {
      var p = a + c,
        q = b + d;
      if (q > limit) {
        break;
      }
      if (x_ <= p / q) {
        c = p;
        d = q;
      } else {
        a = p;
        b = q;
      }
    }
    var result;
    if (x_ - a / b < c / d - x_) {
      result = x_ === x ? [a, b] : [b, a];
    } else {
      result = x_ === x ? [c, d] : [d, c];
    }
    return result;
  }
  function roundToDivide(x, div) {
    var r = x % div;
    return r === 0 ? x : Math.round(x - r + div);
  }
  function backtrackBeforeAllVisibleElements(index, views, top) {
    if (index < 2) {
      return index;
    }
    var elt = views[index].div;
    var pageTop = elt.offsetTop + elt.clientTop;
    if (pageTop >= top) {
      elt = views[index - 1].div;
      pageTop = elt.offsetTop + elt.clientTop;
    }
    for (var i = index - 2; i >= 0; --i) {
      elt = views[i].div;
      if (elt.offsetTop + elt.clientTop + elt.clientHeight <= pageTop) {
        break;
      }
      index = i;
    }
    return index;
  }
  function getVisibleElements(_ref2) {
    var scrollEl = _ref2.scrollEl,
      views = _ref2.views,
      _ref2$sortByVisibilit = _ref2.sortByVisibility,
      sortByVisibility = _ref2$sortByVisibilit === void 0 ? false : _ref2$sortByVisibilit,
      _ref2$horizontal = _ref2.horizontal,
      horizontal = _ref2$horizontal === void 0 ? false : _ref2$horizontal,
      _ref2$rtl = _ref2.rtl,
      rtl = _ref2$rtl === void 0 ? false : _ref2$rtl;
    var top = scrollEl.scrollTop,
      bottom = top + scrollEl.clientHeight;
    var left = scrollEl.scrollLeft,
      right = left + scrollEl.clientWidth;
    function isElementBottomAfterViewTop(view) {
      var element = view.div;
      var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
      return elementBottom > top;
    }
    function isElementNextAfterViewHorizontally(view) {
      var element = view.div;
      var elementLeft = element.offsetLeft + element.clientLeft;
      var elementRight = elementLeft + element.clientWidth;
      return rtl ? elementLeft < right : elementRight > left;
    }
    var visible = [],
      ids = new Set(),
      numViews = views.length;
    var firstVisibleElementInd = binarySearchFirstItem(views, horizontal ? isElementNextAfterViewHorizontally : isElementBottomAfterViewTop);
    if (firstVisibleElementInd > 0 && firstVisibleElementInd < numViews && !horizontal) {
      firstVisibleElementInd = backtrackBeforeAllVisibleElements(firstVisibleElementInd, views, top);
    }
    var lastEdge = horizontal ? right : -1;
    for (var i = firstVisibleElementInd; i < numViews; i++) {
      var view = views[i],
        element = view.div;
      var currentWidth = element.offsetLeft + element.clientLeft;
      var currentHeight = element.offsetTop + element.clientTop;
      var viewWidth = element.clientWidth,
        viewHeight = element.clientHeight;
      var viewRight = currentWidth + viewWidth;
      var viewBottom = currentHeight + viewHeight;
      if (lastEdge === -1) {
        if (viewBottom >= bottom) {
          lastEdge = viewBottom;
        }
      } else if ((horizontal ? currentWidth : currentHeight) > lastEdge) {
        break;
      }
      if (viewBottom <= top || currentHeight >= bottom || viewRight <= left || currentWidth >= right) {
        continue;
      }
      var hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, viewBottom - bottom);
      var hiddenWidth = Math.max(0, left - currentWidth) + Math.max(0, viewRight - right);
      var fractionHeight = (viewHeight - hiddenHeight) / viewHeight,
        fractionWidth = (viewWidth - hiddenWidth) / viewWidth;
      var percent = fractionHeight * fractionWidth * 100 | 0;
      visible.push({
        id: view.id,
        x: currentWidth,
        y: currentHeight,
        view: view,
        percent: percent,
        widthPercent: fractionWidth * 100 | 0
      });
      ids.add(view.id);
    }
    var first = visible[0],
      last = visible.at(-1);
    if (sortByVisibility) {
      visible.sort(function (a, b) {
        var pc = a.percent - b.percent;
        if (Math.abs(pc) > 0.001) {
          return -pc;
        }
        return a.id - b.id;
      });
    }
    return {
      first: first,
      last: last,
      views: visible,
      ids: ids
    };
  }
  function isValidRotation(angle) {
    return Number.isInteger(angle) && angle % 90 === 0;
  }
  function isValidScrollMode(mode) {
    return Number.isInteger(mode) && Object.values(_ScrollMode).includes(mode) && mode !== _ScrollMode.UNKNOWN;
  }
  function isValidSpreadMode(mode) {
    return Number.isInteger(mode) && Object.values(_SpreadMode).includes(mode) && mode !== _SpreadMode.UNKNOWN;
  }
  function isPortraitOrientation(size) {
    return size.width <= size.height;
  }
  new Promise(function (resolve) {
    window.requestAnimationFrame(resolve);
  });
  var docStyle = document.documentElement.style;
  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }
  var _classList = /*#__PURE__*/new WeakMap();
  var _disableAutoFetchTimeout = /*#__PURE__*/new WeakMap();
  var _percent = /*#__PURE__*/new WeakMap();
  var _style = /*#__PURE__*/new WeakMap();
  var _visible = /*#__PURE__*/new WeakMap();
  var _ProgressBar = /*#__PURE__*/function () {
    function _ProgressBar(bar) {
      _classCallCheck(this, _ProgressBar);
      _classPrivateFieldInitSpec(this, _classList, null);
      _classPrivateFieldInitSpec(this, _disableAutoFetchTimeout, null);
      _classPrivateFieldInitSpec(this, _percent, 0);
      _classPrivateFieldInitSpec(this, _style, null);
      _classPrivateFieldInitSpec(this, _visible, true);
      _classPrivateFieldSet2(_classList, this, bar.classList);
      _classPrivateFieldSet2(_style, this, bar.style);
    }
    return _createClass(_ProgressBar, [{
      key: "percent",
      get: function get() {
        return _classPrivateFieldGet2(_percent, this);
      },
      set: function set(val) {
        _classPrivateFieldSet2(_percent, this, clamp(val, 0, 100));
        if (isNaN(val)) {
          _classPrivateFieldGet2(_classList, this).add("indeterminate");
          return;
        }
        _classPrivateFieldGet2(_classList, this).remove("indeterminate");
        _classPrivateFieldGet2(_style, this).setProperty("--progressBar-percent", "".concat(_classPrivateFieldGet2(_percent, this), "%"));
      }
    }, {
      key: "setWidth",
      value: function setWidth(viewer) {
        if (!viewer) {
          return;
        }
        var container = viewer.parentNode;
        var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
        if (scrollbarWidth > 0) {
          _classPrivateFieldGet2(_style, this).setProperty("--progressBar-end-offset", "".concat(scrollbarWidth, "px"));
        }
      }
    }, {
      key: "setDisableAutoFetch",
      value: function setDisableAutoFetch() {
        var _this3 = this;
        var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
        if (isNaN(_classPrivateFieldGet2(_percent, this))) {
          return;
        }
        if (_classPrivateFieldGet2(_disableAutoFetchTimeout, this)) {
          clearTimeout(_classPrivateFieldGet2(_disableAutoFetchTimeout, this));
        }
        this.show();
        _classPrivateFieldSet2(_disableAutoFetchTimeout, this, setTimeout(function () {
          _classPrivateFieldSet2(_disableAutoFetchTimeout, _this3, null);
          _this3.hide();
        }, delay));
      }
    }, {
      key: "hide",
      value: function hide() {
        if (!_classPrivateFieldGet2(_visible, this)) {
          return;
        }
        _classPrivateFieldSet2(_visible, this, false);
        _classPrivateFieldGet2(_classList, this).add("hidden");
      }
    }, {
      key: "show",
      value: function show() {
        if (_classPrivateFieldGet2(_visible, this)) {
          return;
        }
        _classPrivateFieldSet2(_visible, this, true);
        _classPrivateFieldGet2(_classList, this).remove("hidden");
      }
    }]);
  }();
  function apiPageLayoutToViewerModes(layout) {
    var scrollMode = _ScrollMode.VERTICAL,
      spreadMode = _SpreadMode.NONE;
    switch (layout) {
      case "SinglePage":
        scrollMode = _ScrollMode.PAGE;
        break;
      case "OneColumn":
        break;
      case "TwoPageLeft":
        scrollMode = _ScrollMode.PAGE;
      case "TwoColumnLeft":
        spreadMode = _SpreadMode.ODD;
        break;
      case "TwoPageRight":
        scrollMode = _ScrollMode.PAGE;
      case "TwoColumnRight":
        spreadMode = _SpreadMode.EVEN;
        break;
    }
    return {
      scrollMode: scrollMode,
      spreadMode: spreadMode
    };
  }

  var CharacterType = {
    SPACE: 0,
    ALPHA_LETTER: 1,
    PUNCT: 2,
    HAN_LETTER: 3,
    KATAKANA_LETTER: 4,
    HIRAGANA_LETTER: 5,
    HALFWIDTH_KATAKANA_LETTER: 6,
    THAI_LETTER: 7
  };
  function isAlphabeticalScript(charCode) {
    return charCode < 0x2e80;
  }
  function isAscii(charCode) {
    return (charCode & 0xff80) === 0;
  }
  function isAsciiAlpha(charCode) {
    return charCode >= 0x61 && charCode <= 0x7a || charCode >= 0x41 && charCode <= 0x5a;
  }
  function isAsciiDigit(charCode) {
    return charCode >= 0x30 && charCode <= 0x39;
  }
  function isAsciiSpace(charCode) {
    return charCode === 0x20 || charCode === 0x09 || charCode === 0x0d || charCode === 0x0a;
  }
  function isHan(charCode) {
    return charCode >= 0x3400 && charCode <= 0x9fff || charCode >= 0xf900 && charCode <= 0xfaff;
  }
  function isKatakana(charCode) {
    return charCode >= 0x30a0 && charCode <= 0x30ff;
  }
  function isHiragana(charCode) {
    return charCode >= 0x3040 && charCode <= 0x309f;
  }
  function isHalfwidthKatakana(charCode) {
    return charCode >= 0xff60 && charCode <= 0xff9f;
  }
  function isThai(charCode) {
    return (charCode & 0xff80) === 0x0e00;
  }
  function getCharacterType(charCode) {
    if (isAlphabeticalScript(charCode)) {
      if (isAscii(charCode)) {
        if (isAsciiSpace(charCode)) {
          return CharacterType.SPACE;
        } else if (isAsciiAlpha(charCode) || isAsciiDigit(charCode) || charCode === 0x5f) {
          return CharacterType.ALPHA_LETTER;
        }
        return CharacterType.PUNCT;
      } else if (isThai(charCode)) {
        return CharacterType.THAI_LETTER;
      } else if (charCode === 0xa0) {
        return CharacterType.SPACE;
      }
      return CharacterType.ALPHA_LETTER;
    }
    if (isHan(charCode)) {
      return CharacterType.HAN_LETTER;
    } else if (isKatakana(charCode)) {
      return CharacterType.KATAKANA_LETTER;
    } else if (isHiragana(charCode)) {
      return CharacterType.HIRAGANA_LETTER;
    } else if (isHalfwidthKatakana(charCode)) {
      return CharacterType.HALFWIDTH_KATAKANA_LETTER;
    }
    return CharacterType.ALPHA_LETTER;
  }
  var NormalizeWithNFKC;
  function getNormalizeWithNFKC() {
    NormalizeWithNFKC || (NormalizeWithNFKC = "\xA0\xA8\xAA\xAF\xB2-\xB5\xB8-\xBA\xBC-\xBE\u0132-\u0133\u013F-\u0140\u0149\u017F\u01C4-\u01CC\u01F1-\u01F3\u02B0-\u02B8\u02D8-\u02DD\u02E0-\u02E4\u0374\u037A\u037E\u0384-\u0385\u0387\u03D0-\u03D6\u03F0-\u03F2\u03F4-\u03F5\u03F9\u0587\u0675-\u0678\u0958-\u095F\u09DC-\u09DD\u09DF\u0A33\u0A36\u0A59-\u0A5B\u0A5E\u0B5C-\u0B5D\u0E33\u0EB3\u0EDC-\u0EDD\u0F0C\u0F43\u0F4D\u0F52\u0F57\u0F5C\u0F69\u10FC\u1D2C-\u1D2E\u1D30-\u1D3A\u1D3C-\u1D4D\u1D4F-\u1D6A\u1D78\u1D9B-\u1DBF\u1E9A-\u1E9B\u1F71\u1F73\u1F75\u1F77\u1F79\u1F7B\u1F7D\u1FBB\u1FBD-\u1FC1\u1FC9\u1FCB\u1FCD-\u1FCF\u1FD3\u1FDB\u1FDD-\u1FDF\u1FE3\u1FEB\u1FED-\u1FEF\u1FF9\u1FFB\u1FFD-\u1FFE\u2000-\u200A\u2011\u2017\u2024-\u2026\u202F\u2033-\u2034\u2036-\u2037\u203C\u203E\u2047-\u2049\u2057\u205F\u2070-\u2071\u2074-\u208E\u2090-\u209C\u20A8\u2100-\u2103\u2105-\u2107\u2109-\u2113\u2115-\u2116\u2119-\u211D\u2120-\u2122\u2124\u2126\u2128\u212A-\u212D\u212F-\u2131\u2133-\u2139\u213B-\u2140\u2145-\u2149\u2150-\u217F\u2189\u222C-\u222D\u222F-\u2230\u2329-\u232A\u2460-\u24EA\u2A0C\u2A74-\u2A76\u2ADC\u2C7C-\u2C7D\u2D6F\u2E9F\u2EF3\u2F00-\u2FD5\u3000\u3036\u3038-\u303A\u309B-\u309C\u309F\u30FF\u3131-\u318E\u3192-\u319F\u3200-\u321E\u3220-\u3247\u3250-\u327E\u3280-\u33FF\uA69C-\uA69D\uA770\uA7F2-\uA7F4\uA7F8-\uA7F9\uAB5C-\uAB5F\uAB69\uF900-\uFA0D\uFA10\uFA12\uFA15-\uFA1E\uFA20\uFA22\uFA25-\uFA26\uFA2A-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFC\uFE10-\uFE19\uFE30-\uFE44\uFE47-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFE70-\uFE72\uFE74\uFE76-\uFEFC\uFF01-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\uFFE0-\uFFE6");
    return NormalizeWithNFKC;
  }

  var _FindState = {
    FOUND: 0,
    NOT_FOUND: 1,
    WRAPPED: 2,
    PENDING: 3
  };
  var FIND_TIMEOUT = 250;
  var MATCH_SCROLL_OFFSET_TOP = -50;
  var MATCH_SCROLL_OFFSET_LEFT = -400;
  var CHARACTERS_TO_NORMALIZE = {
    "\u2010": "-",
    "\u2018": "'",
    "\u2019": "'",
    "\u201A": "'",
    "\u201B": "'",
    "\u201C": '"',
    "\u201D": '"',
    "\u201E": '"',
    "\u201F": '"',
    "\xBC": "1/4",
    "\xBD": "1/2",
    "\xBE": "3/4"
  };
  var DIACRITICS_EXCEPTION = new Set([0x3099, 0x309a, 0x094d, 0x09cd, 0x0a4d, 0x0acd, 0x0b4d, 0x0bcd, 0x0c4d, 0x0ccd, 0x0d3b, 0x0d3c, 0x0d4d, 0x0dca, 0x0e3a, 0x0eba, 0x0f84, 0x1039, 0x103a, 0x1714, 0x1734, 0x17d2, 0x1a60, 0x1b44, 0x1baa, 0x1bab, 0x1bf2, 0x1bf3, 0x2d7f, 0xa806, 0xa82c, 0xa8c4, 0xa953, 0xa9c0, 0xaaf6, 0xabed, 0x0c56, 0x0f71, 0x0f72, 0x0f7a, 0x0f7b, 0x0f7c, 0x0f7d, 0x0f80, 0x0f74]);
  var DIACRITICS_EXCEPTION_STR;
  var DIACRITICS_REG_EXP = /(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])+/g;
  var SPECIAL_CHARS_REG_EXP = /([\$\(-\+\.\?\[-\^\{-\}])|((?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]))|([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+)|((?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]))|((?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF]))/g;
  var NOT_DIACRITIC_FROM_END_REG_EXP = /((?:[\0-\u02FF\u0370-\u0482\u048A-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u060F\u061B-\u064A\u0660-\u066F\u0671-\u06D5\u06DD\u06DE\u06E5\u06E6\u06E9\u06EE-\u0710\u0712-\u072F\u074B-\u07A5\u07B1-\u07EA\u07F4-\u07FC\u07FE-\u0815\u081A\u0824\u0828\u082E-\u0858\u085C-\u0897\u08A0-\u08C9\u08E2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0964-\u0980\u0984-\u09BB\u09BD\u09C5\u09C6\u09C9\u09CA\u09CE-\u09D6\u09D8-\u09E1\u09E4-\u09FD\u09FF\u0A00\u0A04-\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A6F\u0A72-\u0A74\u0A76-\u0A80\u0A84-\u0ABB\u0ABD\u0AC6\u0ACA\u0ACE-\u0AE1\u0AE4-\u0AF9\u0B00\u0B04-\u0B3B\u0B3D\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B61\u0B64-\u0B81\u0B83-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE-\u0BD6\u0BD8-\u0BFF\u0C05-\u0C3B\u0C3D\u0C45\u0C49\u0C4E-\u0C54\u0C57-\u0C61\u0C64-\u0C80\u0C84-\u0CBB\u0CBD\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CE1\u0CE4-\u0CF2\u0CF4-\u0CFF\u0D04-\u0D3A\u0D3D\u0D45\u0D49\u0D4E-\u0D56\u0D58-\u0D61\u0D64-\u0D80\u0D84-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF4-\u0E30\u0E32\u0E33\u0E3B-\u0E46\u0E4F-\u0EB0\u0EB2\u0EB3\u0EBD-\u0EC7\u0ECF-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F40-\u0F70\u0F85\u0F88-\u0F8C\u0F98\u0FBD-\u0FC5\u0FC7-\u102A\u103F-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u109E-\u135C\u1360-\u1711\u1716-\u1731\u1735-\u1751\u1754-\u1771\u1774-\u17B3\u17D4-\u17DC\u17DE-\u180A\u180E\u1810-\u1884\u1887-\u18A8\u18AA-\u191F\u192C-\u192F\u193C-\u1A16\u1A1C-\u1A54\u1A5F\u1A7D\u1A7E\u1A80-\u1AAF\u1ACF-\u1AFF\u1B05-\u1B33\u1B45-\u1B6A\u1B74-\u1B7F\u1B83-\u1BA0\u1BAE-\u1BE5\u1BF4-\u1C23\u1C38-\u1CCF\u1CD3\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA-\u1DBF\u1E00-\u20CF\u20F1-\u2CEE\u2CF2-\u2D7E\u2D80-\u2DDF\u2E00-\u3029\u3030-\u3098\u309B-\uA66E\uA673\uA67E-\uA69D\uA6A0-\uA6EF\uA6F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA828-\uA82B\uA82D-\uA87F\uA882-\uA8B3\uA8C6-\uA8DF\uA8F2-\uA8FE\uA900-\uA925\uA92E-\uA946\uA954-\uA97F\uA984-\uA9B2\uA9C1-\uA9E4\uA9E6-\uAA28\uAA37-\uAA42\uAA44-\uAA4B\uAA4E-\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2-\uAAEA\uAAF0-\uAAF4\uAAF7-\uABE2\uABEB\uABEE-\uD7FF\uE000-\uFB1D\uFB1F-\uFDFF\uFE10-\uFE1F\uFE30-\uFFFF]|\uD800[\uDC00-\uDDFC\uDDFE-\uDEDF\uDEE1-\uDF75\uDF7B-\uDFFF]|[\uD801\uD808-\uD80C\uD80E-\uD819\uD81C-\uD82E\uD830-\uD832\uD835\uD837\uD83B-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDE00\uDE04\uDE07-\uDE0B\uDE10-\uDE37\uDE3B-\uDE3E\uDE40-\uDEE4\uDEE7-\uDFFF]|\uD803[\uDC00-\uDD23\uDD28-\uDEAA\uDEAD-\uDEFC\uDF00-\uDF45\uDF51-\uDF81\uDF86-\uDFFF]|\uD804[\uDC03-\uDC37\uDC47-\uDC6F\uDC71\uDC72\uDC75-\uDC7E\uDC83-\uDCAF\uDCBB-\uDCC1\uDCC3-\uDCFF\uDD03-\uDD26\uDD35-\uDD44\uDD47-\uDD72\uDD74-\uDD7F\uDD83-\uDDB2\uDDC1-\uDDC8\uDDCD\uDDD0-\uDE2B\uDE38-\uDE3D\uDE3F\uDE40\uDE42-\uDEDE\uDEEB-\uDEFF\uDF04-\uDF3A\uDF3D\uDF45\uDF46\uDF49\uDF4A\uDF4E-\uDF56\uDF58-\uDF61\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC00-\uDC34\uDC47-\uDC5D\uDC5F-\uDCAF\uDCC4-\uDDAE\uDDB6\uDDB7\uDDC1-\uDDDB\uDDDE-\uDE2F\uDE41-\uDEAA\uDEB8-\uDF1C\uDF2C-\uDFFF]|\uD806[\uDC00-\uDC2B\uDC3B-\uDD2F\uDD36\uDD39\uDD3A\uDD3F\uDD41\uDD44-\uDDD0\uDDD8\uDDD9\uDDE1-\uDDE3\uDDE5-\uDE00\uDE0B-\uDE32\uDE3A\uDE3F-\uDE46\uDE48-\uDE50\uDE5C-\uDE89\uDE9A-\uDFFF]|\uD807[\uDC00-\uDC2E\uDC37\uDC40-\uDC91\uDCA8\uDCB7-\uDD30\uDD37-\uDD39\uDD3B\uDD3E\uDD46\uDD48-\uDD89\uDD8F\uDD92\uDD98-\uDEF2\uDEF7-\uDEFF\uDF02\uDF04-\uDF33\uDF3B-\uDF3D\uDF43-\uDFFF]|\uD80D[\uDC00-\uDC3F\uDC41-\uDC46\uDC56-\uDFFF]|\uD81A[\uDC00-\uDEEF\uDEF5-\uDF2F\uDF37-\uDFFF]|\uD81B[\uDC00-\uDF4E\uDF50\uDF88-\uDF8E\uDF93-\uDFE3\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD82F[\uDC00-\uDC9C\uDC9F-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDC8E\uDC90-\uDD2F\uDD37-\uDEAD\uDEAF-\uDEEB\uDEF0-\uDFFF]|\uD839[\uDC00-\uDCEB\uDCF0-\uDFFF]|\uD83A[\uDC00-\uDCCF\uDCD7-\uDD43\uDD4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])*$/;
  var NOT_DIACRITIC_FROM_START_REG_EXP = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])*((?:[\0-\u02FF\u0370-\u0482\u048A-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u060F\u061B-\u064A\u0660-\u066F\u0671-\u06D5\u06DD\u06DE\u06E5\u06E6\u06E9\u06EE-\u0710\u0712-\u072F\u074B-\u07A5\u07B1-\u07EA\u07F4-\u07FC\u07FE-\u0815\u081A\u0824\u0828\u082E-\u0858\u085C-\u0897\u08A0-\u08C9\u08E2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0964-\u0980\u0984-\u09BB\u09BD\u09C5\u09C6\u09C9\u09CA\u09CE-\u09D6\u09D8-\u09E1\u09E4-\u09FD\u09FF\u0A00\u0A04-\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A6F\u0A72-\u0A74\u0A76-\u0A80\u0A84-\u0ABB\u0ABD\u0AC6\u0ACA\u0ACE-\u0AE1\u0AE4-\u0AF9\u0B00\u0B04-\u0B3B\u0B3D\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B61\u0B64-\u0B81\u0B83-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE-\u0BD6\u0BD8-\u0BFF\u0C05-\u0C3B\u0C3D\u0C45\u0C49\u0C4E-\u0C54\u0C57-\u0C61\u0C64-\u0C80\u0C84-\u0CBB\u0CBD\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CE1\u0CE4-\u0CF2\u0CF4-\u0CFF\u0D04-\u0D3A\u0D3D\u0D45\u0D49\u0D4E-\u0D56\u0D58-\u0D61\u0D64-\u0D80\u0D84-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF4-\u0E30\u0E32\u0E33\u0E3B-\u0E46\u0E4F-\u0EB0\u0EB2\u0EB3\u0EBD-\u0EC7\u0ECF-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F40-\u0F70\u0F85\u0F88-\u0F8C\u0F98\u0FBD-\u0FC5\u0FC7-\u102A\u103F-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u109E-\u135C\u1360-\u1711\u1716-\u1731\u1735-\u1751\u1754-\u1771\u1774-\u17B3\u17D4-\u17DC\u17DE-\u180A\u180E\u1810-\u1884\u1887-\u18A8\u18AA-\u191F\u192C-\u192F\u193C-\u1A16\u1A1C-\u1A54\u1A5F\u1A7D\u1A7E\u1A80-\u1AAF\u1ACF-\u1AFF\u1B05-\u1B33\u1B45-\u1B6A\u1B74-\u1B7F\u1B83-\u1BA0\u1BAE-\u1BE5\u1BF4-\u1C23\u1C38-\u1CCF\u1CD3\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA-\u1DBF\u1E00-\u20CF\u20F1-\u2CEE\u2CF2-\u2D7E\u2D80-\u2DDF\u2E00-\u3029\u3030-\u3098\u309B-\uA66E\uA673\uA67E-\uA69D\uA6A0-\uA6EF\uA6F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA828-\uA82B\uA82D-\uA87F\uA882-\uA8B3\uA8C6-\uA8DF\uA8F2-\uA8FE\uA900-\uA925\uA92E-\uA946\uA954-\uA97F\uA984-\uA9B2\uA9C1-\uA9E4\uA9E6-\uAA28\uAA37-\uAA42\uAA44-\uAA4B\uAA4E-\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2-\uAAEA\uAAF0-\uAAF4\uAAF7-\uABE2\uABEB\uABEE-\uD7FF\uE000-\uFB1D\uFB1F-\uFDFF\uFE10-\uFE1F\uFE30-\uFFFF]|\uD800[\uDC00-\uDDFC\uDDFE-\uDEDF\uDEE1-\uDF75\uDF7B-\uDFFF]|[\uD801\uD808-\uD80C\uD80E-\uD819\uD81C-\uD82E\uD830-\uD832\uD835\uD837\uD83B-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDE00\uDE04\uDE07-\uDE0B\uDE10-\uDE37\uDE3B-\uDE3E\uDE40-\uDEE4\uDEE7-\uDFFF]|\uD803[\uDC00-\uDD23\uDD28-\uDEAA\uDEAD-\uDEFC\uDF00-\uDF45\uDF51-\uDF81\uDF86-\uDFFF]|\uD804[\uDC03-\uDC37\uDC47-\uDC6F\uDC71\uDC72\uDC75-\uDC7E\uDC83-\uDCAF\uDCBB-\uDCC1\uDCC3-\uDCFF\uDD03-\uDD26\uDD35-\uDD44\uDD47-\uDD72\uDD74-\uDD7F\uDD83-\uDDB2\uDDC1-\uDDC8\uDDCD\uDDD0-\uDE2B\uDE38-\uDE3D\uDE3F\uDE40\uDE42-\uDEDE\uDEEB-\uDEFF\uDF04-\uDF3A\uDF3D\uDF45\uDF46\uDF49\uDF4A\uDF4E-\uDF56\uDF58-\uDF61\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC00-\uDC34\uDC47-\uDC5D\uDC5F-\uDCAF\uDCC4-\uDDAE\uDDB6\uDDB7\uDDC1-\uDDDB\uDDDE-\uDE2F\uDE41-\uDEAA\uDEB8-\uDF1C\uDF2C-\uDFFF]|\uD806[\uDC00-\uDC2B\uDC3B-\uDD2F\uDD36\uDD39\uDD3A\uDD3F\uDD41\uDD44-\uDDD0\uDDD8\uDDD9\uDDE1-\uDDE3\uDDE5-\uDE00\uDE0B-\uDE32\uDE3A\uDE3F-\uDE46\uDE48-\uDE50\uDE5C-\uDE89\uDE9A-\uDFFF]|\uD807[\uDC00-\uDC2E\uDC37\uDC40-\uDC91\uDCA8\uDCB7-\uDD30\uDD37-\uDD39\uDD3B\uDD3E\uDD46\uDD48-\uDD89\uDD8F\uDD92\uDD98-\uDEF2\uDEF7-\uDEFF\uDF02\uDF04-\uDF33\uDF3B-\uDF3D\uDF43-\uDFFF]|\uD80D[\uDC00-\uDC3F\uDC41-\uDC46\uDC56-\uDFFF]|\uD81A[\uDC00-\uDEEF\uDEF5-\uDF2F\uDF37-\uDFFF]|\uD81B[\uDC00-\uDF4E\uDF50\uDF88-\uDF8E\uDF93-\uDFE3\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD82F[\uDC00-\uDC9C\uDC9F-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDC8E\uDC90-\uDD2F\uDD37-\uDEAD\uDEAF-\uDEEB\uDEF0-\uDFFF]|\uD839[\uDC00-\uDCEB\uDCF0-\uDFFF]|\uD83A[\uDC00-\uDCCF\uDCD7-\uDD43\uDD4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/;
  var SYLLABLES_REG_EXP = /[\uAC00-\uD7AF\uFA6C\uFACF-\uFAD1\uFAD5-\uFAD7]+/g;
  var SYLLABLES_LENGTHS = new Map();
  var FIRST_CHAR_SYLLABLES_REG_EXP = "[\\u1100-\\u1112\\ud7a4-\\ud7af\\ud84a\\ud84c\\ud850\\ud854\\ud857\\ud85f]";
  var NFKC_CHARS_TO_NORMALIZE = new Map();
  var noSyllablesRegExp = null;
  var withSyllablesRegExp = null;
  function normalize(text) {
    var syllablePositions = [];
    var m;
    while ((m = SYLLABLES_REG_EXP.exec(text)) !== null) {
      var _m = m,
        index = _m.index;
      var _iterator3 = _createForOfIteratorHelper(m[0]),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _char = _step3.value;
          var len = SYLLABLES_LENGTHS.get(_char);
          if (!len) {
            len = _char.normalize("NFD").length;
            SYLLABLES_LENGTHS.set(_char, len);
          }
          syllablePositions.push([len, index++]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    var normalizationRegex;
    if (syllablePositions.length === 0 && noSyllablesRegExp) {
      normalizationRegex = noSyllablesRegExp;
    } else if (syllablePositions.length > 0 && withSyllablesRegExp) {
      normalizationRegex = withSyllablesRegExp;
    } else {
      var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join("");
      var toNormalizeWithNFKC = getNormalizeWithNFKC();
      var CJK = "(?:\\p{Ideographic}|[\u3040-\u30FF])";
      var HKDiacritics = "(?:\u3099|\u309A)";
      var regexp = "([".concat(replace, "])|([").concat(toNormalizeWithNFKC, "])|(").concat(HKDiacritics, "\\n)|(\\p{M}+(?:-\\n)?)|(\\S-\\n)|(").concat(CJK, "\\n)|(\\n)");
      if (syllablePositions.length === 0) {
        normalizationRegex = noSyllablesRegExp = new RegExp(regexp + "|(\\u0000)", "gum");
      } else {
        normalizationRegex = withSyllablesRegExp = new RegExp(regexp + "|(".concat(FIRST_CHAR_SYLLABLES_REG_EXP, ")"), "gum");
      }
    }
    var rawDiacriticsPositions = [];
    while ((m = DIACRITICS_REG_EXP.exec(text)) !== null) {
      rawDiacriticsPositions.push([m[0].length, m.index]);
    }
    var normalized = text.normalize("NFD");
    var positions = [[0, 0]];
    var rawDiacriticsIndex = 0;
    var syllableIndex = 0;
    var shift = 0;
    var shiftOrigin = 0;
    var eol = 0;
    var hasDiacritics = false;
    normalized = normalized.replace(normalizationRegex, function (match, p1, p2, p3, p4, p5, p6, p7, p8, i) {
      var _syllablePositions$sy;
      i -= shiftOrigin;
      if (p1) {
        var replacement = CHARACTERS_TO_NORMALIZE[p1];
        var jj = replacement.length;
        for (var j = 1; j < jj; j++) {
          positions.push([i - shift + j, shift - j]);
        }
        shift -= jj - 1;
        return replacement;
      }
      if (p2) {
        var _replacement = NFKC_CHARS_TO_NORMALIZE.get(p2);
        if (!_replacement) {
          _replacement = p2.normalize("NFKC");
          NFKC_CHARS_TO_NORMALIZE.set(p2, _replacement);
        }
        var _jj = _replacement.length;
        for (var _j = 1; _j < _jj; _j++) {
          positions.push([i - shift + _j, shift - _j]);
        }
        shift -= _jj - 1;
        return _replacement;
      }
      if (p3) {
        var _rawDiacriticsPositio;
        hasDiacritics = true;
        if (i + eol === ((_rawDiacriticsPositio = rawDiacriticsPositions[rawDiacriticsIndex]) === null || _rawDiacriticsPositio === void 0 ? void 0 : _rawDiacriticsPositio[1])) {
          ++rawDiacriticsIndex;
        } else {
          positions.push([i - 1 - shift + 1, shift - 1]);
          shift -= 1;
          shiftOrigin += 1;
        }
        positions.push([i - shift + 1, shift]);
        shiftOrigin += 1;
        eol += 1;
        return p3.charAt(0);
      }
      if (p4) {
        var _rawDiacriticsPositio2;
        var hasTrailingDashEOL = p4.endsWith("\n");
        var _len = hasTrailingDashEOL ? p4.length - 2 : p4.length;
        hasDiacritics = true;
        var _jj2 = _len;
        if (i + eol === ((_rawDiacriticsPositio2 = rawDiacriticsPositions[rawDiacriticsIndex]) === null || _rawDiacriticsPositio2 === void 0 ? void 0 : _rawDiacriticsPositio2[1])) {
          _jj2 -= rawDiacriticsPositions[rawDiacriticsIndex][0];
          ++rawDiacriticsIndex;
        }
        for (var _j2 = 1; _j2 <= _jj2; _j2++) {
          positions.push([i - 1 - shift + _j2, shift - _j2]);
        }
        shift -= _jj2;
        shiftOrigin += _jj2;
        if (hasTrailingDashEOL) {
          i += _len - 1;
          positions.push([i - shift + 1, 1 + shift]);
          shift += 1;
          shiftOrigin += 1;
          eol += 1;
          return p4.slice(0, _len);
        }
        return p4;
      }
      if (p5) {
        var _len2 = p5.length - 2;
        positions.push([i - shift + _len2, 1 + shift]);
        shift += 1;
        shiftOrigin += 1;
        eol += 1;
        return p5.slice(0, -2);
      }
      if (p6) {
        var _len3 = p6.length - 1;
        positions.push([i - shift + _len3, shift]);
        shiftOrigin += 1;
        eol += 1;
        return p6.slice(0, -1);
      }
      if (p7) {
        positions.push([i - shift + 1, shift - 1]);
        shift -= 1;
        shiftOrigin += 1;
        eol += 1;
        return " ";
      }
      if (i + eol === ((_syllablePositions$sy = syllablePositions[syllableIndex]) === null || _syllablePositions$sy === void 0 ? void 0 : _syllablePositions$sy[1])) {
        var newCharLen = syllablePositions[syllableIndex][0] - 1;
        ++syllableIndex;
        for (var _j3 = 1; _j3 <= newCharLen; _j3++) {
          positions.push([i - (shift - _j3), shift - _j3]);
        }
        shift -= newCharLen;
        shiftOrigin += newCharLen;
      }
      return p8;
    });
    positions.push([normalized.length, shift]);
    return [normalized, positions, hasDiacritics];
  }
  function getOriginalIndex(diffs, pos, len) {
    if (!diffs) {
      return [pos, len];
    }
    var start = pos;
    var end = pos + len - 1;
    var i = binarySearchFirstItem(diffs, function (x) {
      return x[0] >= start;
    });
    if (diffs[i][0] > start) {
      --i;
    }
    var j = binarySearchFirstItem(diffs, function (x) {
      return x[0] >= end;
    }, i);
    if (diffs[j][0] > end) {
      --j;
    }
    var oldStart = start + diffs[i][1];
    var oldEnd = end + diffs[j][1];
    var oldLen = oldEnd + 1 - oldStart;
    return [oldStart, oldLen];
  }
  var _state = /*#__PURE__*/new WeakMap();
  var _updateMatchesCountOnProgress = /*#__PURE__*/new WeakMap();
  var _visitedPagesCount = /*#__PURE__*/new WeakMap();
  var _PDFFindController_brand = /*#__PURE__*/new WeakSet();
  var _PDFFindController = /*#__PURE__*/function () {
    function _PDFFindController(_ref3) {
      var _linkService = _ref3.linkService,
        eventBus = _ref3.eventBus,
        _ref3$updateMatchesCo = _ref3.updateMatchesCountOnProgress,
        updateMatchesCountOnProgress = _ref3$updateMatchesCo === void 0 ? true : _ref3$updateMatchesCo;
      _classCallCheck(this, _PDFFindController);
      _classPrivateMethodInitSpec(this, _PDFFindController_brand);
      _classPrivateFieldInitSpec(this, _state, null);
      _classPrivateFieldInitSpec(this, _updateMatchesCountOnProgress, true);
      _classPrivateFieldInitSpec(this, _visitedPagesCount, 0);
      this._linkService = _linkService;
      this._eventBus = eventBus;
      _classPrivateFieldSet2(_updateMatchesCountOnProgress, this, updateMatchesCountOnProgress);
      this.onIsPageVisible = null;
      _assertClassBrand(_PDFFindController_brand, this, _reset).call(this);
      eventBus._on("find", _assertClassBrand(_PDFFindController_brand, this, _onFind).bind(this));
      eventBus._on("findbarclose", _assertClassBrand(_PDFFindController_brand, this, _onFindBarClose).bind(this));
    }
    return _createClass(_PDFFindController, [{
      key: "highlightMatches",
      get: function get() {
        return this._highlightMatches;
      }
    }, {
      key: "pageMatches",
      get: function get() {
        return this._pageMatches;
      }
    }, {
      key: "pageMatchesLength",
      get: function get() {
        return this._pageMatchesLength;
      }
    }, {
      key: "selected",
      get: function get() {
        return this._selected;
      }
    }, {
      key: "state",
      get: function get() {
        return _classPrivateFieldGet2(_state, this);
      }
    }, {
      key: "setDocument",
      value: function setDocument(pdfDocument) {
        if (this._pdfDocument) {
          _assertClassBrand(_PDFFindController_brand, this, _reset).call(this);
        }
        if (!pdfDocument) {
          return;
        }
        this._pdfDocument = pdfDocument;
        this._firstPageCapability.resolve();
      }
    }, {
      key: "scrollMatchIntoView",
      value: function scrollMatchIntoView(_ref4) {
        var _ref4$element = _ref4.element,
          element = _ref4$element === void 0 ? null : _ref4$element,
          _ref4$selectedLeft = _ref4.selectedLeft,
          selectedLeft = _ref4$selectedLeft === void 0 ? 0 : _ref4$selectedLeft,
          _ref4$pageIndex = _ref4.pageIndex,
          pageIndex = _ref4$pageIndex === void 0 ? -1 : _ref4$pageIndex,
          _ref4$matchIndex = _ref4.matchIndex,
          matchIndex = _ref4$matchIndex === void 0 ? -1 : _ref4$matchIndex;
        if (!this._scrollMatches || !element) {
          return;
        } else if (matchIndex === -1 || matchIndex !== this._selected.matchIdx) {
          return;
        } else if (pageIndex === -1 || pageIndex !== this._selected.pageIdx) {
          return;
        }
        this._scrollMatches = false;
        var spot = {
          top: MATCH_SCROLL_OFFSET_TOP,
          left: selectedLeft + MATCH_SCROLL_OFFSET_LEFT
        };
        scrollIntoView(element, spot, true);
      }
    }]);
  }(); // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.json.parse.js
  function _onFind(state) {
    var _this32 = this;
    if (!state) {
      return;
    }
    var pdfDocument = this._pdfDocument;
    var type = state.type;
    if (_classPrivateFieldGet2(_state, this) === null || _assertClassBrand(_PDFFindController_brand, this, _shouldDirtyMatch).call(this, state)) {
      this._dirtyMatch = true;
    }
    _classPrivateFieldSet2(_state, this, state);
    if (type !== "highlightallchange") {
      _assertClassBrand(_PDFFindController_brand, this, _updateUIState).call(this, _FindState.PENDING);
    }
    this._firstPageCapability.promise.then(function () {
      if (!_this32._pdfDocument || pdfDocument && _this32._pdfDocument !== pdfDocument) {
        return;
      }
      _assertClassBrand(_PDFFindController_brand, _this32, _extractText).call(_this32);
      var findbarClosed = !_this32._highlightMatches;
      var pendingTimeout = !!_this32._findTimeout;
      if (_this32._findTimeout) {
        clearTimeout(_this32._findTimeout);
        _this32._findTimeout = null;
      }
      if (!type) {
        _this32._findTimeout = setTimeout(function () {
          _assertClassBrand(_PDFFindController_brand, _this32, _nextMatch).call(_this32);
          _this32._findTimeout = null;
        }, FIND_TIMEOUT);
      } else if (_this32._dirtyMatch) {
        _assertClassBrand(_PDFFindController_brand, _this32, _nextMatch).call(_this32);
      } else if (type === "again") {
        _assertClassBrand(_PDFFindController_brand, _this32, _nextMatch).call(_this32);
        if (findbarClosed && _classPrivateFieldGet2(_state, _this32).highlightAll) {
          _assertClassBrand(_PDFFindController_brand, _this32, _updateAllPages).call(_this32);
        }
      } else if (type === "highlightallchange") {
        if (pendingTimeout) {
          _assertClassBrand(_PDFFindController_brand, _this32, _nextMatch).call(_this32);
        } else {
          _this32._highlightMatches = true;
        }
        _assertClassBrand(_PDFFindController_brand, _this32, _updateAllPages).call(_this32);
      } else {
        _assertClassBrand(_PDFFindController_brand, _this32, _nextMatch).call(_this32);
      }
    });
  }
  function _reset() {
    this._highlightMatches = false;
    this._scrollMatches = false;
    this._pdfDocument = null;
    this._pageMatches = [];
    this._pageMatchesLength = [];
    _classPrivateFieldSet2(_visitedPagesCount, this, 0);
    _classPrivateFieldSet2(_state, this, null);
    this._selected = {
      pageIdx: -1,
      matchIdx: -1
    };
    this._offset = {
      pageIdx: null,
      matchIdx: null,
      wrapped: false
    };
    this._extractTextPromises = [];
    this._pageContents = [];
    this._pageDiffs = [];
    this._hasDiacritics = [];
    this._matchesCountTotal = 0;
    this._pagesToSearch = null;
    this._pendingFindMatches = new Set();
    this._resumePageIdx = null;
    this._dirtyMatch = false;
    clearTimeout(this._findTimeout);
    this._findTimeout = null;
    this._firstPageCapability = Promise.withResolvers();
  }
  function _get_query(_this4) {
    var _classPrivateFieldGet29 = _classPrivateFieldGet2(_state, _this4),
      query = _classPrivateFieldGet29.query;
    if (typeof query === "string") {
      if (query !== _this4._rawQuery) {
        _this4._rawQuery = query;
        var _normalize = normalize(query);
        var _normalize2 = _slicedToArray(_normalize, 1);
        _this4._normalizedQuery = _normalize2[0];
      }
      return _this4._normalizedQuery;
    }
    return (query || []).filter(function (q) {
      return !!q;
    }).map(function (q) {
      return normalize(q)[0];
    });
  }
  function _shouldDirtyMatch(state) {
    var _this$onIsPageVisible, _this$onIsPageVisible2;
    var newQuery = state.query,
      prevQuery = _classPrivateFieldGet2(_state, this).query;
    var newType = _typeof(newQuery),
      prevType = _typeof(prevQuery);
    if (newType !== prevType) {
      return true;
    }
    if (newType === "string") {
      if (newQuery !== prevQuery) {
        return true;
      }
    } else if (JSON.stringify(newQuery) !== JSON.stringify(prevQuery)) {
      return true;
    }
    switch (state.type) {
      case "again":
        var pageNumber = this._selected.pageIdx + 1;
        var linkService = this._linkService;
        return pageNumber >= 1 && pageNumber <= linkService.pagesCount && pageNumber !== linkService.page && !((_this$onIsPageVisible = (_this$onIsPageVisible2 = this.onIsPageVisible) === null || _this$onIsPageVisible2 === void 0 ? void 0 : _this$onIsPageVisible2.call(this, pageNumber)) !== null && _this$onIsPageVisible !== void 0 ? _this$onIsPageVisible : true);
      case "highlightallchange":
        return false;
    }
    return true;
  }
  function _isEntireWord(content, startIdx, length) {
    var match = content.slice(0, startIdx).match(NOT_DIACRITIC_FROM_END_REG_EXP);
    if (match) {
      var first = content.charCodeAt(startIdx);
      var limit = match[1].charCodeAt(0);
      if (getCharacterType(first) === getCharacterType(limit)) {
        return false;
      }
    }
    match = content.slice(startIdx + length).match(NOT_DIACRITIC_FROM_START_REG_EXP);
    if (match) {
      var last = content.charCodeAt(startIdx + length - 1);
      var _limit = match[1].charCodeAt(0);
      if (getCharacterType(last) === getCharacterType(_limit)) {
        return false;
      }
    }
    return true;
  }
  function _calculateRegExpMatch(query, entireWord, pageIndex, pageContent) {
    var matches = this._pageMatches[pageIndex] = [];
    var matchesLength = this._pageMatchesLength[pageIndex] = [];
    if (!query) {
      return;
    }
    var diffs = this._pageDiffs[pageIndex];
    var match;
    while ((match = query.exec(pageContent)) !== null) {
      if (entireWord && !_assertClassBrand(_PDFFindController_brand, this, _isEntireWord).call(this, pageContent, match.index, match[0].length)) {
        continue;
      }
      var _getOriginalIndex = getOriginalIndex(diffs, match.index, match[0].length),
        _getOriginalIndex2 = _slicedToArray(_getOriginalIndex, 2),
        matchPos = _getOriginalIndex2[0],
        matchLen = _getOriginalIndex2[1];
      if (matchLen) {
        matches.push(matchPos);
        matchesLength.push(matchLen);
      }
    }
  }
  function _convertToRegExpString(query, hasDiacritics) {
    var _classPrivateFieldGet30 = _classPrivateFieldGet2(_state, this),
      matchDiacritics = _classPrivateFieldGet30.matchDiacritics;
    var isUnicode = false;
    query = query.replaceAll(SPECIAL_CHARS_REG_EXP, function (match, p1, p2, p3, p4, p5) {
      if (p1) {
        return "[ ]*\\".concat(p1, "[ ]*");
      }
      if (p2) {
        return "[ ]*".concat(p2, "[ ]*");
      }
      if (p3) {
        return "[ ]+";
      }
      if (matchDiacritics) {
        return p4 || p5;
      }
      if (p4) {
        return DIACRITICS_EXCEPTION.has(p4.charCodeAt(0)) ? p4 : "";
      }
      if (hasDiacritics) {
        isUnicode = true;
        return "".concat(p5, "\\p{M}*");
      }
      return p5;
    });
    var trailingSpaces = "[ ]*";
    if (query.endsWith(trailingSpaces)) {
      query = query.slice(0, query.length - trailingSpaces.length);
    }
    if (matchDiacritics) {
      if (hasDiacritics) {
        DIACRITICS_EXCEPTION_STR || (DIACRITICS_EXCEPTION_STR = String.fromCharCode.apply(String, _toConsumableArray(DIACRITICS_EXCEPTION)));
        isUnicode = true;
        query = "".concat(query, "(?=[").concat(DIACRITICS_EXCEPTION_STR, "]|[^\\p{M}]|$)");
      }
    }
    return [isUnicode, query];
  }
  function _calculateMatch(pageIndex) {
    var _this33 = this;
    var _this$visitedPagesCou;
    var query = _classPrivateGetter(_PDFFindController_brand, this, _get_query);
    if (query.length === 0) {
      return;
    }
    var _classPrivateFieldGet31 = _classPrivateFieldGet2(_state, this),
      caseSensitive = _classPrivateFieldGet31.caseSensitive,
      entireWord = _classPrivateFieldGet31.entireWord;
    var pageContent = this._pageContents[pageIndex];
    var hasDiacritics = this._hasDiacritics[pageIndex];
    var isUnicode = false;
    if (typeof query === "string") {
      var _assertClassBrand$cal3 = _assertClassBrand(_PDFFindController_brand, this, _convertToRegExpString).call(this, query, hasDiacritics);
      var _assertClassBrand$cal4 = _slicedToArray(_assertClassBrand$cal3, 2);
      isUnicode = _assertClassBrand$cal4[0];
      query = _assertClassBrand$cal4[1];
    } else {
      query = query.sort().reverse().map(function (q) {
        var _assertClassBrand$cal5 = _assertClassBrand(_PDFFindController_brand, _this33, _convertToRegExpString).call(_this33, q, hasDiacritics),
          _assertClassBrand$cal6 = _slicedToArray(_assertClassBrand$cal5, 2),
          isUnicodePart = _assertClassBrand$cal6[0],
          queryPart = _assertClassBrand$cal6[1];
        isUnicode || (isUnicode = isUnicodePart);
        return "(".concat(queryPart, ")");
      }).join("|");
    }
    var flags = "g".concat(isUnicode ? "u" : "").concat(caseSensitive ? "" : "i");
    query = query ? new RegExp(query, flags) : null;
    _assertClassBrand(_PDFFindController_brand, this, _calculateRegExpMatch).call(this, query, entireWord, pageIndex, pageContent);
    if (_classPrivateFieldGet2(_state, this).highlightAll) {
      _assertClassBrand(_PDFFindController_brand, this, _updatePage).call(this, pageIndex);
    }
    if (this._resumePageIdx === pageIndex) {
      this._resumePageIdx = null;
      _assertClassBrand(_PDFFindController_brand, this, _nextPageMatch).call(this);
    }
    var pageMatchesCount = this._pageMatches[pageIndex].length;
    this._matchesCountTotal += pageMatchesCount;
    if (_classPrivateFieldGet2(_updateMatchesCountOnProgress, this)) {
      if (pageMatchesCount > 0) {
        _assertClassBrand(_PDFFindController_brand, this, _updateUIResultsCount).call(this);
      }
    } else if (_classPrivateFieldSet2(_visitedPagesCount, this, (_this$visitedPagesCou = _classPrivateFieldGet2(_visitedPagesCount, this), ++_this$visitedPagesCou)) === this._linkService.pagesCount) {
      _assertClassBrand(_PDFFindController_brand, this, _updateUIResultsCount).call(this);
    }
  }
  function _extractText() {
    var _this34 = this;
    if (this._extractTextPromises.length > 0) {
      return;
    }
    var deferred = Promise.resolve();
    var textOptions = {
      disableNormalization: true
    };
    var _loop2 = function _loop2(i) {
      var _Promise$withResolver = Promise.withResolvers(),
        promise = _Promise$withResolver.promise,
        resolve = _Promise$withResolver.resolve;
      _this34._extractTextPromises[i] = promise;
      deferred = deferred.then(function () {
        return _this34._pdfDocument.getPage(i + 1).then(function (pdfPage) {
          return pdfPage.getTextContent(textOptions);
        }).then(function (textContent) {
          var strBuf = [];
          var _iterator31 = _createForOfIteratorHelper(textContent.items),
            _step31;
          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var textItem = _step31.value;
              strBuf.push(textItem.str);
              if (textItem.hasEOL) {
                strBuf.push("\n");
              }
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }
          var _normalize3 = normalize(strBuf.join(""));
          var _normalize4 = _slicedToArray(_normalize3, 3);
          _this34._pageContents[i] = _normalize4[0];
          _this34._pageDiffs[i] = _normalize4[1];
          _this34._hasDiacritics[i] = _normalize4[2];
          resolve();
        }, function (reason) {
          console.error("Unable to get text content for page ".concat(i + 1), reason);
          _this34._pageContents[i] = "";
          _this34._pageDiffs[i] = null;
          _this34._hasDiacritics[i] = false;
          resolve();
        });
      });
    };
    for (var i = 0, ii = this._linkService.pagesCount; i < ii; i++) {
      _loop2(i);
    }
  }
  function _updatePage(index) {
    if (this._scrollMatches && this._selected.pageIdx === index) {
      this._linkService.page = index + 1;
    }
    this._eventBus.dispatch("updatetextlayermatches", {
      source: this,
      pageIndex: index
    });
  }
  function _updateAllPages() {
    this._eventBus.dispatch("updatetextlayermatches", {
      source: this,
      pageIndex: -1
    });
  }
  function _nextMatch() {
    var _this35 = this;
    var previous = _classPrivateFieldGet2(_state, this).findPrevious;
    var currentPageIndex = this._linkService.page - 1;
    var numPages = this._linkService.pagesCount;
    this._highlightMatches = true;
    if (this._dirtyMatch) {
      this._dirtyMatch = false;
      this._selected.pageIdx = this._selected.matchIdx = -1;
      this._offset.pageIdx = currentPageIndex;
      this._offset.matchIdx = null;
      this._offset.wrapped = false;
      this._resumePageIdx = null;
      this._pageMatches.length = 0;
      this._pageMatchesLength.length = 0;
      _classPrivateFieldSet2(_visitedPagesCount, this, 0);
      this._matchesCountTotal = 0;
      _assertClassBrand(_PDFFindController_brand, this, _updateAllPages).call(this);
      var _loop3 = function _loop3(i) {
        if (_this35._pendingFindMatches.has(i)) {
          return 1; // continue
        }
        _this35._pendingFindMatches.add(i);
        _this35._extractTextPromises[i].then(function () {
          _this35._pendingFindMatches["delete"](i);
          _assertClassBrand(_PDFFindController_brand, _this35, _calculateMatch).call(_this35, i);
        });
      };
      for (var i = 0; i < numPages; i++) {
        if (_loop3(i)) continue;
      }
    }
    var query = _classPrivateGetter(_PDFFindController_brand, this, _get_query);
    if (query.length === 0) {
      _assertClassBrand(_PDFFindController_brand, this, _updateUIState).call(this, _FindState.FOUND);
      return;
    }
    if (this._resumePageIdx) {
      return;
    }
    var offset = this._offset;
    this._pagesToSearch = numPages;
    if (offset.matchIdx !== null) {
      var numPageMatches = this._pageMatches[offset.pageIdx].length;
      if (!previous && offset.matchIdx + 1 < numPageMatches || previous && offset.matchIdx > 0) {
        offset.matchIdx = previous ? offset.matchIdx - 1 : offset.matchIdx + 1;
        _assertClassBrand(_PDFFindController_brand, this, _updateMatch).call(this, true);
        return;
      }
      _assertClassBrand(_PDFFindController_brand, this, _advanceOffsetPage).call(this, previous);
    }
    _assertClassBrand(_PDFFindController_brand, this, _nextPageMatch).call(this);
  }
  function _matchesReady(matches) {
    var offset = this._offset;
    var numMatches = matches.length;
    var previous = _classPrivateFieldGet2(_state, this).findPrevious;
    if (numMatches) {
      offset.matchIdx = previous ? numMatches - 1 : 0;
      _assertClassBrand(_PDFFindController_brand, this, _updateMatch).call(this, true);
      return true;
    }
    _assertClassBrand(_PDFFindController_brand, this, _advanceOffsetPage).call(this, previous);
    if (offset.wrapped) {
      offset.matchIdx = null;
      if (this._pagesToSearch < 0) {
        _assertClassBrand(_PDFFindController_brand, this, _updateMatch).call(this, false);
        return true;
      }
    }
    return false;
  }
  function _nextPageMatch() {
    if (this._resumePageIdx !== null) {
      console.error("There can only be one pending page.");
    }
    var matches = null;
    do {
      var pageIdx = this._offset.pageIdx;
      matches = this._pageMatches[pageIdx];
      if (!matches) {
        this._resumePageIdx = pageIdx;
        break;
      }
    } while (!_assertClassBrand(_PDFFindController_brand, this, _matchesReady).call(this, matches));
  }
  function _advanceOffsetPage(previous) {
    var offset = this._offset;
    var numPages = this._linkService.pagesCount;
    offset.pageIdx = previous ? offset.pageIdx - 1 : offset.pageIdx + 1;
    offset.matchIdx = null;
    this._pagesToSearch--;
    if (offset.pageIdx >= numPages || offset.pageIdx < 0) {
      offset.pageIdx = previous ? numPages - 1 : 0;
      offset.wrapped = true;
    }
  }
  function _updateMatch() {
    var found = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var state = _FindState.NOT_FOUND;
    var wrapped = this._offset.wrapped;
    this._offset.wrapped = false;
    if (found) {
      var previousPage = this._selected.pageIdx;
      this._selected.pageIdx = this._offset.pageIdx;
      this._selected.matchIdx = this._offset.matchIdx;
      state = wrapped ? _FindState.WRAPPED : _FindState.FOUND;
      if (previousPage !== -1 && previousPage !== this._selected.pageIdx) {
        _assertClassBrand(_PDFFindController_brand, this, _updatePage).call(this, previousPage);
      }
    }
    _assertClassBrand(_PDFFindController_brand, this, _updateUIState).call(this, state, _classPrivateFieldGet2(_state, this).findPrevious);
    if (this._selected.pageIdx !== -1) {
      this._scrollMatches = true;
      _assertClassBrand(_PDFFindController_brand, this, _updatePage).call(this, this._selected.pageIdx);
    }
  }
  function _onFindBarClose(evt) {
    var _this36 = this;
    var pdfDocument = this._pdfDocument;
    this._firstPageCapability.promise.then(function () {
      if (!_this36._pdfDocument || pdfDocument && _this36._pdfDocument !== pdfDocument) {
        return;
      }
      if (_this36._findTimeout) {
        clearTimeout(_this36._findTimeout);
        _this36._findTimeout = null;
      }
      if (_this36._resumePageIdx) {
        _this36._resumePageIdx = null;
        _this36._dirtyMatch = true;
      }
      _assertClassBrand(_PDFFindController_brand, _this36, _updateUIState).call(_this36, _FindState.FOUND);
      _this36._highlightMatches = false;
      _assertClassBrand(_PDFFindController_brand, _this36, _updateAllPages).call(_this36);
    });
  }
  function _requestMatchesCount() {
    var _this$_selected = this._selected,
      pageIdx = _this$_selected.pageIdx,
      matchIdx = _this$_selected.matchIdx;
    var current = 0,
      total = this._matchesCountTotal;
    if (matchIdx !== -1) {
      for (var i = 0; i < pageIdx; i++) {
        var _this$_pageMatches$i;
        current += ((_this$_pageMatches$i = this._pageMatches[i]) === null || _this$_pageMatches$i === void 0 ? void 0 : _this$_pageMatches$i.length) || 0;
      }
      current += matchIdx + 1;
    }
    if (current < 1 || current > total) {
      current = total = 0;
    }
    return {
      current: current,
      total: total
    };
  }
  function _updateUIResultsCount() {
    this._eventBus.dispatch("updatefindmatchescount", {
      source: this,
      matchesCount: _assertClassBrand(_PDFFindController_brand, this, _requestMatchesCount).call(this)
    });
  }
  function _updateUIState(state) {
    var _classPrivateFieldGet32, _classPrivateFieldGet33;
    var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!_classPrivateFieldGet2(_updateMatchesCountOnProgress, this) && (_classPrivateFieldGet2(_visitedPagesCount, this) !== this._linkService.pagesCount || state === _FindState.PENDING)) {
      return;
    }
    this._eventBus.dispatch("updatefindcontrolstate", {
      source: this,
      state: state,
      previous: previous,
      matchesCount: _assertClassBrand(_PDFFindController_brand, this, _requestMatchesCount).call(this),
      rawQuery: (_classPrivateFieldGet32 = (_classPrivateFieldGet33 = _classPrivateFieldGet2(_state, this)) === null || _classPrivateFieldGet33 === void 0 ? void 0 : _classPrivateFieldGet33.query) !== null && _classPrivateFieldGet32 !== void 0 ? _classPrivateFieldGet32 : null
    });
  }
  __webpack_require__(8335);

  var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
  var _LinkTarget = {
    NONE: 0,
    SELF: 1,
    BLANK: 2,
    PARENT: 3,
    TOP: 4
  };
  var _PDFLinkService = /*#__PURE__*/function () {
    function _PDFLinkService() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref5.eventBus,
        _ref5$externalLinkTar = _ref5.externalLinkTarget,
        externalLinkTarget = _ref5$externalLinkTar === void 0 ? null : _ref5$externalLinkTar,
        _ref5$externalLinkRel = _ref5.externalLinkRel,
        externalLinkRel = _ref5$externalLinkRel === void 0 ? null : _ref5$externalLinkRel,
        _ref5$ignoreDestinati = _ref5.ignoreDestinationZoom,
        ignoreDestinationZoom = _ref5$ignoreDestinati === void 0 ? false : _ref5$ignoreDestinati;
      _classCallCheck(this, _PDFLinkService);
      _defineProperty(this, "externalLinkEnabled", true);
      this.eventBus = eventBus;
      this.externalLinkTarget = externalLinkTarget;
      this.externalLinkRel = externalLinkRel;
      this._ignoreDestinationZoom = ignoreDestinationZoom;
      this.baseUrl = null;
      this.pdfDocument = null;
      this.pdfViewer = null;
      this.pdfHistory = null;
    }
    return _createClass(_PDFLinkService, [{
      key: "setDocument",
      value: function setDocument(pdfDocument) {
        var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.baseUrl = baseUrl;
        this.pdfDocument = pdfDocument;
      }
    }, {
      key: "setViewer",
      value: function setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
      }
    }, {
      key: "setHistory",
      value: function setHistory(pdfHistory) {
        this.pdfHistory = pdfHistory;
      }
    }, {
      key: "pagesCount",
      get: function get() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
      }
    }, {
      key: "page",
      get: function get() {
        return this.pdfDocument ? this.pdfViewer.currentPageNumber : 1;
      },
      set: function set(value) {
        if (this.pdfDocument) {
          this.pdfViewer.currentPageNumber = value;
        }
      }
    }, {
      key: "rotation",
      get: function get() {
        return this.pdfDocument ? this.pdfViewer.pagesRotation : 0;
      },
      set: function set(value) {
        if (this.pdfDocument) {
          this.pdfViewer.pagesRotation = value;
        }
      }
    }, {
      key: "isInPresentationMode",
      get: function get() {
        return this.pdfDocument ? this.pdfViewer.isInPresentationMode : false;
      }
    }, {
      key: "goToDestination",
      value: function () {
        var _goToDestination = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dest) {
          var namedDest, explicitDest, pageNumber, _explicitDest, _explicitDest2, destRef;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (this.pdfDocument) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                if (!(typeof dest === "string")) {
                  _context.next = 9;
                  break;
                }
                namedDest = dest;
                _context.next = 6;
                return this.pdfDocument.getDestination(dest);
              case 6:
                explicitDest = _context.sent;
                _context.next = 13;
                break;
              case 9:
                namedDest = null;
                _context.next = 12;
                return dest;
              case 12:
                explicitDest = _context.sent;
              case 13:
                if (Array.isArray(explicitDest)) {
                  _context.next = 16;
                  break;
                }
                console.error("goToDestination: \"".concat(explicitDest, "\" is not a valid destination array, for dest=\"").concat(dest, "\"."));
                return _context.abrupt("return");
              case 16:
                _explicitDest = explicitDest, _explicitDest2 = _slicedToArray(_explicitDest, 1), destRef = _explicitDest2[0];
                if (!(destRef && _typeof(destRef) === "object")) {
                  _context.next = 33;
                  break;
                }
                pageNumber = this.pdfDocument.cachedPageNumber(destRef);
                if (pageNumber) {
                  _context.next = 31;
                  break;
                }
                _context.prev = 20;
                _context.next = 23;
                return this.pdfDocument.getPageIndex(destRef);
              case 23:
                _context.t0 = _context.sent;
                pageNumber = _context.t0 + 1;
                _context.next = 31;
                break;
              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](20);
                console.error("goToDestination: \"".concat(destRef, "\" is not a valid page reference, for dest=\"").concat(dest, "\"."));
                return _context.abrupt("return");
              case 31:
                _context.next = 34;
                break;
              case 33:
                if (Number.isInteger(destRef)) {
                  pageNumber = destRef + 1;
                }
              case 34:
                if (!(!pageNumber || pageNumber < 1 || pageNumber > this.pagesCount)) {
                  _context.next = 37;
                  break;
                }
                console.error("goToDestination: \"".concat(pageNumber, "\" is not a valid page number, for dest=\"").concat(dest, "\"."));
                return _context.abrupt("return");
              case 37:
                if (this.pdfHistory) {
                  this.pdfHistory.pushCurrentPosition();
                  this.pdfHistory.push({
                    namedDest: namedDest,
                    explicitDest: explicitDest,
                    pageNumber: pageNumber
                  });
                }
                this.pdfViewer.scrollPageIntoView({
                  pageNumber: pageNumber,
                  destArray: explicitDest,
                  ignoreDestinationZoom: this._ignoreDestinationZoom
                });
              case 39:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[20, 27]]);
        }));
        function goToDestination(_x) {
          return _goToDestination.apply(this, arguments);
        }
        return goToDestination;
      }()
    }, {
      key: "goToPage",
      value: function goToPage(val) {
        if (!this.pdfDocument) {
          return;
        }
        var pageNumber = typeof val === "string" && this.pdfViewer.pageLabelToPageNumber(val) || val | 0;
        if (!(Number.isInteger(pageNumber) && pageNumber > 0 && pageNumber <= this.pagesCount)) {
          console.error("PDFLinkService.goToPage: \"".concat(val, "\" is not a valid page."));
          return;
        }
        if (this.pdfHistory) {
          this.pdfHistory.pushCurrentPosition();
          this.pdfHistory.pushPage(pageNumber);
        }
        this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber
        });
      }
    }, {
      key: "addLinkAttributes",
      value: function addLinkAttributes(link, url) {
        var newWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (!url || typeof url !== "string") {
          throw new Error('A valid "url" parameter must provided.');
        }
        var target = newWindow ? _LinkTarget.BLANK : this.externalLinkTarget,
          rel = this.externalLinkRel;
        if (this.externalLinkEnabled) {
          link.href = link.title = url;
        } else {
          link.href = "";
          link.title = "Disabled: ".concat(url);
          link.onclick = function () {
            return false;
          };
        }
        var targetStr = "";
        switch (target) {
          case _LinkTarget.NONE:
            break;
          case _LinkTarget.SELF:
            targetStr = "_self";
            break;
          case _LinkTarget.BLANK:
            targetStr = "_blank";
            break;
          case _LinkTarget.PARENT:
            targetStr = "_parent";
            break;
          case _LinkTarget.TOP:
            targetStr = "_top";
            break;
        }
        link.target = targetStr;
        link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
      }
    }, {
      key: "getDestinationHash",
      value: function getDestinationHash(dest) {
        if (typeof dest === "string") {
          if (dest.length > 0) {
            return this.getAnchorUrl("#" + escape(dest));
          }
        } else if (Array.isArray(dest)) {
          var str = JSON.stringify(dest);
          if (str.length > 0) {
            return this.getAnchorUrl("#" + escape(str));
          }
        }
        return this.getAnchorUrl("");
      }
    }, {
      key: "getAnchorUrl",
      value: function getAnchorUrl(anchor) {
        return this.baseUrl ? this.baseUrl + anchor : anchor;
      }
    }, {
      key: "setHash",
      value: function setHash(hash) {
        if (!this.pdfDocument) {
          return;
        }
        var pageNumber, dest;
        if (hash.includes("=")) {
          var params = _parseQueryString(hash);
          if (params.has("search")) {
            var query = params.get("search").replaceAll('"', ""),
              phrase = params.get("phrase") === "true";
            this.eventBus.dispatch("findfromurlhash", {
              source: this,
              query: phrase ? query : query.match(/\S+/g)
            });
          }
          if (params.has("page")) {
            pageNumber = params.get("page") | 0 || 1;
          }
          if (params.has("zoom")) {
            var zoomArgs = params.get("zoom").split(",");
            var zoomArg = zoomArgs[0];
            var zoomArgNumber = parseFloat(zoomArg);
            if (!zoomArg.includes("Fit")) {
              dest = [null, {
                name: "XYZ"
              }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
            } else if (zoomArg === "Fit" || zoomArg === "FitB") {
              dest = [null, {
                name: zoomArg
              }];
            } else if (zoomArg === "FitH" || zoomArg === "FitBH" || zoomArg === "FitV" || zoomArg === "FitBV") {
              dest = [null, {
                name: zoomArg
              }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === "FitR") {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, {
                  name: zoomArg
                }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error("PDFLinkService.setHash: \"".concat(zoomArg, "\" is not a valid zoom value."));
            }
          }
          if (dest) {
            this.pdfViewer.scrollPageIntoView({
              pageNumber: pageNumber || this.page,
              destArray: dest,
              allowNegativeOffset: true
            });
          } else if (pageNumber) {
            this.page = pageNumber;
          }
          if (params.has("pagemode")) {
            this.eventBus.dispatch("pagemode", {
              source: this,
              mode: params.get("pagemode")
            });
          }
          if (params.has("nameddest")) {
            this.goToDestination(params.get("nameddest"));
          }
          return;
        }
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!Array.isArray(dest)) {
            dest = dest.toString();
          }
        } catch (_unused2) {}
        if (typeof dest === "string" || _isValidExplicitDest.call(_PDFLinkService, dest)) {
          this.goToDestination(dest);
          return;
        }
        console.error("PDFLinkService.setHash: \"".concat(unescape(hash), "\" is not a valid destination."));
      }
    }, {
      key: "executeNamedAction",
      value: function executeNamedAction(action) {
        var _this$pdfHistory, _this$pdfHistory2;
        if (!this.pdfDocument) {
          return;
        }
        switch (action) {
          case "GoBack":
            (_this$pdfHistory = this.pdfHistory) === null || _this$pdfHistory === void 0 || _this$pdfHistory.back();
            break;
          case "GoForward":
            (_this$pdfHistory2 = this.pdfHistory) === null || _this$pdfHistory2 === void 0 || _this$pdfHistory2.forward();
            break;
          case "NextPage":
            this.pdfViewer.nextPage();
            break;
          case "PrevPage":
            this.pdfViewer.previousPage();
            break;
          case "LastPage":
            this.page = this.pagesCount;
            break;
          case "FirstPage":
            this.page = 1;
            break;
        }
        this.eventBus.dispatch("namedaction", {
          source: this,
          action: action
        });
      }
    }, {
      key: "executeSetOCGState",
      value: function () {
        var _executeSetOCGState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(action) {
          var pdfDocument, optionalContentConfig;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (this.pdfDocument) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                pdfDocument = this.pdfDocument;
                _context2.next = 5;
                return this.pdfViewer.optionalContentConfigPromise;
              case 5:
                optionalContentConfig = _context2.sent;
                if (!(pdfDocument !== this.pdfDocument)) {
                  _context2.next = 8;
                  break;
                }
                return _context2.abrupt("return");
              case 8:
                optionalContentConfig.setOCGState(action);
                this.pdfViewer.optionalContentConfigPromise = Promise.resolve(optionalContentConfig);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function executeSetOCGState(_x2) {
          return _executeSetOCGState.apply(this, arguments);
        }
        return executeSetOCGState;
      }()
    }]);
  }();
  function _isValidExplicitDest(dest) {
    if (!Array.isArray(dest) || dest.length < 2) {
      return false;
    }
    var _dest = _toArray(dest),
      page = _dest[0],
      zoom = _dest[1],
      args = _dest.slice(2);
    if (!(_typeof(page) === "object" && Number.isInteger(page === null || page === void 0 ? void 0 : page.num) && Number.isInteger(page === null || page === void 0 ? void 0 : page.gen)) && !Number.isInteger(page)) {
      return false;
    }
    if (!(_typeof(zoom) === "object" && typeof (zoom === null || zoom === void 0 ? void 0 : zoom.name) === "string")) {
      return false;
    }
    var allowNull = true;
    switch (zoom.name) {
      case "XYZ":
        if (args.length !== 3) {
          return false;
        }
        break;
      case "Fit":
      case "FitB":
        return args.length === 0;
      case "FitH":
      case "FitBH":
      case "FitV":
      case "FitBV":
        if (args.length !== 1) {
          return false;
        }
        break;
      case "FitR":
        if (args.length !== 4) {
          return false;
        }
        allowNull = false;
        break;
      default:
        return false;
    }
    var _iterator32 = _createForOfIteratorHelper(args),
      _step32;
    try {
      for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
        var arg = _step32.value;
        if (!(typeof arg === "number" || allowNull && arg === null)) {
          return false;
        }
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
    return true;
  }
  var _SimpleLinkService = /*#__PURE__*/function (_PDFLinkService3) {
    function _SimpleLinkService() {
      _classCallCheck(this, _SimpleLinkService);
      return _callSuper(this, _SimpleLinkService, arguments);
    }
    _inherits(_SimpleLinkService, _PDFLinkService3);
    return _createClass(_SimpleLinkService, [{
      key: "setDocument",
      value: function setDocument(pdfDocument) {
      }
    }]);
  }(_PDFLinkService);
  var _globalThis$pdfjsLib = globalThis.pdfjsLib,
    AbortException = _globalThis$pdfjsLib.AbortException,
    AnnotationEditorLayer = _globalThis$pdfjsLib.AnnotationEditorLayer;
    _globalThis$pdfjsLib.AnnotationEditorParamsType;
    var AnnotationEditorType = _globalThis$pdfjsLib.AnnotationEditorType,
    AnnotationEditorUIManager = _globalThis$pdfjsLib.AnnotationEditorUIManager,
    AnnotationLayer = _globalThis$pdfjsLib.AnnotationLayer,
    AnnotationMode = _globalThis$pdfjsLib.AnnotationMode;
    _globalThis$pdfjsLib.build;
    _globalThis$pdfjsLib.CMapCompressionType;
    _globalThis$pdfjsLib.ColorPicker;
    var createValidAbsoluteUrl = _globalThis$pdfjsLib.createValidAbsoluteUrl;
    _globalThis$pdfjsLib.DOMSVGFactory;
    var DrawLayer = _globalThis$pdfjsLib.DrawLayer;
    _globalThis$pdfjsLib.FeatureTest;
    var fetchData = _globalThis$pdfjsLib.fetchData;
    _globalThis$pdfjsLib.getDocument;
    _globalThis$pdfjsLib.getFilenameFromUrl;
    var getPdfFilenameFromUrl = _globalThis$pdfjsLib.getPdfFilenameFromUrl;
    _globalThis$pdfjsLib.getXfaPageViewport;
    _globalThis$pdfjsLib.GlobalWorkerOptions;
    _globalThis$pdfjsLib.ImageKind;
    _globalThis$pdfjsLib.InvalidPDFException;
    _globalThis$pdfjsLib.isDataScheme;
    var isPdfFile = _globalThis$pdfjsLib.isPdfFile;
    _globalThis$pdfjsLib.MissingPDFException;
    _globalThis$pdfjsLib.noContextMenu;
    var normalizeUnicode = _globalThis$pdfjsLib.normalizeUnicode;
    _globalThis$pdfjsLib.OPS;
    _globalThis$pdfjsLib.Outliner;
    _globalThis$pdfjsLib.PasswordResponses;
    _globalThis$pdfjsLib.PDFDataRangeTransport;
    _globalThis$pdfjsLib.PDFDateString;
    _globalThis$pdfjsLib.PDFWorker;
    var PermissionFlag = _globalThis$pdfjsLib.PermissionFlag,
    PixelsPerInch = _globalThis$pdfjsLib.PixelsPerInch,
    RenderingCancelledException = _globalThis$pdfjsLib.RenderingCancelledException;
    _globalThis$pdfjsLib.renderTextLayer;
    var setLayerDimensions = _globalThis$pdfjsLib.setLayerDimensions,
    shadow = _globalThis$pdfjsLib.shadow,
    TextLayer = _globalThis$pdfjsLib.TextLayer;
    _globalThis$pdfjsLib.UnexpectedResponseException;
    _globalThis$pdfjsLib.updateTextLayer;
    _globalThis$pdfjsLib.Util;
    _globalThis$pdfjsLib.VerbosityLevel;
    var version = _globalThis$pdfjsLib.version,
    XfaLayer = _globalThis$pdfjsLib.XfaLayer;
  var _onAppend = /*#__PURE__*/new WeakMap();
  var _eventAbortController = /*#__PURE__*/new WeakMap();
  var _AnnotationLayerBuilder_brand = /*#__PURE__*/new WeakSet();
  var _AnnotationLayerBuilder = /*#__PURE__*/function () {
    function _AnnotationLayerBuilder(_ref6) {
      var pdfPage = _ref6.pdfPage,
        linkService = _ref6.linkService,
        downloadManager = _ref6.downloadManager,
        _ref6$annotationStora = _ref6.annotationStorage,
        annotationStorage = _ref6$annotationStora === void 0 ? null : _ref6$annotationStora,
        _ref6$imageResourcesP = _ref6.imageResourcesPath,
        imageResourcesPath = _ref6$imageResourcesP === void 0 ? "" : _ref6$imageResourcesP,
        _ref6$renderForms = _ref6.renderForms,
        renderForms = _ref6$renderForms === void 0 ? true : _ref6$renderForms,
        _ref6$enableScripting = _ref6.enableScripting,
        enableScripting = _ref6$enableScripting === void 0 ? false : _ref6$enableScripting,
        _ref6$hasJSActionsPro = _ref6.hasJSActionsPromise,
        hasJSActionsPromise = _ref6$hasJSActionsPro === void 0 ? null : _ref6$hasJSActionsPro,
        _ref6$fieldObjectsPro = _ref6.fieldObjectsPromise,
        fieldObjectsPromise = _ref6$fieldObjectsPro === void 0 ? null : _ref6$fieldObjectsPro,
        _ref6$annotationCanva = _ref6.annotationCanvasMap,
        annotationCanvasMap = _ref6$annotationCanva === void 0 ? null : _ref6$annotationCanva,
        _ref6$accessibilityMa = _ref6.accessibilityManager,
        accessibilityManager = _ref6$accessibilityMa === void 0 ? null : _ref6$accessibilityMa,
        _ref6$annotationEdito = _ref6.annotationEditorUIManager,
        annotationEditorUIManager = _ref6$annotationEdito === void 0 ? null : _ref6$annotationEdito,
        _ref6$onAppend = _ref6.onAppend,
        onAppend = _ref6$onAppend === void 0 ? null : _ref6$onAppend;
      _classCallCheck(this, _AnnotationLayerBuilder);
      _classPrivateMethodInitSpec(this, _AnnotationLayerBuilder_brand);
      _classPrivateFieldInitSpec(this, _onAppend, null);
      _classPrivateFieldInitSpec(this, _eventAbortController, null);
      this.pdfPage = pdfPage;
      this.linkService = linkService;
      this.downloadManager = downloadManager;
      this.imageResourcesPath = imageResourcesPath;
      this.renderForms = renderForms;
      this.annotationStorage = annotationStorage;
      this.enableScripting = enableScripting;
      this._hasJSActionsPromise = hasJSActionsPromise || Promise.resolve(false);
      this._fieldObjectsPromise = fieldObjectsPromise || Promise.resolve(null);
      this._annotationCanvasMap = annotationCanvasMap;
      this._accessibilityManager = accessibilityManager;
      this._annotationEditorUIManager = annotationEditorUIManager;
      _classPrivateFieldSet2(_onAppend, this, onAppend);
      this.annotationLayer = null;
      this.div = null;
      this._cancelled = false;
      this._eventBus = linkService.eventBus;
    }
    return _createClass(_AnnotationLayerBuilder, [{
      key: "render",
      value: function () {
        var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(viewport) {
          var _classPrivateFieldGet2$1,
            _this5 = this;
          var intent,
            _yield$Promise$all,
            _yield$Promise$all2,
            annotations,
            hasJSActions,
            fieldObjects,
            div,
            _this$_eventBus,
            _args3 = arguments;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                intent = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : "display";
                if (!this.div) {
                  _context3.next = 6;
                  break;
                }
                if (!(this._cancelled || !this.annotationLayer)) {
                  _context3.next = 4;
                  break;
                }
                return _context3.abrupt("return");
              case 4:
                this.annotationLayer.update({
                  viewport: viewport.clone({
                    dontFlip: true
                  })
                });
                return _context3.abrupt("return");
              case 6:
                _context3.next = 8;
                return Promise.all([this.pdfPage.getAnnotations({
                  intent: intent
                }), this._hasJSActionsPromise, this._fieldObjectsPromise]);
              case 8:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                annotations = _yield$Promise$all2[0];
                hasJSActions = _yield$Promise$all2[1];
                fieldObjects = _yield$Promise$all2[2];
                if (!this._cancelled) {
                  _context3.next = 15;
                  break;
                }
                return _context3.abrupt("return");
              case 15:
                div = this.div = document.createElement("div");
                div.className = "annotationLayer";
                (_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_onAppend, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this, div);
                if (!(annotations.length === 0)) {
                  _context3.next = 21;
                  break;
                }
                this.hide();
                return _context3.abrupt("return");
              case 21:
                this.annotationLayer = new AnnotationLayer({
                  div: div,
                  accessibilityManager: this._accessibilityManager,
                  annotationCanvasMap: this._annotationCanvasMap,
                  annotationEditorUIManager: this._annotationEditorUIManager,
                  page: this.pdfPage,
                  viewport: viewport.clone({
                    dontFlip: true
                  })
                });
                _context3.next = 24;
                return this.annotationLayer.render({
                  annotations: annotations,
                  imageResourcesPath: this.imageResourcesPath,
                  renderForms: this.renderForms,
                  linkService: this.linkService,
                  downloadManager: this.downloadManager,
                  annotationStorage: this.annotationStorage,
                  enableScripting: this.enableScripting,
                  hasJSActions: hasJSActions,
                  fieldObjects: fieldObjects
                });
              case 24:
                if (this.linkService.isInPresentationMode) {
                  _assertClassBrand(_AnnotationLayerBuilder_brand, this, _updatePresentationModeState).call(this, PresentationModeState.FULLSCREEN);
                }
                if (!_classPrivateFieldGet2(_eventAbortController, this)) {
                  _classPrivateFieldSet2(_eventAbortController, this, new AbortController());
                  (_this$_eventBus = this._eventBus) === null || _this$_eventBus === void 0 || _this$_eventBus._on("presentationmodechanged", function (evt) {
                    _assertClassBrand(_AnnotationLayerBuilder_brand, _this5, _updatePresentationModeState).call(_this5, evt.state);
                  }, {
                    signal: _classPrivateFieldGet2(_eventAbortController, this).signal
                  });
                }
              case 26:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function render(_x3) {
          return _render.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "cancel",
      value: function cancel() {
        var _classPrivateFieldGet3;
        this._cancelled = true;
        (_classPrivateFieldGet3 = _classPrivateFieldGet2(_eventAbortController, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.abort();
        _classPrivateFieldSet2(_eventAbortController, this, null);
      }
    }, {
      key: "hide",
      value: function hide() {
        if (!this.div) {
          return;
        }
        this.div.hidden = true;
      }
    }]);
  }();
  function _updatePresentationModeState(state) {
    if (!this.div) {
      return;
    }
    var disableFormElements = false;
    switch (state) {
      case PresentationModeState.FULLSCREEN:
        disableFormElements = true;
        break;
      case PresentationModeState.NORMAL:
        break;
      default:
        return;
    }
    var _iterator33 = _createForOfIteratorHelper(this.div.childNodes),
      _step33;
    try {
      for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
        var section = _step33.value;
        if (section.hasAttribute("data-internal-link")) {
          continue;
        }
        section.inert = disableFormElements;
      }
    } catch (err) {
      _iterator33.e(err);
    } finally {
      _iterator33.f();
    }
  }

  function _download(blobUrl, filename) {
    var a = document.createElement("a");
    if (!a.click) {
      throw new Error('DownloadManager: "a.click()" is not supported.');
    }
    a.href = blobUrl;
    a.target = "_parent";
    if ("download" in a) {
      a.download = filename;
    }
    (document.body || document.documentElement).append(a);
    a.click();
    a.remove();
  }
  var _openBlobUrls = /*#__PURE__*/new WeakMap();
  var _DownloadManager = /*#__PURE__*/function () {
    function _DownloadManager() {
      _classCallCheck(this, _DownloadManager);
      _classPrivateFieldInitSpec(this, _openBlobUrls, new WeakMap());
    }
    return _createClass(_DownloadManager, [{
      key: "downloadUrl",
      value: function downloadUrl(url, filename, _options) {
        if (!createValidAbsoluteUrl(url, "http://example.com")) {
          console.error("downloadUrl - not a valid URL: ".concat(url));
          return;
        }
        _download(url + "#pdfjs.action=download", filename);
      }
    }, {
      key: "downloadData",
      value: function downloadData(data, filename, contentType) {
        var blobUrl = URL.createObjectURL(new Blob([data], {
          type: contentType
        }));
        _download(blobUrl, filename);
      }
    }, {
      key: "openOrDownloadData",
      value: function openOrDownloadData(data, filename) {
        var isPdfData = isPdfFile(filename);
        var contentType = isPdfData ? "application/pdf" : "";
        this.downloadData(data, filename, contentType);
        return false;
      }
    }, {
      key: "download",
      value: function download(blob, url, filename, _options) {
        var blobUrl = URL.createObjectURL(blob);
        _download(blobUrl, filename);
      }
    }]);
  }();

  var WaitOnType = {
    EVENT: "event",
    TIMEOUT: "timeout"
  };
  function waitOnEventOrTimeout(_x4) {
    return _waitOnEventOrTimeout.apply(this, arguments);
  }
  function _waitOnEventOrTimeout() {
    _waitOnEventOrTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(_ref7) {
      var target, name, _ref7$delay, delay, _Promise$withResolver2, promise, resolve, ac, handler, evtMethod, timeout;
      return _regeneratorRuntime().wrap(function _callee28$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            handler = function _handler(type) {
              ac.abort();
              clearTimeout(timeout);
              resolve(type);
            };
            target = _ref7.target, name = _ref7.name, _ref7$delay = _ref7.delay, delay = _ref7$delay === void 0 ? 0 : _ref7$delay;
            if (!(_typeof(target) !== "object" || !(name && typeof name === "string") || !(Number.isInteger(delay) && delay >= 0))) {
              _context29.next = 4;
              break;
            }
            throw new Error("waitOnEventOrTimeout - invalid parameters.");
          case 4:
            _Promise$withResolver2 = Promise.withResolvers(), promise = _Promise$withResolver2.promise, resolve = _Promise$withResolver2.resolve;
            ac = new AbortController();
            evtMethod = target instanceof _EventBus ? "_on" : "addEventListener";
            target[evtMethod](name, handler.bind(null, WaitOnType.EVENT), {
              signal: ac.signal
            });
            timeout = setTimeout(handler.bind(null, WaitOnType.TIMEOUT), delay);
            return _context29.abrupt("return", promise);
          case 10:
          case "end":
            return _context29.stop();
        }
      }, _callee28);
    }));
    return _waitOnEventOrTimeout.apply(this, arguments);
  }
  var _listeners = /*#__PURE__*/new WeakMap();
  var _EventBus = /*#__PURE__*/function () {
    function _EventBus() {
      _classCallCheck(this, _EventBus);
      _classPrivateFieldInitSpec(this, _listeners, Object.create(null));
    }
    return _createClass(_EventBus, [{
      key: "on",
      value: function on(eventName, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        this._on(eventName, listener, {
          external: true,
          once: options === null || options === void 0 ? void 0 : options.once,
          signal: options === null || options === void 0 ? void 0 : options.signal
        });
      }
    }, {
      key: "off",
      value: function off(eventName, listener) {
        this._off(eventName, listener);
      }
    }, {
      key: "dispatch",
      value: function dispatch(eventName, data) {
        var eventListeners = _classPrivateFieldGet2(_listeners, this)[eventName];
        if (!eventListeners || eventListeners.length === 0) {
          return;
        }
        var externalListeners;
        var _iterator4 = _createForOfIteratorHelper(eventListeners.slice(0)),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _step4.value,
              _listener = _step4$value.listener,
              external = _step4$value.external,
              once = _step4$value.once;
            if (once) {
              this._off(eventName, _listener);
            }
            if (external) {
              (externalListeners || (externalListeners = [])).push(_listener);
              continue;
            }
            _listener(data);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (externalListeners) {
          var _iterator5 = _createForOfIteratorHelper(externalListeners),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var listener = _step5.value;
              listener(data);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          externalListeners = null;
        }
      }
    }, {
      key: "_on",
      value: function _on(eventName, listener) {
        var _this6 = this,
          _classPrivateFieldGet4;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var rmAbort = null;
        if ((options === null || options === void 0 ? void 0 : options.signal) instanceof AbortSignal) {
          var signal = options.signal;
          if (signal.aborted) {
            console.error("Cannot use an `aborted` signal.");
            return;
          }
          var onAbort = function onAbort() {
            return _this6._off(eventName, listener);
          };
          rmAbort = function rmAbort() {
            return signal.removeEventListener("abort", onAbort);
          };
          signal.addEventListener("abort", onAbort);
        }
        var eventListeners = (_classPrivateFieldGet4 = _classPrivateFieldGet2(_listeners, this))[eventName] || (_classPrivateFieldGet4[eventName] = []);
        eventListeners.push({
          listener: listener,
          external: (options === null || options === void 0 ? void 0 : options.external) === true,
          once: (options === null || options === void 0 ? void 0 : options.once) === true,
          rmAbort: rmAbort
        });
      }
    }, {
      key: "_off",
      value: function _off(eventName, listener) {
        var eventListeners = _classPrivateFieldGet2(_listeners, this)[eventName];
        if (!eventListeners) {
          return;
        }
        for (var i = 0, ii = eventListeners.length; i < ii; i++) {
          var evt = eventListeners[i];
          if (evt.listener === listener) {
            var _evt$rmAbort;
            (_evt$rmAbort = evt.rmAbort) === null || _evt$rmAbort === void 0 || _evt$rmAbort.call(evt);
            eventListeners.splice(i, 1);
            return;
          }
        }
      }
    }]);
  }();
  var FluentType = /*#__PURE__*/function () {
    function FluentType(value) {
      _classCallCheck(this, FluentType);
      this.value = value;
    }
    return _createClass(FluentType, [{
      key: "valueOf",
      value: function valueOf() {
        return this.value;
      }
    }]);
  }();
  var FluentNone = /*#__PURE__*/function (_FluentType) {
    function FluentNone() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "???";
      _classCallCheck(this, FluentNone);
      return _callSuper(this, FluentNone, [value]);
    }
    _inherits(FluentNone, _FluentType);
    return _createClass(FluentNone, [{
      key: "toString",
      value: function toString(scope) {
        return "{".concat(this.value, "}");
      }
    }]);
  }(FluentType);
  var FluentNumber = /*#__PURE__*/function (_FluentType2) {
    function FluentNumber(value) {
      var _this7;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, FluentNumber);
      _this7 = _callSuper(this, FluentNumber, [value]);
      _this7.opts = opts;
      return _this7;
    }
    _inherits(FluentNumber, _FluentType2);
    return _createClass(FluentNumber, [{
      key: "toString",
      value: function toString(scope) {
        try {
          var nf = scope.memoizeIntlObject(Intl.NumberFormat, this.opts);
          return nf.format(this.value);
        } catch (err) {
          scope.reportError(err);
          return this.value.toString(10);
        }
      }
    }]);
  }(FluentType);
  var FluentDateTime = /*#__PURE__*/function (_FluentType3) {
    function FluentDateTime(value) {
      var _this8;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, FluentDateTime);
      _this8 = _callSuper(this, FluentDateTime, [value]);
      _this8.opts = opts;
      return _this8;
    }
    _inherits(FluentDateTime, _FluentType3);
    return _createClass(FluentDateTime, [{
      key: "toString",
      value: function toString(scope) {
        try {
          var dtf = scope.memoizeIntlObject(Intl.DateTimeFormat, this.opts);
          return dtf.format(this.value);
        } catch (err) {
          scope.reportError(err);
          return new Date(this.value).toISOString();
        }
      }
    }]);
  }(FluentType);

  var MAX_PLACEABLES = 100;
  var FSI = "\u2068";
  var PDI = "\u2069";
  function match(scope, selector, key) {
    if (key === selector) {
      return true;
    }
    if (key instanceof FluentNumber && selector instanceof FluentNumber && key.value === selector.value) {
      return true;
    }
    if (selector instanceof FluentNumber && typeof key === "string") {
      var category = scope.memoizeIntlObject(Intl.PluralRules, selector.opts).select(selector.value);
      if (key === category) {
        return true;
      }
    }
    return false;
  }
  function getDefault(scope, variants, star) {
    if (variants[star]) {
      return resolvePattern(scope, variants[star].value);
    }
    scope.reportError(new RangeError("No default"));
    return new FluentNone();
  }
  function getArguments(scope, args) {
    var positional = [];
    var named = Object.create(null);
    var _iterator6 = _createForOfIteratorHelper(args),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var arg = _step6.value;
        if (arg.type === "narg") {
          named[arg.name] = resolveExpression(scope, arg.value);
        } else {
          positional.push(resolveExpression(scope, arg));
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    return {
      positional: positional,
      named: named
    };
  }
  function resolveExpression(scope, expr) {
    switch (expr.type) {
      case "str":
        return expr.value;
      case "num":
        return new FluentNumber(expr.value, {
          minimumFractionDigits: expr.precision
        });
      case "var":
        return resolveVariableReference(scope, expr);
      case "mesg":
        return resolveMessageReference(scope, expr);
      case "term":
        return resolveTermReference(scope, expr);
      case "func":
        return resolveFunctionReference(scope, expr);
      case "select":
        return resolveSelectExpression(scope, expr);
      default:
        return new FluentNone();
    }
  }
  function resolveVariableReference(scope, _ref9) {
    var name = _ref9.name;
    var arg;
    if (scope.params) {
      if (Object.prototype.hasOwnProperty.call(scope.params, name)) {
        arg = scope.params[name];
      } else {
        return new FluentNone("$".concat(name));
      }
    } else if (scope.args && Object.prototype.hasOwnProperty.call(scope.args, name)) {
      arg = scope.args[name];
    } else {
      scope.reportError(new ReferenceError("Unknown variable: $".concat(name)));
      return new FluentNone("$".concat(name));
    }
    if (arg instanceof FluentType) {
      return arg;
    }
    switch (_typeof(arg)) {
      case "string":
        return arg;
      case "number":
        return new FluentNumber(arg);
      case "object":
        if (arg instanceof Date) {
          return new FluentDateTime(arg.getTime());
        }
      default:
        scope.reportError(new TypeError("Variable type not supported: $".concat(name, ", ").concat(_typeof(arg))));
        return new FluentNone("$".concat(name));
    }
  }
  function resolveMessageReference(scope, _ref10) {
    var name = _ref10.name,
      attr = _ref10.attr;
    var message = scope.bundle._messages.get(name);
    if (!message) {
      scope.reportError(new ReferenceError("Unknown message: ".concat(name)));
      return new FluentNone(name);
    }
    if (attr) {
      var attribute = message.attributes[attr];
      if (attribute) {
        return resolvePattern(scope, attribute);
      }
      scope.reportError(new ReferenceError("Unknown attribute: ".concat(attr)));
      return new FluentNone("".concat(name, ".").concat(attr));
    }
    if (message.value) {
      return resolvePattern(scope, message.value);
    }
    scope.reportError(new ReferenceError("No value: ".concat(name)));
    return new FluentNone(name);
  }
  function resolveTermReference(scope, _ref11) {
    var name = _ref11.name,
      attr = _ref11.attr,
      args = _ref11.args;
    var id = "-".concat(name);
    var term = scope.bundle._terms.get(id);
    if (!term) {
      scope.reportError(new ReferenceError("Unknown term: ".concat(id)));
      return new FluentNone(id);
    }
    if (attr) {
      var attribute = term.attributes[attr];
      if (attribute) {
        scope.params = getArguments(scope, args).named;
        var _resolved = resolvePattern(scope, attribute);
        scope.params = null;
        return _resolved;
      }
      scope.reportError(new ReferenceError("Unknown attribute: ".concat(attr)));
      return new FluentNone("".concat(id, ".").concat(attr));
    }
    scope.params = getArguments(scope, args).named;
    var resolved = resolvePattern(scope, term.value);
    scope.params = null;
    return resolved;
  }
  function resolveFunctionReference(scope, _ref12) {
    var name = _ref12.name,
      args = _ref12.args;
    var func = scope.bundle._functions[name];
    if (!func) {
      scope.reportError(new ReferenceError("Unknown function: ".concat(name, "()")));
      return new FluentNone("".concat(name, "()"));
    }
    if (typeof func !== "function") {
      scope.reportError(new TypeError("Function ".concat(name, "() is not callable")));
      return new FluentNone("".concat(name, "()"));
    }
    try {
      var resolved = getArguments(scope, args);
      return func(resolved.positional, resolved.named);
    } catch (err) {
      scope.reportError(err);
      return new FluentNone("".concat(name, "()"));
    }
  }
  function resolveSelectExpression(scope, _ref13) {
    var selector = _ref13.selector,
      variants = _ref13.variants,
      star = _ref13.star;
    var sel = resolveExpression(scope, selector);
    if (sel instanceof FluentNone) {
      return getDefault(scope, variants, star);
    }
    var _iterator7 = _createForOfIteratorHelper(variants),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var variant = _step7.value;
        var key = resolveExpression(scope, variant.key);
        if (match(scope, sel, key)) {
          return resolvePattern(scope, variant.value);
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    return getDefault(scope, variants, star);
  }
  function resolveComplexPattern(scope, ptn) {
    if (scope.dirty.has(ptn)) {
      scope.reportError(new RangeError("Cyclic reference"));
      return new FluentNone();
    }
    scope.dirty.add(ptn);
    var result = [];
    var useIsolating = scope.bundle._useIsolating && ptn.length > 1;
    var _iterator8 = _createForOfIteratorHelper(ptn),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var elem = _step8.value;
        if (typeof elem === "string") {
          result.push(scope.bundle._transform(elem));
          continue;
        }
        scope.placeables++;
        if (scope.placeables > MAX_PLACEABLES) {
          scope.dirty["delete"](ptn);
          throw new RangeError("Too many placeables expanded: ".concat(scope.placeables, ", ") + "max allowed is ".concat(MAX_PLACEABLES));
        }
        if (useIsolating) {
          result.push(FSI);
        }
        result.push(resolveExpression(scope, elem).toString(scope));
        if (useIsolating) {
          result.push(PDI);
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    scope.dirty["delete"](ptn);
    return result.join("");
  }
  function resolvePattern(scope, value) {
    if (typeof value === "string") {
      return scope.bundle._transform(value);
    }
    return resolveComplexPattern(scope, value);
  }
  var Scope = /*#__PURE__*/function () {
    function Scope(bundle, errors, args) {
      _classCallCheck(this, Scope);
      this.dirty = new WeakSet();
      this.params = null;
      this.placeables = 0;
      this.bundle = bundle;
      this.errors = errors;
      this.args = args;
    }
    return _createClass(Scope, [{
      key: "reportError",
      value: function reportError(error) {
        if (!this.errors || !(error instanceof Error)) {
          throw error;
        }
        this.errors.push(error);
      }
    }, {
      key: "memoizeIntlObject",
      value: function memoizeIntlObject(ctor, opts) {
        var cache = this.bundle._intls.get(ctor);
        if (!cache) {
          cache = {};
          this.bundle._intls.set(ctor, cache);
        }
        var id = JSON.stringify(opts);
        if (!cache[id]) {
          cache[id] = new ctor(this.bundle.locales, opts);
        }
        return cache[id];
      }
    }]);
  }();

  function values(opts, allowed) {
    var unwrapped = Object.create(null);
    for (var _i = 0, _Object$entries = Object.entries(opts); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        opt = _Object$entries$_i[1];
      if (allowed.includes(name)) {
        unwrapped[name] = opt.valueOf();
      }
    }
    return unwrapped;
  }
  var NUMBER_ALLOWED = ["unitDisplay", "currencyDisplay", "useGrouping", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits"];
  function NUMBER(args, opts) {
    var arg = args[0];
    if (arg instanceof FluentNone) {
      return new FluentNone("NUMBER(".concat(arg.valueOf(), ")"));
    }
    if (arg instanceof FluentNumber) {
      return new FluentNumber(arg.valueOf(), _objectSpread2(_objectSpread2({}, arg.opts), values(opts, NUMBER_ALLOWED)));
    }
    if (arg instanceof FluentDateTime) {
      return new FluentNumber(arg.valueOf(), _objectSpread2({}, values(opts, NUMBER_ALLOWED)));
    }
    throw new TypeError("Invalid argument to NUMBER");
  }
  var DATETIME_ALLOWED = ["dateStyle", "timeStyle", "fractionalSecondDigits", "dayPeriod", "hour12", "weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName"];
  function DATETIME(args, opts) {
    var arg = args[0];
    if (arg instanceof FluentNone) {
      return new FluentNone("DATETIME(".concat(arg.valueOf(), ")"));
    }
    if (arg instanceof FluentDateTime) {
      return new FluentDateTime(arg.valueOf(), _objectSpread2(_objectSpread2({}, arg.opts), values(opts, DATETIME_ALLOWED)));
    }
    if (arg instanceof FluentNumber) {
      return new FluentDateTime(arg.valueOf(), _objectSpread2({}, values(opts, DATETIME_ALLOWED)));
    }
    throw new TypeError("Invalid argument to DATETIME");
  }
  var cache = new Map();
  function getMemoizerForLocale(locales) {
    var stringLocale = Array.isArray(locales) ? locales.join(" ") : locales;
    var memoizer = cache.get(stringLocale);
    if (memoizer === undefined) {
      memoizer = new Map();
      cache.set(stringLocale, memoizer);
    }
    return memoizer;
  }
  var FluentBundle = /*#__PURE__*/function () {
    function FluentBundle(locales) {
      var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        functions = _ref14.functions,
        _ref14$useIsolating = _ref14.useIsolating,
        useIsolating = _ref14$useIsolating === void 0 ? true : _ref14$useIsolating,
        _ref14$transform = _ref14.transform,
        transform = _ref14$transform === void 0 ? function (v) {
          return v;
        } : _ref14$transform;
      _classCallCheck(this, FluentBundle);
      this._terms = new Map();
      this._messages = new Map();
      this.locales = Array.isArray(locales) ? locales : [locales];
      this._functions = _objectSpread2({
        NUMBER: NUMBER,
        DATETIME: DATETIME
      }, functions);
      this._useIsolating = useIsolating;
      this._transform = transform;
      this._intls = getMemoizerForLocale(locales);
    }
    return _createClass(FluentBundle, [{
      key: "hasMessage",
      value: function hasMessage(id) {
        return this._messages.has(id);
      }
    }, {
      key: "getMessage",
      value: function getMessage(id) {
        return this._messages.get(id);
      }
    }, {
      key: "addResource",
      value: function addResource(res) {
        var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref15$allowOverrides = _ref15.allowOverrides,
          allowOverrides = _ref15$allowOverrides === void 0 ? false : _ref15$allowOverrides;
        var errors = [];
        for (var i = 0; i < res.body.length; i++) {
          var entry = res.body[i];
          if (entry.id.startsWith("-")) {
            if (allowOverrides === false && this._terms.has(entry.id)) {
              errors.push(new Error("Attempt to override an existing term: \"".concat(entry.id, "\"")));
              continue;
            }
            this._terms.set(entry.id, entry);
          } else {
            if (allowOverrides === false && this._messages.has(entry.id)) {
              errors.push(new Error("Attempt to override an existing message: \"".concat(entry.id, "\"")));
              continue;
            }
            this._messages.set(entry.id, entry);
          }
        }
        return errors;
      }
    }, {
      key: "formatPattern",
      value: function formatPattern(pattern) {
        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (typeof pattern === "string") {
          return this._transform(pattern);
        }
        var scope = new Scope(this, errors, args);
        try {
          var value = resolveComplexPattern(scope, pattern);
          return value.toString(scope);
        } catch (err) {
          if (scope.errors && err instanceof Error) {
            scope.errors.push(err);
            return new FluentNone().toString(scope);
          }
          throw err;
        }
      }
    }]);
  }();

  var RE_MESSAGE_START = /^(-?[a-zA-Z][\w-]*) *= */gm;
  var RE_ATTRIBUTE_START = new RegExp("\\.([a-zA-Z][\\w-]*) *= *", "y");
  var RE_VARIANT_START = new RegExp("\\*?\\[", "y");
  var RE_NUMBER_LITERAL = new RegExp("(-?[0-9]+(?:\\.([0-9]+))?)", "y");
  var RE_IDENTIFIER = new RegExp("([a-zA-Z][\\w-]*)", "y");
  var RE_REFERENCE = new RegExp("([$-])?([a-zA-Z][\\w-]*)(?:\\.([a-zA-Z][\\w-]*))?", "y");
  var RE_FUNCTION_NAME = /^[A-Z][A-Z0-9_-]*$/;
  var RE_TEXT_RUN = new RegExp("([^{}\\n\\r]+)", "y");
  var RE_STRING_RUN = new RegExp("([^\\\\\"\\n\\r]*)", "y");
  var RE_STRING_ESCAPE = new RegExp("\\\\([\\\\\"])", "y");
  var RE_UNICODE_ESCAPE = new RegExp("\\\\u([a-fA-F0-9]{4})|\\\\U([a-fA-F0-9]{6})", "y");
  var RE_LEADING_NEWLINES = /^\n+/;
  var RE_TRAILING_SPACES = / +$/;
  var RE_BLANK_LINES = / *\r?\n/g;
  var RE_INDENT = /( *)$/;
  var TOKEN_BRACE_OPEN = new RegExp("{\\s*", "y");
  var TOKEN_BRACE_CLOSE = new RegExp("\\s*}", "y");
  var TOKEN_BRACKET_OPEN = new RegExp("\\[\\s*", "y");
  var TOKEN_BRACKET_CLOSE = new RegExp("\\s*] *", "y");
  var TOKEN_PAREN_OPEN = new RegExp("\\s*\\(\\s*", "y");
  var TOKEN_ARROW = new RegExp("\\s*->\\s*", "y");
  var TOKEN_COLON = new RegExp("\\s*:\\s*", "y");
  var TOKEN_COMMA = new RegExp("\\s*,?\\s*", "y");
  var TOKEN_BLANK = new RegExp("\\s+", "y");
  var FluentResource = /*#__PURE__*/_createClass(function FluentResource(source) {
    _classCallCheck(this, FluentResource);
    this.body = [];
    RE_MESSAGE_START.lastIndex = 0;
    var cursor = 0;
    while (true) {
      var next = RE_MESSAGE_START.exec(source);
      if (next === null) {
        break;
      }
      cursor = RE_MESSAGE_START.lastIndex;
      try {
        this.body.push(parseMessage(next[1]));
      } catch (err) {
        if (err instanceof SyntaxError) {
          continue;
        }
        throw err;
      }
    }
    function test(re) {
      re.lastIndex = cursor;
      return re.test(source);
    }
    function consumeChar(_char2, errorClass) {
      if (source[cursor] === _char2) {
        cursor++;
        return true;
      }
      if (errorClass) {
        throw new errorClass("Expected ".concat(_char2));
      }
      return false;
    }
    function consumeToken(re, errorClass) {
      if (test(re)) {
        cursor = re.lastIndex;
        return true;
      }
      if (errorClass) {
        throw new errorClass("Expected ".concat(re.toString()));
      }
      return false;
    }
    function match(re) {
      re.lastIndex = cursor;
      var result = re.exec(source);
      if (result === null) {
        throw new SyntaxError("Expected ".concat(re.toString()));
      }
      cursor = re.lastIndex;
      return result;
    }
    function match1(re) {
      return match(re)[1];
    }
    function parseMessage(id) {
      var value = parsePattern();
      var attributes = parseAttributes();
      if (value === null && Object.keys(attributes).length === 0) {
        throw new SyntaxError("Expected message value or attributes");
      }
      return {
        id: id,
        value: value,
        attributes: attributes
      };
    }
    function parseAttributes() {
      var attrs = Object.create(null);
      while (test(RE_ATTRIBUTE_START)) {
        var name = match1(RE_ATTRIBUTE_START);
        var value = parsePattern();
        if (value === null) {
          throw new SyntaxError("Expected attribute value");
        }
        attrs[name] = value;
      }
      return attrs;
    }
    function parsePattern() {
      var first;
      if (test(RE_TEXT_RUN)) {
        first = match1(RE_TEXT_RUN);
      }
      if (source[cursor] === "{" || source[cursor] === "}") {
        return parsePatternElements(first ? [first] : [], Infinity);
      }
      var indent = parseIndent();
      if (indent) {
        if (first) {
          return parsePatternElements([first, indent], indent.length);
        }
        indent.value = trim(indent.value, RE_LEADING_NEWLINES);
        return parsePatternElements([indent], indent.length);
      }
      if (first) {
        return trim(first, RE_TRAILING_SPACES);
      }
      return null;
    }
    function parsePatternElements() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var commonIndent = arguments.length > 1 ? arguments[1] : undefined;
      while (true) {
        if (test(RE_TEXT_RUN)) {
          elements.push(match1(RE_TEXT_RUN));
          continue;
        }
        if (source[cursor] === "{") {
          elements.push(parsePlaceable());
          continue;
        }
        if (source[cursor] === "}") {
          throw new SyntaxError("Unbalanced closing brace");
        }
        var indent = parseIndent();
        if (indent) {
          elements.push(indent);
          commonIndent = Math.min(commonIndent, indent.length);
          continue;
        }
        break;
      }
      var lastIndex = elements.length - 1;
      var lastElement = elements[lastIndex];
      if (typeof lastElement === "string") {
        elements[lastIndex] = trim(lastElement, RE_TRAILING_SPACES);
      }
      var baked = [];
      var _iterator9 = _createForOfIteratorHelper(elements),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var element = _step9.value;
          if (element instanceof Indent) {
            element = element.value.slice(0, element.value.length - commonIndent);
          }
          if (element) {
            baked.push(element);
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return baked;
    }
    function parsePlaceable() {
      consumeToken(TOKEN_BRACE_OPEN, SyntaxError);
      var selector = parseInlineExpression();
      if (consumeToken(TOKEN_BRACE_CLOSE)) {
        return selector;
      }
      if (consumeToken(TOKEN_ARROW)) {
        var variants = parseVariants();
        consumeToken(TOKEN_BRACE_CLOSE, SyntaxError);
        return _objectSpread2({
          type: "select",
          selector: selector
        }, variants);
      }
      throw new SyntaxError("Unclosed placeable");
    }
    function parseInlineExpression() {
      if (source[cursor] === "{") {
        return parsePlaceable();
      }
      if (test(RE_REFERENCE)) {
        var _match = match(RE_REFERENCE),
          _match2 = _slicedToArray(_match, 4),
          sigil = _match2[1],
          name = _match2[2],
          _match2$ = _match2[3],
          attr = _match2$ === void 0 ? null : _match2$;
        if (sigil === "$") {
          return {
            type: "var",
            name: name
          };
        }
        if (consumeToken(TOKEN_PAREN_OPEN)) {
          var args = parseArguments();
          if (sigil === "-") {
            return {
              type: "term",
              name: name,
              attr: attr,
              args: args
            };
          }
          if (RE_FUNCTION_NAME.test(name)) {
            return {
              type: "func",
              name: name,
              args: args
            };
          }
          throw new SyntaxError("Function names must be all upper-case");
        }
        if (sigil === "-") {
          return {
            type: "term",
            name: name,
            attr: attr,
            args: []
          };
        }
        return {
          type: "mesg",
          name: name,
          attr: attr
        };
      }
      return parseLiteral();
    }
    function parseArguments() {
      var args = [];
      while (true) {
        switch (source[cursor]) {
          case ")":
            cursor++;
            return args;
          case undefined:
            throw new SyntaxError("Unclosed argument list");
        }
        args.push(parseArgument());
        consumeToken(TOKEN_COMMA);
      }
    }
    function parseArgument() {
      var expr = parseInlineExpression();
      if (expr.type !== "mesg") {
        return expr;
      }
      if (consumeToken(TOKEN_COLON)) {
        return {
          type: "narg",
          name: expr.name,
          value: parseLiteral()
        };
      }
      return expr;
    }
    function parseVariants() {
      var variants = [];
      var count = 0;
      var star;
      while (test(RE_VARIANT_START)) {
        if (consumeChar("*")) {
          star = count;
        }
        var key = parseVariantKey();
        var value = parsePattern();
        if (value === null) {
          throw new SyntaxError("Expected variant value");
        }
        variants[count++] = {
          key: key,
          value: value
        };
      }
      if (count === 0) {
        return null;
      }
      if (star === undefined) {
        throw new SyntaxError("Expected default variant");
      }
      return {
        variants: variants,
        star: star
      };
    }
    function parseVariantKey() {
      consumeToken(TOKEN_BRACKET_OPEN, SyntaxError);
      var key;
      if (test(RE_NUMBER_LITERAL)) {
        key = parseNumberLiteral();
      } else {
        key = {
          type: "str",
          value: match1(RE_IDENTIFIER)
        };
      }
      consumeToken(TOKEN_BRACKET_CLOSE, SyntaxError);
      return key;
    }
    function parseLiteral() {
      if (test(RE_NUMBER_LITERAL)) {
        return parseNumberLiteral();
      }
      if (source[cursor] === '"') {
        return parseStringLiteral();
      }
      throw new SyntaxError("Invalid expression");
    }
    function parseNumberLiteral() {
      var _match3 = match(RE_NUMBER_LITERAL),
        _match4 = _slicedToArray(_match3, 3),
        value = _match4[1],
        _match4$ = _match4[2],
        fraction = _match4$ === void 0 ? "" : _match4$;
      var precision = fraction.length;
      return {
        type: "num",
        value: parseFloat(value),
        precision: precision
      };
    }
    function parseStringLiteral() {
      consumeChar('"', SyntaxError);
      var value = "";
      while (true) {
        value += match1(RE_STRING_RUN);
        if (source[cursor] === "\\") {
          value += parseEscapeSequence();
          continue;
        }
        if (consumeChar('"')) {
          return {
            type: "str",
            value: value
          };
        }
        throw new SyntaxError("Unclosed string literal");
      }
    }
    function parseEscapeSequence() {
      if (test(RE_STRING_ESCAPE)) {
        return match1(RE_STRING_ESCAPE);
      }
      if (test(RE_UNICODE_ESCAPE)) {
        var _match5 = match(RE_UNICODE_ESCAPE),
          _match6 = _slicedToArray(_match5, 3),
          codepoint4 = _match6[1],
          codepoint6 = _match6[2];
        var codepoint = parseInt(codepoint4 || codepoint6, 16);
        return codepoint <= 0xd7ff || 0xe000 <= codepoint ? String.fromCodePoint(codepoint) : "�";
      }
      throw new SyntaxError("Unknown escape sequence");
    }
    function parseIndent() {
      var start = cursor;
      consumeToken(TOKEN_BLANK);
      switch (source[cursor]) {
        case ".":
        case "[":
        case "*":
        case "}":
        case undefined:
          return false;
        case "{":
          return makeIndent(source.slice(start, cursor));
      }
      if (source[cursor - 1] === " ") {
        return makeIndent(source.slice(start, cursor));
      }
      return false;
    }
    function trim(text, re) {
      return text.replace(re, "");
    }
    function makeIndent(blank) {
      var value = blank.replace(RE_BLANK_LINES, "\n");
      var length = RE_INDENT.exec(blank)[1].length;
      return new Indent(value, length);
    }
  });
  var Indent = /*#__PURE__*/_createClass(function Indent(value, length) {
    _classCallCheck(this, Indent);
    this.value = value;
    this.length = length;
  });

  var reOverlay = /<|&#?\w+;/;
  var TEXT_LEVEL_ELEMENTS = {
    "http://www.w3.org/1999/xhtml": ["em", "strong", "small", "s", "cite", "q", "dfn", "abbr", "data", "time", "code", "var", "samp", "kbd", "sub", "sup", "i", "b", "u", "mark", "bdi", "bdo", "span", "br", "wbr"]
  };
  var LOCALIZABLE_ATTRIBUTES = {
    "http://www.w3.org/1999/xhtml": {
      global: ["title", "aria-label", "aria-valuetext"],
      a: ["download"],
      area: ["download", "alt"],
      input: ["alt", "placeholder"],
      menuitem: ["label"],
      menu: ["label"],
      optgroup: ["label"],
      option: ["label"],
      track: ["label"],
      img: ["alt"],
      textarea: ["placeholder"],
      th: ["abbr"]
    },
    "http://www.mozilla.org/keymaster/gatekeeper/there.is.only.xul": {
      global: ["accesskey", "aria-label", "aria-valuetext", "label", "title", "tooltiptext"],
      description: ["value"],
      key: ["key", "keycode"],
      label: ["value"],
      textbox: ["placeholder", "value"]
    }
  };
  function translateElement(element, translation) {
    var value = translation.value;
    if (typeof value === "string") {
      if (element.localName === "title" && element.namespaceURI === "http://www.w3.org/1999/xhtml") {
        element.textContent = value;
      } else if (!reOverlay.test(value)) {
        element.textContent = value;
      } else {
        var templateElement = element.ownerDocument.createElementNS("http://www.w3.org/1999/xhtml", "template");
        templateElement.innerHTML = value;
        overlayChildNodes(templateElement.content, element);
      }
    }
    overlayAttributes(translation, element);
  }
  function overlayChildNodes(fromFragment, toElement) {
    var _iterator10 = _createForOfIteratorHelper(fromFragment.childNodes),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var childNode = _step10.value;
        if (childNode.nodeType === childNode.TEXT_NODE) {
          continue;
        }
        if (childNode.hasAttribute("data-l10n-name")) {
          var sanitized = getNodeForNamedElement(toElement, childNode);
          fromFragment.replaceChild(sanitized, childNode);
          continue;
        }
        if (isElementAllowed(childNode)) {
          var _sanitized = createSanitizedElement(childNode);
          fromFragment.replaceChild(_sanitized, childNode);
          continue;
        }
        console.warn("An element of forbidden type \"".concat(childNode.localName, "\" was found in ") + "the translation. Only safe text-level elements and elements with " + "data-l10n-name are allowed.");
        fromFragment.replaceChild(createTextNodeFromTextContent(childNode), childNode);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
    toElement.textContent = "";
    toElement.appendChild(fromFragment);
  }
  function hasAttribute(attributes, name) {
    if (!attributes) {
      return false;
    }
    var _iterator11 = _createForOfIteratorHelper(attributes),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var attr = _step11.value;
        if (attr.name === name) {
          return true;
        }
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
    return false;
  }
  function overlayAttributes(fromElement, toElement) {
    var explicitlyAllowed = toElement.hasAttribute("data-l10n-attrs") ? toElement.getAttribute("data-l10n-attrs").split(",").map(function (i) {
      return i.trim();
    }) : null;
    for (var _i2 = 0, _Array$from = Array.from(toElement.attributes); _i2 < _Array$from.length; _i2++) {
      var attr = _Array$from[_i2];
      if (isAttrNameLocalizable(attr.name, toElement, explicitlyAllowed) && !hasAttribute(fromElement.attributes, attr.name)) {
        toElement.removeAttribute(attr.name);
      }
    }
    if (!fromElement.attributes) {
      return;
    }
    for (var _i3 = 0, _Array$from2 = Array.from(fromElement.attributes); _i3 < _Array$from2.length; _i3++) {
      var _attr = _Array$from2[_i3];
      if (isAttrNameLocalizable(_attr.name, toElement, explicitlyAllowed) && toElement.getAttribute(_attr.name) !== _attr.value) {
        toElement.setAttribute(_attr.name, _attr.value);
      }
    }
  }
  function getNodeForNamedElement(sourceElement, translatedChild) {
    var childName = translatedChild.getAttribute("data-l10n-name");
    var sourceChild = sourceElement.querySelector("[data-l10n-name=\"".concat(childName, "\"]"));
    if (!sourceChild) {
      console.warn("An element named \"".concat(childName, "\" wasn't found in the source."));
      return createTextNodeFromTextContent(translatedChild);
    }
    if (sourceChild.localName !== translatedChild.localName) {
      console.warn("An element named \"".concat(childName, "\" was found in the translation ") + "but its type ".concat(translatedChild.localName, " didn't match the ") + "element found in the source (".concat(sourceChild.localName, ")."));
      return createTextNodeFromTextContent(translatedChild);
    }
    sourceElement.removeChild(sourceChild);
    var clone = sourceChild.cloneNode(false);
    return shallowPopulateUsing(translatedChild, clone);
  }
  function createSanitizedElement(element) {
    var clone = element.ownerDocument.createElement(element.localName);
    return shallowPopulateUsing(element, clone);
  }
  function createTextNodeFromTextContent(element) {
    return element.ownerDocument.createTextNode(element.textContent);
  }
  function isElementAllowed(element) {
    var allowed = TEXT_LEVEL_ELEMENTS[element.namespaceURI];
    return allowed && allowed.includes(element.localName);
  }
  function isAttrNameLocalizable(name, element) {
    var explicitlyAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (explicitlyAllowed && explicitlyAllowed.includes(name)) {
      return true;
    }
    var allowed = LOCALIZABLE_ATTRIBUTES[element.namespaceURI];
    if (!allowed) {
      return false;
    }
    var attrName = name.toLowerCase();
    var elemName = element.localName;
    if (allowed.global.includes(attrName)) {
      return true;
    }
    if (!allowed[elemName]) {
      return false;
    }
    if (allowed[elemName].includes(attrName)) {
      return true;
    }
    if (element.namespaceURI === "http://www.w3.org/1999/xhtml" && elemName === "input" && attrName === "value") {
      var type = element.type.toLowerCase();
      if (type === "submit" || type === "button" || type === "reset") {
        return true;
      }
    }
    return false;
  }
  function shallowPopulateUsing(fromElement, toElement) {
    toElement.textContent = fromElement.textContent;
    overlayAttributes(fromElement, toElement);
    return toElement;
  }
  // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.for-each.js
  __webpack_require__(3949);
  var CachedIterable = /*#__PURE__*/function (_Array) {
    function CachedIterable() {
      _classCallCheck(this, CachedIterable);
      return _callSuper(this, CachedIterable, arguments);
    }
    _inherits(CachedIterable, _Array);
    return _createClass(CachedIterable, null, [{
      key: "from",
      value: function from(iterable) {
        if (iterable instanceof this) {
          return iterable;
        }
        return new this(iterable);
      }
    }]);
  }( /*#__PURE__*/_wrapNativeSuper(Array));
  var CachedAsyncIterable = /*#__PURE__*/function (_CachedIterable2) {
    function CachedAsyncIterable(iterable) {
      var _this10;
      _classCallCheck(this, CachedAsyncIterable);
      _this10 = _callSuper(this, CachedAsyncIterable);
      if (Symbol.asyncIterator in Object(iterable)) {
        _this10.iterator = iterable[Symbol.asyncIterator]();
      } else if (Symbol.iterator in Object(iterable)) {
        _this10.iterator = iterable[Symbol.iterator]();
      } else {
        throw new TypeError("Argument must implement the iteration protocol.");
      }
      return _this10;
    }
    _inherits(CachedAsyncIterable, _CachedIterable2);
    return _createClass(CachedAsyncIterable, [{
      key: Symbol.asyncIterator,
      value: function value() {
        var cached = this;
        var cur = 0;
        return {
          next: function next() {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (cached.length <= cur) {
                      cached.push(cached.iterator.next());
                    }
                    return _context4.abrupt("return", cached[cur++]);
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }))();
          }
        };
      }
    }, {
      key: "touchNext",
      value: function () {
        var _touchNext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var count,
            idx,
            last,
            _args5 = arguments;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                count = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : 1;
                idx = 0;
              case 2:
                if (!(idx++ < count)) {
                  _context5.next = 14;
                  break;
                }
                last = this[this.length - 1];
                _context5.t0 = last;
                if (!_context5.t0) {
                  _context5.next = 9;
                  break;
                }
                _context5.next = 8;
                return last;
              case 8:
                _context5.t0 = _context5.sent.done;
              case 9:
                if (!_context5.t0) {
                  _context5.next = 11;
                  break;
                }
                return _context5.abrupt("break", 14);
              case 11:
                this.push(this.iterator.next());
                _context5.next = 2;
                break;
              case 14:
                return _context5.abrupt("return", this[this.length - 1]);
              case 15:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function touchNext() {
          return _touchNext.apply(this, arguments);
        }
        return touchNext;
      }()
    }]);
  }(CachedIterable);
  var Localization = /*#__PURE__*/function () {
    function Localization() {
      var resourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var generateBundles = arguments.length > 1 ? arguments[1] : undefined;
      _classCallCheck(this, Localization);
      this.resourceIds = resourceIds;
      this.generateBundles = generateBundles;
      this.onChange(true);
    }
    return _createClass(Localization, [{
      key: "addResourceIds",
      value: function addResourceIds(resourceIds) {
        var _this$resourceIds;
        var eager = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        (_this$resourceIds = this.resourceIds).push.apply(_this$resourceIds, _toConsumableArray(resourceIds));
        this.onChange(eager);
        return this.resourceIds.length;
      }
    }, {
      key: "removeResourceIds",
      value: function removeResourceIds(resourceIds) {
        this.resourceIds = this.resourceIds.filter(function (r) {
          return !resourceIds.includes(r);
        });
        this.onChange();
        return this.resourceIds.length;
      }
    }, {
      key: "formatWithFallback",
      value: function () {
        var _formatWithFallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(keys, method) {
          var translations, hasAtLeastOneBundle, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, bundle, missingIds, locale, ids;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                translations = [];
                hasAtLeastOneBundle = false;
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context6.prev = 4;
                _iterator = _asyncIterator(this.bundles);
              case 6:
                _context6.next = 8;
                return _iterator.next();
              case 8:
                if (!(_iteratorAbruptCompletion = !(_step = _context6.sent).done)) {
                  _context6.next = 18;
                  break;
                }
                bundle = _step.value;
                hasAtLeastOneBundle = true;
                missingIds = keysFromBundle(method, bundle, keys, translations);
                if (!(missingIds.size === 0)) {
                  _context6.next = 14;
                  break;
                }
                return _context6.abrupt("break", 18);
              case 14:
                if (typeof console !== "undefined") {
                  locale = bundle.locales[0];
                  ids = Array.from(missingIds).join(", ");
                  console.warn("[fluent] Missing translations in ".concat(locale, ": ").concat(ids));
                }
              case 15:
                _iteratorAbruptCompletion = false;
                _context6.next = 6;
                break;
              case 18:
                _context6.next = 24;
                break;
              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context6.t0;
              case 24:
                _context6.prev = 24;
                _context6.prev = 25;
                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
                  _context6.next = 29;
                  break;
                }
                _context6.next = 29;
                return _iterator["return"]();
              case 29:
                _context6.prev = 29;
                if (!_didIteratorError) {
                  _context6.next = 32;
                  break;
                }
                throw _iteratorError;
              case 32:
                return _context6.finish(29);
              case 33:
                return _context6.finish(24);
              case 34:
                if (!hasAtLeastOneBundle && typeof console !== "undefined") {
                  console.warn("[fluent] Request for keys failed because no resource bundles got generated.\n  keys: ".concat(JSON.stringify(keys), ".\n  resourceIds: ").concat(JSON.stringify(this.resourceIds), "."));
                }
                return _context6.abrupt("return", translations);
              case 36:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this, [[4, 20, 24, 34], [25,, 29, 33]]);
        }));
        function formatWithFallback(_x5, _x6) {
          return _formatWithFallback.apply(this, arguments);
        }
        return formatWithFallback;
      }()
    }, {
      key: "formatMessages",
      value: function formatMessages(keys) {
        return this.formatWithFallback(keys, messageFromBundle);
      }
    }, {
      key: "formatValues",
      value: function formatValues(keys) {
        return this.formatWithFallback(keys, valueFromBundle);
      }
    }, {
      key: "formatValue",
      value: function () {
        var _formatValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(id, args) {
          var _yield$this$formatVal, _yield$this$formatVal2, val;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.formatValues([{
                  id: id,
                  args: args
                }]);
              case 2:
                _yield$this$formatVal = _context7.sent;
                _yield$this$formatVal2 = _slicedToArray(_yield$this$formatVal, 1);
                val = _yield$this$formatVal2[0];
                return _context7.abrupt("return", val);
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function formatValue(_x7, _x8) {
          return _formatValue.apply(this, arguments);
        }
        return formatValue;
      }()
    }, {
      key: "handleEvent",
      value: function handleEvent() {
        this.onChange();
      }
    }, {
      key: "onChange",
      value: function onChange() {
        var eager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        this.bundles = CachedAsyncIterable.from(this.generateBundles(this.resourceIds));
        if (eager) {
          this.bundles.touchNext(2);
        }
      }
    }]);
  }();
  function valueFromBundle(bundle, errors, message, args) {
    if (message.value) {
      return bundle.formatPattern(message.value, args, errors);
    }
    return null;
  }
  function messageFromBundle(bundle, errors, message, args) {
    var formatted = {
      value: null,
      attributes: null
    };
    if (message.value) {
      formatted.value = bundle.formatPattern(message.value, args, errors);
    }
    var attrNames = Object.keys(message.attributes);
    if (attrNames.length > 0) {
      formatted.attributes = new Array(attrNames.length);
      var _iterator12 = _createForOfIteratorHelper(attrNames.entries()),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _step12$value = _slicedToArray(_step12.value, 2),
            i = _step12$value[0],
            name = _step12$value[1];
          var value = bundle.formatPattern(message.attributes[name], args, errors);
          formatted.attributes[i] = {
            name: name,
            value: value
          };
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
    return formatted;
  }
  function keysFromBundle(method, bundle, keys, translations) {
    var messageErrors = [];
    var missingIds = new Set();
    keys.forEach(function (_ref16, i) {
      var id = _ref16.id,
        args = _ref16.args;
      if (translations[i] !== undefined) {
        return;
      }
      var message = bundle.getMessage(id);
      if (message) {
        messageErrors.length = 0;
        translations[i] = method(bundle, messageErrors, message, args);
        if (messageErrors.length > 0 && typeof console !== "undefined") {
          var locale = bundle.locales[0];
          var errors = messageErrors.join(", ");
          console.warn("[fluent][resolver] errors in ".concat(locale, "/").concat(id, ": ").concat(errors, "."));
        }
      } else {
        missingIds.add(id);
      }
    });
    return missingIds;
  }

  var L10NID_ATTR_NAME = "data-l10n-id";
  var L10NARGS_ATTR_NAME = "data-l10n-args";
  var L10N_ELEMENT_QUERY = "[".concat(L10NID_ATTR_NAME, "]");
  var DOMLocalization = /*#__PURE__*/function (_Localization) {
    function DOMLocalization(resourceIds, generateBundles) {
      var _this11;
      _classCallCheck(this, DOMLocalization);
      _this11 = _callSuper(this, DOMLocalization, [resourceIds, generateBundles]);
      _this11.roots = new Set();
      _this11.pendingrAF = null;
      _this11.pendingElements = new Set();
      _this11.windowElement = null;
      _this11.mutationObserver = null;
      _this11.observerConfig = {
        attributes: true,
        characterData: false,
        childList: true,
        subtree: true,
        attributeFilter: [L10NID_ATTR_NAME, L10NARGS_ATTR_NAME]
      };
      return _this11;
    }
    _inherits(DOMLocalization, _Localization);
    return _createClass(DOMLocalization, [{
      key: "onChange",
      value: function onChange() {
        var eager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        _get(_getPrototypeOf(DOMLocalization.prototype), "onChange", this).call(this, eager);
        if (this.roots) {
          this.translateRoots();
        }
      }
    }, {
      key: "setAttributes",
      value: function setAttributes(element, id, args) {
        element.setAttribute(L10NID_ATTR_NAME, id);
        if (args) {
          element.setAttribute(L10NARGS_ATTR_NAME, JSON.stringify(args));
        } else {
          element.removeAttribute(L10NARGS_ATTR_NAME);
        }
        return element;
      }
    }, {
      key: "getAttributes",
      value: function getAttributes(element) {
        return {
          id: element.getAttribute(L10NID_ATTR_NAME),
          args: JSON.parse(element.getAttribute(L10NARGS_ATTR_NAME) || null)
        };
      }
    }, {
      key: "connectRoot",
      value: function connectRoot(newRoot) {
        var _this12 = this;
        var _iterator13 = _createForOfIteratorHelper(this.roots),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var root = _step13.value;
            if (root === newRoot || root.contains(newRoot) || newRoot.contains(root)) {
              throw new Error("Cannot add a root that overlaps with existing root.");
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
        if (this.windowElement) {
          if (this.windowElement !== newRoot.ownerDocument.defaultView) {
            throw new Error("Cannot connect a root:\n          DOMLocalization already has a root from a different window.");
          }
        } else {
          this.windowElement = newRoot.ownerDocument.defaultView;
          this.mutationObserver = new this.windowElement.MutationObserver(function (mutations) {
            return _this12.translateMutations(mutations);
          });
        }
        this.roots.add(newRoot);
        this.mutationObserver.observe(newRoot, this.observerConfig);
      }
    }, {
      key: "disconnectRoot",
      value: function disconnectRoot(root) {
        this.roots["delete"](root);
        this.pauseObserving();
        if (this.roots.size === 0) {
          this.mutationObserver = null;
          this.windowElement = null;
          this.pendingrAF = null;
          this.pendingElements.clear();
          return true;
        }
        this.resumeObserving();
        return false;
      }
    }, {
      key: "translateRoots",
      value: function translateRoots() {
        var _this13 = this;
        var roots = Array.from(this.roots);
        return Promise.all(roots.map(function (root) {
          return _this13.translateFragment(root);
        }));
      }
    }, {
      key: "pauseObserving",
      value: function pauseObserving() {
        if (!this.mutationObserver) {
          return;
        }
        this.translateMutations(this.mutationObserver.takeRecords());
        this.mutationObserver.disconnect();
      }
    }, {
      key: "resumeObserving",
      value: function resumeObserving() {
        if (!this.mutationObserver) {
          return;
        }
        var _iterator14 = _createForOfIteratorHelper(this.roots),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var root = _step14.value;
            this.mutationObserver.observe(root, this.observerConfig);
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
    }, {
      key: "translateMutations",
      value: function translateMutations(mutations) {
        var _this14 = this;
        var _iterator15 = _createForOfIteratorHelper(mutations),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var mutation = _step15.value;
            switch (mutation.type) {
              case "attributes":
                if (mutation.target.hasAttribute("data-l10n-id")) {
                  this.pendingElements.add(mutation.target);
                }
                break;
              case "childList":
                var _iterator16 = _createForOfIteratorHelper(mutation.addedNodes),
                  _step16;
                try {
                  for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                    var addedNode = _step16.value;
                    if (addedNode.nodeType === addedNode.ELEMENT_NODE) {
                      if (addedNode.childElementCount) {
                        var _iterator17 = _createForOfIteratorHelper(this.getTranslatables(addedNode)),
                          _step17;
                        try {
                          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                            var element = _step17.value;
                            this.pendingElements.add(element);
                          }
                        } catch (err) {
                          _iterator17.e(err);
                        } finally {
                          _iterator17.f();
                        }
                      } else if (addedNode.hasAttribute(L10NID_ATTR_NAME)) {
                        this.pendingElements.add(addedNode);
                      }
                    }
                  }
                } catch (err) {
                  _iterator16.e(err);
                } finally {
                  _iterator16.f();
                }
                break;
            }
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
        if (this.pendingElements.size > 0) {
          if (this.pendingrAF === null) {
            this.pendingrAF = this.windowElement.requestAnimationFrame(function () {
              _this14.translateElements(Array.from(_this14.pendingElements));
              _this14.pendingElements.clear();
              _this14.pendingrAF = null;
            });
          }
        }
      }
    }, {
      key: "translateFragment",
      value: function translateFragment(frag) {
        return this.translateElements(this.getTranslatables(frag));
      }
    }, {
      key: "translateElements",
      value: function () {
        var _translateElements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(elements) {
          var keys, translations;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (elements.length) {
                  _context8.next = 2;
                  break;
                }
                return _context8.abrupt("return", undefined);
              case 2:
                keys = elements.map(this.getKeysForElement);
                _context8.next = 5;
                return this.formatMessages(keys);
              case 5:
                translations = _context8.sent;
                return _context8.abrupt("return", this.applyTranslations(elements, translations));
              case 7:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function translateElements(_x9) {
          return _translateElements.apply(this, arguments);
        }
        return translateElements;
      }()
    }, {
      key: "applyTranslations",
      value: function applyTranslations(elements, translations) {
        this.pauseObserving();
        for (var i = 0; i < elements.length; i++) {
          if (translations[i] !== undefined) {
            translateElement(elements[i], translations[i]);
          }
        }
        this.resumeObserving();
      }
    }, {
      key: "getTranslatables",
      value: function getTranslatables(element) {
        var nodes = Array.from(element.querySelectorAll(L10N_ELEMENT_QUERY));
        if (typeof element.hasAttribute === "function" && element.hasAttribute(L10NID_ATTR_NAME)) {
          nodes.push(element);
        }
        return nodes;
      }
    }, {
      key: "getKeysForElement",
      value: function getKeysForElement(element) {
        return {
          id: element.getAttribute(L10NID_ATTR_NAME),
          args: JSON.parse(element.getAttribute(L10NARGS_ATTR_NAME) || null)
        };
      }
    }]);
  }(Localization);
  var _dir = /*#__PURE__*/new WeakMap();
  var _lang = /*#__PURE__*/new WeakMap();
  var _l10n = /*#__PURE__*/new WeakMap();
  var L10n = /*#__PURE__*/function () {
    function L10n(_ref17) {
      var lang = _ref17.lang,
        isRTL = _ref17.isRTL;
      var l10n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _classCallCheck(this, L10n);
      _classPrivateFieldInitSpec(this, _dir, void 0);
      _classPrivateFieldInitSpec(this, _lang, void 0);
      _classPrivateFieldInitSpec(this, _l10n, void 0);
      _classPrivateFieldSet2(_lang, this, _fixupLangCode.call(L10n, lang));
      _classPrivateFieldSet2(_l10n, this, l10n);
      _classPrivateFieldSet2(_dir, this, (isRTL !== null && isRTL !== void 0 ? isRTL : _isRTL.call(L10n, _classPrivateFieldGet2(_lang, this))) ? "rtl" : "ltr");
    }
    return _createClass(L10n, [{
      key: "_setL10n",
      value: function _setL10n(l10n) {
        _classPrivateFieldSet2(_l10n, this, l10n);
      }
    }, {
      key: "getLanguage",
      value: function getLanguage() {
        return _classPrivateFieldGet2(_lang, this);
      }
    }, {
      key: "getDirection",
      value: function getDirection() {
        return _classPrivateFieldGet2(_dir, this);
      }
    }, {
      key: "get",
      value: function () {
        var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(ids) {
          var args,
            fallback,
            _messages,
            messages,
            _args9 = arguments;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                args = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
                fallback = _args9.length > 2 ? _args9[2] : undefined;
                if (!Array.isArray(ids)) {
                  _context9.next = 8;
                  break;
                }
                ids = ids.map(function (id) {
                  return {
                    id: id
                  };
                });
                _context9.next = 6;
                return _classPrivateFieldGet2(_l10n, this).formatMessages(ids);
              case 6:
                _messages = _context9.sent;
                return _context9.abrupt("return", _messages.map(function (message) {
                  return message.value;
                }));
              case 8:
                _context9.next = 10;
                return _classPrivateFieldGet2(_l10n, this).formatMessages([{
                  id: ids,
                  args: args
                }]);
              case 10:
                messages = _context9.sent;
                return _context9.abrupt("return", (messages === null || messages === void 0 ? void 0 : messages[0].value) || fallback);
              case 12:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this);
        }));
        function get(_x10) {
          return _get2.apply(this, arguments);
        }
        return get;
      }()
    }, {
      key: "translate",
      value: function () {
        var _translate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(element) {
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _classPrivateFieldGet2(_l10n, this).connectRoot(element);
                _context10.next = 4;
                return _classPrivateFieldGet2(_l10n, this).translateRoots();
              case 4:
                _context10.next = 8;
                break;
              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10["catch"](0);
              case 8:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this, [[0, 6]]);
        }));
        function translate(_x11) {
          return _translate.apply(this, arguments);
        }
        return translate;
      }()
    }, {
      key: "pause",
      value: function pause() {
        _classPrivateFieldGet2(_l10n, this).pauseObserving();
      }
    }, {
      key: "resume",
      value: function resume() {
        _classPrivateFieldGet2(_l10n, this).resumeObserving();
      }
    }]);
  }();
  function _fixupLangCode(langCode) {
    var _langCode;
    langCode = ((_langCode = langCode) === null || _langCode === void 0 ? void 0 : _langCode.toLowerCase()) || "en-us";
    var PARTIAL_LANG_CODES = {
      en: "en-us",
      es: "es-es",
      fy: "fy-nl",
      ga: "ga-ie",
      gu: "gu-in",
      hi: "hi-in",
      hy: "hy-am",
      nb: "nb-no",
      ne: "ne-np",
      nn: "nn-no",
      pa: "pa-in",
      pt: "pt-pt",
      sv: "sv-se",
      zh: "zh-cn"
    };
    return PARTIAL_LANG_CODES[langCode] || langCode;
  }
  function _isRTL(lang) {
    var shortCode = lang.split("-", 1)[0];
    return ["ar", "he", "fa", "ps", "ur"].includes(shortCode);
  }

  function createBundle(lang, text) {
    var resource = new FluentResource(text);
    var bundle = new FluentBundle(lang);
    var errors = bundle.addResource(resource);
    if (errors.length) {
      console.error("L10n errors", errors);
    }
    return bundle;
  }
  var genericl10n_GenericL10n = /*#__PURE__*/function (_L10n2) {
    function genericl10n_GenericL10n(lang) {
      var _this15;
      _classCallCheck(this, genericl10n_GenericL10n);
      _this15 = _callSuper(this, genericl10n_GenericL10n, [{
        lang: lang
      }]);
      var generateBundles = !lang ? _generateBundlesFallback.bind(genericl10n_GenericL10n, _this15.getLanguage()) : _generateBundles.bind(genericl10n_GenericL10n, "en-us", _this15.getLanguage());
      _this15._setL10n(new DOMLocalization([], generateBundles));
      return _this15;
    }
    _inherits(genericl10n_GenericL10n, _L10n2);
    return _createClass(genericl10n_GenericL10n);
  }(L10n);
  _genericl10n_GenericL10n = genericl10n_GenericL10n;
  function _generateBundles(defaultLang, baseLang) {
    var _this = this;
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      var _yield$_awaitAsyncGen, baseURL, paths, langs, shortLang, _i6, _langs, lang, bundle;
      return _regeneratorRuntime().wrap(function _callee29$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return _awaitAsyncGenerator(_assertClassBrand(_genericl10n_GenericL10n, _this, _getPaths).call(_this));
          case 2:
            _yield$_awaitAsyncGen = _context30.sent;
            baseURL = _yield$_awaitAsyncGen.baseURL;
            paths = _yield$_awaitAsyncGen.paths;
            langs = [baseLang];
            if (defaultLang !== baseLang) {
              shortLang = baseLang.split("-", 1)[0];
              if (shortLang !== baseLang) {
                langs.push(shortLang);
              }
              langs.push(defaultLang);
            }
            _i6 = 0, _langs = langs;
          case 8:
            if (!(_i6 < _langs.length)) {
              _context30.next = 22;
              break;
            }
            lang = _langs[_i6];
            _context30.next = 12;
            return _awaitAsyncGenerator(_assertClassBrand(_genericl10n_GenericL10n, _this, _createBundle).call(_this, lang, baseURL, paths));
          case 12:
            bundle = _context30.sent;
            if (!bundle) {
              _context30.next = 16;
              break;
            }
            _context30.next = 16;
            return bundle;
          case 16:
            if (!(lang === "en-us")) {
              _context30.next = 19;
              break;
            }
            _context30.next = 19;
            return _assertClassBrand(_genericl10n_GenericL10n, _this, _createBundleFallback).call(_this, lang);
          case 19:
            _i6++;
            _context30.next = 8;
            break;
          case 22:
          case "end":
            return _context30.stop();
        }
      }, _callee29);
    }))();
  }
  function _createBundle(_x19, _x20, _x21) {
    return _createBundle3.apply(this, arguments);
  }
  function _createBundle3() {
    _createBundle3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(lang, baseURL, paths) {
      var path, url, text;
      return _regeneratorRuntime().wrap(function _callee33$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            path = paths[lang];
            if (path) {
              _context34.next = 3;
              break;
            }
            return _context34.abrupt("return", null);
          case 3:
            url = new URL(path, baseURL);
            _context34.next = 6;
            return fetchData(url, "text");
          case 6:
            text = _context34.sent;
            return _context34.abrupt("return", createBundle(lang, text));
          case 8:
          case "end":
            return _context34.stop();
        }
      }, _callee33);
    }));
    return _createBundle3.apply(this, arguments);
  }
  function _getPaths() {
    return _getPaths3.apply(this, arguments);
  }
  function _getPaths3() {
    _getPaths3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
      var _document$querySelect, href, paths;
      return _regeneratorRuntime().wrap(function _callee34$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            _context35.prev = 0;
            _document$querySelect = document.querySelector("link[type=\"application/l10n\"]"), href = _document$querySelect.href;
            _context35.next = 4;
            return fetchData(href, "json");
          case 4:
            paths = _context35.sent;
            return _context35.abrupt("return", {
              baseURL: href.replace(/[^/]*$/, "") || "./",
              paths: paths
            });
          case 8:
            _context35.prev = 8;
            _context35.t0 = _context35["catch"](0);
          case 10:
            return _context35.abrupt("return", {
              baseURL: "./",
              paths: Object.create(null)
            });
          case 11:
          case "end":
            return _context35.stop();
        }
      }, _callee34, null, [[0, 8]]);
    }));
    return _getPaths3.apply(this, arguments);
  }
  function _generateBundlesFallback(lang) {
    var _this2 = this;
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      return _regeneratorRuntime().wrap(function _callee30$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return _assertClassBrand(_genericl10n_GenericL10n, _this2, _createBundleFallback).call(_this2, lang);
          case 2:
          case "end":
            return _context31.stop();
        }
      }, _callee30);
    }))();
  }
  function _createBundleFallback(_x22) {
    return _createBundleFallback3.apply(this, arguments);
  }
  function _createBundleFallback3() {
    _createBundleFallback3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(lang) {
      var text;
      return _regeneratorRuntime().wrap(function _callee35$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            text = "pdfjs-previous-button =\n    .title = Previous Page\npdfjs-previous-button-label = Previous\npdfjs-next-button =\n    .title = Next Page\npdfjs-next-button-label = Next\npdfjs-page-input =\n    .title = Page\npdfjs-of-pages = of { $pagesCount }\npdfjs-page-of-pages = ({ $pageNumber } of { $pagesCount })\npdfjs-zoom-out-button =\n    .title = Zoom Out\npdfjs-zoom-out-button-label = Zoom Out\npdfjs-zoom-in-button =\n    .title = Zoom In\npdfjs-zoom-in-button-label = Zoom In\npdfjs-zoom-select =\n    .title = Zoom\npdfjs-presentation-mode-button =\n    .title = Switch to Presentation Mode\npdfjs-presentation-mode-button-label = Presentation Mode\npdfjs-open-file-button =\n    .title = Open File\npdfjs-open-file-button-label = Open\npdfjs-print-button =\n    .title = Print\npdfjs-print-button-label = Print\npdfjs-save-button =\n    .title = Save\npdfjs-save-button-label = Save\npdfjs-download-button =\n    .title = Download\npdfjs-download-button-label = Download\npdfjs-bookmark-button =\n    .title = Current Page (View URL from Current Page)\npdfjs-bookmark-button-label = Current Page\npdfjs-tools-button =\n    .title = Tools\npdfjs-tools-button-label = Tools\npdfjs-first-page-button =\n    .title = Go to First Page\npdfjs-first-page-button-label = Go to First Page\npdfjs-last-page-button =\n    .title = Go to Last Page\npdfjs-last-page-button-label = Go to Last Page\npdfjs-page-rotate-cw-button =\n    .title = Rotate Clockwise\npdfjs-page-rotate-cw-button-label = Rotate Clockwise\npdfjs-page-rotate-ccw-button =\n    .title = Rotate Counterclockwise\npdfjs-page-rotate-ccw-button-label = Rotate Counterclockwise\npdfjs-cursor-text-select-tool-button =\n    .title = Enable Text Selection Tool\npdfjs-cursor-text-select-tool-button-label = Text Selection Tool\npdfjs-cursor-hand-tool-button =\n    .title = Enable Hand Tool\npdfjs-cursor-hand-tool-button-label = Hand Tool\npdfjs-scroll-page-button =\n    .title = Use Page Scrolling\npdfjs-scroll-page-button-label = Page Scrolling\npdfjs-scroll-vertical-button =\n    .title = Use Vertical Scrolling\npdfjs-scroll-vertical-button-label = Vertical Scrolling\npdfjs-scroll-horizontal-button =\n    .title = Use Horizontal Scrolling\npdfjs-scroll-horizontal-button-label = Horizontal Scrolling\npdfjs-scroll-wrapped-button =\n    .title = Use Wrapped Scrolling\npdfjs-scroll-wrapped-button-label = Wrapped Scrolling\npdfjs-spread-none-button =\n    .title = Do not join page spreads\npdfjs-spread-none-button-label = No Spreads\npdfjs-spread-odd-button =\n    .title = Join page spreads starting with odd-numbered pages\npdfjs-spread-odd-button-label = Odd Spreads\npdfjs-spread-even-button =\n    .title = Join page spreads starting with even-numbered pages\npdfjs-spread-even-button-label = Even Spreads\npdfjs-document-properties-button =\n    .title = Document Properties\u2026\npdfjs-document-properties-button-label = Document Properties\u2026\npdfjs-document-properties-file-name = File name:\npdfjs-document-properties-file-size = File size:\npdfjs-document-properties-kb = { $size_kb } KB ({ $size_b } bytes)\npdfjs-document-properties-mb = { $size_mb } MB ({ $size_b } bytes)\npdfjs-document-properties-title = Title:\npdfjs-document-properties-author = Author:\npdfjs-document-properties-subject = Subject:\npdfjs-document-properties-keywords = Keywords:\npdfjs-document-properties-creation-date = Creation Date:\npdfjs-document-properties-modification-date = Modification Date:\npdfjs-document-properties-date-string = { $date }, { $time }\npdfjs-document-properties-creator = Creator:\npdfjs-document-properties-producer = PDF Producer:\npdfjs-document-properties-version = PDF Version:\npdfjs-document-properties-page-count = Page Count:\npdfjs-document-properties-page-size = Page Size:\npdfjs-document-properties-page-size-unit-inches = in\npdfjs-document-properties-page-size-unit-millimeters = mm\npdfjs-document-properties-page-size-orientation-portrait = portrait\npdfjs-document-properties-page-size-orientation-landscape = landscape\npdfjs-document-properties-page-size-name-a-three = A3\npdfjs-document-properties-page-size-name-a-four = A4\npdfjs-document-properties-page-size-name-letter = Letter\npdfjs-document-properties-page-size-name-legal = Legal\npdfjs-document-properties-page-size-dimension-string = { $width } \xD7 { $height } { $unit } ({ $orientation })\npdfjs-document-properties-page-size-dimension-name-string = { $width } \xD7 { $height } { $unit } ({ $name }, { $orientation })\npdfjs-document-properties-linearized = Fast Web View:\npdfjs-document-properties-linearized-yes = Yes\npdfjs-document-properties-linearized-no = No\npdfjs-document-properties-close-button = Close\npdfjs-print-progress-message = Preparing document for printing\u2026\npdfjs-print-progress-percent = { $progress }%\npdfjs-print-progress-close-button = Cancel\npdfjs-printing-not-supported = Warning: Printing is not fully supported by this browser.\npdfjs-printing-not-ready = Warning: The PDF is not fully loaded for printing.\npdfjs-toggle-sidebar-button =\n    .title = Toggle Sidebar\npdfjs-toggle-sidebar-notification-button =\n    .title = Toggle Sidebar (document contains outline/attachments/layers)\npdfjs-toggle-sidebar-button-label = Toggle Sidebar\npdfjs-document-outline-button =\n    .title = Show Document Outline (double-click to expand/collapse all items)\npdfjs-document-outline-button-label = Document Outline\npdfjs-attachments-button =\n    .title = Show Attachments\npdfjs-attachments-button-label = Attachments\npdfjs-layers-button =\n    .title = Show Layers (double-click to reset all layers to the default state)\npdfjs-layers-button-label = Layers\npdfjs-thumbs-button =\n    .title = Show Thumbnails\npdfjs-thumbs-button-label = Thumbnails\npdfjs-current-outline-item-button =\n    .title = Find Current Outline Item\npdfjs-current-outline-item-button-label = Current Outline Item\npdfjs-findbar-button =\n    .title = Find in Document\npdfjs-findbar-button-label = Find\npdfjs-additional-layers = Additional Layers\npdfjs-thumb-page-title =\n    .title = Page { $page }\npdfjs-thumb-page-canvas =\n    .aria-label = Thumbnail of Page { $page }\npdfjs-find-input =\n    .title = Find\n    .placeholder = Find in document\u2026\npdfjs-find-previous-button =\n    .title = Find the previous occurrence of the phrase\npdfjs-find-previous-button-label = Previous\npdfjs-find-next-button =\n    .title = Find the next occurrence of the phrase\npdfjs-find-next-button-label = Next\npdfjs-find-highlight-checkbox = Highlight All\npdfjs-find-match-case-checkbox-label = Match Case\npdfjs-find-match-diacritics-checkbox-label = Match Diacritics\npdfjs-find-entire-word-checkbox-label = Whole Words\npdfjs-find-reached-top = Reached top of document, continued from bottom\npdfjs-find-reached-bottom = Reached end of document, continued from top\npdfjs-find-match-count =\n    { $total ->\n        [one] { $current } of { $total } match\n       *[other] { $current } of { $total } matches\n    }\npdfjs-find-match-count-limit =\n    { $limit ->\n        [one] More than { $limit } match\n       *[other] More than { $limit } matches\n    }\npdfjs-find-not-found = Phrase not found\npdfjs-page-scale-width = Page Width\npdfjs-page-scale-fit = Page Fit\npdfjs-page-scale-auto = Automatic Zoom\npdfjs-page-scale-actual = Actual Size\npdfjs-page-scale-percent = { $scale }%\npdfjs-page-landmark =\n    .aria-label = Page { $page }\npdfjs-loading-error = An error occurred while loading the PDF.\npdfjs-invalid-file-error = Invalid or corrupted PDF file.\npdfjs-missing-file-error = Missing PDF file.\npdfjs-unexpected-response-error = Unexpected server response.\npdfjs-rendering-error = An error occurred while rendering the page.\npdfjs-annotation-date-string = { $date }, { $time }\npdfjs-text-annotation-type =\n    .alt = [{ $type } Annotation]\npdfjs-password-label = Enter the password to open this PDF file.\npdfjs-password-invalid = Invalid password. Please try again.\npdfjs-password-ok-button = OK\npdfjs-password-cancel-button = Cancel\npdfjs-web-fonts-disabled = Web fonts are disabled: unable to use embedded PDF fonts.\npdfjs-editor-free-text-button =\n    .title = Text\npdfjs-editor-free-text-button-label = Text\npdfjs-editor-ink-button =\n    .title = Draw\npdfjs-editor-ink-button-label = Draw\npdfjs-editor-stamp-button =\n    .title = Add or edit images\npdfjs-editor-stamp-button-label = Add or edit images\npdfjs-editor-highlight-button =\n    .title = Highlight\npdfjs-editor-highlight-button-label = Highlight\npdfjs-highlight-floating-button1 =\n    .title = Highlight\n    .aria-label = Highlight\npdfjs-highlight-floating-button-label = Highlight\npdfjs-editor-remove-ink-button =\n    .title = Remove drawing\npdfjs-editor-remove-freetext-button =\n    .title = Remove text\npdfjs-editor-remove-stamp-button =\n    .title = Remove image\npdfjs-editor-remove-highlight-button =\n    .title = Remove highlight\npdfjs-editor-free-text-color-input = Color\npdfjs-editor-free-text-size-input = Size\npdfjs-editor-ink-color-input = Color\npdfjs-editor-ink-thickness-input = Thickness\npdfjs-editor-ink-opacity-input = Opacity\npdfjs-editor-stamp-add-image-button =\n    .title = Add image\npdfjs-editor-stamp-add-image-button-label = Add image\npdfjs-editor-free-highlight-thickness-input = Thickness\npdfjs-editor-free-highlight-thickness-title =\n    .title = Change thickness when highlighting items other than text\npdfjs-free-text =\n    .aria-label = Text Editor\npdfjs-free-text-default-content = Start typing\u2026\npdfjs-ink =\n    .aria-label = Draw Editor\npdfjs-ink-canvas =\n    .aria-label = User-created image\npdfjs-editor-alt-text-button-label = Alt text\npdfjs-editor-alt-text-edit-button-label = Edit alt text\npdfjs-editor-alt-text-dialog-label = Choose an option\npdfjs-editor-alt-text-dialog-description = Alt text (alternative text) helps when people can\u2019t see the image or when it doesn\u2019t load.\npdfjs-editor-alt-text-add-description-label = Add a description\npdfjs-editor-alt-text-add-description-description = Aim for 1-2 sentences that describe the subject, setting, or actions.\npdfjs-editor-alt-text-mark-decorative-label = Mark as decorative\npdfjs-editor-alt-text-mark-decorative-description = This is used for ornamental images, like borders or watermarks.\npdfjs-editor-alt-text-cancel-button = Cancel\npdfjs-editor-alt-text-save-button = Save\npdfjs-editor-alt-text-decorative-tooltip = Marked as decorative\npdfjs-editor-alt-text-textarea =\n    .placeholder = For example, \u201CA young man sits down at a table to eat a meal\u201D\npdfjs-editor-resizer-label-top-left = Top left corner \u2014 resize\npdfjs-editor-resizer-label-top-middle = Top middle \u2014 resize\npdfjs-editor-resizer-label-top-right = Top right corner \u2014 resize\npdfjs-editor-resizer-label-middle-right = Middle right \u2014 resize\npdfjs-editor-resizer-label-bottom-right = Bottom right corner \u2014 resize\npdfjs-editor-resizer-label-bottom-middle = Bottom middle \u2014 resize\npdfjs-editor-resizer-label-bottom-left = Bottom left corner \u2014 resize\npdfjs-editor-resizer-label-middle-left = Middle left \u2014 resize\npdfjs-editor-highlight-colorpicker-label = Highlight color\npdfjs-editor-colorpicker-button =\n    .title = Change color\npdfjs-editor-colorpicker-dropdown =\n    .aria-label = Color choices\npdfjs-editor-colorpicker-yellow =\n    .title = Yellow\npdfjs-editor-colorpicker-green =\n    .title = Green\npdfjs-editor-colorpicker-blue =\n    .title = Blue\npdfjs-editor-colorpicker-pink =\n    .title = Pink\npdfjs-editor-colorpicker-red =\n    .title = Red\npdfjs-editor-highlight-show-all-button-label = Show all\npdfjs-editor-highlight-show-all-button =\n    .title = Show all";
            return _context36.abrupt("return", createBundle(lang, text));
          case 2:
          case "end":
            return _context36.stop();
        }
      }, _callee35);
    }));
    return _createBundleFallback3.apply(this, arguments);
  }

  var HASH_CHANGE_TIMEOUT = 1000;
  var POSITION_UPDATED_THRESHOLD = 50;
  var UPDATE_VIEWAREA_TIMEOUT = 1000;
  function getCurrentHash() {
    return document.location.hash;
  }
  var _eventAbortController2 = /*#__PURE__*/new WeakMap();
  var _PDFHistory_brand = /*#__PURE__*/new WeakSet();
  var _PDFHistory = /*#__PURE__*/function () {
    function _PDFHistory(_ref18) {
      var _this16 = this;
      var linkService = _ref18.linkService,
        eventBus = _ref18.eventBus;
      _classCallCheck(this, _PDFHistory);
      _classPrivateMethodInitSpec(this, _PDFHistory_brand);
      _classPrivateFieldInitSpec(this, _eventAbortController2, null);
      this.linkService = linkService;
      this.eventBus = eventBus;
      this._initialized = false;
      this._fingerprint = "";
      this.reset();
      this.eventBus._on("pagesinit", function () {
        _this16._isPagesLoaded = false;
        _this16.eventBus._on("pagesloaded", function (evt) {
          _this16._isPagesLoaded = !!evt.pagesCount;
        }, {
          once: true
        });
      });
    }
    return _createClass(_PDFHistory, [{
      key: "initialize",
      value: function initialize(_ref19) {
        var fingerprint = _ref19.fingerprint,
          _ref19$resetHistory = _ref19.resetHistory,
          resetHistory = _ref19$resetHistory === void 0 ? false : _ref19$resetHistory,
          _ref19$updateUrl = _ref19.updateUrl,
          updateUrl = _ref19$updateUrl === void 0 ? false : _ref19$updateUrl;
        if (!fingerprint || typeof fingerprint !== "string") {
          console.error('PDFHistory.initialize: The "fingerprint" must be a non-empty string.');
          return;
        }
        if (this._initialized) {
          this.reset();
        }
        var reInitialized = this._fingerprint !== "" && this._fingerprint !== fingerprint;
        this._fingerprint = fingerprint;
        this._updateUrl = updateUrl === true;
        this._initialized = true;
        _assertClassBrand(_PDFHistory_brand, this, _bindEvents).call(this);
        var state = window.history.state;
        this._popStateInProgress = false;
        this._blockHashChange = 0;
        this._currentHash = getCurrentHash();
        this._numPositionUpdates = 0;
        this._uid = this._maxUid = 0;
        this._destination = null;
        this._position = null;
        if (!_assertClassBrand(_PDFHistory_brand, this, _isValidState).call(this, state, true) || resetHistory) {
          var _assertClassBrand$cal = _assertClassBrand(_PDFHistory_brand, this, _parseCurrentHash).call(this, true),
            hash = _assertClassBrand$cal.hash,
            page = _assertClassBrand$cal.page,
            rotation = _assertClassBrand$cal.rotation;
          if (!hash || reInitialized || resetHistory) {
            _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, null, true);
            return;
          }
          _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, {
            hash: hash,
            page: page,
            rotation: rotation
          }, true);
          return;
        }
        var destination = state.destination;
        _assertClassBrand(_PDFHistory_brand, this, _updateInternalState).call(this, destination, state.uid, true);
        if (destination.rotation !== undefined) {
          this._initialRotation = destination.rotation;
        }
        if (destination.dest) {
          this._initialBookmark = JSON.stringify(destination.dest);
          this._destination.page = null;
        } else if (destination.hash) {
          this._initialBookmark = destination.hash;
        } else if (destination.page) {
          this._initialBookmark = "page=".concat(destination.page);
        }
      }
    }, {
      key: "reset",
      value: function reset() {
        if (this._initialized) {
          _assertClassBrand(_PDFHistory_brand, this, _pageHide).call(this);
          this._initialized = false;
          _assertClassBrand(_PDFHistory_brand, this, _unbindEvents).call(this);
        }
        if (this._updateViewareaTimeout) {
          clearTimeout(this._updateViewareaTimeout);
          this._updateViewareaTimeout = null;
        }
        this._initialBookmark = null;
        this._initialRotation = null;
      }
    }, {
      key: "push",
      value: function push(_ref20) {
        var _this17 = this;
        var _ref20$namedDest = _ref20.namedDest,
          namedDest = _ref20$namedDest === void 0 ? null : _ref20$namedDest,
          explicitDest = _ref20.explicitDest,
          pageNumber = _ref20.pageNumber;
        if (!this._initialized) {
          return;
        }
        if (namedDest && typeof namedDest !== "string") {
          console.error("PDFHistory.push: " + "\"".concat(namedDest, "\" is not a valid namedDest parameter."));
          return;
        } else if (!Array.isArray(explicitDest)) {
          console.error("PDFHistory.push: " + "\"".concat(explicitDest, "\" is not a valid explicitDest parameter."));
          return;
        } else if (!_assertClassBrand(_PDFHistory_brand, this, _isValidPage).call(this, pageNumber)) {
          if (pageNumber !== null || this._destination) {
            console.error("PDFHistory.push: " + "\"".concat(pageNumber, "\" is not a valid pageNumber parameter."));
            return;
          }
        }
        var hash = namedDest || JSON.stringify(explicitDest);
        if (!hash) {
          return;
        }
        var forceReplace = false;
        if (this._destination && (isDestHashesEqual(this._destination.hash, hash) || isDestArraysEqual(this._destination.dest, explicitDest))) {
          if (this._destination.page) {
            return;
          }
          forceReplace = true;
        }
        if (this._popStateInProgress && !forceReplace) {
          return;
        }
        _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, {
          dest: explicitDest,
          hash: hash,
          page: pageNumber,
          rotation: this.linkService.rotation
        }, forceReplace);
        if (!this._popStateInProgress) {
          this._popStateInProgress = true;
          Promise.resolve().then(function () {
            _this17._popStateInProgress = false;
          });
        }
      }
    }, {
      key: "pushPage",
      value: function pushPage(pageNumber) {
        var _this$_destination,
          _this18 = this;
        if (!this._initialized) {
          return;
        }
        if (!_assertClassBrand(_PDFHistory_brand, this, _isValidPage).call(this, pageNumber)) {
          console.error("PDFHistory.pushPage: \"".concat(pageNumber, "\" is not a valid page number."));
          return;
        }
        if (((_this$_destination = this._destination) === null || _this$_destination === void 0 ? void 0 : _this$_destination.page) === pageNumber) {
          return;
        }
        if (this._popStateInProgress) {
          return;
        }
        _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, {
          dest: null,
          hash: "page=".concat(pageNumber),
          page: pageNumber,
          rotation: this.linkService.rotation
        });
        if (!this._popStateInProgress) {
          this._popStateInProgress = true;
          Promise.resolve().then(function () {
            _this18._popStateInProgress = false;
          });
        }
      }
    }, {
      key: "pushCurrentPosition",
      value: function pushCurrentPosition() {
        if (!this._initialized || this._popStateInProgress) {
          return;
        }
        _assertClassBrand(_PDFHistory_brand, this, _tryPushCurrentPosition).call(this);
      }
    }, {
      key: "back",
      value: function back() {
        if (!this._initialized || this._popStateInProgress) {
          return;
        }
        var state = window.history.state;
        if (_assertClassBrand(_PDFHistory_brand, this, _isValidState).call(this, state) && state.uid > 0) {
          window.history.back();
        }
      }
    }, {
      key: "forward",
      value: function forward() {
        if (!this._initialized || this._popStateInProgress) {
          return;
        }
        var state = window.history.state;
        if (_assertClassBrand(_PDFHistory_brand, this, _isValidState).call(this, state) && state.uid < this._maxUid) {
          window.history.forward();
        }
      }
    }, {
      key: "popStateInProgress",
      get: function get() {
        return this._initialized && (this._popStateInProgress || this._blockHashChange > 0);
      }
    }, {
      key: "initialBookmark",
      get: function get() {
        return this._initialized ? this._initialBookmark : null;
      }
    }, {
      key: "initialRotation",
      get: function get() {
        return this._initialized ? this._initialRotation : null;
      }
    }]);
  }();
  function _pushOrReplaceState(destination) {
    var forceReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var shouldReplace = forceReplace || !this._destination;
    var newState = {
      fingerprint: this._fingerprint,
      uid: shouldReplace ? this._uid : this._uid + 1,
      destination: destination
    };
    _assertClassBrand(_PDFHistory_brand, this, _updateInternalState).call(this, destination, newState.uid);
    var newUrl;
    if (this._updateUrl && destination !== null && destination !== void 0 && destination.hash) {
      var baseUrl = document.location.href.split("#", 1)[0];
      if (!baseUrl.startsWith("file://")) {
        newUrl = "".concat(baseUrl, "#").concat(destination.hash);
      }
    }
    if (shouldReplace) {
      window.history.replaceState(newState, "", newUrl);
    } else {
      window.history.pushState(newState, "", newUrl);
    }
  }
  function _tryPushCurrentPosition() {
    var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!this._position) {
      return;
    }
    var position = this._position;
    if (temporary) {
      position = Object.assign(Object.create(null), this._position);
      position.temporary = true;
    }
    if (!this._destination) {
      _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, position);
      return;
    }
    if (this._destination.temporary) {
      _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, position, true);
      return;
    }
    if (this._destination.hash === position.hash) {
      return;
    }
    if (!this._destination.page && (this._numPositionUpdates <= POSITION_UPDATED_THRESHOLD)) {
      return;
    }
    var forceReplace = false;
    if (this._destination.page >= position.first && this._destination.page <= position.page) {
      if (this._destination.dest !== undefined || !this._destination.first) {
        return;
      }
      forceReplace = true;
    }
    _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, position, forceReplace);
  }
  function _isValidPage(val) {
    return Number.isInteger(val) && val > 0 && val <= this.linkService.pagesCount;
  }
  function _isValidState(state) {
    var checkReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!state) {
      return false;
    }
    if (state.fingerprint !== this._fingerprint) {
      if (checkReload) {
        if (typeof state.fingerprint !== "string" || state.fingerprint.length !== this._fingerprint.length) {
          return false;
        }
        var _performance$getEntri = performance.getEntriesByType("navigation"),
          _performance$getEntri2 = _slicedToArray(_performance$getEntri, 1),
          perfEntry = _performance$getEntri2[0];
        if ((perfEntry === null || perfEntry === void 0 ? void 0 : perfEntry.type) !== "reload") {
          return false;
        }
      } else {
        return false;
      }
    }
    if (!Number.isInteger(state.uid) || state.uid < 0) {
      return false;
    }
    if (state.destination === null || _typeof(state.destination) !== "object") {
      return false;
    }
    return true;
  }
  function _updateInternalState(destination, uid) {
    var removeTemporary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (this._updateViewareaTimeout) {
      clearTimeout(this._updateViewareaTimeout);
      this._updateViewareaTimeout = null;
    }
    if (removeTemporary && destination !== null && destination !== void 0 && destination.temporary) {
      delete destination.temporary;
    }
    this._destination = destination;
    this._uid = uid;
    this._maxUid = Math.max(this._maxUid, uid);
    this._numPositionUpdates = 0;
  }
  function _parseCurrentHash() {
    var checkNameddest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var hash = unescape(getCurrentHash()).substring(1);
    var params = _parseQueryString(hash);
    var nameddest = params.get("nameddest") || "";
    var page = params.get("page") | 0;
    if (!_assertClassBrand(_PDFHistory_brand, this, _isValidPage).call(this, page) || checkNameddest && nameddest.length > 0) {
      page = null;
    }
    return {
      hash: hash,
      page: page,
      rotation: this.linkService.rotation
    };
  }
  function _updateViewarea(_ref43) {
    var _this37 = this;
    var location = _ref43.location;
    if (this._updateViewareaTimeout) {
      clearTimeout(this._updateViewareaTimeout);
      this._updateViewareaTimeout = null;
    }
    this._position = {
      hash: location.pdfOpenParams.substring(1),
      page: this.linkService.page,
      first: location.pageNumber,
      rotation: location.rotation
    };
    if (this._popStateInProgress) {
      return;
    }
    if (this._isPagesLoaded && this._destination && !this._destination.page) {
      this._numPositionUpdates++;
    }
    {
      this._updateViewareaTimeout = setTimeout(function () {
        if (!_this37._popStateInProgress) {
          _assertClassBrand(_PDFHistory_brand, _this37, _tryPushCurrentPosition).call(_this37, true);
        }
        _this37._updateViewareaTimeout = null;
      }, UPDATE_VIEWAREA_TIMEOUT);
    }
  }
  function _popState(_ref44) {
    var _this38 = this;
    var state = _ref44.state;
    var newHash = getCurrentHash(),
      hashChanged = this._currentHash !== newHash;
    this._currentHash = newHash;
    if (!state) {
      this._uid++;
      var _assertClassBrand$cal7 = _assertClassBrand(_PDFHistory_brand, this, _parseCurrentHash).call(this),
        hash = _assertClassBrand$cal7.hash,
        page = _assertClassBrand$cal7.page,
        rotation = _assertClassBrand$cal7.rotation;
      _assertClassBrand(_PDFHistory_brand, this, _pushOrReplaceState).call(this, {
        hash: hash,
        page: page,
        rotation: rotation
      }, true);
      return;
    }
    if (!_assertClassBrand(_PDFHistory_brand, this, _isValidState).call(this, state)) {
      return;
    }
    this._popStateInProgress = true;
    if (hashChanged) {
      this._blockHashChange++;
      waitOnEventOrTimeout({
        target: window,
        name: "hashchange",
        delay: HASH_CHANGE_TIMEOUT
      }).then(function () {
        _this38._blockHashChange--;
      });
    }
    var destination = state.destination;
    _assertClassBrand(_PDFHistory_brand, this, _updateInternalState).call(this, destination, state.uid, true);
    if (isValidRotation(destination.rotation)) {
      this.linkService.rotation = destination.rotation;
    }
    if (destination.dest) {
      this.linkService.goToDestination(destination.dest);
    } else if (destination.hash) {
      this.linkService.setHash(destination.hash);
    } else if (destination.page) {
      this.linkService.page = destination.page;
    }
    Promise.resolve().then(function () {
      _this38._popStateInProgress = false;
    });
  }
  function _pageHide() {
    if (!this._destination || this._destination.temporary) {
      _assertClassBrand(_PDFHistory_brand, this, _tryPushCurrentPosition).call(this);
    }
  }
  function _bindEvents() {
    if (_classPrivateFieldGet2(_eventAbortController2, this)) {
      return;
    }
    _classPrivateFieldSet2(_eventAbortController2, this, new AbortController());
    var _classPrivateFieldGet34 = _classPrivateFieldGet2(_eventAbortController2, this),
      signal = _classPrivateFieldGet34.signal;
    this.eventBus._on("updateviewarea", _assertClassBrand(_PDFHistory_brand, this, _updateViewarea).bind(this), {
      signal: signal
    });
    window.addEventListener("popstate", _assertClassBrand(_PDFHistory_brand, this, _popState).bind(this), {
      signal: signal
    });
    window.addEventListener("pagehide", _assertClassBrand(_PDFHistory_brand, this, _pageHide).bind(this), {
      signal: signal
    });
  }
  function _unbindEvents() {
    var _classPrivateFieldGet35;
    (_classPrivateFieldGet35 = _classPrivateFieldGet2(_eventAbortController2, this)) === null || _classPrivateFieldGet35 === void 0 || _classPrivateFieldGet35.abort();
    _classPrivateFieldSet2(_eventAbortController2, this, null);
  }
  function isDestHashesEqual(destHash, pushHash) {
    if (typeof destHash !== "string" || typeof pushHash !== "string") {
      return false;
    }
    if (destHash === pushHash) {
      return true;
    }
    var nameddest = _parseQueryString(destHash).get("nameddest");
    if (nameddest === pushHash) {
      return true;
    }
    return false;
  }
  function isDestArraysEqual(firstDest, secondDest) {
    function isEntryEqual(first, second) {
      if (_typeof(first) !== _typeof(second)) {
        return false;
      }
      if (Array.isArray(first) || Array.isArray(second)) {
        return false;
      }
      if (first !== null && _typeof(first) === "object" && second !== null) {
        if (Object.keys(first).length !== Object.keys(second).length) {
          return false;
        }
        for (var key in first) {
          if (!isEntryEqual(first[key], second[key])) {
            return false;
          }
        }
        return true;
      }
      return first === second || Number.isNaN(first) && Number.isNaN(second);
    }
    if (!(Array.isArray(firstDest) && Array.isArray(secondDest))) {
      return false;
    }
    if (firstDest.length !== secondDest.length) {
      return false;
    }
    for (var i = 0, ii = firstDest.length; i < ii; i++) {
      if (!isEntryEqual(firstDest[i], secondDest[i])) {
        return false;
      }
    }
    return true;
  }
  var _annotationLayer = /*#__PURE__*/new WeakMap();
  var _drawLayer = /*#__PURE__*/new WeakMap();
  var _onAppend2 = /*#__PURE__*/new WeakMap();
  var _textLayer = /*#__PURE__*/new WeakMap();
  var _uiManager = /*#__PURE__*/new WeakMap();
  var AnnotationEditorLayerBuilder = /*#__PURE__*/function () {
    function AnnotationEditorLayerBuilder(options) {
      _classCallCheck(this, AnnotationEditorLayerBuilder);
      _classPrivateFieldInitSpec(this, _annotationLayer, null);
      _classPrivateFieldInitSpec(this, _drawLayer, null);
      _classPrivateFieldInitSpec(this, _onAppend2, null);
      _classPrivateFieldInitSpec(this, _textLayer, null);
      _classPrivateFieldInitSpec(this, _uiManager, void 0);
      this.pdfPage = options.pdfPage;
      this.accessibilityManager = options.accessibilityManager;
      this.l10n = options.l10n;
      this.l10n || (this.l10n = new genericl10n_GenericL10n());
      this.annotationEditorLayer = null;
      this.div = null;
      this._cancelled = false;
      _classPrivateFieldSet2(_uiManager, this, options.uiManager);
      _classPrivateFieldSet2(_annotationLayer, this, options.annotationLayer || null);
      _classPrivateFieldSet2(_textLayer, this, options.textLayer || null);
      _classPrivateFieldSet2(_drawLayer, this, options.drawLayer || null);
      _classPrivateFieldSet2(_onAppend2, this, options.onAppend || null);
    }
    return _createClass(AnnotationEditorLayerBuilder, [{
      key: "render",
      value: function () {
        var _render2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(viewport) {
          var _classPrivateFieldGet5;
          var intent,
            clonedViewport,
            div,
            parameters,
            _args11 = arguments;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                intent = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : "display";
                if (!(intent !== "display")) {
                  _context11.next = 3;
                  break;
                }
                return _context11.abrupt("return");
              case 3:
                if (!this._cancelled) {
                  _context11.next = 5;
                  break;
                }
                return _context11.abrupt("return");
              case 5:
                clonedViewport = viewport.clone({
                  dontFlip: true
                });
                if (!this.div) {
                  _context11.next = 10;
                  break;
                }
                this.annotationEditorLayer.update({
                  viewport: clonedViewport
                });
                this.show();
                return _context11.abrupt("return");
              case 10:
                div = this.div = document.createElement("div");
                div.className = "annotationEditorLayer";
                div.hidden = true;
                div.dir = _classPrivateFieldGet2(_uiManager, this).direction;
                (_classPrivateFieldGet5 = _classPrivateFieldGet2(_onAppend2, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.call(this, div);
                this.annotationEditorLayer = new AnnotationEditorLayer({
                  uiManager: _classPrivateFieldGet2(_uiManager, this),
                  div: div,
                  accessibilityManager: this.accessibilityManager,
                  pageIndex: this.pdfPage.pageNumber - 1,
                  l10n: this.l10n,
                  viewport: clonedViewport,
                  annotationLayer: _classPrivateFieldGet2(_annotationLayer, this),
                  textLayer: _classPrivateFieldGet2(_textLayer, this),
                  drawLayer: _classPrivateFieldGet2(_drawLayer, this)
                });
                parameters = {
                  viewport: clonedViewport,
                  div: div,
                  annotations: null,
                  intent: intent
                };
                this.annotationEditorLayer.render(parameters);
                this.show();
              case 19:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
        function render(_x12) {
          return _render2.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "cancel",
      value: function cancel() {
        this._cancelled = true;
        if (!this.div) {
          return;
        }
        this.annotationEditorLayer.destroy();
      }
    }, {
      key: "hide",
      value: function hide() {
        if (!this.div) {
          return;
        }
        this.div.hidden = true;
      }
    }, {
      key: "show",
      value: function show() {
        if (!this.div || this.annotationEditorLayer.isInvisible) {
          return;
        }
        this.div.hidden = false;
      }
    }]);
  }();
  {
    var compatibilityParams = Object.create(null);
    var userAgent = navigator.userAgent || "";
    var platform = navigator.platform || "";
    var maxTouchPoints = navigator.maxTouchPoints || 1;
    var isAndroid = /Android/.test(userAgent);
    var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent) || platform === "MacIntel" && maxTouchPoints > 1;
    (function checkCanvasSizeLimitation() {
      if (isIOS || isAndroid) {
        compatibilityParams.maxCanvasPixels = 5242880;
      }
    })();
  }
  var OptionKind = {
    BROWSER: 0x01,
    VIEWER: 0x02,
    API: 0x04,
    WORKER: 0x08,
    PREFERENCE: 0x80
  };
  var defaultOptions = {
    canvasMaxAreaInBytes: {
      value: -1,
      kind: OptionKind.BROWSER + OptionKind.API
    },
    isInAutomation: {
      value: false,
      kind: OptionKind.BROWSER
    },
    supportsCaretBrowsingMode: {
      value: false,
      kind: OptionKind.BROWSER
    },
    supportsDocumentFonts: {
      value: true,
      kind: OptionKind.BROWSER
    },
    supportsIntegratedFind: {
      value: false,
      kind: OptionKind.BROWSER
    },
    supportsMouseWheelZoomCtrlKey: {
      value: true,
      kind: OptionKind.BROWSER
    },
    supportsMouseWheelZoomMetaKey: {
      value: true,
      kind: OptionKind.BROWSER
    },
    supportsPinchToZoom: {
      value: true,
      kind: OptionKind.BROWSER
    },
    annotationEditorMode: {
      value: 0,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    annotationMode: {
      value: 2,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    cursorToolOnLoad: {
      value: 0,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    debuggerSrc: {
      value: "./debugger.mjs",
      kind: OptionKind.VIEWER
    },
    defaultZoomDelay: {
      value: 400,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    defaultZoomValue: {
      value: "",
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    disableHistory: {
      value: false,
      kind: OptionKind.VIEWER
    },
    disablePageLabels: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enableHighlightEditor: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enableHighlightFloatingButton: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enableML: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enablePermissions: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enablePrintAutoRotate: {
      value: true,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enableScripting: {
      value: true,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    enableStampEditor: {
      value: true,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    externalLinkRel: {
      value: "noopener noreferrer nofollow",
      kind: OptionKind.VIEWER
    },
    externalLinkTarget: {
      value: 0,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    highlightEditorColors: {
      value: "yellow=#FFFF98,green=#53FFBC,blue=#80EBFF,pink=#FFCBE6,red=#FF4F5F",
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    historyUpdateUrl: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    ignoreDestinationZoom: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    imageResourcesPath: {
      value: "./images/",
      kind: OptionKind.VIEWER
    },
    maxCanvasPixels: {
      value: Math.pow(2, 25),
      kind: OptionKind.VIEWER
    },
    forcePageColors: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    pageColorsBackground: {
      value: "Canvas",
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    pageColorsForeground: {
      value: "CanvasText",
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    pdfBugEnabled: {
      value: false,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    printResolution: {
      value: 150,
      kind: OptionKind.VIEWER
    },
    sidebarViewOnLoad: {
      value: -1,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    scrollModeOnLoad: {
      value: -1,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    spreadModeOnLoad: {
      value: -1,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    textLayerMode: {
      value: 1,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    viewOnLoad: {
      value: 0,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    },
    cMapPacked: {
      value: true,
      kind: OptionKind.API
    },
    cMapUrl: {
      value: "../web/cmaps/",
      kind: OptionKind.API
    },
    disableAutoFetch: {
      value: false,
      kind: OptionKind.API + OptionKind.PREFERENCE
    },
    disableFontFace: {
      value: false,
      kind: OptionKind.API + OptionKind.PREFERENCE
    },
    disableRange: {
      value: false,
      kind: OptionKind.API + OptionKind.PREFERENCE
    },
    disableStream: {
      value: false,
      kind: OptionKind.API + OptionKind.PREFERENCE
    },
    docBaseUrl: {
      value: "",
      kind: OptionKind.API
    },
    enableXfa: {
      value: true,
      kind: OptionKind.API + OptionKind.PREFERENCE
    },
    fontExtraProperties: {
      value: false,
      kind: OptionKind.API
    },
    isEvalSupported: {
      value: true,
      kind: OptionKind.API
    },
    isOffscreenCanvasSupported: {
      value: true,
      kind: OptionKind.API
    },
    maxImageSize: {
      value: -1,
      kind: OptionKind.API
    },
    pdfBug: {
      value: false,
      kind: OptionKind.API
    },
    standardFontDataUrl: {
      value: "../web/standard_fonts/",
      kind: OptionKind.API
    },
    verbosity: {
      value: 1,
      kind: OptionKind.API
    },
    workerPort: {
      value: null,
      kind: OptionKind.WORKER
    },
    workerSrc: {
      value: "../build/pdf.worker.mjs",
      kind: OptionKind.WORKER
    }
  };
  {
    defaultOptions.defaultUrl = {
      value: "compressed.tracemonkey-pldi-09.pdf",
      kind: OptionKind.VIEWER
    };
    defaultOptions.sandboxBundleSrc = {
      value: "../build/pdf.sandbox.mjs",
      kind: OptionKind.VIEWER
    };
    defaultOptions.viewerCssTheme = {
      value: 0,
      kind: OptionKind.VIEWER + OptionKind.PREFERENCE
    };
  }
  {
    defaultOptions.disablePreferences = {
      value: false,
      kind: OptionKind.VIEWER
    };
    defaultOptions.locale = {
      value: navigator.language || "en-US",
      kind: OptionKind.VIEWER
    };
  }
  var userOptions = Object.create(null);
  {
    for (var name in compatibilityParams) {
      userOptions[name] = compatibilityParams[name];
    }
  }
  var AppOptions = /*#__PURE__*/function () {
    function AppOptions() {
      _classCallCheck(this, AppOptions);
      throw new Error("Cannot initialize AppOptions.");
    }
    return _createClass(AppOptions, null, [{
      key: "get",
      value: function get(name) {
        var _ref21, _userOptions$name, _defaultOptions$name;
        return (_ref21 = (_userOptions$name = userOptions[name]) !== null && _userOptions$name !== void 0 ? _userOptions$name : (_defaultOptions$name = defaultOptions[name]) === null || _defaultOptions$name === void 0 ? void 0 : _defaultOptions$name.value) !== null && _ref21 !== void 0 ? _ref21 : undefined;
      }
    }, {
      key: "getAll",
      value: function getAll() {
        var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var defaultOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var options = Object.create(null);
        for (var _name in defaultOptions) {
          var _userOptions$_name;
          var defaultOption = defaultOptions[_name];
          if (kind && !(kind & defaultOption.kind)) {
            continue;
          }
          options[_name] = defaultOnly ? defaultOption.value : (_userOptions$_name = userOptions[_name]) !== null && _userOptions$_name !== void 0 ? _userOptions$_name : defaultOption.value;
        }
        return options;
      }
    }, {
      key: "set",
      value: function set(name, value) {
        userOptions[name] = value;
      }
    }, {
      key: "setAll",
      value: function setAll(options) {
        var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (init) {
          if (this.get("disablePreferences")) {
            return;
          }
          for (var _name2 in userOptions) {
            if (compatibilityParams[_name2] !== undefined) {
              continue;
            }
            console.warn("setAll: The Preferences may override manually set AppOptions; " + 'please use the "disablePreferences"-option in order to prevent that.');
            break;
          }
        }
        for (var _name3 in options) {
          userOptions[_name3] = options[_name3];
        }
      }
    }, {
      key: "remove",
      value: function remove(name) {
        delete userOptions[name];
        var val = compatibilityParams[name];
        if (val !== undefined) {
          userOptions[name] = val;
        }
      }
    }]);
  }();
  var _drawLayer2 = /*#__PURE__*/new WeakMap();
  var DrawLayerBuilder = /*#__PURE__*/function () {
    function DrawLayerBuilder(options) {
      _classCallCheck(this, DrawLayerBuilder);
      _classPrivateFieldInitSpec(this, _drawLayer2, null);
      this.pageIndex = options.pageIndex;
    }
    return _createClass(DrawLayerBuilder, [{
      key: "render",
      value: function () {
        var _render3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
          var intent,
            _args12 = arguments;
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                intent = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : "display";
                if (!(intent !== "display" || _classPrivateFieldGet2(_drawLayer2, this) || this._cancelled)) {
                  _context12.next = 3;
                  break;
                }
                return _context12.abrupt("return");
              case 3:
                _classPrivateFieldSet2(_drawLayer2, this, new DrawLayer({
                  pageIndex: this.pageIndex
                }));
              case 4:
              case "end":
                return _context12.stop();
            }
          }, _callee12, this);
        }));
        function render() {
          return _render3.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "cancel",
      value: function cancel() {
        this._cancelled = true;
        if (!_classPrivateFieldGet2(_drawLayer2, this)) {
          return;
        }
        _classPrivateFieldGet2(_drawLayer2, this).destroy();
        _classPrivateFieldSet2(_drawLayer2, this, null);
      }
    }, {
      key: "setParent",
      value: function setParent(parent) {
        var _classPrivateFieldGet6;
        (_classPrivateFieldGet6 = _classPrivateFieldGet2(_drawLayer2, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.setParent(parent);
      }
    }, {
      key: "getDrawLayer",
      value: function getDrawLayer() {
        return _classPrivateFieldGet2(_drawLayer2, this);
      }
    }]);
  }();

  var PDF_ROLE_TO_HTML_ROLE = {
    Document: null,
    DocumentFragment: null,
    Part: "group",
    Sect: "group",
    Div: "group",
    Aside: "note",
    NonStruct: "none",
    P: null,
    H: "heading",
    Title: null,
    FENote: "note",
    Sub: "group",
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: "link",
    Annot: "note",
    Form: "form",
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    L: "list",
    LI: "listitem",
    LBody: null,
    Table: "table",
    TR: "row",
    TH: "columnheader",
    TD: "cell",
    THead: "columnheader",
    TBody: null,
    TFoot: null,
    Caption: null,
    Figure: "figure",
    Formula: null,
    Artifact: null
  };
  var HEADING_PATTERN = /^H(\d+)$/;
  var _treeDom = /*#__PURE__*/new WeakMap();
  var _StructTreeLayerBuilder_brand = /*#__PURE__*/new WeakSet();
  var _StructTreeLayerBuilder = /*#__PURE__*/function () {
    function _StructTreeLayerBuilder() {
      _classCallCheck(this, _StructTreeLayerBuilder);
      _classPrivateMethodInitSpec(this, _StructTreeLayerBuilder_brand);
      _classPrivateFieldInitSpec(this, _treeDom, undefined);
    }
    return _createClass(_StructTreeLayerBuilder, [{
      key: "renderingDone",
      get: function get() {
        return _classPrivateFieldGet2(_treeDom, this) !== undefined;
      }
    }, {
      key: "render",
      value: function render(structTree) {
        if (_classPrivateFieldGet2(_treeDom, this) !== undefined) {
          return _classPrivateFieldGet2(_treeDom, this);
        }
        var treeDom = _assertClassBrand(_StructTreeLayerBuilder_brand, this, _walk).call(this, structTree);
        treeDom === null || treeDom === void 0 || treeDom.classList.add("structTree");
        return _classPrivateFieldSet2(_treeDom, this, treeDom);
      }
    }, {
      key: "hide",
      value: function hide() {
        if (_classPrivateFieldGet2(_treeDom, this) && !_classPrivateFieldGet2(_treeDom, this).hidden) {
          _classPrivateFieldGet2(_treeDom, this).hidden = true;
        }
      }
    }, {
      key: "show",
      value: function show() {
        var _classPrivateFieldGet7;
        if ((_classPrivateFieldGet7 = _classPrivateFieldGet2(_treeDom, this)) !== null && _classPrivateFieldGet7 !== void 0 && _classPrivateFieldGet7.hidden) {
          _classPrivateFieldGet2(_treeDom, this).hidden = false;
        }
      }
    }]);
  }();
  function _setAttributes(structElement, htmlElement) {
    var alt = structElement.alt,
      id = structElement.id,
      lang = structElement.lang;
    if (alt !== undefined) {
      htmlElement.setAttribute("aria-label", removeNullCharacters(alt));
    }
    if (id !== undefined) {
      htmlElement.setAttribute("aria-owns", id);
    }
    if (lang !== undefined) {
      htmlElement.setAttribute("lang", removeNullCharacters(lang, true));
    }
  }
  function _walk(node) {
    if (!node) {
      return null;
    }
    var element = document.createElement("span");
    if ("role" in node) {
      var role = node.role;
      var _match10 = role.match(HEADING_PATTERN);
      if (_match10) {
        element.setAttribute("role", "heading");
        element.setAttribute("aria-level", _match10[1]);
      } else if (PDF_ROLE_TO_HTML_ROLE[role]) {
        element.setAttribute("role", PDF_ROLE_TO_HTML_ROLE[role]);
      }
    }
    _assertClassBrand(_StructTreeLayerBuilder_brand, this, _setAttributes).call(this, node, element);
    if (node.children) {
      if (node.children.length === 1 && "id" in node.children[0]) {
        _assertClassBrand(_StructTreeLayerBuilder_brand, this, _setAttributes).call(this, node.children[0], element);
      } else {
        var _iterator34 = _createForOfIteratorHelper(node.children),
          _step34;
        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var kid = _step34.value;
            element.append(_assertClassBrand(_StructTreeLayerBuilder_brand, this, _walk).call(this, kid));
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
      }
    }
    return element;
  }
  var _enabled = /*#__PURE__*/new WeakMap();
  var _textChildren = /*#__PURE__*/new WeakMap();
  var _textNodes = /*#__PURE__*/new WeakMap();
  var _waitingElements = /*#__PURE__*/new WeakMap();
  var _TextAccessibilityManager_brand = /*#__PURE__*/new WeakSet();
  var TextAccessibilityManager = /*#__PURE__*/function () {
    function TextAccessibilityManager() {
      _classCallCheck(this, TextAccessibilityManager);
      _classPrivateMethodInitSpec(this, _TextAccessibilityManager_brand);
      _classPrivateFieldInitSpec(this, _enabled, false);
      _classPrivateFieldInitSpec(this, _textChildren, null);
      _classPrivateFieldInitSpec(this, _textNodes, new Map());
      _classPrivateFieldInitSpec(this, _waitingElements, new Map());
    }
    return _createClass(TextAccessibilityManager, [{
      key: "setTextMapping",
      value: function setTextMapping(textDivs) {
        _classPrivateFieldSet2(_textChildren, this, textDivs);
      }
    }, {
      key: "enable",
      value: function enable() {
        if (_classPrivateFieldGet2(_enabled, this)) {
          throw new Error("TextAccessibilityManager is already enabled.");
        }
        if (!_classPrivateFieldGet2(_textChildren, this)) {
          throw new Error("Text divs and strings have not been set.");
        }
        _classPrivateFieldSet2(_enabled, this, true);
        _classPrivateFieldSet2(_textChildren, this, _classPrivateFieldGet2(_textChildren, this).slice());
        _classPrivateFieldGet2(_textChildren, this).sort(_compareElementPositions);
        if (_classPrivateFieldGet2(_textNodes, this).size > 0) {
          var textChildren = _classPrivateFieldGet2(_textChildren, this);
          var _iterator18 = _createForOfIteratorHelper(_classPrivateFieldGet2(_textNodes, this)),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _step18$value = _slicedToArray(_step18.value, 2),
                id = _step18$value[0],
                nodeIndex = _step18$value[1];
              var element = document.getElementById(id);
              if (!element) {
                _classPrivateFieldGet2(_textNodes, this)["delete"](id);
                continue;
              }
              _assertClassBrand(_TextAccessibilityManager_brand, this, _addIdToAriaOwns).call(this, id, textChildren[nodeIndex]);
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
        var _iterator19 = _createForOfIteratorHelper(_classPrivateFieldGet2(_waitingElements, this)),
          _step19;
        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var _step19$value = _slicedToArray(_step19.value, 2),
              _element = _step19$value[0],
              isRemovable = _step19$value[1];
            this.addPointerInTextLayer(_element, isRemovable);
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
        _classPrivateFieldGet2(_waitingElements, this).clear();
      }
    }, {
      key: "disable",
      value: function disable() {
        if (!_classPrivateFieldGet2(_enabled, this)) {
          return;
        }
        _classPrivateFieldGet2(_waitingElements, this).clear();
        _classPrivateFieldSet2(_textChildren, this, null);
        _classPrivateFieldSet2(_enabled, this, false);
      }
    }, {
      key: "removePointerInTextLayer",
      value: function removePointerInTextLayer(element) {
        var _owns;
        if (!_classPrivateFieldGet2(_enabled, this)) {
          _classPrivateFieldGet2(_waitingElements, this)["delete"](element);
          return;
        }
        var children = _classPrivateFieldGet2(_textChildren, this);
        if (!children || children.length === 0) {
          return;
        }
        var id = element.id;
        var nodeIndex = _classPrivateFieldGet2(_textNodes, this).get(id);
        if (nodeIndex === undefined) {
          return;
        }
        var node = children[nodeIndex];
        _classPrivateFieldGet2(_textNodes, this)["delete"](id);
        var owns = node.getAttribute("aria-owns");
        if ((_owns = owns) !== null && _owns !== void 0 && _owns.includes(id)) {
          owns = owns.split(" ").filter(function (x) {
            return x !== id;
          }).join(" ");
          if (owns) {
            node.setAttribute("aria-owns", owns);
          } else {
            node.removeAttribute("aria-owns");
            node.setAttribute("role", "presentation");
          }
        }
      }
    }, {
      key: "addPointerInTextLayer",
      value: function addPointerInTextLayer(element, isRemovable) {
        var id = element.id;
        if (!id) {
          return null;
        }
        if (!_classPrivateFieldGet2(_enabled, this)) {
          _classPrivateFieldGet2(_waitingElements, this).set(element, isRemovable);
          return null;
        }
        if (isRemovable) {
          this.removePointerInTextLayer(element);
        }
        var children = _classPrivateFieldGet2(_textChildren, this);
        if (!children || children.length === 0) {
          return null;
        }
        var index = binarySearchFirstItem(children, function (node) {
          return _compareElementPositions.call(TextAccessibilityManager, element, node) < 0;
        });
        var nodeIndex = Math.max(0, index - 1);
        var child = children[nodeIndex];
        _assertClassBrand(_TextAccessibilityManager_brand, this, _addIdToAriaOwns).call(this, id, child);
        _classPrivateFieldGet2(_textNodes, this).set(id, nodeIndex);
        var parent = child.parentNode;
        return parent !== null && parent !== void 0 && parent.classList.contains("markedContent") ? parent.id : null;
      }
    }, {
      key: "moveElementInDOM",
      value: function moveElementInDOM(container, element, contentElement, isRemovable) {
        var id = this.addPointerInTextLayer(contentElement, isRemovable);
        if (!container.hasChildNodes()) {
          container.append(element);
          return id;
        }
        var children = Array.from(container.childNodes).filter(function (node) {
          return node !== element;
        });
        if (children.length === 0) {
          return id;
        }
        var elementToCompare = contentElement || element;
        var index = binarySearchFirstItem(children, function (node) {
          return _compareElementPositions.call(TextAccessibilityManager, elementToCompare, node) < 0;
        });
        if (index === 0) {
          children[0].before(element);
        } else {
          children[index - 1].after(element);
        }
        return id;
      }
    }]);
  }();
  function _compareElementPositions(e1, e2) {
    var rect1 = e1.getBoundingClientRect();
    var rect2 = e2.getBoundingClientRect();
    if (rect1.width === 0 && rect1.height === 0) {
      return +1;
    }
    if (rect2.width === 0 && rect2.height === 0) {
      return -1;
    }
    var top1 = rect1.y;
    var bot1 = rect1.y + rect1.height;
    var mid1 = rect1.y + rect1.height / 2;
    var top2 = rect2.y;
    var bot2 = rect2.y + rect2.height;
    var mid2 = rect2.y + rect2.height / 2;
    if (mid1 <= top2 && mid2 >= bot1) {
      return -1;
    }
    if (mid2 <= top1 && mid1 >= bot2) {
      return +1;
    }
    var centerX1 = rect1.x + rect1.width / 2;
    var centerX2 = rect2.x + rect2.width / 2;
    return centerX1 - centerX2;
  }
  function _addIdToAriaOwns(id, node) {
    var owns = node.getAttribute("aria-owns");
    if (!(owns !== null && owns !== void 0 && owns.includes(id))) {
      node.setAttribute("aria-owns", owns ? "".concat(owns, " ").concat(id) : id);
    }
    node.removeAttribute("role");
  }
  var _eventAbortController3 = /*#__PURE__*/new WeakMap();
  var TextHighlighter = /*#__PURE__*/function () {
    function TextHighlighter(_ref22) {
      var findController = _ref22.findController,
        eventBus = _ref22.eventBus,
        pageIndex = _ref22.pageIndex;
      _classCallCheck(this, TextHighlighter);
      _classPrivateFieldInitSpec(this, _eventAbortController3, null);
      this.findController = findController;
      this.matches = [];
      this.eventBus = eventBus;
      this.pageIdx = pageIndex;
      this.textDivs = null;
      this.textContentItemsStr = null;
      this.enabled = false;
    }
    return _createClass(TextHighlighter, [{
      key: "setTextMapping",
      value: function setTextMapping(divs, texts) {
        this.textDivs = divs;
        this.textContentItemsStr = texts;
      }
    }, {
      key: "enable",
      value: function enable() {
        var _this19 = this;
        if (!this.textDivs || !this.textContentItemsStr) {
          throw new Error("Text divs and strings have not been set.");
        }
        if (this.enabled) {
          throw new Error("TextHighlighter is already enabled.");
        }
        this.enabled = true;
        if (!_classPrivateFieldGet2(_eventAbortController3, this)) {
          _classPrivateFieldSet2(_eventAbortController3, this, new AbortController());
          this.eventBus._on("updatetextlayermatches", function (evt) {
            if (evt.pageIndex === _this19.pageIdx || evt.pageIndex === -1) {
              _this19._updateMatches();
            }
          }, {
            signal: _classPrivateFieldGet2(_eventAbortController3, this).signal
          });
        }
        this._updateMatches();
      }
    }, {
      key: "disable",
      value: function disable() {
        var _classPrivateFieldGet8;
        if (!this.enabled) {
          return;
        }
        this.enabled = false;
        (_classPrivateFieldGet8 = _classPrivateFieldGet2(_eventAbortController3, this)) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.abort();
        _classPrivateFieldSet2(_eventAbortController3, this, null);
        this._updateMatches(true);
      }
    }, {
      key: "_convertMatches",
      value: function _convertMatches(matches, matchesLength) {
        if (!matches) {
          return [];
        }
        var textContentItemsStr = this.textContentItemsStr;
        var i = 0,
          iIndex = 0;
        var end = textContentItemsStr.length - 1;
        var result = [];
        for (var m = 0, mm = matches.length; m < mm; m++) {
          var matchIdx = matches[m];
          while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
            iIndex += textContentItemsStr[i].length;
            i++;
          }
          if (i === textContentItemsStr.length) {
            console.error("Could not find a matching mapping");
          }
          var _match7 = {
            begin: {
              divIdx: i,
              offset: matchIdx - iIndex
            }
          };
          matchIdx += matchesLength[m];
          while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
            iIndex += textContentItemsStr[i].length;
            i++;
          }
          _match7.end = {
            divIdx: i,
            offset: matchIdx - iIndex
          };
          result.push(_match7);
        }
        return result;
      }
    }, {
      key: "_renderMatches",
      value: function _renderMatches(matches) {
        if (matches.length === 0) {
          return;
        }
        var findController = this.findController,
          pageIdx = this.pageIdx;
        var textContentItemsStr = this.textContentItemsStr,
          textDivs = this.textDivs;
        var isSelectedPage = pageIdx === findController.selected.pageIdx;
        var selectedMatchIdx = findController.selected.matchIdx;
        var highlightAll = findController.state.highlightAll;
        var prevEnd = null;
        var infinity = {
          divIdx: -1,
          offset: undefined
        };
        function beginText(begin, className) {
          var divIdx = begin.divIdx;
          textDivs[divIdx].textContent = "";
          return appendTextToDiv(divIdx, 0, begin.offset, className);
        }
        function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
          var div = textDivs[divIdx];
          if (div.nodeType === Node.TEXT_NODE) {
            var span = document.createElement("span");
            div.before(span);
            span.append(div);
            textDivs[divIdx] = span;
            div = span;
          }
          var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
          var node = document.createTextNode(content);
          if (className) {
            var _span = document.createElement("span");
            _span.className = "".concat(className, " appended");
            _span.append(node);
            div.append(_span);
            return className.includes("selected") ? _span.offsetLeft : 0;
          }
          div.append(node);
          return 0;
        }
        var i0 = selectedMatchIdx,
          i1 = i0 + 1;
        if (highlightAll) {
          i0 = 0;
          i1 = matches.length;
        } else if (!isSelectedPage) {
          return;
        }
        var lastDivIdx = -1;
        var lastOffset = -1;
        for (var i = i0; i < i1; i++) {
          var _match8 = matches[i];
          var begin = _match8.begin;
          if (begin.divIdx === lastDivIdx && begin.offset === lastOffset) {
            continue;
          }
          lastDivIdx = begin.divIdx;
          lastOffset = begin.offset;
          var end = _match8.end;
          var isSelected = isSelectedPage && i === selectedMatchIdx;
          var highlightSuffix = isSelected ? " selected" : "";
          var selectedLeft = 0;
          if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
            if (prevEnd !== null) {
              appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
            }
            beginText(begin);
          } else {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
          }
          if (begin.divIdx === end.divIdx) {
            selectedLeft = appendTextToDiv(begin.divIdx, begin.offset, end.offset, "highlight" + highlightSuffix);
          } else {
            selectedLeft = appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, "highlight begin" + highlightSuffix);
            for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
              textDivs[n0].className = "highlight middle" + highlightSuffix;
            }
            beginText(end, "highlight end" + highlightSuffix);
          }
          prevEnd = end;
          if (isSelected) {
            findController.scrollMatchIntoView({
              element: textDivs[begin.divIdx],
              selectedLeft: selectedLeft,
              pageIndex: pageIdx,
              matchIndex: selectedMatchIdx
            });
          }
        }
        if (prevEnd) {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
        }
      }
    }, {
      key: "_updateMatches",
      value: function _updateMatches() {
        var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!this.enabled && !reset) {
          return;
        }
        var findController = this.findController,
          matches = this.matches,
          pageIdx = this.pageIdx;
        var textContentItemsStr = this.textContentItemsStr,
          textDivs = this.textDivs;
        var clearedUntilDivIdx = -1;
        var _iterator20 = _createForOfIteratorHelper(matches),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var _match9 = _step20.value;
            var begin = Math.max(clearedUntilDivIdx, _match9.begin.divIdx);
            for (var n = begin, end = _match9.end.divIdx; n <= end; n++) {
              var div = textDivs[n];
              div.textContent = textContentItemsStr[n];
              div.className = "";
            }
            clearedUntilDivIdx = _match9.end.divIdx + 1;
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
        if (!(findController !== null && findController !== void 0 && findController.highlightMatches) || reset) {
          return;
        }
        var pageMatches = findController.pageMatches[pageIdx] || null;
        var pageMatchesLength = findController.pageMatchesLength[pageIdx] || null;
        this.matches = this._convertMatches(pageMatches, pageMatchesLength);
        this._renderMatches(this.matches);
      }
    }]);
  }();
  var _enablePermissions = /*#__PURE__*/new WeakMap();
  var _onAppend3 = /*#__PURE__*/new WeakMap();
  var _renderingDone = /*#__PURE__*/new WeakMap();
  var _textLayer2 = /*#__PURE__*/new WeakMap();
  var _TextLayerBuilder_brand = /*#__PURE__*/new WeakSet();
  var _TextLayerBuilder = /*#__PURE__*/function () {
    function _TextLayerBuilder(_ref23) {
      var pdfPage = _ref23.pdfPage,
        _ref23$highlighter = _ref23.highlighter,
        highlighter = _ref23$highlighter === void 0 ? null : _ref23$highlighter,
        _ref23$accessibilityM = _ref23.accessibilityManager,
        accessibilityManager = _ref23$accessibilityM === void 0 ? null : _ref23$accessibilityM,
        _ref23$enablePermissi = _ref23.enablePermissions,
        enablePermissions = _ref23$enablePermissi === void 0 ? false : _ref23$enablePermissi,
        _ref23$onAppend = _ref23.onAppend,
        onAppend = _ref23$onAppend === void 0 ? null : _ref23$onAppend;
      _classCallCheck(this, _TextLayerBuilder);
      _classPrivateMethodInitSpec(this, _TextLayerBuilder_brand);
      _classPrivateFieldInitSpec(this, _enablePermissions, false);
      _classPrivateFieldInitSpec(this, _onAppend3, null);
      _classPrivateFieldInitSpec(this, _renderingDone, false);
      _classPrivateFieldInitSpec(this, _textLayer2, null);
      this.pdfPage = pdfPage;
      this.highlighter = highlighter;
      this.accessibilityManager = accessibilityManager;
      _classPrivateFieldSet2(_enablePermissions, this, enablePermissions === true);
      _classPrivateFieldSet2(_onAppend3, this, onAppend);
      this.div = document.createElement("div");
      this.div.tabIndex = 0;
      this.div.className = "textLayer";
    }
    return _createClass(_TextLayerBuilder, [{
      key: "render",
      value: function () {
        var _render4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(viewport) {
          var _this$highlighter, _this$accessibilityMa, _classPrivateFieldGet10, _this$highlighter2, _this$accessibilityMa2;
          var textContentParams,
            _classPrivateFieldGet9,
            textDivs,
            textContentItemsStr,
            _args13 = arguments;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                textContentParams = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
                if (!(_classPrivateFieldGet2(_renderingDone, this) && _classPrivateFieldGet2(_textLayer2, this))) {
                  _context13.next = 5;
                  break;
                }
                _classPrivateFieldGet2(_textLayer2, this).update({
                  viewport: viewport,
                  onBefore: this.hide.bind(this)
                });
                this.show();
                return _context13.abrupt("return");
              case 5:
                this.cancel();
                _classPrivateFieldSet2(_textLayer2, this, new TextLayer({
                  textContentSource: this.pdfPage.streamTextContent(textContentParams || {
                    includeMarkedContent: true,
                    disableNormalization: true
                  }),
                  container: this.div,
                  viewport: viewport
                }));
                _classPrivateFieldGet9 = _classPrivateFieldGet2(_textLayer2, this), textDivs = _classPrivateFieldGet9.textDivs, textContentItemsStr = _classPrivateFieldGet9.textContentItemsStr;
                (_this$highlighter = this.highlighter) === null || _this$highlighter === void 0 || _this$highlighter.setTextMapping(textDivs, textContentItemsStr);
                (_this$accessibilityMa = this.accessibilityManager) === null || _this$accessibilityMa === void 0 || _this$accessibilityMa.setTextMapping(textDivs);
                _context13.next = 12;
                return _classPrivateFieldGet2(_textLayer2, this).render();
              case 12:
                _assertClassBrand(_TextLayerBuilder_brand, this, _finishRendering).call(this);
                (_classPrivateFieldGet10 = _classPrivateFieldGet2(_onAppend3, this)) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(this, this.div);
                (_this$highlighter2 = this.highlighter) === null || _this$highlighter2 === void 0 || _this$highlighter2.enable();
                (_this$accessibilityMa2 = this.accessibilityManager) === null || _this$accessibilityMa2 === void 0 || _this$accessibilityMa2.enable();
              case 16:
              case "end":
                return _context13.stop();
            }
          }, _callee13, this);
        }));
        function render(_x13) {
          return _render4.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "hide",
      value: function hide() {
        if (!this.div.hidden && _classPrivateFieldGet2(_renderingDone, this)) {
          var _this$highlighter3;
          (_this$highlighter3 = this.highlighter) === null || _this$highlighter3 === void 0 || _this$highlighter3.disable();
          this.div.hidden = true;
        }
      }
    }, {
      key: "show",
      value: function show() {
        if (this.div.hidden && _classPrivateFieldGet2(_renderingDone, this)) {
          var _this$highlighter4;
          this.div.hidden = false;
          (_this$highlighter4 = this.highlighter) === null || _this$highlighter4 === void 0 || _this$highlighter4.enable();
        }
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var _classPrivateFieldGet11, _this$highlighter5, _this$accessibilityMa3;
        (_classPrivateFieldGet11 = _classPrivateFieldGet2(_textLayer2, this)) === null || _classPrivateFieldGet11 === void 0 || _classPrivateFieldGet11.cancel();
        _classPrivateFieldSet2(_textLayer2, this, null);
        (_this$highlighter5 = this.highlighter) === null || _this$highlighter5 === void 0 || _this$highlighter5.disable();
        (_this$accessibilityMa3 = this.accessibilityManager) === null || _this$accessibilityMa3 === void 0 || _this$accessibilityMa3.disable();
        _removeGlobalSelectionListener.call(_TextLayerBuilder, this.div);
      }
    }]);
  }();
  _TextLayerBuilder2 = _TextLayerBuilder;
  function _finishRendering() {
    _classPrivateFieldSet2(_renderingDone, this, true);
    var endOfContent = document.createElement("div");
    endOfContent.className = "endOfContent";
    this.div.append(endOfContent);
    _assertClassBrand(_TextLayerBuilder_brand, this, _bindMouse).call(this, endOfContent);
  }
  function _bindMouse(end) {
    var _this39 = this;
    var div = this.div;
    div.addEventListener("mousedown", function (evt) {
      end.classList.add("active");
    });
    div.addEventListener("copy", function (event) {
      if (!_classPrivateFieldGet2(_enablePermissions, _this39)) {
        var selection = document.getSelection();
        event.clipboardData.setData("text/plain", removeNullCharacters(normalizeUnicode(selection.toString())));
      }
      event.preventDefault();
      event.stopPropagation();
    });
    _textLayers._.set(div, end);
    _enableGlobalSelectionListener.call(_TextLayerBuilder2);
  }
  function _removeGlobalSelectionListener(textLayerDiv) {
    _assertClassBrand(_TextLayerBuilder2, this, _textLayers)._["delete"](textLayerDiv);
    if (_assertClassBrand(_TextLayerBuilder2, this, _textLayers)._.size === 0) {
      var _assertClassBrand$_;
      (_assertClassBrand$_ = _assertClassBrand(_TextLayerBuilder2, this, _selectionChangeAbortController)._) === null || _assertClassBrand$_ === void 0 || _assertClassBrand$_.abort();
      _selectionChangeAbortController._ = _assertClassBrand(_TextLayerBuilder2, this, null);
    }
  }
  function _enableGlobalSelectionListener() {
    var _this40 = this;
    if (_assertClassBrand(_TextLayerBuilder2, this, _selectionChangeAbortController)._) {
      return;
    }
    _selectionChangeAbortController._ = _assertClassBrand(_TextLayerBuilder2, this, new AbortController());
    var signal = _assertClassBrand(_TextLayerBuilder2, this, _selectionChangeAbortController)._.signal;
    var reset = function reset(end, textLayer) {
      textLayer.append(end);
      end.style.width = "";
      end.style.height = "";
      end.classList.remove("active");
    };
    document.addEventListener("pointerup", function () {
      _assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._.forEach(reset);
    }, {
      signal: signal
    });
    var isFirefox, prevRange;
    document.addEventListener("selectionchange", function () {
      var _isFirefox;
      var selection = document.getSelection();
      if (selection.rangeCount === 0) {
        _assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._.forEach(reset);
        return;
      }
      var activeTextLayers = new Set();
      for (var i = 0; i < selection.rangeCount; i++) {
        var _range = selection.getRangeAt(i);
        var _iterator35 = _createForOfIteratorHelper(_assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._.keys()),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var textLayerDiv = _step35.value;
            if (!activeTextLayers.has(textLayerDiv) && _range.intersectsNode(textLayerDiv)) {
              activeTextLayers.add(textLayerDiv);
            }
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
      }
      var _iterator36 = _createForOfIteratorHelper(_assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _step36$value = _slicedToArray(_step36.value, 2),
            _textLayerDiv = _step36$value[0],
            _endDiv = _step36$value[1];
          if (activeTextLayers.has(_textLayerDiv)) {
            _endDiv.classList.add("active");
          } else {
            reset(_endDiv, _textLayerDiv);
          }
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      (_isFirefox = isFirefox) !== null && _isFirefox !== void 0 ? _isFirefox : isFirefox = getComputedStyle(_assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._.values().next().value).getPropertyValue("-moz-user-select") === "none";
      if (isFirefox) {
        return;
      }
      var range = selection.getRangeAt(0);
      var modifyStart = prevRange && (range.compareBoundaryPoints(Range.END_TO_END, prevRange) === 0 || range.compareBoundaryPoints(Range.START_TO_END, prevRange) === 0);
      var anchor = modifyStart ? range.startContainer : range.endContainer;
      if (anchor.nodeType === Node.TEXT_NODE) {
        anchor = anchor.parentNode;
      }
      var parentTextLayer = anchor.parentElement.closest(".textLayer");
      var endDiv = _assertClassBrand(_TextLayerBuilder2, _this40, _textLayers)._.get(parentTextLayer);
      if (endDiv) {
        endDiv.style.width = parentTextLayer.style.width;
        endDiv.style.height = parentTextLayer.style.height;
        anchor.parentElement.insertBefore(endDiv, modifyStart ? anchor : anchor.nextSibling);
      }
      prevRange = range.cloneRange();
    }, {
      signal: signal
    });
  }
  var _textLayers = {
    _: new Map()
  };
  var _selectionChangeAbortController = {
    _: null
  };
  var _XfaLayerBuilder = /*#__PURE__*/function () {
    function _XfaLayerBuilder(_ref24) {
      var pdfPage = _ref24.pdfPage,
        _ref24$annotationStor = _ref24.annotationStorage,
        annotationStorage = _ref24$annotationStor === void 0 ? null : _ref24$annotationStor,
        linkService = _ref24.linkService,
        _ref24$xfaHtml = _ref24.xfaHtml,
        xfaHtml = _ref24$xfaHtml === void 0 ? null : _ref24$xfaHtml;
      _classCallCheck(this, _XfaLayerBuilder);
      this.pdfPage = pdfPage;
      this.annotationStorage = annotationStorage;
      this.linkService = linkService;
      this.xfaHtml = xfaHtml;
      this.div = null;
      this._cancelled = false;
    }
    return _createClass(_XfaLayerBuilder, [{
      key: "render",
      value: function () {
        var _render5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(viewport) {
          var intent,
            _parameters,
            xfaHtml,
            parameters,
            _args14 = arguments;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                intent = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : "display";
                if (!(intent === "print")) {
                  _context14.next = 6;
                  break;
                }
                _parameters = {
                  viewport: viewport.clone({
                    dontFlip: true
                  }),
                  div: this.div,
                  xfaHtml: this.xfaHtml,
                  annotationStorage: this.annotationStorage,
                  linkService: this.linkService,
                  intent: intent
                };
                this.div = document.createElement("div");
                _parameters.div = this.div;
                return _context14.abrupt("return", XfaLayer.render(_parameters));
              case 6:
                _context14.next = 8;
                return this.pdfPage.getXfa();
              case 8:
                xfaHtml = _context14.sent;
                if (!(this._cancelled || !xfaHtml)) {
                  _context14.next = 11;
                  break;
                }
                return _context14.abrupt("return", {
                  textDivs: []
                });
              case 11:
                parameters = {
                  viewport: viewport.clone({
                    dontFlip: true
                  }),
                  div: this.div,
                  xfaHtml: xfaHtml,
                  annotationStorage: this.annotationStorage,
                  linkService: this.linkService,
                  intent: intent
                };
                if (!this.div) {
                  _context14.next = 14;
                  break;
                }
                return _context14.abrupt("return", XfaLayer.update(parameters));
              case 14:
                this.div = document.createElement("div");
                parameters.div = this.div;
                return _context14.abrupt("return", XfaLayer.render(parameters));
              case 17:
              case "end":
                return _context14.stop();
            }
          }, _callee14, this);
        }));
        function render(_x14) {
          return _render5.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "cancel",
      value: function cancel() {
        this._cancelled = true;
      }
    }, {
      key: "hide",
      value: function hide() {
        if (!this.div) {
          return;
        }
        this.div.hidden = true;
      }
    }]);
  }();

  var DEFAULT_LAYER_PROPERTIES = {
    annotationEditorUIManager: null,
    annotationStorage: null,
    downloadManager: null,
    enableScripting: false,
    fieldObjectsPromise: null,
    findController: null,
    hasJSActionsPromise: null,
    get linkService() {
      return new _SimpleLinkService();
    }
  };
  var LAYERS_ORDER = new Map([["canvasWrapper", 0], ["textLayer", 1], ["annotationLayer", 2], ["annotationEditorLayer", 3], ["xfaLayer", 3]]);
  var _annotationMode = /*#__PURE__*/new WeakMap();
  var _hasRestrictedScaling = /*#__PURE__*/new WeakMap();
  var _layerProperties = /*#__PURE__*/new WeakMap();
  var _loadingId = /*#__PURE__*/new WeakMap();
  var _previousRotation = /*#__PURE__*/new WeakMap();
  var _renderError = /*#__PURE__*/new WeakMap();
  var _renderingState = /*#__PURE__*/new WeakMap();
  var _textLayerMode = /*#__PURE__*/new WeakMap();
  var _useThumbnailCanvas = /*#__PURE__*/new WeakMap();
  var _viewportMap = /*#__PURE__*/new WeakMap();
  var _layers = /*#__PURE__*/new WeakMap();
  var _PDFPageView_brand = /*#__PURE__*/new WeakSet();
  var _PDFPageView = /*#__PURE__*/function () {
    function _PDFPageView(options) {
      var _options$textLayerMod,
        _options$annotationMo,
        _options$maxCanvasPix,
        _this$renderingQueue,
        _this20 = this;
      _classCallCheck(this, _PDFPageView);
      _classPrivateMethodInitSpec(this, _PDFPageView_brand);
      _classPrivateFieldInitSpec(this, _annotationMode, AnnotationMode.ENABLE_FORMS);
      _classPrivateFieldInitSpec(this, _hasRestrictedScaling, false);
      _classPrivateFieldInitSpec(this, _layerProperties, null);
      _classPrivateFieldInitSpec(this, _loadingId, null);
      _classPrivateFieldInitSpec(this, _previousRotation, null);
      _classPrivateFieldInitSpec(this, _renderError, null);
      _classPrivateFieldInitSpec(this, _renderingState, _RenderingStates.INITIAL);
      _classPrivateFieldInitSpec(this, _textLayerMode, TextLayerMode.ENABLE);
      _classPrivateFieldInitSpec(this, _useThumbnailCanvas, {
        directDrawing: true,
        initialOptionalContent: true,
        regularAnnotations: true
      });
      _classPrivateFieldInitSpec(this, _viewportMap, new WeakMap());
      _classPrivateFieldInitSpec(this, _layers, [null, null, null, null]);
      var container = options.container;
      var defaultViewport = options.defaultViewport;
      this.id = options.id;
      this.renderingId = "page" + this.id;
      _classPrivateFieldSet2(_layerProperties, this, options.layerProperties || DEFAULT_LAYER_PROPERTIES);
      this.pdfPage = null;
      this.pageLabel = null;
      this.rotation = 0;
      this.scale = options.scale || DEFAULT_SCALE;
      this.viewport = defaultViewport;
      this.pdfPageRotate = defaultViewport.rotation;
      this._optionalContentConfigPromise = options.optionalContentConfigPromise || null;
      _classPrivateFieldSet2(_textLayerMode, this, (_options$textLayerMod = options.textLayerMode) !== null && _options$textLayerMod !== void 0 ? _options$textLayerMod : TextLayerMode.ENABLE);
      _classPrivateFieldSet2(_annotationMode, this, (_options$annotationMo = options.annotationMode) !== null && _options$annotationMo !== void 0 ? _options$annotationMo : AnnotationMode.ENABLE_FORMS);
      this.imageResourcesPath = options.imageResourcesPath || "";
      this.maxCanvasPixels = (_options$maxCanvasPix = options.maxCanvasPixels) !== null && _options$maxCanvasPix !== void 0 ? _options$maxCanvasPix : AppOptions.get("maxCanvasPixels");
      this.pageColors = options.pageColors || null;
      this.eventBus = options.eventBus;
      this.renderingQueue = options.renderingQueue;
      this.l10n = options.l10n;
      this.l10n || (this.l10n = new genericl10n_GenericL10n());
      this.renderTask = null;
      this.resume = null;
      this._isStandalone = !((_this$renderingQueue = this.renderingQueue) !== null && _this$renderingQueue !== void 0 && _this$renderingQueue.hasViewer());
      this._container = container;
      this._annotationCanvasMap = null;
      this.annotationLayer = null;
      this.annotationEditorLayer = null;
      this.textLayer = null;
      this.zoomLayer = null;
      this.xfaLayer = null;
      this.structTreeLayer = null;
      this.drawLayer = null;
      var _div = document.createElement("div");
      _div.className = "page";
      _div.setAttribute("data-page-number", this.id);
      _div.setAttribute("role", "region");
      _div.setAttribute("data-l10n-id", "pdfjs-page-landmark");
      _div.setAttribute("data-l10n-args", JSON.stringify({
        page: this.id
      }));
      this.div = _div;
      _assertClassBrand(_PDFPageView_brand, this, _setDimensions).call(this);
      container === null || container === void 0 || container.append(_div);
      if (this._isStandalone) {
        container === null || container === void 0 || container.style.setProperty("--scale-factor", this.scale * PixelsPerInch.PDF_TO_CSS_UNITS);
        var optionalContentConfigPromise = options.optionalContentConfigPromise;
        if (optionalContentConfigPromise) {
          optionalContentConfigPromise.then(function (optionalContentConfig) {
            if (optionalContentConfigPromise !== _this20._optionalContentConfigPromise) {
              return;
            }
            _classPrivateFieldGet2(_useThumbnailCanvas, _this20).initialOptionalContent = optionalContentConfig.hasInitialVisibility;
          });
        }
        if (!options.l10n) {
          this.l10n.translate(this.div);
        }
      }
    }
    return _createClass(_PDFPageView, [{
      key: "renderingState",
      get: function get() {
        return _classPrivateFieldGet2(_renderingState, this);
      },
      set: function set(state) {
        var _this21 = this;
        if (state === _classPrivateFieldGet2(_renderingState, this)) {
          return;
        }
        _classPrivateFieldSet2(_renderingState, this, state);
        if (_classPrivateFieldGet2(_loadingId, this)) {
          clearTimeout(_classPrivateFieldGet2(_loadingId, this));
          _classPrivateFieldSet2(_loadingId, this, null);
        }
        switch (state) {
          case _RenderingStates.PAUSED:
            this.div.classList.remove("loading");
            break;
          case _RenderingStates.RUNNING:
            this.div.classList.add("loadingIcon");
            _classPrivateFieldSet2(_loadingId, this, setTimeout(function () {
              _this21.div.classList.add("loading");
              _classPrivateFieldSet2(_loadingId, _this21, null);
            }, 0));
            break;
          case _RenderingStates.INITIAL:
          case _RenderingStates.FINISHED:
            this.div.classList.remove("loadingIcon", "loading");
            break;
        }
      }
    }, {
      key: "setPdfPage",
      value: function setPdfPage(pdfPage) {
        var _this$pageColors, _this$pageColors2;
        if (this._isStandalone && (((_this$pageColors = this.pageColors) === null || _this$pageColors === void 0 ? void 0 : _this$pageColors.foreground) === "CanvasText" || ((_this$pageColors2 = this.pageColors) === null || _this$pageColors2 === void 0 ? void 0 : _this$pageColors2.background) === "Canvas")) {
          var _this$_container, _this$_container2;
          (_this$_container = this._container) === null || _this$_container === void 0 || _this$_container.style.setProperty("--hcm-highlight-filter", pdfPage.filterFactory.addHighlightHCMFilter("highlight", "CanvasText", "Canvas", "HighlightText", "Highlight"));
          (_this$_container2 = this._container) === null || _this$_container2 === void 0 || _this$_container2.style.setProperty("--hcm-highlight-selected-filter", pdfPage.filterFactory.addHighlightHCMFilter("highlight_selected", "CanvasText", "Canvas", "HighlightText", "Highlight"));
        }
        this.pdfPage = pdfPage;
        this.pdfPageRotate = pdfPage.rotate;
        var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
        this.viewport = pdfPage.getViewport({
          scale: this.scale * PixelsPerInch.PDF_TO_CSS_UNITS,
          rotation: totalRotation
        });
        _assertClassBrand(_PDFPageView_brand, this, _setDimensions).call(this);
        this.reset();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        var _this$pdfPage;
        this.reset();
        (_this$pdfPage = this.pdfPage) === null || _this$pdfPage === void 0 || _this$pdfPage.cleanup();
      }
    }, {
      key: "_textHighlighter",
      get: function get() {
        return shadow(this, "_textHighlighter", new TextHighlighter({
          pageIndex: this.id - 1,
          eventBus: this.eventBus,
          findController: _classPrivateFieldGet2(_layerProperties, this).findController
        }));
      }
    }, {
      key: "_resetZoomLayer",
      value: function _resetZoomLayer() {
        var removeFromDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!this.zoomLayer) {
          return;
        }
        var zoomLayerCanvas = this.zoomLayer.firstChild;
        _classPrivateFieldGet2(_viewportMap, this)["delete"](zoomLayerCanvas);
        zoomLayerCanvas.width = 0;
        zoomLayerCanvas.height = 0;
        if (removeFromDOM) {
          this.zoomLayer.remove();
        }
        this.zoomLayer = null;
      }
    }, {
      key: "reset",
      value: function reset() {
        var _this$annotationLayer, _this$annotationEdito, _this$xfaLayer, _this$textLayer, _this$structTreeLayer;
        var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref25$keepZoomLayer = _ref25.keepZoomLayer,
          keepZoomLayer = _ref25$keepZoomLayer === void 0 ? false : _ref25$keepZoomLayer,
          _ref25$keepAnnotation = _ref25.keepAnnotationLayer,
          keepAnnotationLayer = _ref25$keepAnnotation === void 0 ? false : _ref25$keepAnnotation,
          _ref25$keepAnnotation2 = _ref25.keepAnnotationEditorLayer,
          keepAnnotationEditorLayer = _ref25$keepAnnotation2 === void 0 ? false : _ref25$keepAnnotation2,
          _ref25$keepXfaLayer = _ref25.keepXfaLayer,
          keepXfaLayer = _ref25$keepXfaLayer === void 0 ? false : _ref25$keepXfaLayer,
          _ref25$keepTextLayer = _ref25.keepTextLayer,
          keepTextLayer = _ref25$keepTextLayer === void 0 ? false : _ref25$keepTextLayer;
        this.cancelRendering({
          keepAnnotationLayer: keepAnnotationLayer,
          keepAnnotationEditorLayer: keepAnnotationEditorLayer,
          keepXfaLayer: keepXfaLayer,
          keepTextLayer: keepTextLayer
        });
        this.renderingState = _RenderingStates.INITIAL;
        var div = this.div;
        var childNodes = div.childNodes,
          zoomLayerNode = keepZoomLayer && this.zoomLayer || null,
          annotationLayerNode = keepAnnotationLayer && ((_this$annotationLayer = this.annotationLayer) === null || _this$annotationLayer === void 0 ? void 0 : _this$annotationLayer.div) || null,
          annotationEditorLayerNode = keepAnnotationEditorLayer && ((_this$annotationEdito = this.annotationEditorLayer) === null || _this$annotationEdito === void 0 ? void 0 : _this$annotationEdito.div) || null,
          xfaLayerNode = keepXfaLayer && ((_this$xfaLayer = this.xfaLayer) === null || _this$xfaLayer === void 0 ? void 0 : _this$xfaLayer.div) || null,
          textLayerNode = keepTextLayer && ((_this$textLayer = this.textLayer) === null || _this$textLayer === void 0 ? void 0 : _this$textLayer.div) || null;
        for (var i = childNodes.length - 1; i >= 0; i--) {
          var node = childNodes[i];
          switch (node) {
            case zoomLayerNode:
            case annotationLayerNode:
            case annotationEditorLayerNode:
            case xfaLayerNode:
            case textLayerNode:
              continue;
          }
          node.remove();
          var layerIndex = _classPrivateFieldGet2(_layers, this).indexOf(node);
          if (layerIndex >= 0) {
            _classPrivateFieldGet2(_layers, this)[layerIndex] = null;
          }
        }
        div.removeAttribute("data-loaded");
        if (annotationLayerNode) {
          this.annotationLayer.hide();
        }
        if (annotationEditorLayerNode) {
          this.annotationEditorLayer.hide();
        }
        if (xfaLayerNode) {
          this.xfaLayer.hide();
        }
        if (textLayerNode) {
          this.textLayer.hide();
        }
        (_this$structTreeLayer = this.structTreeLayer) === null || _this$structTreeLayer === void 0 || _this$structTreeLayer.hide();
        if (!zoomLayerNode) {
          if (this.canvas) {
            _classPrivateFieldGet2(_viewportMap, this)["delete"](this.canvas);
            this.canvas.width = 0;
            this.canvas.height = 0;
            delete this.canvas;
          }
          this._resetZoomLayer();
        }
      }
    }, {
      key: "update",
      value: function update(_ref26) {
        var _this22 = this;
        var _ref26$scale = _ref26.scale,
          scale = _ref26$scale === void 0 ? 0 : _ref26$scale,
          _ref26$rotation = _ref26.rotation,
          rotation = _ref26$rotation === void 0 ? null : _ref26$rotation,
          _ref26$optionalConten = _ref26.optionalContentConfigPromise,
          optionalContentConfigPromise = _ref26$optionalConten === void 0 ? null : _ref26$optionalConten,
          _ref26$drawingDelay = _ref26.drawingDelay,
          drawingDelay = _ref26$drawingDelay === void 0 ? -1 : _ref26$drawingDelay;
        this.scale = scale || this.scale;
        if (typeof rotation === "number") {
          this.rotation = rotation;
        }
        if (optionalContentConfigPromise instanceof Promise) {
          this._optionalContentConfigPromise = optionalContentConfigPromise;
          optionalContentConfigPromise.then(function (optionalContentConfig) {
            if (optionalContentConfigPromise !== _this22._optionalContentConfigPromise) {
              return;
            }
            _classPrivateFieldGet2(_useThumbnailCanvas, _this22).initialOptionalContent = optionalContentConfig.hasInitialVisibility;
          });
        }
        _classPrivateFieldGet2(_useThumbnailCanvas, this).directDrawing = true;
        var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
        this.viewport = this.viewport.clone({
          scale: this.scale * PixelsPerInch.PDF_TO_CSS_UNITS,
          rotation: totalRotation
        });
        _assertClassBrand(_PDFPageView_brand, this, _setDimensions).call(this);
        if (this._isStandalone) {
          var _this$_container3;
          (_this$_container3 = this._container) === null || _this$_container3 === void 0 || _this$_container3.style.setProperty("--scale-factor", this.viewport.scale);
        }
        if (this.canvas) {
          var onlyCssZoom = false;
          if (_classPrivateFieldGet2(_hasRestrictedScaling, this)) {
            if (this.maxCanvasPixels === 0) {
              onlyCssZoom = true;
            } else if (this.maxCanvasPixels > 0) {
              var _this$viewport = this.viewport,
                width = _this$viewport.width,
                height = _this$viewport.height;
              var _this$outputScale = this.outputScale,
                sx = _this$outputScale.sx,
                sy = _this$outputScale.sy;
              onlyCssZoom = (Math.floor(width) * sx | 0) * (Math.floor(height) * sy | 0) > this.maxCanvasPixels;
            }
          }
          var postponeDrawing = drawingDelay >= 0 && drawingDelay < 1000;
          if (postponeDrawing || onlyCssZoom) {
            if (postponeDrawing && !onlyCssZoom && this.renderingState !== _RenderingStates.FINISHED) {
              this.cancelRendering({
                keepZoomLayer: true,
                keepAnnotationLayer: true,
                keepAnnotationEditorLayer: true,
                keepXfaLayer: true,
                keepTextLayer: true,
                cancelExtraDelay: drawingDelay
              });
              this.renderingState = _RenderingStates.FINISHED;
              _classPrivateFieldGet2(_useThumbnailCanvas, this).directDrawing = false;
            }
            this.cssTransform({
              target: this.canvas,
              redrawAnnotationLayer: true,
              redrawAnnotationEditorLayer: true,
              redrawXfaLayer: true,
              redrawTextLayer: !postponeDrawing,
              hideTextLayer: postponeDrawing
            });
            if (postponeDrawing) {
              return;
            }
            this.eventBus.dispatch("pagerendered", {
              source: this,
              pageNumber: this.id,
              cssTransform: true,
              timestamp: performance.now(),
              error: _classPrivateFieldGet2(_renderError, this)
            });
            return;
          }
          if (!this.zoomLayer && !this.canvas.hidden) {
            this.zoomLayer = this.canvas.parentNode;
            this.zoomLayer.style.position = "absolute";
          }
        }
        if (this.zoomLayer) {
          this.cssTransform({
            target: this.zoomLayer.firstChild
          });
        }
        this.reset({
          keepZoomLayer: true,
          keepAnnotationLayer: true,
          keepAnnotationEditorLayer: true,
          keepXfaLayer: true,
          keepTextLayer: true
        });
      }
    }, {
      key: "cancelRendering",
      value: function cancelRendering() {
        var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref27$keepAnnotation = _ref27.keepAnnotationLayer,
          keepAnnotationLayer = _ref27$keepAnnotation === void 0 ? false : _ref27$keepAnnotation,
          _ref27$keepAnnotation2 = _ref27.keepAnnotationEditorLayer,
          keepAnnotationEditorLayer = _ref27$keepAnnotation2 === void 0 ? false : _ref27$keepAnnotation2,
          _ref27$keepXfaLayer = _ref27.keepXfaLayer,
          keepXfaLayer = _ref27$keepXfaLayer === void 0 ? false : _ref27$keepXfaLayer,
          _ref27$keepTextLayer = _ref27.keepTextLayer,
          keepTextLayer = _ref27$keepTextLayer === void 0 ? false : _ref27$keepTextLayer,
          _ref27$cancelExtraDel = _ref27.cancelExtraDelay,
          cancelExtraDelay = _ref27$cancelExtraDel === void 0 ? 0 : _ref27$cancelExtraDel;
        if (this.renderTask) {
          this.renderTask.cancel(cancelExtraDelay);
          this.renderTask = null;
        }
        this.resume = null;
        if (this.textLayer && (!keepTextLayer || !this.textLayer.div)) {
          this.textLayer.cancel();
          this.textLayer = null;
        }
        if (this.structTreeLayer && !this.textLayer) {
          this.structTreeLayer = null;
        }
        if (this.annotationLayer && (!keepAnnotationLayer || !this.annotationLayer.div)) {
          this.annotationLayer.cancel();
          this.annotationLayer = null;
          this._annotationCanvasMap = null;
        }
        if (this.annotationEditorLayer && (!keepAnnotationEditorLayer || !this.annotationEditorLayer.div)) {
          if (this.drawLayer) {
            this.drawLayer.cancel();
            this.drawLayer = null;
          }
          this.annotationEditorLayer.cancel();
          this.annotationEditorLayer = null;
        }
        if (this.xfaLayer && (!keepXfaLayer || !this.xfaLayer.div)) {
          var _this$_textHighlighte;
          this.xfaLayer.cancel();
          this.xfaLayer = null;
          (_this$_textHighlighte = this._textHighlighter) === null || _this$_textHighlighte === void 0 || _this$_textHighlighte.disable();
        }
      }
    }, {
      key: "cssTransform",
      value: function cssTransform(_ref28) {
        var target = _ref28.target,
          _ref28$redrawAnnotati = _ref28.redrawAnnotationLayer,
          redrawAnnotationLayer = _ref28$redrawAnnotati === void 0 ? false : _ref28$redrawAnnotati,
          _ref28$redrawAnnotati2 = _ref28.redrawAnnotationEditorLayer,
          redrawAnnotationEditorLayer = _ref28$redrawAnnotati2 === void 0 ? false : _ref28$redrawAnnotati2,
          _ref28$redrawXfaLayer = _ref28.redrawXfaLayer,
          redrawXfaLayer = _ref28$redrawXfaLayer === void 0 ? false : _ref28$redrawXfaLayer,
          _ref28$redrawTextLaye = _ref28.redrawTextLayer,
          redrawTextLayer = _ref28$redrawTextLaye === void 0 ? false : _ref28$redrawTextLaye,
          _ref28$hideTextLayer = _ref28.hideTextLayer,
          hideTextLayer = _ref28$hideTextLayer === void 0 ? false : _ref28$hideTextLayer;
        if (!target.hasAttribute("zooming")) {
          target.setAttribute("zooming", true);
          var style = target.style;
          style.width = style.height = "";
        }
        var originalViewport = _classPrivateFieldGet2(_viewportMap, this).get(target);
        if (this.viewport !== originalViewport) {
          var relativeRotation = this.viewport.rotation - originalViewport.rotation;
          var absRotation = Math.abs(relativeRotation);
          var scaleX = 1,
            scaleY = 1;
          if (absRotation === 90 || absRotation === 270) {
            var _this$viewport2 = this.viewport,
              width = _this$viewport2.width,
              height = _this$viewport2.height;
            scaleX = height / width;
            scaleY = width / height;
          }
          target.style.transform = "rotate(".concat(relativeRotation, "deg) scale(").concat(scaleX, ", ").concat(scaleY, ")");
        }
        if (redrawAnnotationLayer && this.annotationLayer) {
          _assertClassBrand(_PDFPageView_brand, this, _renderAnnotationLayer).call(this);
        }
        if (redrawAnnotationEditorLayer && this.annotationEditorLayer) {
          if (this.drawLayer) {
            _assertClassBrand(_PDFPageView_brand, this, _renderDrawLayer).call(this);
          }
          _assertClassBrand(_PDFPageView_brand, this, _renderAnnotationEditorLayer).call(this);
        }
        if (redrawXfaLayer && this.xfaLayer) {
          _assertClassBrand(_PDFPageView_brand, this, _renderXfaLayer).call(this);
        }
        if (this.textLayer) {
          if (hideTextLayer) {
            var _this$structTreeLayer2;
            this.textLayer.hide();
            (_this$structTreeLayer2 = this.structTreeLayer) === null || _this$structTreeLayer2 === void 0 || _this$structTreeLayer2.hide();
          } else if (redrawTextLayer) {
            _assertClassBrand(_PDFPageView_brand, this, _renderTextLayer).call(this);
          }
        }
      }
    }, {
      key: "width",
      get: function get() {
        return this.viewport.width;
      }
    }, {
      key: "height",
      get: function get() {
        return this.viewport.height;
      }
    }, {
      key: "getPagePoint",
      value: function getPagePoint(x, y) {
        return this.viewport.convertToPdfPoint(x, y);
      }
    }, {
      key: "draw",
      value: function () {
        var _draw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
          var _this23 = this;
          var div, l10n, pageColors, pdfPage, viewport, canvasWrapper, _classPrivateFieldGet12, annotationStorage, annotationEditorUIManager, downloadManager, enableScripting, fieldObjectsPromise, hasJSActionsPromise, linkService, renderContinueCallback, width, height, canvas, hasHCM, _showCanvas2, ctx, outputScale, invScale, pixelsInViewport, maxScale, sfx, sfy, style, transform, renderContext, renderTask, resultPromise, _classPrivateFieldGet14, _annotationStorage, _linkService2;
          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                if (this.renderingState !== _RenderingStates.INITIAL) {
                  console.error("Must be in new state before drawing");
                  this.reset();
                }
                div = this.div, l10n = this.l10n, pageColors = this.pageColors, pdfPage = this.pdfPage, viewport = this.viewport;
                if (pdfPage) {
                  _context16.next = 5;
                  break;
                }
                this.renderingState = _RenderingStates.FINISHED;
                throw new Error("pdfPage is not loaded");
              case 5:
                this.renderingState = _RenderingStates.RUNNING;
                canvasWrapper = document.createElement("div");
                canvasWrapper.classList.add("canvasWrapper");
                _assertClassBrand(_PDFPageView_brand, this, _addLayer).call(this, canvasWrapper, "canvasWrapper");
                if (!this.textLayer && _classPrivateFieldGet2(_textLayerMode, this) !== TextLayerMode.DISABLE && !pdfPage.isPureXfa) {
                  this._accessibilityManager || (this._accessibilityManager = new TextAccessibilityManager());
                  this.textLayer = new _TextLayerBuilder({
                    pdfPage: pdfPage,
                    highlighter: this._textHighlighter,
                    accessibilityManager: this._accessibilityManager,
                    enablePermissions: _classPrivateFieldGet2(_textLayerMode, this) === TextLayerMode.ENABLE_PERMISSIONS,
                    onAppend: function onAppend(textLayerDiv) {
                      _this23.l10n.pause();
                      _assertClassBrand(_PDFPageView_brand, _this23, _addLayer).call(_this23, textLayerDiv, "textLayer");
                      _this23.l10n.resume();
                    }
                  });
                }
                if (!this.annotationLayer && _classPrivateFieldGet2(_annotationMode, this) !== AnnotationMode.DISABLE) {
                  _classPrivateFieldGet12 = _classPrivateFieldGet2(_layerProperties, this), annotationStorage = _classPrivateFieldGet12.annotationStorage, annotationEditorUIManager = _classPrivateFieldGet12.annotationEditorUIManager, downloadManager = _classPrivateFieldGet12.downloadManager, enableScripting = _classPrivateFieldGet12.enableScripting, fieldObjectsPromise = _classPrivateFieldGet12.fieldObjectsPromise, hasJSActionsPromise = _classPrivateFieldGet12.hasJSActionsPromise, linkService = _classPrivateFieldGet12.linkService;
                  this._annotationCanvasMap || (this._annotationCanvasMap = new Map());
                  this.annotationLayer = new _AnnotationLayerBuilder({
                    pdfPage: pdfPage,
                    annotationStorage: annotationStorage,
                    imageResourcesPath: this.imageResourcesPath,
                    renderForms: _classPrivateFieldGet2(_annotationMode, this) === AnnotationMode.ENABLE_FORMS,
                    linkService: linkService,
                    downloadManager: downloadManager,
                    enableScripting: enableScripting,
                    hasJSActionsPromise: hasJSActionsPromise,
                    fieldObjectsPromise: fieldObjectsPromise,
                    annotationCanvasMap: this._annotationCanvasMap,
                    accessibilityManager: this._accessibilityManager,
                    annotationEditorUIManager: annotationEditorUIManager,
                    onAppend: function onAppend(annotationLayerDiv) {
                      _assertClassBrand(_PDFPageView_brand, _this23, _addLayer).call(_this23, annotationLayerDiv, "annotationLayer");
                    }
                  });
                }
                renderContinueCallback = function renderContinueCallback(cont) {
                  var _showCanvas;
                  (_showCanvas = _showCanvas2) === null || _showCanvas === void 0 || _showCanvas(false);
                  if (_this23.renderingQueue && !_this23.renderingQueue.isHighestPriority(_this23)) {
                    _this23.renderingState = _RenderingStates.PAUSED;
                    _this23.resume = function () {
                      _this23.renderingState = _RenderingStates.RUNNING;
                      cont();
                    };
                    return;
                  }
                  cont();
                };
                width = viewport.width, height = viewport.height;
                canvas = document.createElement("canvas");
                canvas.setAttribute("role", "presentation");
                canvas.hidden = true;
                hasHCM = !!(pageColors !== null && pageColors !== void 0 && pageColors.background && pageColors !== null && pageColors !== void 0 && pageColors.foreground);
                _showCanvas2 = function showCanvas(isLastShow) {
                  if (!hasHCM || isLastShow) {
                    canvas.hidden = false;
                    _showCanvas2 = null;
                  }
                };
                canvasWrapper.append(canvas);
                this.canvas = canvas;
                ctx = canvas.getContext("2d", {
                  alpha: false
                });
                outputScale = this.outputScale = new OutputScale();
                if (this.maxCanvasPixels === 0) {
                  invScale = 1 / this.scale;
                  outputScale.sx *= invScale;
                  outputScale.sy *= invScale;
                  _classPrivateFieldSet2(_hasRestrictedScaling, this, true);
                } else if (this.maxCanvasPixels > 0) {
                  pixelsInViewport = width * height;
                  maxScale = Math.sqrt(this.maxCanvasPixels / pixelsInViewport);
                  if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
                    outputScale.sx = maxScale;
                    outputScale.sy = maxScale;
                    _classPrivateFieldSet2(_hasRestrictedScaling, this, true);
                  } else {
                    _classPrivateFieldSet2(_hasRestrictedScaling, this, false);
                  }
                }
                sfx = approximateFraction(outputScale.sx);
                sfy = approximateFraction(outputScale.sy);
                canvas.width = roundToDivide(width * outputScale.sx, sfx[0]);
                canvas.height = roundToDivide(height * outputScale.sy, sfy[0]);
                style = canvas.style;
                style.width = roundToDivide(width, sfx[1]) + "px";
                style.height = roundToDivide(height, sfy[1]) + "px";
                _classPrivateFieldGet2(_viewportMap, this).set(canvas, viewport);
                transform = outputScale.scaled ? [outputScale.sx, 0, 0, outputScale.sy, 0, 0] : null;
                renderContext = {
                  canvasContext: ctx,
                  transform: transform,
                  viewport: viewport,
                  annotationMode: _classPrivateFieldGet2(_annotationMode, this),
                  optionalContentConfigPromise: this._optionalContentConfigPromise,
                  annotationCanvasMap: this._annotationCanvasMap,
                  pageColors: pageColors
                };
                renderTask = this.renderTask = pdfPage.render(renderContext);
                renderTask.onContinue = renderContinueCallback;
                resultPromise = renderTask.promise.then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
                  var _showCanvas3;
                  var _classPrivateFieldGet13, annotationEditorUIManager, _this23$annotationLay;
                  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                    while (1) switch (_context15.prev = _context15.next) {
                      case 0:
                        (_showCanvas3 = _showCanvas2) === null || _showCanvas3 === void 0 || _showCanvas3(true);
                        _context15.next = 3;
                        return _assertClassBrand(_PDFPageView_brand, _this23, _finishRenderTask).call(_this23, renderTask);
                      case 3:
                        _assertClassBrand(_PDFPageView_brand, _this23, _renderTextLayer).call(_this23);
                        if (!_this23.annotationLayer) {
                          _context15.next = 7;
                          break;
                        }
                        _context15.next = 7;
                        return _assertClassBrand(_PDFPageView_brand, _this23, _renderAnnotationLayer).call(_this23);
                      case 7:
                        _classPrivateFieldGet13 = _classPrivateFieldGet2(_layerProperties, _this23), annotationEditorUIManager = _classPrivateFieldGet13.annotationEditorUIManager;
                        if (annotationEditorUIManager) {
                          _context15.next = 10;
                          break;
                        }
                        return _context15.abrupt("return");
                      case 10:
                        _this23.drawLayer || (_this23.drawLayer = new DrawLayerBuilder({
                          pageIndex: _this23.id
                        }));
                        _context15.next = 13;
                        return _assertClassBrand(_PDFPageView_brand, _this23, _renderDrawLayer).call(_this23);
                      case 13:
                        _this23.drawLayer.setParent(canvasWrapper);
                        if (!_this23.annotationEditorLayer) {
                          _this23.annotationEditorLayer = new AnnotationEditorLayerBuilder({
                            uiManager: annotationEditorUIManager,
                            pdfPage: pdfPage,
                            l10n: l10n,
                            accessibilityManager: _this23._accessibilityManager,
                            annotationLayer: (_this23$annotationLay = _this23.annotationLayer) === null || _this23$annotationLay === void 0 ? void 0 : _this23$annotationLay.annotationLayer,
                            textLayer: _this23.textLayer,
                            drawLayer: _this23.drawLayer.getDrawLayer(),
                            onAppend: function onAppend(annotationEditorLayerDiv) {
                              _assertClassBrand(_PDFPageView_brand, _this23, _addLayer).call(_this23, annotationEditorLayerDiv, "annotationEditorLayer");
                            }
                          });
                        }
                        _assertClassBrand(_PDFPageView_brand, _this23, _renderAnnotationEditorLayer).call(_this23);
                      case 16:
                      case "end":
                        return _context15.stop();
                    }
                  }, _callee15);
                })), function (error) {
                  if (!(error instanceof RenderingCancelledException)) {
                    var _showCanvas4;
                    (_showCanvas4 = _showCanvas2) === null || _showCanvas4 === void 0 || _showCanvas4(true);
                  }
                  return _assertClassBrand(_PDFPageView_brand, _this23, _finishRenderTask).call(_this23, renderTask, error);
                });
                if (pdfPage.isPureXfa) {
                  if (!this.xfaLayer) {
                    _classPrivateFieldGet14 = _classPrivateFieldGet2(_layerProperties, this), _annotationStorage = _classPrivateFieldGet14.annotationStorage, _linkService2 = _classPrivateFieldGet14.linkService;
                    this.xfaLayer = new _XfaLayerBuilder({
                      pdfPage: pdfPage,
                      annotationStorage: _annotationStorage,
                      linkService: _linkService2
                    });
                  }
                  _assertClassBrand(_PDFPageView_brand, this, _renderXfaLayer).call(this);
                }
                div.setAttribute("data-loaded", true);
                this.eventBus.dispatch("pagerender", {
                  source: this,
                  pageNumber: this.id
                });
                return _context16.abrupt("return", resultPromise);
              case 40:
              case "end":
                return _context16.stop();
            }
          }, _callee16, this);
        }));
        function draw() {
          return _draw.apply(this, arguments);
        }
        return draw;
      }()
    }, {
      key: "setPageLabel",
      value: function setPageLabel(label) {
        var _this$pageLabel;
        this.pageLabel = typeof label === "string" ? label : null;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
          page: (_this$pageLabel = this.pageLabel) !== null && _this$pageLabel !== void 0 ? _this$pageLabel : this.id
        }));
        if (this.pageLabel !== null) {
          this.div.setAttribute("data-page-label", this.pageLabel);
        } else {
          this.div.removeAttribute("data-page-label");
        }
      }
    }, {
      key: "thumbnailCanvas",
      get: function get() {
        var _classPrivateFieldGet15 = _classPrivateFieldGet2(_useThumbnailCanvas, this),
          directDrawing = _classPrivateFieldGet15.directDrawing,
          initialOptionalContent = _classPrivateFieldGet15.initialOptionalContent,
          regularAnnotations = _classPrivateFieldGet15.regularAnnotations;
        return directDrawing && initialOptionalContent && regularAnnotations ? this.canvas : null;
      }
    }]);
  }();
  function _addLayer(div, name) {
    var pos = LAYERS_ORDER.get(name);
    var oldDiv = _classPrivateFieldGet2(_layers, this)[pos];
    _classPrivateFieldGet2(_layers, this)[pos] = div;
    if (oldDiv) {
      oldDiv.replaceWith(div);
      return;
    }
    for (var i = pos - 1; i >= 0; i--) {
      var layer = _classPrivateFieldGet2(_layers, this)[i];
      if (layer) {
        layer.after(div);
        return;
      }
    }
    this.div.prepend(div);
  }
  function _setDimensions() {
    var viewport = this.viewport;
    if (this.pdfPage) {
      if (_classPrivateFieldGet2(_previousRotation, this) === viewport.rotation) {
        return;
      }
      _classPrivateFieldSet2(_previousRotation, this, viewport.rotation);
    }
    setLayerDimensions(this.div, viewport, true, false);
  }
  function _dispatchLayerRendered(name, error) {
    this.eventBus.dispatch(name, {
      source: this,
      pageNumber: this.id,
      error: error
    });
  }
  function _renderAnnotationLayer() {
    return _renderAnnotationLayer2.apply(this, arguments);
  }
  function _renderAnnotationLayer2() {
    _renderAnnotationLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
      var error;
      return _regeneratorRuntime().wrap(function _callee36$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            error = null;
            _context37.prev = 1;
            _context37.next = 4;
            return this.annotationLayer.render(this.viewport, "display");
          case 4:
            _context37.next = 10;
            break;
          case 6:
            _context37.prev = 6;
            _context37.t0 = _context37["catch"](1);
            console.error("#renderAnnotationLayer: \"".concat(_context37.t0, "\"."));
            error = _context37.t0;
          case 10:
            _context37.prev = 10;
            _assertClassBrand(_PDFPageView_brand, this, _dispatchLayerRendered).call(this, "annotationlayerrendered", error);
            return _context37.finish(10);
          case 13:
          case "end":
            return _context37.stop();
        }
      }, _callee36, this, [[1, 6, 10, 13]]);
    }));
    return _renderAnnotationLayer2.apply(this, arguments);
  }
  function _renderAnnotationEditorLayer() {
    return _renderAnnotationEditorLayer2.apply(this, arguments);
  }
  function _renderAnnotationEditorLayer2() {
    _renderAnnotationEditorLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
      var error;
      return _regeneratorRuntime().wrap(function _callee37$(_context38) {
        while (1) switch (_context38.prev = _context38.next) {
          case 0:
            error = null;
            _context38.prev = 1;
            _context38.next = 4;
            return this.annotationEditorLayer.render(this.viewport, "display");
          case 4:
            _context38.next = 10;
            break;
          case 6:
            _context38.prev = 6;
            _context38.t0 = _context38["catch"](1);
            console.error("#renderAnnotationEditorLayer: \"".concat(_context38.t0, "\"."));
            error = _context38.t0;
          case 10:
            _context38.prev = 10;
            _assertClassBrand(_PDFPageView_brand, this, _dispatchLayerRendered).call(this, "annotationeditorlayerrendered", error);
            return _context38.finish(10);
          case 13:
          case "end":
            return _context38.stop();
        }
      }, _callee37, this, [[1, 6, 10, 13]]);
    }));
    return _renderAnnotationEditorLayer2.apply(this, arguments);
  }
  function _renderDrawLayer() {
    return _renderDrawLayer2.apply(this, arguments);
  }
  function _renderDrawLayer2() {
    _renderDrawLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
      return _regeneratorRuntime().wrap(function _callee38$(_context39) {
        while (1) switch (_context39.prev = _context39.next) {
          case 0:
            _context39.prev = 0;
            _context39.next = 3;
            return this.drawLayer.render("display");
          case 3:
            _context39.next = 8;
            break;
          case 5:
            _context39.prev = 5;
            _context39.t0 = _context39["catch"](0);
            console.error("#renderDrawLayer: \"".concat(_context39.t0, "\"."));
          case 8:
          case "end":
            return _context39.stop();
        }
      }, _callee38, this, [[0, 5]]);
    }));
    return _renderDrawLayer2.apply(this, arguments);
  }
  function _renderXfaLayer() {
    return _renderXfaLayer2.apply(this, arguments);
  }
  function _renderXfaLayer2() {
    _renderXfaLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
      var error, result, _this$xfaLayer2;
      return _regeneratorRuntime().wrap(function _callee39$(_context40) {
        while (1) switch (_context40.prev = _context40.next) {
          case 0:
            error = null;
            _context40.prev = 1;
            _context40.next = 4;
            return this.xfaLayer.render(this.viewport, "display");
          case 4:
            result = _context40.sent;
            if (result !== null && result !== void 0 && result.textDivs && this._textHighlighter) {
              _assertClassBrand(_PDFPageView_brand, this, _buildXfaTextContentItems).call(this, result.textDivs);
            }
            _context40.next = 12;
            break;
          case 8:
            _context40.prev = 8;
            _context40.t0 = _context40["catch"](1);
            console.error("#renderXfaLayer: \"".concat(_context40.t0, "\"."));
            error = _context40.t0;
          case 12:
            _context40.prev = 12;
            if ((_this$xfaLayer2 = this.xfaLayer) !== null && _this$xfaLayer2 !== void 0 && _this$xfaLayer2.div) {
              this.l10n.pause();
              _assertClassBrand(_PDFPageView_brand, this, _addLayer).call(this, this.xfaLayer.div, "xfaLayer");
              this.l10n.resume();
            }
            _assertClassBrand(_PDFPageView_brand, this, _dispatchLayerRendered).call(this, "xfalayerrendered", error);
            return _context40.finish(12);
          case 16:
          case "end":
            return _context40.stop();
        }
      }, _callee39, this, [[1, 8, 12, 16]]);
    }));
    return _renderXfaLayer2.apply(this, arguments);
  }
  function _renderTextLayer() {
    return _renderTextLayer2.apply(this, arguments);
  }
  function _renderTextLayer2() {
    _renderTextLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
      var error;
      return _regeneratorRuntime().wrap(function _callee40$(_context41) {
        while (1) switch (_context41.prev = _context41.next) {
          case 0:
            if (this.textLayer) {
              _context41.next = 2;
              break;
            }
            return _context41.abrupt("return");
          case 2:
            error = null;
            _context41.prev = 3;
            _context41.next = 6;
            return this.textLayer.render(this.viewport);
          case 6:
            _context41.next = 14;
            break;
          case 8:
            _context41.prev = 8;
            _context41.t0 = _context41["catch"](3);
            if (!(_context41.t0 instanceof AbortException)) {
              _context41.next = 12;
              break;
            }
            return _context41.abrupt("return");
          case 12:
            console.error("#renderTextLayer: \"".concat(_context41.t0, "\"."));
            error = _context41.t0;
          case 14:
            _assertClassBrand(_PDFPageView_brand, this, _dispatchLayerRendered).call(this, "textlayerrendered", error);
            _assertClassBrand(_PDFPageView_brand, this, _renderStructTreeLayer).call(this);
          case 16:
          case "end":
            return _context41.stop();
        }
      }, _callee40, this, [[3, 8]]);
    }));
    return _renderTextLayer2.apply(this, arguments);
  }
  function _renderStructTreeLayer() {
    return _renderStructTreeLayer2.apply(this, arguments);
  }
  function _renderStructTreeLayer2() {
    _renderStructTreeLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
      var _this$structTreeLayer3, _this$structTreeLayer4;
      var tree, treeDom, _this$canvas;
      return _regeneratorRuntime().wrap(function _callee41$(_context42) {
        while (1) switch (_context42.prev = _context42.next) {
          case 0:
            if (this.textLayer) {
              _context42.next = 2;
              break;
            }
            return _context42.abrupt("return");
          case 2:
            this.structTreeLayer || (this.structTreeLayer = new _StructTreeLayerBuilder());
            _context42.next = 5;
            return !this.structTreeLayer.renderingDone ? this.pdfPage.getStructTree() : null;
          case 5:
            tree = _context42.sent;
            treeDom = (_this$structTreeLayer3 = this.structTreeLayer) === null || _this$structTreeLayer3 === void 0 ? void 0 : _this$structTreeLayer3.render(tree);
            if (treeDom) {
              this.l10n.pause();
              (_this$canvas = this.canvas) === null || _this$canvas === void 0 || _this$canvas.append(treeDom);
              this.l10n.resume();
            }
            (_this$structTreeLayer4 = this.structTreeLayer) === null || _this$structTreeLayer4 === void 0 || _this$structTreeLayer4.show();
          case 9:
          case "end":
            return _context42.stop();
        }
      }, _callee41, this);
    }));
    return _renderStructTreeLayer2.apply(this, arguments);
  }
  function _buildXfaTextContentItems(_x23) {
    return _buildXfaTextContentItems2.apply(this, arguments);
  }
  function _buildXfaTextContentItems2() {
    _buildXfaTextContentItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(textDivs) {
      var text, items, _iterator39, _step39, item;
      return _regeneratorRuntime().wrap(function _callee42$(_context43) {
        while (1) switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return this.pdfPage.getTextContent();
          case 2:
            text = _context43.sent;
            items = [];
            _iterator39 = _createForOfIteratorHelper(text.items);
            try {
              for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                item = _step39.value;
                items.push(item.str);
              }
            } catch (err) {
              _iterator39.e(err);
            } finally {
              _iterator39.f();
            }
            this._textHighlighter.setTextMapping(textDivs, items);
            this._textHighlighter.enable();
          case 8:
          case "end":
            return _context43.stop();
        }
      }, _callee42, this);
    }));
    return _buildXfaTextContentItems2.apply(this, arguments);
  }
  function _finishRenderTask(_x24) {
    return _finishRenderTask2.apply(this, arguments);
  }
  function _finishRenderTask2() {
    _finishRenderTask2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(renderTask) {
      var error,
        _args44 = arguments;
      return _regeneratorRuntime().wrap(function _callee43$(_context44) {
        while (1) switch (_context44.prev = _context44.next) {
          case 0:
            error = _args44.length > 1 && _args44[1] !== undefined ? _args44[1] : null;
            if (renderTask === this.renderTask) {
              this.renderTask = null;
            }
            if (!(error instanceof RenderingCancelledException)) {
              _context44.next = 5;
              break;
            }
            _classPrivateFieldSet2(_renderError, this, null);
            return _context44.abrupt("return");
          case 5:
            _classPrivateFieldSet2(_renderError, this, error);
            this.renderingState = _RenderingStates.FINISHED;
            this._resetZoomLayer(true);
            _classPrivateFieldGet2(_useThumbnailCanvas, this).regularAnnotations = !renderTask.separateAnnots;
            this.eventBus.dispatch("pagerendered", {
              source: this,
              pageNumber: this.id,
              cssTransform: false,
              timestamp: performance.now(),
              error: _classPrivateFieldGet2(_renderError, this)
            });
            if (!error) {
              _context44.next = 12;
              break;
            }
            throw error;
          case 12:
          case "end":
            return _context44.stop();
        }
      }, _callee43, this);
    }));
    return _finishRenderTask2.apply(this, arguments);
  }
  function docProperties(_x15) {
    return _docProperties.apply(this, arguments);
  }
  function _docProperties() {
    _docProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(pdfDocument) {
      var url, baseUrl, _yield$pdfDocument$ge, info, metadata, contentDispositionFilename, contentLength, _yield$pdfDocument$ge2, length;
      return _regeneratorRuntime().wrap(function _callee31$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            url = "", baseUrl = url.split("#", 1)[0];
            _context32.next = 3;
            return pdfDocument.getMetadata();
          case 3:
            _yield$pdfDocument$ge = _context32.sent;
            info = _yield$pdfDocument$ge.info;
            metadata = _yield$pdfDocument$ge.metadata;
            contentDispositionFilename = _yield$pdfDocument$ge.contentDispositionFilename;
            contentLength = _yield$pdfDocument$ge.contentLength;
            if (contentLength) {
              _context32.next = 14;
              break;
            }
            _context32.next = 11;
            return pdfDocument.getDownloadInfo();
          case 11:
            _yield$pdfDocument$ge2 = _context32.sent;
            length = _yield$pdfDocument$ge2.length;
            contentLength = length;
          case 14:
            return _context32.abrupt("return", _objectSpread2(_objectSpread2({}, info), {}, {
              baseURL: baseUrl,
              filesize: contentLength,
              filename: contentDispositionFilename || getPdfFilenameFromUrl(url),
              metadata: metadata === null || metadata === void 0 ? void 0 : metadata.getRaw(),
              authors: metadata === null || metadata === void 0 ? void 0 : metadata.get("dc:creator"),
              numPages: pdfDocument.numPages,
              URL: url
            }));
          case 15:
          case "end":
            return _context32.stop();
        }
      }, _callee31);
    }));
    return _docProperties.apply(this, arguments);
  }
  var GenericScripting = /*#__PURE__*/function () {
    function GenericScripting(sandboxBundleSrc) {
      _classCallCheck(this, GenericScripting);
      this._ready = new Promise(function (resolve, reject) {
        var sandbox = import( /*webpackIgnore: true*/sandboxBundleSrc);
        sandbox.then(function (pdfjsSandbox) {
          resolve(pdfjsSandbox.QuickJSSandbox());
        })["catch"](reject);
      });
    }
    return _createClass(GenericScripting, [{
      key: "createSandbox",
      value: function () {
        var _createSandbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(data) {
          var sandbox;
          return _regeneratorRuntime().wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this._ready;
              case 2:
                sandbox = _context17.sent;
                sandbox.create(data);
              case 4:
              case "end":
                return _context17.stop();
            }
          }, _callee17, this);
        }));
        function createSandbox(_x16) {
          return _createSandbox.apply(this, arguments);
        }
        return createSandbox;
      }()
    }, {
      key: "dispatchEventInSandbox",
      value: function () {
        var _dispatchEventInSandbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(event) {
          var sandbox;
          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this._ready;
              case 2:
                sandbox = _context18.sent;
                setTimeout(function () {
                  return sandbox.dispatchEvent(event);
                }, 0);
              case 4:
              case "end":
                return _context18.stop();
            }
          }, _callee18, this);
        }));
        function dispatchEventInSandbox(_x17) {
          return _dispatchEventInSandbox.apply(this, arguments);
        }
        return dispatchEventInSandbox;
      }()
    }, {
      key: "destroySandbox",
      value: function () {
        var _destroySandbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
          var sandbox;
          return _regeneratorRuntime().wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this._ready;
              case 2:
                sandbox = _context19.sent;
                sandbox.nukeSandbox();
              case 4:
              case "end":
                return _context19.stop();
            }
          }, _callee19, this);
        }));
        function destroySandbox() {
          return _destroySandbox.apply(this, arguments);
        }
        return destroySandbox;
      }()
    }]);
  }();
  var _closeCapability = /*#__PURE__*/new WeakMap();
  var _destroyCapability = /*#__PURE__*/new WeakMap();
  var _docProperties2 = /*#__PURE__*/new WeakMap();
  var _eventAbortController4 = /*#__PURE__*/new WeakMap();
  var _eventBus = /*#__PURE__*/new WeakMap();
  var _externalServices = /*#__PURE__*/new WeakMap();
  var _pdfDocument = /*#__PURE__*/new WeakMap();
  var _pdfViewer = /*#__PURE__*/new WeakMap();
  var _ready = /*#__PURE__*/new WeakMap();
  var _scripting = /*#__PURE__*/new WeakMap();
  var _willPrintCapability = /*#__PURE__*/new WeakMap();
  var _PDFScriptingManager_brand = /*#__PURE__*/new WeakSet();
  var PDFScriptingManager = /*#__PURE__*/function () {
    function PDFScriptingManager(_ref30) {
      var eventBus = _ref30.eventBus,
        _ref30$externalServic = _ref30.externalServices,
        externalServices = _ref30$externalServic === void 0 ? null : _ref30$externalServic,
        _ref30$docProperties = _ref30.docProperties,
        docProperties = _ref30$docProperties === void 0 ? null : _ref30$docProperties;
      _classCallCheck(this, PDFScriptingManager);
      _classPrivateMethodInitSpec(this, _PDFScriptingManager_brand);
      _classPrivateFieldInitSpec(this, _closeCapability, null);
      _classPrivateFieldInitSpec(this, _destroyCapability, null);
      _classPrivateFieldInitSpec(this, _docProperties2, null);
      _classPrivateFieldInitSpec(this, _eventAbortController4, null);
      _classPrivateFieldInitSpec(this, _eventBus, null);
      _classPrivateFieldInitSpec(this, _externalServices, null);
      _classPrivateFieldInitSpec(this, _pdfDocument, null);
      _classPrivateFieldInitSpec(this, _pdfViewer, null);
      _classPrivateFieldInitSpec(this, _ready, false);
      _classPrivateFieldInitSpec(this, _scripting, null);
      _classPrivateFieldInitSpec(this, _willPrintCapability, null);
      _classPrivateFieldSet2(_eventBus, this, eventBus);
      _classPrivateFieldSet2(_externalServices, this, externalServices);
      _classPrivateFieldSet2(_docProperties2, this, docProperties);
    }
    return _createClass(PDFScriptingManager, [{
      key: "setViewer",
      value: function setViewer(pdfViewer) {
        _classPrivateFieldSet2(_pdfViewer, this, pdfViewer);
      }
    }, {
      key: "setDocument",
      value: function () {
        var _setDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(pdfDocument) {
          var _this24 = this,
            _classPrivateFieldGet20;
          var _yield$Promise$all3, _yield$Promise$all4, objects, calculationOrder, docActions, eventBus, _classPrivateFieldGet16, signal, _docProperties3;
          return _regeneratorRuntime().wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                if (!_classPrivateFieldGet2(_pdfDocument, this)) {
                  _context21.next = 3;
                  break;
                }
                _context21.next = 3;
                return _assertClassBrand(_PDFScriptingManager_brand, this, _destroyScripting).call(this);
              case 3:
                _classPrivateFieldSet2(_pdfDocument, this, pdfDocument);
                if (pdfDocument) {
                  _context21.next = 6;
                  break;
                }
                return _context21.abrupt("return");
              case 6:
                _context21.next = 8;
                return Promise.all([pdfDocument.getFieldObjects(), pdfDocument.getCalculationOrderIds(), pdfDocument.getJSActions()]);
              case 8:
                _yield$Promise$all3 = _context21.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
                objects = _yield$Promise$all4[0];
                calculationOrder = _yield$Promise$all4[1];
                docActions = _yield$Promise$all4[2];
                if (!(!objects && !docActions)) {
                  _context21.next = 17;
                  break;
                }
                _context21.next = 16;
                return _assertClassBrand(_PDFScriptingManager_brand, this, _destroyScripting).call(this);
              case 16:
                return _context21.abrupt("return");
              case 17:
                if (!(pdfDocument !== _classPrivateFieldGet2(_pdfDocument, this))) {
                  _context21.next = 19;
                  break;
                }
                return _context21.abrupt("return");
              case 19:
                _context21.prev = 19;
                _classPrivateFieldSet2(_scripting, this, _assertClassBrand(_PDFScriptingManager_brand, this, _initScripting).call(this));
                _context21.next = 29;
                break;
              case 23:
                _context21.prev = 23;
                _context21.t0 = _context21["catch"](19);
                console.error("setDocument: \"".concat(_context21.t0.message, "\"."));
                _context21.next = 28;
                return _assertClassBrand(_PDFScriptingManager_brand, this, _destroyScripting).call(this);
              case 28:
                return _context21.abrupt("return");
              case 29:
                eventBus = _classPrivateFieldGet2(_eventBus, this);
                _classPrivateFieldSet2(_eventAbortController4, this, new AbortController());
                _classPrivateFieldGet16 = _classPrivateFieldGet2(_eventAbortController4, this), signal = _classPrivateFieldGet16.signal;
                eventBus._on("updatefromsandbox", function (event) {
                  if ((event === null || event === void 0 ? void 0 : event.source) === window) {
                    _assertClassBrand(_PDFScriptingManager_brand, _this24, _updateFromSandbox).call(_this24, event.detail);
                  }
                }, {
                  signal: signal
                });
                eventBus._on("dispatcheventinsandbox", function (event) {
                  var _classPrivateFieldGet17;
                  (_classPrivateFieldGet17 = _classPrivateFieldGet2(_scripting, _this24)) === null || _classPrivateFieldGet17 === void 0 || _classPrivateFieldGet17.dispatchEventInSandbox(event.detail);
                }, {
                  signal: signal
                });
                eventBus._on("pagechanging", function (_ref31) {
                  var pageNumber = _ref31.pageNumber,
                    previous = _ref31.previous;
                  if (pageNumber === previous) {
                    return;
                  }
                  _assertClassBrand(_PDFScriptingManager_brand, _this24, _dispatchPageClose).call(_this24, previous);
                  _assertClassBrand(_PDFScriptingManager_brand, _this24, _dispatchPageOpen).call(_this24, pageNumber);
                }, {
                  signal: signal
                });
                eventBus._on("pagerendered", function (_ref32) {
                  var pageNumber = _ref32.pageNumber;
                  if (!_this24._pageOpenPending.has(pageNumber)) {
                    return;
                  }
                  if (pageNumber !== _classPrivateFieldGet2(_pdfViewer, _this24).currentPageNumber) {
                    return;
                  }
                  _assertClassBrand(_PDFScriptingManager_brand, _this24, _dispatchPageOpen).call(_this24, pageNumber);
                }, {
                  signal: signal
                });
                eventBus._on("pagesdestroy", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
                  var _classPrivateFieldGet18, _classPrivateFieldGet19;
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        _context20.next = 2;
                        return _assertClassBrand(_PDFScriptingManager_brand, _this24, _dispatchPageClose).call(_this24, _classPrivateFieldGet2(_pdfViewer, _this24).currentPageNumber);
                      case 2:
                        _context20.next = 4;
                        return (_classPrivateFieldGet18 = _classPrivateFieldGet2(_scripting, _this24)) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.dispatchEventInSandbox({
                          id: "doc",
                          name: "WillClose"
                        });
                      case 4:
                        (_classPrivateFieldGet19 = _classPrivateFieldGet2(_closeCapability, _this24)) === null || _classPrivateFieldGet19 === void 0 || _classPrivateFieldGet19.resolve();
                      case 5:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20);
                })), {
                  signal: signal
                });
                _context21.prev = 37;
                _context21.next = 40;
                return _classPrivateFieldGet2(_docProperties2, this).call(this, pdfDocument);
              case 40:
                _docProperties3 = _context21.sent;
                if (!(pdfDocument !== _classPrivateFieldGet2(_pdfDocument, this))) {
                  _context21.next = 43;
                  break;
                }
                return _context21.abrupt("return");
              case 43:
                _context21.next = 45;
                return _classPrivateFieldGet2(_scripting, this).createSandbox({
                  objects: objects,
                  calculationOrder: calculationOrder,
                  appInfo: {
                    platform: navigator.platform,
                    language: navigator.language
                  },
                  docInfo: _objectSpread2(_objectSpread2({}, _docProperties3), {}, {
                    actions: docActions
                  })
                });
              case 45:
                eventBus.dispatch("sandboxcreated", {
                  source: this
                });
                _context21.next = 54;
                break;
              case 48:
                _context21.prev = 48;
                _context21.t1 = _context21["catch"](37);
                console.error("setDocument: \"".concat(_context21.t1.message, "\"."));
                _context21.next = 53;
                return _assertClassBrand(_PDFScriptingManager_brand, this, _destroyScripting).call(this);
              case 53:
                return _context21.abrupt("return");
              case 54:
                _context21.next = 56;
                return (_classPrivateFieldGet20 = _classPrivateFieldGet2(_scripting, this)) === null || _classPrivateFieldGet20 === void 0 ? void 0 : _classPrivateFieldGet20.dispatchEventInSandbox({
                  id: "doc",
                  name: "Open"
                });
              case 56:
                _context21.next = 58;
                return _assertClassBrand(_PDFScriptingManager_brand, this, _dispatchPageOpen).call(this, _classPrivateFieldGet2(_pdfViewer, this).currentPageNumber, true);
              case 58:
                Promise.resolve().then(function () {
                  if (pdfDocument === _classPrivateFieldGet2(_pdfDocument, _this24)) {
                    _classPrivateFieldSet2(_ready, _this24, true);
                  }
                });
              case 59:
              case "end":
                return _context21.stop();
            }
          }, _callee21, this, [[19, 23], [37, 48]]);
        }));
        function setDocument(_x18) {
          return _setDocument.apply(this, arguments);
        }
        return setDocument;
      }()
    }, {
      key: "dispatchWillSave",
      value: function () {
        var _dispatchWillSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
          var _classPrivateFieldGet21;
          return _regeneratorRuntime().wrap(function _callee22$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", (_classPrivateFieldGet21 = _classPrivateFieldGet2(_scripting, this)) === null || _classPrivateFieldGet21 === void 0 ? void 0 : _classPrivateFieldGet21.dispatchEventInSandbox({
                  id: "doc",
                  name: "WillSave"
                }));
              case 1:
              case "end":
                return _context22.stop();
            }
          }, _callee22, this);
        }));
        function dispatchWillSave() {
          return _dispatchWillSave.apply(this, arguments);
        }
        return dispatchWillSave;
      }()
    }, {
      key: "dispatchDidSave",
      value: function () {
        var _dispatchDidSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
          var _classPrivateFieldGet22;
          return _regeneratorRuntime().wrap(function _callee23$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", (_classPrivateFieldGet22 = _classPrivateFieldGet2(_scripting, this)) === null || _classPrivateFieldGet22 === void 0 ? void 0 : _classPrivateFieldGet22.dispatchEventInSandbox({
                  id: "doc",
                  name: "DidSave"
                }));
              case 1:
              case "end":
                return _context23.stop();
            }
          }, _callee23, this);
        }));
        function dispatchDidSave() {
          return _dispatchDidSave.apply(this, arguments);
        }
        return dispatchDidSave;
      }()
    }, {
      key: "dispatchWillPrint",
      value: function () {
        var _dispatchWillPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
          var _classPrivateFieldGet23;
          return _regeneratorRuntime().wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                if (_classPrivateFieldGet2(_scripting, this)) {
                  _context24.next = 2;
                  break;
                }
                return _context24.abrupt("return");
              case 2:
                _context24.next = 4;
                return (_classPrivateFieldGet23 = _classPrivateFieldGet2(_willPrintCapability, this)) === null || _classPrivateFieldGet23 === void 0 ? void 0 : _classPrivateFieldGet23.promise;
              case 4:
                _classPrivateFieldSet2(_willPrintCapability, this, Promise.withResolvers());
                _context24.prev = 5;
                _context24.next = 8;
                return _classPrivateFieldGet2(_scripting, this).dispatchEventInSandbox({
                  id: "doc",
                  name: "WillPrint"
                });
              case 8:
                _context24.next = 15;
                break;
              case 10:
                _context24.prev = 10;
                _context24.t0 = _context24["catch"](5);
                _classPrivateFieldGet2(_willPrintCapability, this).resolve();
                _classPrivateFieldSet2(_willPrintCapability, this, null);
                throw _context24.t0;
              case 15:
                _context24.next = 17;
                return _classPrivateFieldGet2(_willPrintCapability, this).promise;
              case 17:
              case "end":
                return _context24.stop();
            }
          }, _callee24, this, [[5, 10]]);
        }));
        function dispatchWillPrint() {
          return _dispatchWillPrint.apply(this, arguments);
        }
        return dispatchWillPrint;
      }()
    }, {
      key: "dispatchDidPrint",
      value: function () {
        var _dispatchDidPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
          var _classPrivateFieldGet24;
          return _regeneratorRuntime().wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", (_classPrivateFieldGet24 = _classPrivateFieldGet2(_scripting, this)) === null || _classPrivateFieldGet24 === void 0 ? void 0 : _classPrivateFieldGet24.dispatchEventInSandbox({
                  id: "doc",
                  name: "DidPrint"
                }));
              case 1:
              case "end":
                return _context25.stop();
            }
          }, _callee25, this);
        }));
        function dispatchDidPrint() {
          return _dispatchDidPrint.apply(this, arguments);
        }
        return dispatchDidPrint;
      }()
    }, {
      key: "destroyPromise",
      get: function get() {
        var _classPrivateFieldGet25;
        return ((_classPrivateFieldGet25 = _classPrivateFieldGet2(_destroyCapability, this)) === null || _classPrivateFieldGet25 === void 0 ? void 0 : _classPrivateFieldGet25.promise) || null;
      }
    }, {
      key: "ready",
      get: function get() {
        return _classPrivateFieldGet2(_ready, this);
      }
    }, {
      key: "_pageOpenPending",
      get: function get() {
        return shadow(this, "_pageOpenPending", new Set());
      }
    }, {
      key: "_visitedPages",
      get: function get() {
        return shadow(this, "_visitedPages", new Map());
      }
    }]);
  }();
  function _updateFromSandbox(_x25) {
    return _updateFromSandbox2.apply(this, arguments);
  }
  function _updateFromSandbox2() {
    _updateFromSandbox2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(detail) {
      var _classPrivateFieldGet36;
      var pdfViewer, isInPresentationMode, id, siblings, command, value, modes, ids, _iterator40, _step40, elementId, element, _classPrivateFieldGet37;
      return _regeneratorRuntime().wrap(function _callee44$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            pdfViewer = _classPrivateFieldGet2(_pdfViewer, this);
            isInPresentationMode = pdfViewer.isInPresentationMode || pdfViewer.isChangingPresentationMode;
            id = detail.id, siblings = detail.siblings, command = detail.command, value = detail.value;
            if (id) {
              _context45.next = 41;
              break;
            }
            _context45.t0 = command;
            _context45.next = _context45.t0 === "clear" ? 7 : _context45.t0 === "error" ? 9 : _context45.t0 === "layout" ? 11 : _context45.t0 === "page-num" ? 13 : _context45.t0 === "print" ? 15 : _context45.t0 === "println" ? 19 : _context45.t0 === "zoom" ? 21 : _context45.t0 === "SaveAs" ? 23 : _context45.t0 === "FirstPage" ? 25 : _context45.t0 === "LastPage" ? 27 : _context45.t0 === "NextPage" ? 29 : _context45.t0 === "PrevPage" ? 31 : _context45.t0 === "ZoomViewIn" ? 33 : _context45.t0 === "ZoomViewOut" ? 35 : _context45.t0 === "WillPrintFinished" ? 37 : 40;
            break;
          case 7:
            console.clear();
            return _context45.abrupt("break", 40);
          case 9:
            console.error(value);
            return _context45.abrupt("break", 40);
          case 11:
            if (!isInPresentationMode) {
              modes = apiPageLayoutToViewerModes(value);
              pdfViewer.spreadMode = modes.spreadMode;
            }
            return _context45.abrupt("break", 40);
          case 13:
            pdfViewer.currentPageNumber = value + 1;
            return _context45.abrupt("break", 40);
          case 15:
            _context45.next = 17;
            return pdfViewer.pagesPromise;
          case 17:
            _classPrivateFieldGet2(_eventBus, this).dispatch("print", {
              source: this
            });
            return _context45.abrupt("break", 40);
          case 19:
            console.log(value);
            return _context45.abrupt("break", 40);
          case 21:
            if (!isInPresentationMode) {
              pdfViewer.currentScaleValue = value;
            }
            return _context45.abrupt("break", 40);
          case 23:
            _classPrivateFieldGet2(_eventBus, this).dispatch("download", {
              source: this
            });
            return _context45.abrupt("break", 40);
          case 25:
            pdfViewer.currentPageNumber = 1;
            return _context45.abrupt("break", 40);
          case 27:
            pdfViewer.currentPageNumber = pdfViewer.pagesCount;
            return _context45.abrupt("break", 40);
          case 29:
            pdfViewer.nextPage();
            return _context45.abrupt("break", 40);
          case 31:
            pdfViewer.previousPage();
            return _context45.abrupt("break", 40);
          case 33:
            if (!isInPresentationMode) {
              pdfViewer.increaseScale();
            }
            return _context45.abrupt("break", 40);
          case 35:
            if (!isInPresentationMode) {
              pdfViewer.decreaseScale();
            }
            return _context45.abrupt("break", 40);
          case 37:
            (_classPrivateFieldGet36 = _classPrivateFieldGet2(_willPrintCapability, this)) === null || _classPrivateFieldGet36 === void 0 || _classPrivateFieldGet36.resolve();
            _classPrivateFieldSet2(_willPrintCapability, this, null);
            return _context45.abrupt("break", 40);
          case 40:
            return _context45.abrupt("return");
          case 41:
            if (!(isInPresentationMode && detail.focus)) {
              _context45.next = 43;
              break;
            }
            return _context45.abrupt("return");
          case 43:
            delete detail.id;
            delete detail.siblings;
            ids = siblings ? [id].concat(_toConsumableArray(siblings)) : [id];
            _iterator40 = _createForOfIteratorHelper(ids);
            try {
              for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                elementId = _step40.value;
                element = document.querySelector("[data-element-id=\"".concat(elementId, "\"]"));
                if (element) {
                  element.dispatchEvent(new CustomEvent("updatefromsandbox", {
                    detail: detail
                  }));
                } else {
                  (_classPrivateFieldGet37 = _classPrivateFieldGet2(_pdfDocument, this)) === null || _classPrivateFieldGet37 === void 0 || _classPrivateFieldGet37.annotationStorage.setValue(elementId, detail);
                }
              }
            } catch (err) {
              _iterator40.e(err);
            } finally {
              _iterator40.f();
            }
          case 48:
          case "end":
            return _context45.stop();
        }
      }, _callee44, this);
    }));
    return _updateFromSandbox2.apply(this, arguments);
  }
  function _dispatchPageOpen(_x26) {
    return _dispatchPageOpen2.apply(this, arguments);
  }
  function _dispatchPageOpen2() {
    _dispatchPageOpen2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(pageNumber) {
      var _this43 = this;
      var initialize,
        pdfDocument,
        visitedPages,
        pageView,
        actionsPromise,
        _args47 = arguments;
      return _regeneratorRuntime().wrap(function _callee46$(_context47) {
        while (1) switch (_context47.prev = _context47.next) {
          case 0:
            initialize = _args47.length > 1 && _args47[1] !== undefined ? _args47[1] : false;
            pdfDocument = _classPrivateFieldGet2(_pdfDocument, this), visitedPages = this._visitedPages;
            if (initialize) {
              _classPrivateFieldSet2(_closeCapability, this, Promise.withResolvers());
            }
            if (_classPrivateFieldGet2(_closeCapability, this)) {
              _context47.next = 5;
              break;
            }
            return _context47.abrupt("return");
          case 5:
            pageView = _classPrivateFieldGet2(_pdfViewer, this).getPageView(pageNumber - 1);
            if (!((pageView === null || pageView === void 0 ? void 0 : pageView.renderingState) !== _RenderingStates.FINISHED)) {
              _context47.next = 9;
              break;
            }
            this._pageOpenPending.add(pageNumber);
            return _context47.abrupt("return");
          case 9:
            this._pageOpenPending["delete"](pageNumber);
            actionsPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
              var _pageView$pdfPage, _classPrivateFieldGet38;
              var actions;
              return _regeneratorRuntime().wrap(function _callee45$(_context46) {
                while (1) switch (_context46.prev = _context46.next) {
                  case 0:
                    _context46.next = 2;
                    return !visitedPages.has(pageNumber) ? (_pageView$pdfPage = pageView.pdfPage) === null || _pageView$pdfPage === void 0 ? void 0 : _pageView$pdfPage.getJSActions() : null;
                  case 2:
                    actions = _context46.sent;
                    if (!(pdfDocument !== _classPrivateFieldGet2(_pdfDocument, _this43))) {
                      _context46.next = 5;
                      break;
                    }
                    return _context46.abrupt("return");
                  case 5:
                    _context46.next = 7;
                    return (_classPrivateFieldGet38 = _classPrivateFieldGet2(_scripting, _this43)) === null || _classPrivateFieldGet38 === void 0 ? void 0 : _classPrivateFieldGet38.dispatchEventInSandbox({
                      id: "page",
                      name: "PageOpen",
                      pageNumber: pageNumber,
                      actions: actions
                    });
                  case 7:
                  case "end":
                    return _context46.stop();
                }
              }, _callee45);
            }))();
            visitedPages.set(pageNumber, actionsPromise);
          case 12:
          case "end":
            return _context47.stop();
        }
      }, _callee46, this);
    }));
    return _dispatchPageOpen2.apply(this, arguments);
  }
  function _dispatchPageClose(_x27) {
    return _dispatchPageClose2.apply(this, arguments);
  }
  function _dispatchPageClose2() {
    _dispatchPageClose2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(pageNumber) {
      var _classPrivateFieldGet39;
      var pdfDocument, visitedPages, actionsPromise;
      return _regeneratorRuntime().wrap(function _callee47$(_context48) {
        while (1) switch (_context48.prev = _context48.next) {
          case 0:
            pdfDocument = _classPrivateFieldGet2(_pdfDocument, this), visitedPages = this._visitedPages;
            if (_classPrivateFieldGet2(_closeCapability, this)) {
              _context48.next = 3;
              break;
            }
            return _context48.abrupt("return");
          case 3:
            if (!this._pageOpenPending.has(pageNumber)) {
              _context48.next = 5;
              break;
            }
            return _context48.abrupt("return");
          case 5:
            actionsPromise = visitedPages.get(pageNumber);
            if (actionsPromise) {
              _context48.next = 8;
              break;
            }
            return _context48.abrupt("return");
          case 8:
            visitedPages.set(pageNumber, null);
            _context48.next = 11;
            return actionsPromise;
          case 11:
            if (!(pdfDocument !== _classPrivateFieldGet2(_pdfDocument, this))) {
              _context48.next = 13;
              break;
            }
            return _context48.abrupt("return");
          case 13:
            _context48.next = 15;
            return (_classPrivateFieldGet39 = _classPrivateFieldGet2(_scripting, this)) === null || _classPrivateFieldGet39 === void 0 ? void 0 : _classPrivateFieldGet39.dispatchEventInSandbox({
              id: "page",
              name: "PageClose",
              pageNumber: pageNumber
            });
          case 15:
          case "end":
            return _context48.stop();
        }
      }, _callee47, this);
    }));
    return _dispatchPageClose2.apply(this, arguments);
  }
  function _initScripting() {
    _classPrivateFieldSet2(_destroyCapability, this, Promise.withResolvers());
    if (_classPrivateFieldGet2(_scripting, this)) {
      throw new Error("#initScripting: Scripting already exists.");
    }
    return _classPrivateFieldGet2(_externalServices, this).createScripting();
  }
  function _destroyScripting() {
    return _destroyScripting2.apply(this, arguments);
  }
  function _destroyScripting2() {
    _destroyScripting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
      var _classPrivateFieldGet41, _classPrivateFieldGet42, _classPrivateFieldGet43;
      var _classPrivateFieldGet40;
      return _regeneratorRuntime().wrap(function _callee48$(_context49) {
        while (1) switch (_context49.prev = _context49.next) {
          case 0:
            if (_classPrivateFieldGet2(_scripting, this)) {
              _context49.next = 4;
              break;
            }
            _classPrivateFieldSet2(_pdfDocument, this, null);
            (_classPrivateFieldGet40 = _classPrivateFieldGet2(_destroyCapability, this)) === null || _classPrivateFieldGet40 === void 0 || _classPrivateFieldGet40.resolve();
            return _context49.abrupt("return");
          case 4:
            if (!_classPrivateFieldGet2(_closeCapability, this)) {
              _context49.next = 8;
              break;
            }
            _context49.next = 7;
            return Promise.race([_classPrivateFieldGet2(_closeCapability, this).promise, new Promise(function (resolve) {
              setTimeout(resolve, 1000);
            })])["catch"](function () {});
          case 7:
            _classPrivateFieldSet2(_closeCapability, this, null);
          case 8:
            _classPrivateFieldSet2(_pdfDocument, this, null);
            _context49.prev = 9;
            _context49.next = 12;
            return _classPrivateFieldGet2(_scripting, this).destroySandbox();
          case 12:
            _context49.next = 16;
            break;
          case 14:
            _context49.prev = 14;
            _context49.t0 = _context49["catch"](9);
          case 16:
            (_classPrivateFieldGet41 = _classPrivateFieldGet2(_willPrintCapability, this)) === null || _classPrivateFieldGet41 === void 0 || _classPrivateFieldGet41.reject(new Error("Scripting destroyed."));
            _classPrivateFieldSet2(_willPrintCapability, this, null);
            (_classPrivateFieldGet42 = _classPrivateFieldGet2(_eventAbortController4, this)) === null || _classPrivateFieldGet42 === void 0 || _classPrivateFieldGet42.abort();
            _classPrivateFieldSet2(_eventAbortController4, this, null);
            this._pageOpenPending.clear();
            this._visitedPages.clear();
            _classPrivateFieldSet2(_scripting, this, null);
            _classPrivateFieldSet2(_ready, this, false);
            (_classPrivateFieldGet43 = _classPrivateFieldGet2(_destroyCapability, this)) === null || _classPrivateFieldGet43 === void 0 || _classPrivateFieldGet43.resolve();
          case 25:
          case "end":
            return _context49.stop();
        }
      }, _callee48, this, [[9, 14]]);
    }));
    return _destroyScripting2.apply(this, arguments);
  }
  var PDFScriptingManagerComponents = /*#__PURE__*/function (_PDFScriptingManager2) {
    function PDFScriptingManagerComponents(options) {
      _classCallCheck(this, PDFScriptingManagerComponents);
      if (!options.externalServices) {
        window.addEventListener("updatefromsandbox", function (event) {
          options.eventBus.dispatch("updatefromsandbox", {
            source: window,
            detail: event.detail
          });
        });
      }
      options.externalServices || (options.externalServices = {
        createScripting: function createScripting() {
          return new GenericScripting(options.sandboxBundleSrc);
        }
      });
      options.docProperties || (options.docProperties = function (pdfDocument) {
        return docProperties(pdfDocument);
      });
      return _callSuper(this, PDFScriptingManagerComponents, [options]);
    }
    _inherits(PDFScriptingManagerComponents, _PDFScriptingManager2);
    return _createClass(PDFScriptingManagerComponents);
  }(PDFScriptingManager); // EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.every.js
  __webpack_require__(3215);

  var CLEANUP_TIMEOUT = 30000;
  var PDFRenderingQueue = /*#__PURE__*/function () {
    function PDFRenderingQueue() {
      var _this25 = this;
      _classCallCheck(this, PDFRenderingQueue);
      this.pdfViewer = null;
      this.pdfThumbnailViewer = null;
      this.onIdle = null;
      this.highestPriorityPage = null;
      this.idleTimeout = null;
      this.printing = false;
      this.isThumbnailViewEnabled = false;
      Object.defineProperty(this, "hasViewer", {
        value: function value() {
          return !!_this25.pdfViewer;
        }
      });
    }
    return _createClass(PDFRenderingQueue, [{
      key: "setViewer",
      value: function setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
      }
    }, {
      key: "setThumbnailViewer",
      value: function setThumbnailViewer(pdfThumbnailViewer) {
        this.pdfThumbnailViewer = pdfThumbnailViewer;
      }
    }, {
      key: "isHighestPriority",
      value: function isHighestPriority(view) {
        return this.highestPriorityPage === view.renderingId;
      }
    }, {
      key: "renderHighestPriority",
      value: function renderHighestPriority(currentlyVisiblePages) {
        var _this$pdfThumbnailVie;
        if (this.idleTimeout) {
          clearTimeout(this.idleTimeout);
          this.idleTimeout = null;
        }
        if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
          return;
        }
        if (this.isThumbnailViewEnabled && (_this$pdfThumbnailVie = this.pdfThumbnailViewer) !== null && _this$pdfThumbnailVie !== void 0 && _this$pdfThumbnailVie.forceRendering()) {
          return;
        }
        if (this.printing) {
          return;
        }
        if (this.onIdle) {
          this.idleTimeout = setTimeout(this.onIdle.bind(this), CLEANUP_TIMEOUT);
        }
      }
    }, {
      key: "getHighestPriority",
      value: function getHighestPriority(visible, views, scrolledDown) {
        var preRenderExtra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var visibleViews = visible.views,
          numVisible = visibleViews.length;
        if (numVisible === 0) {
          return null;
        }
        for (var i = 0; i < numVisible; i++) {
          var view = visibleViews[i].view;
          if (!this.isViewFinished(view)) {
            return view;
          }
        }
        var firstId = visible.first.id,
          lastId = visible.last.id;
        if (lastId - firstId + 1 > numVisible) {
          var visibleIds = visible.ids;
          for (var _i4 = 1, ii = lastId - firstId; _i4 < ii; _i4++) {
            var holeId = scrolledDown ? firstId + _i4 : lastId - _i4;
            if (visibleIds.has(holeId)) {
              continue;
            }
            var holeView = views[holeId - 1];
            if (!this.isViewFinished(holeView)) {
              return holeView;
            }
          }
        }
        var preRenderIndex = scrolledDown ? lastId : firstId - 2;
        var preRenderView = views[preRenderIndex];
        if (preRenderView && !this.isViewFinished(preRenderView)) {
          return preRenderView;
        }
        if (preRenderExtra) {
          preRenderIndex += scrolledDown ? 1 : -1;
          preRenderView = views[preRenderIndex];
          if (preRenderView && !this.isViewFinished(preRenderView)) {
            return preRenderView;
          }
        }
        return null;
      }
    }, {
      key: "isViewFinished",
      value: function isViewFinished(view) {
        return view.renderingState === _RenderingStates.FINISHED;
      }
    }, {
      key: "renderView",
      value: function renderView(view) {
        var _this26 = this;
        switch (view.renderingState) {
          case _RenderingStates.FINISHED:
            return false;
          case _RenderingStates.PAUSED:
            this.highestPriorityPage = view.renderingId;
            view.resume();
            break;
          case _RenderingStates.RUNNING:
            this.highestPriorityPage = view.renderingId;
            break;
          case _RenderingStates.INITIAL:
            this.highestPriorityPage = view.renderingId;
            view.draw()["finally"](function () {
              _this26.renderHighestPriority();
            })["catch"](function (reason) {
              if (reason instanceof RenderingCancelledException) {
                return;
              }
              console.error("renderView: \"".concat(reason, "\""));
            });
            break;
        }
        return true;
      }
    }]);
  }();

  var DEFAULT_CACHE_SIZE = 10;
  var PagesCountLimit = {
    FORCE_SCROLL_MODE_PAGE: 15000,
    FORCE_LAZY_PAGE_INIT: 7500,
    PAUSE_EAGER_PAGE_INIT: 250
  };
  function isValidAnnotationEditorMode(mode) {
    return Object.values(AnnotationEditorType).includes(mode) && mode !== AnnotationEditorType.DISABLE;
  }
  var _buf = /*#__PURE__*/new WeakMap();
  var _size = /*#__PURE__*/new WeakMap();
  var _PDFPageViewBuffer_brand = /*#__PURE__*/new WeakSet();
  var PDFPageViewBuffer = /*#__PURE__*/function () {
    function PDFPageViewBuffer(size) {
      _classCallCheck(this, PDFPageViewBuffer);
      _classPrivateMethodInitSpec(this, _PDFPageViewBuffer_brand);
      _classPrivateFieldInitSpec(this, _buf, new Set());
      _classPrivateFieldInitSpec(this, _size, 0);
      _classPrivateFieldSet2(_size, this, size);
    }
    return _createClass(PDFPageViewBuffer, [{
      key: "push",
      value: function push(view) {
        var buf = _classPrivateFieldGet2(_buf, this);
        if (buf.has(view)) {
          buf["delete"](view);
        }
        buf.add(view);
        if (buf.size > _classPrivateFieldGet2(_size, this)) {
          _assertClassBrand(_PDFPageViewBuffer_brand, this, _destroyFirstView).call(this);
        }
      }
    }, {
      key: "resize",
      value: function resize(newSize) {
        var idsToKeep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _classPrivateFieldSet2(_size, this, newSize);
        var buf = _classPrivateFieldGet2(_buf, this);
        if (idsToKeep) {
          var ii = buf.size;
          var i = 1;
          var _iterator21 = _createForOfIteratorHelper(buf),
            _step21;
          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var view = _step21.value;
              if (idsToKeep.has(view.id)) {
                buf["delete"](view);
                buf.add(view);
              }
              if (++i > ii) {
                break;
              }
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }
        while (buf.size > _classPrivateFieldGet2(_size, this)) {
          _assertClassBrand(_PDFPageViewBuffer_brand, this, _destroyFirstView).call(this);
        }
      }
    }, {
      key: "has",
      value: function has(view) {
        return _classPrivateFieldGet2(_buf, this).has(view);
      }
    }, {
      key: Symbol.iterator,
      value: function value() {
        return _classPrivateFieldGet2(_buf, this).keys();
      }
    }]);
  }();
  function _destroyFirstView() {
    var firstView = _classPrivateFieldGet2(_buf, this).keys().next().value;
    firstView === null || firstView === void 0 || firstView.destroy();
    _classPrivateFieldGet2(_buf, this)["delete"](firstView);
  }
  var _buffer = /*#__PURE__*/new WeakMap();
  var _altTextManager = /*#__PURE__*/new WeakMap();
  var _annotationEditorHighlightColors = /*#__PURE__*/new WeakMap();
  var _annotationEditorMode = /*#__PURE__*/new WeakMap();
  var _annotationEditorUIManager = /*#__PURE__*/new WeakMap();
  var _annotationMode2 = /*#__PURE__*/new WeakMap();
  var _containerTopLeft = /*#__PURE__*/new WeakMap();
  var _enableHighlightFloatingButton = /*#__PURE__*/new WeakMap();
  var _enablePermissions2 = /*#__PURE__*/new WeakMap();
  var _eventAbortController5 = /*#__PURE__*/new WeakMap();
  var _mlManager = /*#__PURE__*/new WeakMap();
  var _getAllTextInProgress = /*#__PURE__*/new WeakMap();
  var _hiddenCopyElement = /*#__PURE__*/new WeakMap();
  var _interruptCopyCondition = /*#__PURE__*/new WeakMap();
  var _previousContainerHeight = /*#__PURE__*/new WeakMap();
  var _resizeObserver = /*#__PURE__*/new WeakMap();
  var _scrollModePageState = /*#__PURE__*/new WeakMap();
  var _scaleTimeoutId = /*#__PURE__*/new WeakMap();
  var _textLayerMode2 = /*#__PURE__*/new WeakMap();
  var _PDFViewer_brand = /*#__PURE__*/new WeakSet();
  var _PDFViewer = /*#__PURE__*/function () {
    function _PDFViewer(_options2) {
      var _this$container,
        _this$viewer,
        _this28 = this,
        _options2$textLayerMo,
        _options2$annotationM,
        _options2$annotationE;
      _classCallCheck(this, _PDFViewer);
      _classPrivateMethodInitSpec(this, _PDFViewer_brand);
      _classPrivateFieldInitSpec(this, _buffer, null);
      _classPrivateFieldInitSpec(this, _altTextManager, null);
      _classPrivateFieldInitSpec(this, _annotationEditorHighlightColors, null);
      _classPrivateFieldInitSpec(this, _annotationEditorMode, AnnotationEditorType.NONE);
      _classPrivateFieldInitSpec(this, _annotationEditorUIManager, null);
      _classPrivateFieldInitSpec(this, _annotationMode2, AnnotationMode.ENABLE_FORMS);
      _classPrivateFieldInitSpec(this, _containerTopLeft, null);
      _classPrivateFieldInitSpec(this, _enableHighlightFloatingButton, false);
      _classPrivateFieldInitSpec(this, _enablePermissions2, false);
      _classPrivateFieldInitSpec(this, _eventAbortController5, null);
      _classPrivateFieldInitSpec(this, _mlManager, null);
      _classPrivateFieldInitSpec(this, _getAllTextInProgress, false);
      _classPrivateFieldInitSpec(this, _hiddenCopyElement, null);
      _classPrivateFieldInitSpec(this, _interruptCopyCondition, false);
      _classPrivateFieldInitSpec(this, _previousContainerHeight, 0);
      _classPrivateFieldInitSpec(this, _resizeObserver, new ResizeObserver(_assertClassBrand(_PDFViewer_brand, this, _resizeObserverCallback).bind(this)));
      _classPrivateFieldInitSpec(this, _scrollModePageState, null);
      _classPrivateFieldInitSpec(this, _scaleTimeoutId, null);
      _classPrivateFieldInitSpec(this, _textLayerMode2, TextLayerMode.ENABLE);
      var viewerVersion = "4.3.136";
      if (version !== viewerVersion) {
        throw new Error("The API version \"".concat(version, "\" does not match the Viewer version \"").concat(viewerVersion, "\"."));
      }
      this.container = _options2.container;
      this.viewer = _options2.viewer || _options2.container.firstElementChild;
      if (((_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.tagName) !== "DIV" || ((_this$viewer = this.viewer) === null || _this$viewer === void 0 ? void 0 : _this$viewer.tagName) !== "DIV") {
        throw new Error("Invalid `container` and/or `viewer` option.");
      }
      if (this.container.offsetParent && getComputedStyle(this.container).position !== "absolute") {
        throw new Error("The `container` must be absolutely positioned.");
      }
      _classPrivateFieldGet2(_resizeObserver, this).observe(this.container);
      this.eventBus = _options2.eventBus;
      this.linkService = _options2.linkService || new _SimpleLinkService();
      this.downloadManager = _options2.downloadManager || null;
      this.findController = _options2.findController || null;
      _classPrivateFieldSet2(_altTextManager, this, _options2.altTextManager || null);
      if (this.findController) {
        this.findController.onIsPageVisible = function (pageNumber) {
          return _this28._getVisiblePages().ids.has(pageNumber);
        };
      }
      this._scriptingManager = _options2.scriptingManager || null;
      _classPrivateFieldSet2(_textLayerMode2, this, (_options2$textLayerMo = _options2.textLayerMode) !== null && _options2$textLayerMo !== void 0 ? _options2$textLayerMo : TextLayerMode.ENABLE);
      _classPrivateFieldSet2(_annotationMode2, this, (_options2$annotationM = _options2.annotationMode) !== null && _options2$annotationM !== void 0 ? _options2$annotationM : AnnotationMode.ENABLE_FORMS);
      _classPrivateFieldSet2(_annotationEditorMode, this, (_options2$annotationE = _options2.annotationEditorMode) !== null && _options2$annotationE !== void 0 ? _options2$annotationE : AnnotationEditorType.NONE);
      _classPrivateFieldSet2(_annotationEditorHighlightColors, this, _options2.annotationEditorHighlightColors || null);
      _classPrivateFieldSet2(_enableHighlightFloatingButton, this, _options2.enableHighlightFloatingButton === true);
      this.imageResourcesPath = _options2.imageResourcesPath || "";
      this.enablePrintAutoRotate = _options2.enablePrintAutoRotate || false;
      this.removePageBorders = _options2.removePageBorders || false;
      this.maxCanvasPixels = _options2.maxCanvasPixels;
      this.l10n = _options2.l10n;
      this.l10n || (this.l10n = new genericl10n_GenericL10n());
      _classPrivateFieldSet2(_enablePermissions2, this, _options2.enablePermissions || false);
      this.pageColors = _options2.pageColors || null;
      _classPrivateFieldSet2(_mlManager, this, _options2.mlManager || null);
      this.defaultRenderingQueue = !_options2.renderingQueue;
      if (this.defaultRenderingQueue) {
        this.renderingQueue = new PDFRenderingQueue();
        this.renderingQueue.setViewer(this);
      } else {
        this.renderingQueue = _options2.renderingQueue;
      }
      this.scroll = watchScroll(this.container, this._scrollUpdate.bind(this));
      this.presentationModeState = PresentationModeState.UNKNOWN;
      this._resetView();
      if (this.removePageBorders) {
        this.viewer.classList.add("removePageBorders");
      }
      _assertClassBrand(_PDFViewer_brand, this, _updateContainerHeightCss).call(this);
      this.eventBus._on("thumbnailrendered", function (_ref34) {
        var pageNumber = _ref34.pageNumber,
          pdfPage = _ref34.pdfPage;
        var pageView = _this28._pages[pageNumber - 1];
        if (!_classPrivateFieldGet2(_buffer, _this28).has(pageView)) {
          pdfPage === null || pdfPage === void 0 || pdfPage.cleanup();
        }
      });
      if (!_options2.l10n) {
        this.l10n.translate(this.container);
      }
    }
    return _createClass(_PDFViewer, [{
      key: "pagesCount",
      get: function get() {
        return this._pages.length;
      }
    }, {
      key: "getPageView",
      value: function getPageView(index) {
        return this._pages[index];
      }
    }, {
      key: "getCachedPageViews",
      value: function getCachedPageViews() {
        return new Set(_classPrivateFieldGet2(_buffer, this));
      }
    }, {
      key: "pageViewsReady",
      get: function get() {
        return this._pages.every(function (pageView) {
          return pageView === null || pageView === void 0 ? void 0 : pageView.pdfPage;
        });
      }
    }, {
      key: "renderForms",
      get: function get() {
        return _classPrivateFieldGet2(_annotationMode2, this) === AnnotationMode.ENABLE_FORMS;
      }
    }, {
      key: "enableScripting",
      get: function get() {
        return !!this._scriptingManager;
      }
    }, {
      key: "currentPageNumber",
      get: function get() {
        return this._currentPageNumber;
      },
      set: function set(val) {
        if (!Number.isInteger(val)) {
          throw new Error("Invalid page number.");
        }
        if (!this.pdfDocument) {
          return;
        }
        if (!this._setCurrentPageNumber(val, true)) {
          console.error("currentPageNumber: \"".concat(val, "\" is not a valid page."));
        }
      }
    }, {
      key: "_setCurrentPageNumber",
      value: function _setCurrentPageNumber(val) {
        var _this$_pageLabels, _this$_pageLabels2;
        var resetCurrentPageView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this._currentPageNumber === val) {
          if (resetCurrentPageView) {
            _assertClassBrand(_PDFViewer_brand, this, _resetCurrentPageView).call(this);
          }
          return true;
        }
        if (!(0 < val && val <= this.pagesCount)) {
          return false;
        }
        var previous = this._currentPageNumber;
        this._currentPageNumber = val;
        this.eventBus.dispatch("pagechanging", {
          source: this,
          pageNumber: val,
          pageLabel: (_this$_pageLabels = (_this$_pageLabels2 = this._pageLabels) === null || _this$_pageLabels2 === void 0 ? void 0 : _this$_pageLabels2[val - 1]) !== null && _this$_pageLabels !== void 0 ? _this$_pageLabels : null,
          previous: previous
        });
        if (resetCurrentPageView) {
          _assertClassBrand(_PDFViewer_brand, this, _resetCurrentPageView).call(this);
        }
        return true;
      }
    }, {
      key: "currentPageLabel",
      get: function get() {
        var _this$_pageLabels3, _this$_pageLabels4;
        return (_this$_pageLabels3 = (_this$_pageLabels4 = this._pageLabels) === null || _this$_pageLabels4 === void 0 ? void 0 : _this$_pageLabels4[this._currentPageNumber - 1]) !== null && _this$_pageLabels3 !== void 0 ? _this$_pageLabels3 : null;
      },
      set: function set(val) {
        if (!this.pdfDocument) {
          return;
        }
        var page = val | 0;
        if (this._pageLabels) {
          var i = this._pageLabels.indexOf(val);
          if (i >= 0) {
            page = i + 1;
          }
        }
        if (!this._setCurrentPageNumber(page, true)) {
          console.error("currentPageLabel: \"".concat(val, "\" is not a valid page."));
        }
      }
    }, {
      key: "currentScale",
      get: function get() {
        return this._currentScale !== UNKNOWN_SCALE ? this._currentScale : DEFAULT_SCALE;
      },
      set: function set(val) {
        if (isNaN(val)) {
          throw new Error("Invalid numeric scale.");
        }
        if (!this.pdfDocument) {
          return;
        }
        _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, val, {
          noScroll: false
        });
      }
    }, {
      key: "currentScaleValue",
      get: function get() {
        return this._currentScaleValue;
      },
      set: function set(val) {
        if (!this.pdfDocument) {
          return;
        }
        _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, val, {
          noScroll: false
        });
      }
    }, {
      key: "pagesRotation",
      get: function get() {
        return this._pagesRotation;
      },
      set: function set(rotation) {
        if (!isValidRotation(rotation)) {
          throw new Error("Invalid pages rotation angle.");
        }
        if (!this.pdfDocument) {
          return;
        }
        rotation %= 360;
        if (rotation < 0) {
          rotation += 360;
        }
        if (this._pagesRotation === rotation) {
          return;
        }
        this._pagesRotation = rotation;
        var pageNumber = this._currentPageNumber;
        this.refresh(true, {
          rotation: rotation
        });
        if (this._currentScaleValue) {
          _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, this._currentScaleValue, {
            noScroll: true
          });
        }
        this.eventBus.dispatch("rotationchanging", {
          source: this,
          pagesRotation: rotation,
          pageNumber: pageNumber
        });
        if (this.defaultRenderingQueue) {
          this.update();
        }
      }
    }, {
      key: "firstPagePromise",
      get: function get() {
        return this.pdfDocument ? this._firstPageCapability.promise : null;
      }
    }, {
      key: "onePageRendered",
      get: function get() {
        return this.pdfDocument ? this._onePageRenderedCapability.promise : null;
      }
    }, {
      key: "pagesPromise",
      get: function get() {
        return this.pdfDocument ? this._pagesCapability.promise : null;
      }
    }, {
      key: "_layerProperties",
      get: function get() {
        var self = this;
        return shadow(this, "_layerProperties", {
          get annotationEditorUIManager() {
            return _classPrivateFieldGet2(_annotationEditorUIManager, self);
          },
          get annotationStorage() {
            var _self$pdfDocument;
            return (_self$pdfDocument = self.pdfDocument) === null || _self$pdfDocument === void 0 ? void 0 : _self$pdfDocument.annotationStorage;
          },
          get downloadManager() {
            return self.downloadManager;
          },
          get enableScripting() {
            return !!self._scriptingManager;
          },
          get fieldObjectsPromise() {
            var _self$pdfDocument2;
            return (_self$pdfDocument2 = self.pdfDocument) === null || _self$pdfDocument2 === void 0 ? void 0 : _self$pdfDocument2.getFieldObjects();
          },
          get findController() {
            return self.findController;
          },
          get hasJSActionsPromise() {
            var _self$pdfDocument3;
            return (_self$pdfDocument3 = self.pdfDocument) === null || _self$pdfDocument3 === void 0 ? void 0 : _self$pdfDocument3.hasJSActions();
          },
          get linkService() {
            return self.linkService;
          }
        });
      }
    }, {
      key: "getAllText",
      value: function () {
        var _getAllText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
          var texts, buffer, pageNum, pagesCount, page, _yield$page$getTextCo, items, _iterator22, _step22, item;
          return _regeneratorRuntime().wrap(function _callee26$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                texts = [];
                buffer = [];
                pageNum = 1, pagesCount = this.pdfDocument.numPages;
              case 3:
                if (!(pageNum <= pagesCount)) {
                  _context26.next = 20;
                  break;
                }
                if (!_classPrivateFieldGet2(_interruptCopyCondition, this)) {
                  _context26.next = 6;
                  break;
                }
                return _context26.abrupt("return", null);
              case 6:
                buffer.length = 0;
                _context26.next = 9;
                return this.pdfDocument.getPage(pageNum);
              case 9:
                page = _context26.sent;
                _context26.next = 12;
                return page.getTextContent();
              case 12:
                _yield$page$getTextCo = _context26.sent;
                items = _yield$page$getTextCo.items;
                _iterator22 = _createForOfIteratorHelper(items);
                try {
                  for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                    item = _step22.value;
                    if (item.str) {
                      buffer.push(item.str);
                    }
                    if (item.hasEOL) {
                      buffer.push("\n");
                    }
                  }
                } catch (err) {
                  _iterator22.e(err);
                } finally {
                  _iterator22.f();
                }
                texts.push(removeNullCharacters(buffer.join("")));
              case 17:
                ++pageNum;
                _context26.next = 3;
                break;
              case 20:
                return _context26.abrupt("return", texts.join("\n"));
              case 21:
              case "end":
                return _context26.stop();
            }
          }, _callee26, this);
        }));
        function getAllText() {
          return _getAllText.apply(this, arguments);
        }
        return getAllText;
      }()
    }, {
      key: "setDocument",
      value: function setDocument(pdfDocument) {
        var _this29 = this;
        if (this.pdfDocument) {
          var _this$findController, _this$_scriptingManag;
          this.eventBus.dispatch("pagesdestroy", {
            source: this
          });
          this._cancelRendering();
          this._resetView();
          (_this$findController = this.findController) === null || _this$findController === void 0 || _this$findController.setDocument(null);
          (_this$_scriptingManag = this._scriptingManager) === null || _this$_scriptingManag === void 0 || _this$_scriptingManag.setDocument(null);
          if (_classPrivateFieldGet2(_annotationEditorUIManager, this)) {
            _classPrivateFieldGet2(_annotationEditorUIManager, this).destroy();
            _classPrivateFieldSet2(_annotationEditorUIManager, this, null);
          }
        }
        this.pdfDocument = pdfDocument;
        if (!pdfDocument) {
          return;
        }
        var pagesCount = pdfDocument.numPages;
        var firstPagePromise = pdfDocument.getPage(1);
        var optionalContentConfigPromise = pdfDocument.getOptionalContentConfig({
          intent: "display"
        });
        var permissionsPromise = _classPrivateFieldGet2(_enablePermissions2, this) ? pdfDocument.getPermissions() : Promise.resolve();
        var eventBus = this.eventBus,
          pageColors = this.pageColors,
          viewer = this.viewer;
        _classPrivateFieldSet2(_eventAbortController5, this, new AbortController());
        var _classPrivateFieldGet26 = _classPrivateFieldGet2(_eventAbortController5, this),
          signal = _classPrivateFieldGet26.signal;
        if (pagesCount > PagesCountLimit.FORCE_SCROLL_MODE_PAGE) {
          console.warn("Forcing PAGE-scrolling for performance reasons, given the length of the document.");
          var mode = this._scrollMode = _ScrollMode.PAGE;
          eventBus.dispatch("scrollmodechanged", {
            source: this,
            mode: mode
          });
        }
        this._pagesCapability.promise.then(function () {
          eventBus.dispatch("pagesloaded", {
            source: _this29,
            pagesCount: pagesCount
          });
        }, function () {});
        var onBeforeDraw = function onBeforeDraw(evt) {
          var pageView = _this29._pages[evt.pageNumber - 1];
          if (!pageView) {
            return;
          }
          _classPrivateFieldGet2(_buffer, _this29).push(pageView);
        };
        eventBus._on("pagerender", onBeforeDraw, {
          signal: signal
        });
        var onAfterDraw = function onAfterDraw(evt) {
          if (evt.cssTransform) {
            return;
          }
          _this29._onePageRenderedCapability.resolve({
            timestamp: evt.timestamp
          });
          eventBus._off("pagerendered", onAfterDraw);
        };
        eventBus._on("pagerendered", onAfterDraw, {
          signal: signal
        });
        Promise.all([firstPagePromise, permissionsPromise]).then(function (_ref35) {
          var _this29$_pages$;
          var _ref36 = _slicedToArray(_ref35, 2),
            firstPdfPage = _ref36[0],
            permissions = _ref36[1];
          if (pdfDocument !== _this29.pdfDocument) {
            return;
          }
          _this29._firstPageCapability.resolve(firstPdfPage);
          _this29._optionalContentConfigPromise = optionalContentConfigPromise;
          var _assertClassBrand$cal2 = _assertClassBrand(_PDFViewer_brand, _this29, _initializePermissions).call(_this29, permissions),
            annotationEditorMode = _assertClassBrand$cal2.annotationEditorMode,
            annotationMode = _assertClassBrand$cal2.annotationMode,
            textLayerMode = _assertClassBrand$cal2.textLayerMode;
          if (textLayerMode !== TextLayerMode.DISABLE) {
            var element = _classPrivateFieldSet2(_hiddenCopyElement, _this29, document.createElement("div"));
            element.id = "hiddenCopyElement";
            viewer.before(element);
          }
          if (annotationEditorMode !== AnnotationEditorType.DISABLE) {
            var _mode = annotationEditorMode;
            if (pdfDocument.isPureXfa) {
              console.warn("Warning: XFA-editing is not implemented.");
            } else if (isValidAnnotationEditorMode(_mode)) {
              _classPrivateFieldSet2(_annotationEditorUIManager, _this29, new AnnotationEditorUIManager(_this29.container, viewer, _classPrivateFieldGet2(_altTextManager, _this29), eventBus, pdfDocument, pageColors, _classPrivateFieldGet2(_annotationEditorHighlightColors, _this29), _classPrivateFieldGet2(_enableHighlightFloatingButton, _this29), _classPrivateFieldGet2(_mlManager, _this29)));
              eventBus.dispatch("annotationeditoruimanager", {
                source: _this29,
                uiManager: _classPrivateFieldGet2(_annotationEditorUIManager, _this29)
              });
              if (_mode !== AnnotationEditorType.NONE) {
                _classPrivateFieldGet2(_annotationEditorUIManager, _this29).updateMode(_mode);
              }
            } else {
              console.error("Invalid AnnotationEditor mode: ".concat(_mode));
            }
          }
          var viewerElement = _this29._scrollMode === _ScrollMode.PAGE ? null : viewer;
          var scale = _this29.currentScale;
          var viewport = firstPdfPage.getViewport({
            scale: scale * PixelsPerInch.PDF_TO_CSS_UNITS
          });
          viewer.style.setProperty("--scale-factor", viewport.scale);
          if ((pageColors === null || pageColors === void 0 ? void 0 : pageColors.foreground) === "CanvasText" || (pageColors === null || pageColors === void 0 ? void 0 : pageColors.background) === "Canvas") {
            viewer.style.setProperty("--hcm-highlight-filter", pdfDocument.filterFactory.addHighlightHCMFilter("highlight", "CanvasText", "Canvas", "HighlightText", "Highlight"));
            viewer.style.setProperty("--hcm-highlight-selected-filter", pdfDocument.filterFactory.addHighlightHCMFilter("highlight_selected", "CanvasText", "Canvas", "HighlightText", "ButtonText"));
          }
          for (var pageNum = 1; pageNum <= pagesCount; ++pageNum) {
            var pageView = new _PDFPageView({
              container: viewerElement,
              eventBus: eventBus,
              id: pageNum,
              scale: scale,
              defaultViewport: viewport.clone(),
              optionalContentConfigPromise: optionalContentConfigPromise,
              renderingQueue: _this29.renderingQueue,
              textLayerMode: textLayerMode,
              annotationMode: annotationMode,
              imageResourcesPath: _this29.imageResourcesPath,
              maxCanvasPixels: _this29.maxCanvasPixels,
              pageColors: pageColors,
              l10n: _this29.l10n,
              layerProperties: _this29._layerProperties
            });
            _this29._pages.push(pageView);
          }
          (_this29$_pages$ = _this29._pages[0]) === null || _this29$_pages$ === void 0 || _this29$_pages$.setPdfPage(firstPdfPage);
          if (_this29._scrollMode === _ScrollMode.PAGE) {
            _assertClassBrand(_PDFViewer_brand, _this29, _ensurePageViewVisible).call(_this29);
          } else if (_this29._spreadMode !== _SpreadMode.NONE) {
            _this29._updateSpreadMode();
          }
          _assertClassBrand(_PDFViewer_brand, _this29, _onePageRenderedOrForceFetch).call(_this29, signal).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
            var _this29$findControlle, _this29$_scriptingMan;
            var getPagesLeft, _loop, _pageNum;
            return _regeneratorRuntime().wrap(function _callee27$(_context28) {
              while (1) switch (_context28.prev = _context28.next) {
                case 0:
                  if (!(pdfDocument !== _this29.pdfDocument)) {
                    _context28.next = 2;
                    break;
                  }
                  return _context28.abrupt("return");
                case 2:
                  (_this29$findControlle = _this29.findController) === null || _this29$findControlle === void 0 || _this29$findControlle.setDocument(pdfDocument);
                  (_this29$_scriptingMan = _this29._scriptingManager) === null || _this29$_scriptingMan === void 0 || _this29$_scriptingMan.setDocument(pdfDocument);
                  if (_classPrivateFieldGet2(_hiddenCopyElement, _this29)) {
                    document.addEventListener("copy", _assertClassBrand(_PDFViewer_brand, _this29, _copyCallback).bind(_this29, textLayerMode), {
                      signal: signal
                    });
                  }
                  if (_classPrivateFieldGet2(_annotationEditorUIManager, _this29)) {
                    eventBus.dispatch("annotationeditormodechanged", {
                      source: _this29,
                      mode: _classPrivateFieldGet2(_annotationEditorMode, _this29)
                    });
                  }
                  if (!(pdfDocument.loadingParams.disableAutoFetch || pagesCount > PagesCountLimit.FORCE_LAZY_PAGE_INIT)) {
                    _context28.next = 9;
                    break;
                  }
                  _this29._pagesCapability.resolve();
                  return _context28.abrupt("return");
                case 9:
                  getPagesLeft = pagesCount - 1;
                  if (!(getPagesLeft <= 0)) {
                    _context28.next = 13;
                    break;
                  }
                  _this29._pagesCapability.resolve();
                  return _context28.abrupt("return");
                case 13:
                  _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(_pageNum) {
                    var promise;
                    return _regeneratorRuntime().wrap(function _loop$(_context27) {
                      while (1) switch (_context27.prev = _context27.next) {
                        case 0:
                          promise = pdfDocument.getPage(_pageNum).then(function (pdfPage) {
                            var pageView = _this29._pages[_pageNum - 1];
                            if (!pageView.pdfPage) {
                              pageView.setPdfPage(pdfPage);
                            }
                            if (--getPagesLeft === 0) {
                              _this29._pagesCapability.resolve();
                            }
                          }, function (reason) {
                            console.error("Unable to get page ".concat(_pageNum, " to initialize viewer"), reason);
                            if (--getPagesLeft === 0) {
                              _this29._pagesCapability.resolve();
                            }
                          });
                          if (!(_pageNum % PagesCountLimit.PAUSE_EAGER_PAGE_INIT === 0)) {
                            _context27.next = 4;
                            break;
                          }
                          _context27.next = 4;
                          return promise;
                        case 4:
                        case "end":
                          return _context27.stop();
                      }
                    }, _loop);
                  });
                  _pageNum = 2;
                case 15:
                  if (!(_pageNum <= pagesCount)) {
                    _context28.next = 20;
                    break;
                  }
                  return _context28.delegateYield(_loop(_pageNum), "t0", 17);
                case 17:
                  ++_pageNum;
                  _context28.next = 15;
                  break;
                case 20:
                case "end":
                  return _context28.stop();
              }
            }, _callee27);
          })));
          eventBus.dispatch("pagesinit", {
            source: _this29
          });
          pdfDocument.getMetadata().then(function (_ref38) {
            var info = _ref38.info;
            if (pdfDocument !== _this29.pdfDocument) {
              return;
            }
            if (info.Language) {
              viewer.lang = info.Language;
            }
          });
          if (_this29.defaultRenderingQueue) {
            _this29.update();
          }
        })["catch"](function (reason) {
          console.error("Unable to initialize viewer", reason);
          _this29._pagesCapability.reject(reason);
        });
      }
    }, {
      key: "setPageLabels",
      value: function setPageLabels(labels) {
        if (!this.pdfDocument) {
          return;
        }
        if (!labels) {
          this._pageLabels = null;
        } else if (!(Array.isArray(labels) && this.pdfDocument.numPages === labels.length)) {
          this._pageLabels = null;
          console.error("setPageLabels: Invalid page labels.");
        } else {
          this._pageLabels = labels;
        }
        for (var i = 0, ii = this._pages.length; i < ii; i++) {
          var _this$_pageLabels$i, _this$_pageLabels5;
          this._pages[i].setPageLabel((_this$_pageLabels$i = (_this$_pageLabels5 = this._pageLabels) === null || _this$_pageLabels5 === void 0 ? void 0 : _this$_pageLabels5[i]) !== null && _this$_pageLabels$i !== void 0 ? _this$_pageLabels$i : null);
        }
      }
    }, {
      key: "_resetView",
      value: function _resetView() {
        var _classPrivateFieldGet27, _classPrivateFieldGet28;
        this._pages = [];
        this._currentPageNumber = 1;
        this._currentScale = UNKNOWN_SCALE;
        this._currentScaleValue = null;
        this._pageLabels = null;
        _classPrivateFieldSet2(_buffer, this, new PDFPageViewBuffer(DEFAULT_CACHE_SIZE));
        this._location = null;
        this._pagesRotation = 0;
        this._optionalContentConfigPromise = null;
        this._firstPageCapability = Promise.withResolvers();
        this._onePageRenderedCapability = Promise.withResolvers();
        this._pagesCapability = Promise.withResolvers();
        this._scrollMode = _ScrollMode.VERTICAL;
        this._previousScrollMode = _ScrollMode.UNKNOWN;
        this._spreadMode = _SpreadMode.NONE;
        _classPrivateFieldSet2(_scrollModePageState, this, {
          previousPageNumber: 1,
          scrollDown: true,
          pages: []
        });
        (_classPrivateFieldGet27 = _classPrivateFieldGet2(_eventAbortController5, this)) === null || _classPrivateFieldGet27 === void 0 || _classPrivateFieldGet27.abort();
        _classPrivateFieldSet2(_eventAbortController5, this, null);
        this.viewer.textContent = "";
        this._updateScrollMode();
        this.viewer.removeAttribute("lang");
        (_classPrivateFieldGet28 = _classPrivateFieldGet2(_hiddenCopyElement, this)) === null || _classPrivateFieldGet28 === void 0 || _classPrivateFieldGet28.remove();
        _classPrivateFieldSet2(_hiddenCopyElement, this, null);
      }
    }, {
      key: "_scrollUpdate",
      value: function _scrollUpdate() {
        if (this.pagesCount === 0) {
          return;
        }
        this.update();
      }
    }, {
      key: "pageLabelToPageNumber",
      value: function pageLabelToPageNumber(label) {
        if (!this._pageLabels) {
          return null;
        }
        var i = this._pageLabels.indexOf(label);
        if (i < 0) {
          return null;
        }
        return i + 1;
      }
    }, {
      key: "scrollPageIntoView",
      value: function scrollPageIntoView(_ref39) {
        var pageNumber = _ref39.pageNumber,
          _ref39$destArray = _ref39.destArray,
          destArray = _ref39$destArray === void 0 ? null : _ref39$destArray,
          _ref39$allowNegativeO = _ref39.allowNegativeOffset,
          allowNegativeOffset = _ref39$allowNegativeO === void 0 ? false : _ref39$allowNegativeO,
          _ref39$ignoreDestinat = _ref39.ignoreDestinationZoom,
          ignoreDestinationZoom = _ref39$ignoreDestinat === void 0 ? false : _ref39$ignoreDestinat;
        if (!this.pdfDocument) {
          return;
        }
        var pageView = Number.isInteger(pageNumber) && this._pages[pageNumber - 1];
        if (!pageView) {
          console.error("scrollPageIntoView: \"".concat(pageNumber, "\" is not a valid pageNumber parameter."));
          return;
        }
        if (this.isInPresentationMode || !destArray) {
          this._setCurrentPageNumber(pageNumber, true);
          return;
        }
        var x = 0,
          y = 0;
        var width = 0,
          height = 0,
          widthScale,
          heightScale;
        var changeOrientation = pageView.rotation % 180 !== 0;
        var pageWidth = (changeOrientation ? pageView.height : pageView.width) / pageView.scale / PixelsPerInch.PDF_TO_CSS_UNITS;
        var pageHeight = (changeOrientation ? pageView.width : pageView.height) / pageView.scale / PixelsPerInch.PDF_TO_CSS_UNITS;
        var scale = 0;
        switch (destArray[1].name) {
          case "XYZ":
            x = destArray[2];
            y = destArray[3];
            scale = destArray[4];
            x = x !== null ? x : 0;
            y = y !== null ? y : pageHeight;
            break;
          case "Fit":
          case "FitB":
            scale = "page-fit";
            break;
          case "FitH":
          case "FitBH":
            y = destArray[2];
            scale = "page-width";
            if (y === null && this._location) {
              x = this._location.left;
              y = this._location.top;
            } else if (typeof y !== "number" || y < 0) {
              y = pageHeight;
            }
            break;
          case "FitV":
          case "FitBV":
            x = destArray[2];
            width = pageWidth;
            height = pageHeight;
            scale = "page-height";
            break;
          case "FitR":
            x = destArray[2];
            y = destArray[3];
            width = destArray[4] - x;
            height = destArray[5] - y;
            var hPadding = SCROLLBAR_PADDING,
              vPadding = VERTICAL_PADDING;
            if (this.removePageBorders) {
              hPadding = vPadding = 0;
            }
            widthScale = (this.container.clientWidth - hPadding) / width / PixelsPerInch.PDF_TO_CSS_UNITS;
            heightScale = (this.container.clientHeight - vPadding) / height / PixelsPerInch.PDF_TO_CSS_UNITS;
            scale = Math.min(Math.abs(widthScale), Math.abs(heightScale));
            break;
          default:
            console.error("scrollPageIntoView: \"".concat(destArray[1].name, "\" is not a valid destination type."));
            return;
        }
        if (!ignoreDestinationZoom) {
          if (scale && scale !== this._currentScale) {
            this.currentScaleValue = scale;
          } else if (this._currentScale === UNKNOWN_SCALE) {
            this.currentScaleValue = DEFAULT_SCALE_VALUE;
          }
        }
        if (scale === "page-fit" && !destArray[4]) {
          _assertClassBrand(_PDFViewer_brand, this, _scrollIntoView).call(this, pageView);
          return;
        }
        var boundingRect = [pageView.viewport.convertToViewportPoint(x, y), pageView.viewport.convertToViewportPoint(x + width, y + height)];
        var left = Math.min(boundingRect[0][0], boundingRect[1][0]);
        var top = Math.min(boundingRect[0][1], boundingRect[1][1]);
        if (!allowNegativeOffset) {
          left = Math.max(left, 0);
          top = Math.max(top, 0);
        }
        _assertClassBrand(_PDFViewer_brand, this, _scrollIntoView).call(this, pageView, {
          left: left,
          top: top
        });
      }
    }, {
      key: "_updateLocation",
      value: function _updateLocation(firstPage) {
        var currentScale = this._currentScale;
        var currentScaleValue = this._currentScaleValue;
        var normalizedScaleValue = parseFloat(currentScaleValue) === currentScale ? Math.round(currentScale * 10000) / 100 : currentScaleValue;
        var pageNumber = firstPage.id;
        var currentPageView = this._pages[pageNumber - 1];
        var container = this.container;
        var topLeft = currentPageView.getPagePoint(container.scrollLeft - firstPage.x, container.scrollTop - firstPage.y);
        var intLeft = Math.round(topLeft[0]);
        var intTop = Math.round(topLeft[1]);
        var pdfOpenParams = "#page=".concat(pageNumber);
        if (!this.isInPresentationMode) {
          pdfOpenParams += "&zoom=".concat(normalizedScaleValue, ",").concat(intLeft, ",").concat(intTop);
        }
        this._location = {
          pageNumber: pageNumber,
          scale: normalizedScaleValue,
          top: intTop,
          left: intLeft,
          rotation: this._pagesRotation,
          pdfOpenParams: pdfOpenParams
        };
      }
    }, {
      key: "update",
      value: function update() {
        var visible = this._getVisiblePages();
        var visiblePages = visible.views,
          numVisiblePages = visiblePages.length;
        if (numVisiblePages === 0) {
          return;
        }
        var newCacheSize = Math.max(DEFAULT_CACHE_SIZE, 2 * numVisiblePages + 1);
        _classPrivateFieldGet2(_buffer, this).resize(newCacheSize, visible.ids);
        this.renderingQueue.renderHighestPriority(visible);
        var isSimpleLayout = this._spreadMode === _SpreadMode.NONE && (this._scrollMode === _ScrollMode.PAGE || this._scrollMode === _ScrollMode.VERTICAL);
        var currentId = this._currentPageNumber;
        var stillFullyVisible = false;
        var _iterator23 = _createForOfIteratorHelper(visiblePages),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var page = _step23.value;
            if (page.percent < 100) {
              break;
            }
            if (page.id === currentId && isSimpleLayout) {
              stillFullyVisible = true;
              break;
            }
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
        this._setCurrentPageNumber(stillFullyVisible ? currentId : visiblePages[0].id);
        this._updateLocation(visible.first);
        this.eventBus.dispatch("updateviewarea", {
          source: this,
          location: this._location
        });
      }
    }, {
      key: "containsElement",
      value: function containsElement(element) {
        return this.container.contains(element);
      }
    }, {
      key: "focus",
      value: function focus() {
        this.container.focus();
      }
    }, {
      key: "_isContainerRtl",
      get: function get() {
        return getComputedStyle(this.container).direction === "rtl";
      }
    }, {
      key: "isInPresentationMode",
      get: function get() {
        return this.presentationModeState === PresentationModeState.FULLSCREEN;
      }
    }, {
      key: "isChangingPresentationMode",
      get: function get() {
        return this.presentationModeState === PresentationModeState.CHANGING;
      }
    }, {
      key: "isHorizontalScrollbarEnabled",
      get: function get() {
        return this.isInPresentationMode ? false : this.container.scrollWidth > this.container.clientWidth;
      }
    }, {
      key: "isVerticalScrollbarEnabled",
      get: function get() {
        return this.isInPresentationMode ? false : this.container.scrollHeight > this.container.clientHeight;
      }
    }, {
      key: "_getVisiblePages",
      value: function _getVisiblePages() {
        var views = this._scrollMode === _ScrollMode.PAGE ? _classPrivateFieldGet2(_scrollModePageState, this).pages : this._pages,
          horizontal = this._scrollMode === _ScrollMode.HORIZONTAL,
          rtl = horizontal && this._isContainerRtl;
        return getVisibleElements({
          scrollEl: this.container,
          views: views,
          sortByVisibility: true,
          horizontal: horizontal,
          rtl: rtl
        });
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        var _iterator24 = _createForOfIteratorHelper(this._pages),
          _step24;
        try {
          for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
            var pageView = _step24.value;
            if (pageView.renderingState !== _RenderingStates.FINISHED) {
              pageView.reset();
            }
          }
        } catch (err) {
          _iterator24.e(err);
        } finally {
          _iterator24.f();
        }
      }
    }, {
      key: "_cancelRendering",
      value: function _cancelRendering() {
        var _iterator25 = _createForOfIteratorHelper(this._pages),
          _step25;
        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var pageView = _step25.value;
            pageView.cancelRendering();
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }
      }
    }, {
      key: "forceRendering",
      value: function forceRendering(currentlyVisiblePages) {
        var _this30 = this;
        var visiblePages = currentlyVisiblePages || this._getVisiblePages();
        var scrollAhead = _assertClassBrand(_PDFViewer_brand, this, _getScrollAhead).call(this, visiblePages);
        var preRenderExtra = this._spreadMode !== _SpreadMode.NONE && this._scrollMode !== _ScrollMode.HORIZONTAL;
        var pageView = this.renderingQueue.getHighestPriority(visiblePages, this._pages, scrollAhead, preRenderExtra);
        if (pageView) {
          _assertClassBrand(_PDFViewer_brand, this, _ensurePdfPageLoaded).call(this, pageView).then(function () {
            _this30.renderingQueue.renderView(pageView);
          });
          return true;
        }
        return false;
      }
    }, {
      key: "hasEqualPageSizes",
      get: function get() {
        var firstPageView = this._pages[0];
        for (var i = 1, ii = this._pages.length; i < ii; ++i) {
          var pageView = this._pages[i];
          if (pageView.width !== firstPageView.width || pageView.height !== firstPageView.height) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "getPagesOverview",
      value: function getPagesOverview() {
        var _this31 = this;
        var initialOrientation;
        return this._pages.map(function (pageView) {
          var viewport = pageView.pdfPage.getViewport({
            scale: 1
          });
          var orientation = isPortraitOrientation(viewport);
          if (initialOrientation === undefined) {
            initialOrientation = orientation;
          } else if (_this31.enablePrintAutoRotate && orientation !== initialOrientation) {
            return {
              width: viewport.height,
              height: viewport.width,
              rotation: (viewport.rotation - 90) % 360
            };
          }
          return {
            width: viewport.width,
            height: viewport.height,
            rotation: viewport.rotation
          };
        });
      }
    }, {
      key: "optionalContentConfigPromise",
      get: function get() {
        if (!this.pdfDocument) {
          return Promise.resolve(null);
        }
        if (!this._optionalContentConfigPromise) {
          console.error("optionalContentConfigPromise: Not initialized yet.");
          return this.pdfDocument.getOptionalContentConfig({
            intent: "display"
          });
        }
        return this._optionalContentConfigPromise;
      },
      set: function set(promise) {
        if (!(promise instanceof Promise)) {
          throw new Error("Invalid optionalContentConfigPromise: ".concat(promise));
        }
        if (!this.pdfDocument) {
          return;
        }
        if (!this._optionalContentConfigPromise) {
          return;
        }
        this._optionalContentConfigPromise = promise;
        this.refresh(false, {
          optionalContentConfigPromise: promise
        });
        this.eventBus.dispatch("optionalcontentconfigchanged", {
          source: this,
          promise: promise
        });
      }
    }, {
      key: "scrollMode",
      get: function get() {
        return this._scrollMode;
      },
      set: function set(mode) {
        if (this._scrollMode === mode) {
          return;
        }
        if (!isValidScrollMode(mode)) {
          throw new Error("Invalid scroll mode: ".concat(mode));
        }
        if (this.pagesCount > PagesCountLimit.FORCE_SCROLL_MODE_PAGE) {
          return;
        }
        this._previousScrollMode = this._scrollMode;
        this._scrollMode = mode;
        this.eventBus.dispatch("scrollmodechanged", {
          source: this,
          mode: mode
        });
        this._updateScrollMode(this._currentPageNumber);
      }
    }, {
      key: "_updateScrollMode",
      value: function _updateScrollMode() {
        var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var scrollMode = this._scrollMode,
          viewer = this.viewer;
        viewer.classList.toggle("scrollHorizontal", scrollMode === _ScrollMode.HORIZONTAL);
        viewer.classList.toggle("scrollWrapped", scrollMode === _ScrollMode.WRAPPED);
        if (!this.pdfDocument || !pageNumber) {
          return;
        }
        if (scrollMode === _ScrollMode.PAGE) {
          _assertClassBrand(_PDFViewer_brand, this, _ensurePageViewVisible).call(this);
        } else if (this._previousScrollMode === _ScrollMode.PAGE) {
          this._updateSpreadMode();
        }
        if (this._currentScaleValue && isNaN(this._currentScaleValue)) {
          _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, this._currentScaleValue, {
            noScroll: true
          });
        }
        this._setCurrentPageNumber(pageNumber, true);
        this.update();
      }
    }, {
      key: "spreadMode",
      get: function get() {
        return this._spreadMode;
      },
      set: function set(mode) {
        if (this._spreadMode === mode) {
          return;
        }
        if (!isValidSpreadMode(mode)) {
          throw new Error("Invalid spread mode: ".concat(mode));
        }
        this._spreadMode = mode;
        this.eventBus.dispatch("spreadmodechanged", {
          source: this,
          mode: mode
        });
        this._updateSpreadMode(this._currentPageNumber);
      }
    }, {
      key: "_updateSpreadMode",
      value: function _updateSpreadMode() {
        var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (!this.pdfDocument) {
          return;
        }
        var viewer = this.viewer,
          pages = this._pages;
        if (this._scrollMode === _ScrollMode.PAGE) {
          _assertClassBrand(_PDFViewer_brand, this, _ensurePageViewVisible).call(this);
        } else {
          viewer.textContent = "";
          if (this._spreadMode === _SpreadMode.NONE) {
            var _iterator26 = _createForOfIteratorHelper(this._pages),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var pageView = _step26.value;
                viewer.append(pageView.div);
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
          } else {
            var parity = this._spreadMode - 1;
            var spread = null;
            for (var i = 0, ii = pages.length; i < ii; ++i) {
              if (spread === null) {
                spread = document.createElement("div");
                spread.className = "spread";
                viewer.append(spread);
              } else if (i % 2 === parity) {
                spread = spread.cloneNode(false);
                viewer.append(spread);
              }
              spread.append(pages[i].div);
            }
          }
        }
        if (!pageNumber) {
          return;
        }
        if (this._currentScaleValue && isNaN(this._currentScaleValue)) {
          _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, this._currentScaleValue, {
            noScroll: true
          });
        }
        this._setCurrentPageNumber(pageNumber, true);
        this.update();
      }
    }, {
      key: "_getPageAdvance",
      value: function _getPageAdvance(currentPageNumber) {
        var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        switch (this._scrollMode) {
          case _ScrollMode.WRAPPED:
            {
              var _this$_getVisiblePage = this._getVisiblePages(),
                views = _this$_getVisiblePage.views,
                pageLayout = new Map();
              var _iterator27 = _createForOfIteratorHelper(views),
                _step27;
              try {
                for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                  var _step27$value = _step27.value,
                    id = _step27$value.id,
                    y = _step27$value.y,
                    percent = _step27$value.percent,
                    widthPercent = _step27$value.widthPercent;
                  if (percent === 0 || widthPercent < 100) {
                    continue;
                  }
                  var yArray = pageLayout.get(y);
                  if (!yArray) {
                    pageLayout.set(y, yArray || (yArray = []));
                  }
                  yArray.push(id);
                }
              } catch (err) {
                _iterator27.e(err);
              } finally {
                _iterator27.f();
              }
              var _iterator28 = _createForOfIteratorHelper(pageLayout.values()),
                _step28;
              try {
                for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                  var _yArray = _step28.value;
                  var currentIndex = _yArray.indexOf(currentPageNumber);
                  if (currentIndex === -1) {
                    continue;
                  }
                  var numPages = _yArray.length;
                  if (numPages === 1) {
                    break;
                  }
                  if (previous) {
                    for (var i = currentIndex - 1, ii = 0; i >= ii; i--) {
                      var currentId = _yArray[i],
                        expectedId = _yArray[i + 1] - 1;
                      if (currentId < expectedId) {
                        return currentPageNumber - expectedId;
                      }
                    }
                  } else {
                    for (var _i5 = currentIndex + 1, _ii = numPages; _i5 < _ii; _i5++) {
                      var _currentId = _yArray[_i5],
                        _expectedId = _yArray[_i5 - 1] + 1;
                      if (_currentId > _expectedId) {
                        return _expectedId - currentPageNumber;
                      }
                    }
                  }
                  if (previous) {
                    var firstId = _yArray[0];
                    if (firstId < currentPageNumber) {
                      return currentPageNumber - firstId + 1;
                    }
                  } else {
                    var lastId = _yArray[numPages - 1];
                    if (lastId > currentPageNumber) {
                      return lastId - currentPageNumber + 1;
                    }
                  }
                  break;
                }
              } catch (err) {
                _iterator28.e(err);
              } finally {
                _iterator28.f();
              }
              break;
            }
          case _ScrollMode.HORIZONTAL:
            {
              break;
            }
          case _ScrollMode.PAGE:
          case _ScrollMode.VERTICAL:
            {
              if (this._spreadMode === _SpreadMode.NONE) {
                break;
              }
              var parity = this._spreadMode - 1;
              if (previous && currentPageNumber % 2 !== parity) {
                break;
              } else if (!previous && currentPageNumber % 2 === parity) {
                break;
              }
              var _this$_getVisiblePage2 = this._getVisiblePages(),
                _views = _this$_getVisiblePage2.views,
                _expectedId2 = previous ? currentPageNumber - 1 : currentPageNumber + 1;
              var _iterator29 = _createForOfIteratorHelper(_views),
                _step29;
              try {
                for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                  var _step29$value = _step29.value,
                    _id = _step29$value.id,
                    _percent2 = _step29$value.percent,
                    _widthPercent = _step29$value.widthPercent;
                  if (_id !== _expectedId2) {
                    continue;
                  }
                  if (_percent2 > 0 && _widthPercent === 100) {
                    return 2;
                  }
                  break;
                }
              } catch (err) {
                _iterator29.e(err);
              } finally {
                _iterator29.f();
              }
              break;
            }
        }
        return 1;
      }
    }, {
      key: "nextPage",
      value: function nextPage() {
        var currentPageNumber = this._currentPageNumber,
          pagesCount = this.pagesCount;
        if (currentPageNumber >= pagesCount) {
          return false;
        }
        var advance = this._getPageAdvance(currentPageNumber, false) || 1;
        this.currentPageNumber = Math.min(currentPageNumber + advance, pagesCount);
        return true;
      }
    }, {
      key: "previousPage",
      value: function previousPage() {
        var currentPageNumber = this._currentPageNumber;
        if (currentPageNumber <= 1) {
          return false;
        }
        var advance = this._getPageAdvance(currentPageNumber, true) || 1;
        this.currentPageNumber = Math.max(currentPageNumber - advance, 1);
        return true;
      }
    }, {
      key: "updateScale",
      value: function updateScale(_ref40) {
        var drawingDelay = _ref40.drawingDelay,
          _ref40$scaleFactor = _ref40.scaleFactor,
          scaleFactor = _ref40$scaleFactor === void 0 ? null : _ref40$scaleFactor,
          _ref40$steps = _ref40.steps,
          steps = _ref40$steps === void 0 ? null : _ref40$steps,
          origin = _ref40.origin;
        if (steps === null && scaleFactor === null) {
          throw new Error("Invalid updateScale options: either `steps` or `scaleFactor` must be provided.");
        }
        if (!this.pdfDocument) {
          return;
        }
        var newScale = this._currentScale;
        if (scaleFactor > 0 && scaleFactor !== 1) {
          newScale = Math.round(newScale * scaleFactor * 100) / 100;
        } else if (steps) {
          var delta = steps > 0 ? DEFAULT_SCALE_DELTA : 1 / DEFAULT_SCALE_DELTA;
          var round = steps > 0 ? Math.ceil : Math.floor;
          steps = Math.abs(steps);
          do {
            newScale = round((newScale * delta).toFixed(2) * 10) / 10;
          } while (--steps > 0);
        }
        newScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
        _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, newScale, {
          noScroll: false,
          drawingDelay: drawingDelay,
          origin: origin
        });
      }
    }, {
      key: "increaseScale",
      value: function increaseScale() {
        var _options$steps;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.updateScale(_objectSpread2(_objectSpread2({}, options), {}, {
          steps: (_options$steps = options.steps) !== null && _options$steps !== void 0 ? _options$steps : 1
        }));
      }
    }, {
      key: "decreaseScale",
      value: function decreaseScale() {
        var _options$steps2;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.updateScale(_objectSpread2(_objectSpread2({}, options), {}, {
          steps: -((_options$steps2 = options.steps) !== null && _options$steps2 !== void 0 ? _options$steps2 : 1)
        }));
      }
    }, {
      key: "containerTopLeft",
      get: function get() {
        return _classPrivateFieldGet2(_containerTopLeft, this) || _classPrivateFieldSet2(_containerTopLeft, this, [this.container.offsetTop, this.container.offsetLeft]);
      }
    }, {
      key: "annotationEditorMode",
      get: function get() {
        return _classPrivateFieldGet2(_annotationEditorUIManager, this) ? _classPrivateFieldGet2(_annotationEditorMode, this) : AnnotationEditorType.DISABLE;
      },
      set: function set(_ref41) {
        var mode = _ref41.mode,
          _ref41$editId = _ref41.editId,
          editId = _ref41$editId === void 0 ? null : _ref41$editId,
          _ref41$isFromKeyboard = _ref41.isFromKeyboard,
          isFromKeyboard = _ref41$isFromKeyboard === void 0 ? false : _ref41$isFromKeyboard;
        if (!_classPrivateFieldGet2(_annotationEditorUIManager, this)) {
          throw new Error("The AnnotationEditor is not enabled.");
        }
        if (_classPrivateFieldGet2(_annotationEditorMode, this) === mode) {
          return;
        }
        if (!isValidAnnotationEditorMode(mode)) {
          throw new Error("Invalid AnnotationEditor mode: ".concat(mode));
        }
        if (!this.pdfDocument) {
          return;
        }
        _classPrivateFieldSet2(_annotationEditorMode, this, mode);
        this.eventBus.dispatch("annotationeditormodechanged", {
          source: this,
          mode: mode
        });
        _classPrivateFieldGet2(_annotationEditorUIManager, this).updateMode(mode, editId, isFromKeyboard);
      }
    }, {
      key: "annotationEditorParams",
      set: function set(_ref42) {
        var type = _ref42.type,
          value = _ref42.value;
        if (!_classPrivateFieldGet2(_annotationEditorUIManager, this)) {
          throw new Error("The AnnotationEditor is not enabled.");
        }
        _classPrivateFieldGet2(_annotationEditorUIManager, this).updateParams(type, value);
      }
    }, {
      key: "refresh",
      value: function refresh() {
        var noUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var updateArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);
        if (!this.pdfDocument) {
          return;
        }
        var _iterator30 = _createForOfIteratorHelper(this._pages),
          _step30;
        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var pageView = _step30.value;
            pageView.update(updateArgs);
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
        if (_classPrivateFieldGet2(_scaleTimeoutId, this) !== null) {
          clearTimeout(_classPrivateFieldGet2(_scaleTimeoutId, this));
          _classPrivateFieldSet2(_scaleTimeoutId, this, null);
        }
        if (!noUpdate) {
          this.update();
        }
      }
    }]);
  }();
  function _initializePermissions(permissions) {
    var params = {
      annotationEditorMode: _classPrivateFieldGet2(_annotationEditorMode, this),
      annotationMode: _classPrivateFieldGet2(_annotationMode2, this),
      textLayerMode: _classPrivateFieldGet2(_textLayerMode2, this)
    };
    if (!permissions) {
      return params;
    }
    if (!permissions.includes(PermissionFlag.COPY) && _classPrivateFieldGet2(_textLayerMode2, this) === TextLayerMode.ENABLE) {
      params.textLayerMode = TextLayerMode.ENABLE_PERMISSIONS;
    }
    if (!permissions.includes(PermissionFlag.MODIFY_CONTENTS)) {
      params.annotationEditorMode = AnnotationEditorType.DISABLE;
    }
    if (!permissions.includes(PermissionFlag.MODIFY_ANNOTATIONS) && !permissions.includes(PermissionFlag.FILL_INTERACTIVE_FORMS) && _classPrivateFieldGet2(_annotationMode2, this) === AnnotationMode.ENABLE_FORMS) {
      params.annotationMode = AnnotationMode.ENABLE;
    }
    return params;
  }
  function _onePageRenderedOrForceFetch(_x28) {
    return _onePageRenderedOrForceFetch2.apply(this, arguments);
  }
  function _onePageRenderedOrForceFetch2() {
    _onePageRenderedOrForceFetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(signal) {
      var hiddenCapability, onVisibilityChange;
      return _regeneratorRuntime().wrap(function _callee49$(_context50) {
        while (1) switch (_context50.prev = _context50.next) {
          case 0:
            onVisibilityChange = function _onVisibilityChange() {
              if (document.visibilityState === "hidden") {
                hiddenCapability.resolve();
              }
            };
            if (!(document.visibilityState === "hidden" || !this.container.offsetParent || this._getVisiblePages().views.length === 0)) {
              _context50.next = 3;
              break;
            }
            return _context50.abrupt("return");
          case 3:
            hiddenCapability = Promise.withResolvers();
            document.addEventListener("visibilitychange", onVisibilityChange, {
              signal: signal
            });
            _context50.next = 7;
            return Promise.race([this._onePageRenderedCapability.promise, hiddenCapability.promise]);
          case 7:
            document.removeEventListener("visibilitychange", onVisibilityChange);
          case 8:
          case "end":
            return _context50.stop();
        }
      }, _callee49, this);
    }));
    return _onePageRenderedOrForceFetch2.apply(this, arguments);
  }
  function _copyCallback(textLayerMode, event) {
    var _this41 = this;
    var selection = document.getSelection();
    var focusNode = selection.focusNode,
      anchorNode = selection.anchorNode;
    if (anchorNode && focusNode && selection.containsNode(_classPrivateFieldGet2(_hiddenCopyElement, this))) {
      if (_classPrivateFieldGet2(_getAllTextInProgress, this) || textLayerMode === TextLayerMode.ENABLE_PERMISSIONS) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      _classPrivateFieldSet2(_getAllTextInProgress, this, true);
      var savedCursor = this.container.style.cursor;
      this.container.style.cursor = "wait";
      var interruptCopy = function interruptCopy(ev) {
        return _classPrivateFieldSet2(_interruptCopyCondition, _this41, ev.key === "Escape");
      };
      window.addEventListener("keydown", interruptCopy);
      this.getAllText().then( /*#__PURE__*/function () {
        var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(text) {
          return _regeneratorRuntime().wrap(function _callee32$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                if (!(text !== null)) {
                  _context33.next = 3;
                  break;
                }
                _context33.next = 3;
                return navigator.clipboard.writeText(text);
              case 3:
              case "end":
                return _context33.stop();
            }
          }, _callee32);
        }));
        return function (_x29) {
          return _ref45.apply(this, arguments);
        };
      }())["catch"](function (reason) {
        console.warn("Something goes wrong when extracting the text: ".concat(reason.message));
      })["finally"](function () {
        _classPrivateFieldSet2(_getAllTextInProgress, _this41, false);
        _classPrivateFieldSet2(_interruptCopyCondition, _this41, false);
        window.removeEventListener("keydown", interruptCopy);
        _this41.container.style.cursor = savedCursor;
      });
      event.preventDefault();
      event.stopPropagation();
    }
  }
  function _ensurePageViewVisible() {
    if (this._scrollMode !== _ScrollMode.PAGE) {
      throw new Error("#ensurePageViewVisible: Invalid scrollMode value.");
    }
    var pageNumber = this._currentPageNumber,
      state = _classPrivateFieldGet2(_scrollModePageState, this),
      viewer = this.viewer;
    viewer.textContent = "";
    state.pages.length = 0;
    if (this._spreadMode === _SpreadMode.NONE && !this.isInPresentationMode) {
      var pageView = this._pages[pageNumber - 1];
      viewer.append(pageView.div);
      state.pages.push(pageView);
    } else {
      var pageIndexSet = new Set(),
        parity = this._spreadMode - 1;
      if (parity === -1) {
        pageIndexSet.add(pageNumber - 1);
      } else if (pageNumber % 2 !== parity) {
        pageIndexSet.add(pageNumber - 1);
        pageIndexSet.add(pageNumber);
      } else {
        pageIndexSet.add(pageNumber - 2);
        pageIndexSet.add(pageNumber - 1);
      }
      var spread = document.createElement("div");
      spread.className = "spread";
      if (this.isInPresentationMode) {
        var dummyPage = document.createElement("div");
        dummyPage.className = "dummyPage";
        spread.append(dummyPage);
      }
      var _iterator37 = _createForOfIteratorHelper(pageIndexSet),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var i = _step37.value;
          var _pageView = this._pages[i];
          if (!_pageView) {
            continue;
          }
          spread.append(_pageView.div);
          state.pages.push(_pageView);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      viewer.append(spread);
    }
    state.scrollDown = pageNumber >= state.previousPageNumber;
    state.previousPageNumber = pageNumber;
  }
  function _scrollIntoView(pageView) {
    var pageSpot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var div = pageView.div,
      id = pageView.id;
    if (this._currentPageNumber !== id) {
      this._setCurrentPageNumber(id);
    }
    if (this._scrollMode === _ScrollMode.PAGE) {
      _assertClassBrand(_PDFViewer_brand, this, _ensurePageViewVisible).call(this);
      this.update();
    }
    if (!pageSpot && !this.isInPresentationMode) {
      var left = div.offsetLeft + div.clientLeft,
        right = left + div.clientWidth;
      var _this$container2 = this.container,
        scrollLeft = _this$container2.scrollLeft,
        clientWidth = _this$container2.clientWidth;
      if (this._scrollMode === _ScrollMode.HORIZONTAL || left < scrollLeft || right > scrollLeft + clientWidth) {
        pageSpot = {
          left: 0,
          top: 0
        };
      }
    }
    scrollIntoView(div, pageSpot);
    if (!this._currentScaleValue && this._location) {
      this._location = null;
    }
  }
  function _isSameScale(newScale) {
    return newScale === this._currentScale || Math.abs(newScale - this._currentScale) < 1e-15;
  }
  function _setScaleUpdatePages(newScale, newValue, _ref46) {
    var _this42 = this;
    var _ref46$noScroll = _ref46.noScroll,
      noScroll = _ref46$noScroll === void 0 ? false : _ref46$noScroll,
      _ref46$preset = _ref46.preset,
      preset = _ref46$preset === void 0 ? false : _ref46$preset,
      _ref46$drawingDelay = _ref46.drawingDelay,
      drawingDelay = _ref46$drawingDelay === void 0 ? -1 : _ref46$drawingDelay,
      _ref46$origin = _ref46.origin,
      origin = _ref46$origin === void 0 ? null : _ref46$origin;
    this._currentScaleValue = newValue.toString();
    if (_assertClassBrand(_PDFViewer_brand, this, _isSameScale).call(this, newScale)) {
      if (preset) {
        this.eventBus.dispatch("scalechanging", {
          source: this,
          scale: newScale,
          presetValue: newValue
        });
      }
      return;
    }
    this.viewer.style.setProperty("--scale-factor", newScale * PixelsPerInch.PDF_TO_CSS_UNITS);
    var postponeDrawing = drawingDelay >= 0 && drawingDelay < 1000;
    this.refresh(true, {
      scale: newScale,
      drawingDelay: postponeDrawing ? drawingDelay : -1
    });
    if (postponeDrawing) {
      _classPrivateFieldSet2(_scaleTimeoutId, this, setTimeout(function () {
        _classPrivateFieldSet2(_scaleTimeoutId, _this42, null);
        _this42.refresh();
      }, drawingDelay));
    }
    var previousScale = this._currentScale;
    this._currentScale = newScale;
    if (!noScroll) {
      var page = this._currentPageNumber,
        dest;
      if (this._location && !(this.isInPresentationMode || this.isChangingPresentationMode)) {
        page = this._location.pageNumber;
        dest = [null, {
          name: "XYZ"
        }, this._location.left, this._location.top, null];
      }
      this.scrollPageIntoView({
        pageNumber: page,
        destArray: dest,
        allowNegativeOffset: true
      });
      if (Array.isArray(origin)) {
        var scaleDiff = newScale / previousScale - 1;
        var _this$containerTopLef = _slicedToArray(this.containerTopLeft, 2),
          top = _this$containerTopLef[0],
          left = _this$containerTopLef[1];
        this.container.scrollLeft += (origin[0] - left) * scaleDiff;
        this.container.scrollTop += (origin[1] - top) * scaleDiff;
      }
    }
    this.eventBus.dispatch("scalechanging", {
      source: this,
      scale: newScale,
      presetValue: preset ? newValue : undefined
    });
    if (this.defaultRenderingQueue) {
      this.update();
    }
  }
  function _get_pageWidthScaleFactor(_this27) {
    if (_this27._spreadMode !== _SpreadMode.NONE && _this27._scrollMode !== _ScrollMode.HORIZONTAL) {
      return 2;
    }
    return 1;
  }
  function _setScale(value, options) {
    var scale = parseFloat(value);
    if (scale > 0) {
      options.preset = false;
      _assertClassBrand(_PDFViewer_brand, this, _setScaleUpdatePages).call(this, scale, value, options);
    } else {
      var currentPage = this._pages[this._currentPageNumber - 1];
      if (!currentPage) {
        return;
      }
      var hPadding = SCROLLBAR_PADDING,
        vPadding = VERTICAL_PADDING;
      if (this.isInPresentationMode) {
        hPadding = vPadding = 4;
        if (this._spreadMode !== _SpreadMode.NONE) {
          hPadding *= 2;
        }
      } else if (this.removePageBorders) {
        hPadding = vPadding = 0;
      } else if (this._scrollMode === _ScrollMode.HORIZONTAL) {
        var _ref47 = [vPadding, hPadding];
        hPadding = _ref47[0];
        vPadding = _ref47[1];
      }
      var pageWidthScale = (this.container.clientWidth - hPadding) / currentPage.width * currentPage.scale / _classPrivateGetter(_PDFViewer_brand, this, _get_pageWidthScaleFactor);
      var pageHeightScale = (this.container.clientHeight - vPadding) / currentPage.height * currentPage.scale;
      switch (value) {
        case "page-actual":
          scale = 1;
          break;
        case "page-width":
          scale = pageWidthScale;
          break;
        case "page-height":
          scale = pageHeightScale;
          break;
        case "page-fit":
          scale = Math.min(pageWidthScale, pageHeightScale);
          break;
        case "auto":
          var horizontalScale = isPortraitOrientation(currentPage) ? pageWidthScale : Math.min(pageHeightScale, pageWidthScale);
          scale = Math.min(MAX_AUTO_SCALE, horizontalScale);
          break;
        default:
          console.error("#setScale: \"".concat(value, "\" is an unknown zoom value."));
          return;
      }
      options.preset = true;
      _assertClassBrand(_PDFViewer_brand, this, _setScaleUpdatePages).call(this, scale, value, options);
    }
  }
  function _resetCurrentPageView() {
    var pageView = this._pages[this._currentPageNumber - 1];
    if (this.isInPresentationMode) {
      _assertClassBrand(_PDFViewer_brand, this, _setScale).call(this, this._currentScaleValue, {
        noScroll: true
      });
    }
    _assertClassBrand(_PDFViewer_brand, this, _scrollIntoView).call(this, pageView);
  }
  function _ensurePdfPageLoaded(_x30) {
    return _ensurePdfPageLoaded2.apply(this, arguments);
  }
  function _ensurePdfPageLoaded2() {
    _ensurePdfPageLoaded2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(pageView) {
      var pdfPage;
      return _regeneratorRuntime().wrap(function _callee50$(_context51) {
        while (1) switch (_context51.prev = _context51.next) {
          case 0:
            if (!pageView.pdfPage) {
              _context51.next = 2;
              break;
            }
            return _context51.abrupt("return", pageView.pdfPage);
          case 2:
            _context51.prev = 2;
            _context51.next = 5;
            return this.pdfDocument.getPage(pageView.id);
          case 5:
            pdfPage = _context51.sent;
            if (!pageView.pdfPage) {
              pageView.setPdfPage(pdfPage);
            }
            return _context51.abrupt("return", pdfPage);
          case 10:
            _context51.prev = 10;
            _context51.t0 = _context51["catch"](2);
            console.error("Unable to get page for page view", _context51.t0);
            return _context51.abrupt("return", null);
          case 14:
          case "end":
            return _context51.stop();
        }
      }, _callee50, this, [[2, 10]]);
    }));
    return _ensurePdfPageLoaded2.apply(this, arguments);
  }
  function _getScrollAhead(visible) {
    var _visible$first, _visible$last;
    if (((_visible$first = visible.first) === null || _visible$first === void 0 ? void 0 : _visible$first.id) === 1) {
      return true;
    } else if (((_visible$last = visible.last) === null || _visible$last === void 0 ? void 0 : _visible$last.id) === this.pagesCount) {
      return false;
    }
    switch (this._scrollMode) {
      case _ScrollMode.PAGE:
        return _classPrivateFieldGet2(_scrollModePageState, this).scrollDown;
      case _ScrollMode.HORIZONTAL:
        return this.scroll.right;
    }
    return this.scroll.down;
  }
  function _updateContainerHeightCss() {
    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.container.clientHeight;
    if (height !== _classPrivateFieldGet2(_previousContainerHeight, this)) {
      _classPrivateFieldSet2(_previousContainerHeight, this, height);
      docStyle.setProperty("--viewer-container-height", "".concat(height, "px"));
    }
  }
  function _resizeObserverCallback(entries) {
    var _iterator38 = _createForOfIteratorHelper(entries),
      _step38;
    try {
      for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
        var entry = _step38.value;
        if (entry.target === this.container) {
          _assertClassBrand(_PDFViewer_brand, this, _updateContainerHeightCss).call(this, Math.floor(entry.borderBoxSize[0].blockSize));
          _classPrivateFieldSet2(_containerTopLeft, this, null);
          break;
        }
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }
  }
  var _PDFSinglePageViewer = /*#__PURE__*/function (_PDFViewer3) {
    function _PDFSinglePageViewer() {
      _classCallCheck(this, _PDFSinglePageViewer);
      return _callSuper(this, _PDFSinglePageViewer, arguments);
    }
    _inherits(_PDFSinglePageViewer, _PDFViewer3);
    return _createClass(_PDFSinglePageViewer, [{
      key: "_resetView",
      value: function _resetView() {
        _get(_getPrototypeOf(_PDFSinglePageViewer.prototype), "_resetView", this).call(this);
        this._scrollMode = _ScrollMode.PAGE;
        this._spreadMode = _SpreadMode.NONE;
      }
    }, {
      key: "scrollMode",
      set: function set(mode) {}
    }, {
      key: "_updateScrollMode",
      value: function _updateScrollMode() {}
    }, {
      key: "spreadMode",
      set: function set(mode) {}
    }, {
      key: "_updateSpreadMode",
      value: function _updateSpreadMode() {}
    }]);
  }(_PDFViewer);
})();
var __webpack_exports__AnnotationLayerBuilder = __webpack_exports__.AnnotationLayerBuilder;
var __webpack_exports__DownloadManager = __webpack_exports__.DownloadManager;
var __webpack_exports__EventBus = __webpack_exports__.EventBus;
var __webpack_exports__FindState = __webpack_exports__.FindState;
var __webpack_exports__GenericL10n = __webpack_exports__.GenericL10n;
var __webpack_exports__LinkTarget = __webpack_exports__.LinkTarget;
var __webpack_exports__PDFFindController = __webpack_exports__.PDFFindController;
var __webpack_exports__PDFHistory = __webpack_exports__.PDFHistory;
var __webpack_exports__PDFLinkService = __webpack_exports__.PDFLinkService;
var __webpack_exports__PDFPageView = __webpack_exports__.PDFPageView;
var __webpack_exports__PDFScriptingManager = __webpack_exports__.PDFScriptingManager;
var __webpack_exports__PDFSinglePageViewer = __webpack_exports__.PDFSinglePageViewer;
var __webpack_exports__PDFViewer = __webpack_exports__.PDFViewer;
var __webpack_exports__ProgressBar = __webpack_exports__.ProgressBar;
var __webpack_exports__RenderingStates = __webpack_exports__.RenderingStates;
var __webpack_exports__ScrollMode = __webpack_exports__.ScrollMode;
var __webpack_exports__SimpleLinkService = __webpack_exports__.SimpleLinkService;
var __webpack_exports__SpreadMode = __webpack_exports__.SpreadMode;
var __webpack_exports__StructTreeLayerBuilder = __webpack_exports__.StructTreeLayerBuilder;
var __webpack_exports__TextLayerBuilder = __webpack_exports__.TextLayerBuilder;
var __webpack_exports__XfaLayerBuilder = __webpack_exports__.XfaLayerBuilder;
var __webpack_exports__parseQueryString = __webpack_exports__.parseQueryString;

exports.AnnotationLayerBuilder = __webpack_exports__AnnotationLayerBuilder;
exports.DownloadManager = __webpack_exports__DownloadManager;
exports.EventBus = __webpack_exports__EventBus;
exports.FindState = __webpack_exports__FindState;
exports.GenericL10n = __webpack_exports__GenericL10n;
exports.LinkTarget = __webpack_exports__LinkTarget;
exports.PDFFindController = __webpack_exports__PDFFindController;
exports.PDFHistory = __webpack_exports__PDFHistory;
exports.PDFLinkService = __webpack_exports__PDFLinkService;
exports.PDFPageView = __webpack_exports__PDFPageView;
exports.PDFScriptingManager = __webpack_exports__PDFScriptingManager;
exports.PDFSinglePageViewer = __webpack_exports__PDFSinglePageViewer;
exports.PDFViewer = __webpack_exports__PDFViewer;
exports.ProgressBar = __webpack_exports__ProgressBar;
exports.RenderingStates = __webpack_exports__RenderingStates;
exports.ScrollMode = __webpack_exports__ScrollMode;
exports.SimpleLinkService = __webpack_exports__SimpleLinkService;
exports.SpreadMode = __webpack_exports__SpreadMode;
exports.StructTreeLayerBuilder = __webpack_exports__StructTreeLayerBuilder;
exports.TextLayerBuilder = __webpack_exports__TextLayerBuilder;
exports.XfaLayerBuilder = __webpack_exports__XfaLayerBuilder;
exports.parseQueryString = __webpack_exports__parseQueryString;
